/* eslint-disable */
import { useState, useEffect, useRef, createContext, useContext } from "react";

import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://zzmgshwkvzctomrnsjhx.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp6bWdzaHdrdnpjdG9tcm5zamh4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY5NjIwMzIsImV4cCI6MjA5MjUzODAzMn0.XDvraLYJReldksLs1EDhBgRFEdsWdUQlFHcipGPwEUo";
const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);


// ── Πλάνα: free (δοκιμή 365 ημ.) / lite (49€/έτος) / pro ──
const LIMITS = {
  free:         { fields: 1,  logs: 10,       machines: 0,        inventory: 0,        deliveries: 2,        workers: 0 },
  lite:         { fields: 5,  logs: Infinity, machines: 0,        inventory: 0,        deliveries: Infinity, workers: 1 },
  pro:          { fields: Infinity, logs: Infinity, machines: Infinity, inventory: Infinity, deliveries: Infinity, workers: Infinity },
  free_expired: { fields: 0,  logs: 0,        machines: 0,        inventory: 0,        deliveries: 0,        workers: 0 },
};

// Ποια tabs επιτρέπονται σε κάθε πλάνο (τα υπόλοιπα → θαμπό teaser)
const PLAN_TABS = {
  free: ["activities", "deliveries", "weather", "fields", "settings"],
  lite: ["activities", "deliveries", "weather", "fields", "workers", "settings"],
  pro:  ["activities", "notes", "deliveries", "weather", "fields", "machines", "workers", "inventory", "finance", "stats", "settings"],
  free_expired: ["settings"],
};
// Σε ποιο πλάνο ξεκλειδώνει κάθε κλειδωμένο tab (για το μήνυμα «Διαθέσιμο στο …»)
const TAB_MIN_PLAN = {
  notes: "PRO", machines: "PRO", inventory: "PRO", finance: "PRO", stats: "PRO",
  workers: "LITE",
};

// Στοιχεία επικοινωνίας για αναβάθμιση (LITE → πλήρες)
const UPGRADE_CONTACT = { email: "info@jitech.gr", phone: "+306978552777" };
const APP_VERSION = "v2.2.1 · 11/09";

const AppContext = createContext();
const useApp = () => useContext(AppContext);

function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [plan, setPlan] = useState("free");
  const [planExpiresAt, setPlanExpiresAt] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userName, setUserName] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [settingsLoaded, setSettingsLoaded] = useState(false);
  const [settings, setSettings] = useState({
    showTransport: true, showMachine: true, showWorkers: true,
    showSpray: true, showFertilizer: true, showRows: true, showExtraCost: true,
    cat_katergasia:true, cat_apskilosi:true, cat_spora:true, cat_kladema:true,
    cat_psekasmos:true, cat_lipansh:true, cat_ardeysh:true, cat_araioma:true,
    cat_sygkomidh:true, cat_syntirisi:true,
    weatherCities: ["Λάρισα"],
  });
  const settingsRef = useRef(null);
  useEffect(() => {
    // Κράτα ως «τελευταία καλή» μόνο ρυθμίσεις που ΕΧΟΥΝ προϊόντα/εκδότες,
    // ώστε να μη χαθεί το dn από πρόωρη/κενή κατάσταση.
    const dn = settings?.dn || {};
    const hasData = (Array.isArray(dn.products)&&dn.products.length) || (Array.isArray(dn.issuers)&&dn.issuers.length);
    if (hasData || !settingsRef.current) settingsRef.current = settings;
  }, [settings]);
  const [fields, setFields] = useState([]);
  const [logs, setLogs] = useState([]);
  const [machines, setMachines] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [workers, setWorkers] = useState([]);
  const [activities, setActivities] = useState([]);
  const [fieldRows, setFieldRows] = useState([]);
  const [income, setIncome] = useState([]);
  const [expenditure, setExpenditure] = useState([]);
  const [deliveries, setDeliveries] = useState([]);
  const [allSprayProducts, setAllSprayProducts] = useState([]);
  const [allActivityWorkers, setAllActivityWorkers] = useState([]);
  const [notes, setNotes] = useState([]);
  const [dbError, setDbError] = useState(null);

  const load = async (uid) => {
    const [f, l, m, i, p, w, ac, fr, inc, exp, del, spray, n] = await Promise.all([
      supabase.from("fields").select("*").eq("user_id", uid),
      supabase.from("work_logs").select("*").eq("user_id", uid).order("date", { ascending: false }),
      supabase.from("machines").select("*").eq("user_id", uid),
      supabase.from("inventory").select("*").eq("user_id", uid),
      supabase.from("profiles").select("plan,plan_expires_at,name,settings,phone,is_admin").eq("id", uid),
      supabase.from("workers").select("*").eq("user_id", uid),
      supabase.from("activities").select("*").eq("user_id", uid).order("date", { ascending: false }),
      supabase.from("field_rows").select("*").eq("user_id", uid),
      supabase.from("income").select("*").eq("user_id", uid).order("date", { ascending: false }),
      supabase.from("expenditure").select("*").eq("user_id", uid).order("date", { ascending: false }),
      supabase.from("deliveries").select("*").eq("user_id", uid).order("date", { ascending: false }),
      supabase.from("spray_products").select("*").eq("user_id", uid),
      supabase.from("notes").select("*").eq("user_id", uid).order("due_date", { ascending: true }),
    ]);
    setDbError(null);
    setFields(Array.isArray(f.data) ? f.data : []);
    setLogs(Array.isArray(l.data) ? l.data : []);
    setMachines(Array.isArray(m.data) ? m.data : []);
    setInventory(Array.isArray(i.data) ? i.data : []);
    setWorkers(Array.isArray(w.data) ? w.data : []);
    setActivities(Array.isArray(ac.data) ? ac.data : []);
    setFieldRows(Array.isArray(fr.data) ? fr.data : []);
    setIncome(Array.isArray(inc.data) ? inc.data : []);
    setExpenditure(Array.isArray(exp.data) ? exp.data : []);
    setDeliveries(Array.isArray(del.data) ? del.data : []);
    setAllSprayProducts(Array.isArray(spray?.data) ? spray.data : []);
    setNotes(Array.isArray(n?.data) ? n.data : []);

    // Load activity_workers. RLS ήδη περιορίζει στα μεροκάματα των δικών σου εργασιών,
    // οπότε τα ζητάμε απευθείας — πιο ανθεκτικό από το .in() με λίστα IDs.
    const awRes = await supabase.from("activity_workers").select("*");
    let awData = Array.isArray(awRes?.data) ? awRes.data : [];
    if ((!awData || awData.length === 0)) {
      // fallback: αν επιστρέψει άδειο, δοκίμασε με τα activity IDs σε κομμάτια
      const userActIds = Array.isArray(ac.data) ? ac.data.map(a=>a.id) : [];
      if (userActIds.length > 0) {
        const chunks = [];
        for (let i=0;i<userActIds.length;i+=80) chunks.push(userActIds.slice(i,i+80));
        const results = await Promise.all(chunks.map(c => supabase.from("activity_workers").select("*").in("activity_id", c)));
        awData = results.flatMap(r => Array.isArray(r?.data) ? r.data : []);
      }
    }
    setAllActivityWorkers(awData);
    // Set plan from profile (free / lite / pro)
    if (p.data && Array.isArray(p.data) && p.data.length > 0) {
      const profile = p.data[0];
      const rawPlan = profile.plan || "free";
      const expired = profile.plan_expires_at && new Date(profile.plan_expires_at) < new Date();
      // Λήξη: το FREE κλειδώνει τελείως· LITE/PRO με λήξη πέφτουν σε free_expired
      const newPlan = expired ? (rawPlan === "free" ? "free_expired" : "free_expired") : rawPlan;
      setPlan(newPlan);
      setPlanExpiresAt(profile.plan_expires_at || null);
      setIsAdmin(profile.is_admin === true);
      if (profile.name) setUserName(profile.name);
      if (profile.phone) setUserPhone(profile.phone);
      if (profile.settings) setSettings(s=>({...s,...profile.settings}));
      else setSettingsLoaded(true);
      setSettingsLoaded(true);
    }
  };

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        setUser(session.user);
        load(session.user.id);
      }
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) {
        setUser(session.user);
      } else {
        setUser(null);
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  const signIn = async (email, password, captchaToken=null) => {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password, options: { captchaToken } });
    if (!error && data.user) {
      setUser(data.user);
      load(data.user.id);
    }
    return { error };
  };

  const signUp = async (email, password, name="", captchaToken=null, phone="") => {
    const { data, error } = await supabase.auth.signUp({ email, password, options: { data: { name, phone }, captchaToken } });
    if (!error && name) setUserName(name);
    return { data, error };
  };

  const updateSettings = async (newSettings) => {
    // ΚΡΙΣΙΜΟ: μη γράφεις τίποτα πριν φορτώσουν οι ρυθμίσεις — αλλιώς κινδυνεύεις
    // να γράψεις κενό dn πάνω στα σωστά της βάσης (αιτία που «σβήνονταν» τα προϊόντα).
    if (!settingsLoaded) {
      return { error: null, skipped: true };
    }
    // Προστασία: μη σβήσεις ποτέ προϊόντα/εκδότες που ήδη υπάρχουν.
    const cur = settingsRef.current || {};
    const merged = { ...cur, ...newSettings };
    const curDn = cur.dn || {};
    const nextDn = merged.dn || {};
    const arr = (x) => Array.isArray(x) ? x : [];
    const curProd = arr(curDn.products), nextProd = arr(nextDn.products);
    const curIss = arr(curDn.issuers), nextIss = arr(nextDn.issuers);
    if ((curProd.length && !nextProd.length) || (curIss.length && !nextIss.length)) {
      merged.dn = {
        ...nextDn,
        products: nextProd.length ? nextProd : curProd,
        issuers:  nextIss.length  ? nextIss  : curIss,
        issuer:   nextIss.length  ? nextDn.issuer : (curDn.issuer || (curIss[0] || null)),
      };
    }
    settingsRef.current = merged;
    const { error } = await supabase.from("profiles").update({ settings: merged }).eq("id", user.id);
    if (!error) setSettings(merged);
    return { error };
  };

  const signOut = async () => {
    await supabase.auth.signOut();
    setUser(null);
    setFields([]); setLogs([]); setMachines([]); setInventory([]); setWorkers([]);
    setActivities([]); setFieldRows([]); setIncome([]); setExpenditure([]); setDeliveries([]);
  };

  const canAdd = (type, len) => { const lim = (LIMITS[plan] || LIMITS.free); const cap = lim[type]; return len < (cap === undefined ? Infinity : cap); };

  const addField = async (name, region, parcel_number, hectares, crop, variety="", is_rented=false, rent_amount=null, rows_enabled=false, gps_lat=null, gps_lng=null) => {
    const { error } = await supabase.from("fields").insert({ user_id: user.id, name, hectares: parseFloat(hectares)||0, crop, region, parcel_number, variety, is_rented, rent_amount, rows_enabled, gps_lat, gps_lng });
    if (error === null) {
      const r = await supabase.from("fields").select("*").eq("user_id", user.id);
      if (!r.error) setFields(Array.isArray(r.data) ? r.data : []);
      return true;
    }
    return false;
  };
  const updateField = async (id, upd) => {
    const { error } = await supabase.from("fields").update(upd).eq("id", id);
    if (!error) setFields(p => p.map(x => x.id===id ? {...x,...upd} : x));
    return !error;
  };
  const deleteField = async (id) => { await supabase.from("fields").delete().eq("id", id); setFields(p => p.filter(x=>x.id!==id)); };

  const addLog = async (log) => {
    if (!canAdd("logs", logs.length)) return false;
    const { error } = await supabase.from("work_logs").insert({ user_id: user.id, ...log });
    if (!error) { const { data: rows } = await supabase.from("work_logs").select("*").eq("user_id", user.id).order("date", { ascending: false }); if (rows) setLogs(rows); return true; }
    return false;
  };
  const updateLog = async (id, upd) => {
    const { error } = await supabase.from("work_logs").update(upd).eq("id", id);
    if (!error) setLogs(p => p.map(x => x.id===id ? {...x,...upd} : x));
    return !error;
  };
  const deleteLog = async (id) => { await supabase.from("work_logs").delete().eq("id", id); setLogs(p => p.filter(x=>x.id!==id)); };

  const addMachine = async (name, type, plate, icon) => {
    if (!canAdd("machines", machines.length)) return false;
    const { error } = await supabase.from("machines").insert({ user_id: user.id, name, type, plate, icon });
    if (!error) { const { data: rows } = await supabase.from("machines").select("*").eq("user_id", user.id); if (rows) setMachines(rows); return true; }
    return false;
  };
  const updateMachine = async (id, upd) => {
    const { error } = await supabase.from("machines").update(upd).eq("id", id);
    if (!error) setMachines(p => p.map(x => x.id===id ? {...x,...upd} : x));
    return !error;
  };
  const deleteMachine = async (id) => { await supabase.from("machines").delete().eq("id", id); setMachines(p => p.filter(x=>x.id!==id)); };

  const addInventory = async (item) => {
    if (!canAdd("inventory", inventory.length)) return false;
    const { error } = await supabase.from("inventory").insert({ user_id: user.id, ...item });
    if (!error) { const { data: rows } = await supabase.from("inventory").select("*").eq("user_id", user.id); if (rows) setInventory(rows); return true; }
    return false;
  };
  const updateInventory = async (id, upd) => {
    const { error } = await supabase.from("inventory").update(upd).eq("id", id);
    if (!error) setInventory(p => p.map(x => x.id===id ? {...x,...upd} : x));
    return !error;
  };
  const deleteInventory = async (id) => { await supabase.from("inventory").delete().eq("id", id); setInventory(p => p.filter(x=>x.id!==id)); };

  const addWorker = async (w) => {
    const { error } = await supabase.from("workers").insert({ user_id: user.id, ...w });
    if (!error) { const { data: rows } = await supabase.from("workers").select("*").eq("user_id", user.id); if (rows) setWorkers(rows); return true; }
    return false;
  };
  const updateWorker = async (id, upd) => {
    const { error } = await supabase.from("workers").update(upd).eq("id", id);
    if (!error) setWorkers(p => p.map(x => x.id===id ? {...x,...upd} : x));
    return !error;
  };
  const deleteWorker = async (id) => { await supabase.from("workers").delete().eq("id", id); setWorkers(p => p.filter(x=>x.id!==id)); };

  // ── Deliveries ──
  const addDelivery = async (item) => {
    const { error } = await supabase.from("deliveries").insert({ user_id: user.id, ...item });
    if (!error) { const { data: rows } = await supabase.from("deliveries").select("*").eq("user_id", user.id).order("date", { ascending: false }); if (rows) setDeliveries(rows); return true; }
    return false;
  };
  const updateDelivery = async (id, upd) => {
    const { error } = await supabase.from("deliveries").update(upd).eq("id", id);
    if (!error) setDeliveries(p => p.map(x => x.id===id ? {...x,...upd} : x));
    return !error;
  };
  const deleteDelivery = async (id) => { await supabase.from("deliveries").delete().eq("id", id); setDeliveries(p=>p.filter(x=>x.id!==id)); };

  // ── Income ──
  const addIncome = async (item) => {
    const { error } = await supabase.from("income").insert({ user_id: user.id, ...item });
    if (!error) { const { data: rows } = await supabase.from("income").select("*").eq("user_id", user.id).order("date", { ascending: false }); if (rows) setIncome(rows); return true; }
    return false;
  };
  const deleteIncome = async (id) => { await supabase.from("income").delete().eq("id", id); setIncome(p=>p.filter(x=>x.id!==id)); };

  // ── Expenditure ──
  const addExpenditure = async (item) => {
    const { error } = await supabase.from("expenditure").insert({ user_id: user.id, ...item });
    if (!error) { const { data: rows } = await supabase.from("expenditure").select("*").eq("user_id", user.id).order("date", { ascending: false }); if (rows) setExpenditure(rows); return true; }
    return false;
  };
  const deleteExpenditure = async (id) => { await supabase.from("expenditure").delete().eq("id", id); setExpenditure(p=>p.filter(x=>x.id!==id)); };

  // ── Field Rows ──
  const addFieldRow = async (row) => {
    const { error } = await supabase.from("field_rows").insert({ user_id: user.id, ...row });
    if (!error) { const { data: rows } = await supabase.from("field_rows").select("*").eq("user_id", user.id); if (rows) setFieldRows(rows); return true; }
    return false;
  };
  const updateFieldRow = async (id, upd) => {
    const { error } = await supabase.from("field_rows").update(upd).eq("id", id);
    if (!error) setFieldRows(p => p.map(x => x.id===id ? {...x,...upd} : x));
    return !error;
  };
  const deleteFieldRow = async (id) => { await supabase.from("field_rows").delete().eq("id", id); setFieldRows(p => p.filter(x=>x.id!==id)); };

  // ── Activities ──
  const addActivity = async (activity, workers_list, rows_list, spray_list, fertilizer_list) => {
    const { error } = await supabase.from("activities").insert({ user_id: user.id, ...activity });
    if (error) return false;
    // Reload to get new activity with id
    const { data: newActs } = await supabase.from("activities").select("*").eq("user_id", user.id).order("date", { ascending: false });
    if (newActs) setActivities(newActs);
    const act = newActs?.[0];
    if (!act) return true;
    // Insert related records
    if (workers_list && workers_list.length > 0) {
      await supabase.from("activity_workers").insert(workers_list.map(w => ({ activity_id: act.id, ...w })));
    }
    if (rows_list && rows_list.length > 0) {
      await supabase.from("activity_rows").insert(rows_list.map(r => ({ activity_id: act.id, ...r })));
    }
    if (spray_list && spray_list.length > 0) {
      await supabase.from("spray_products").insert(spray_list.map(s => ({ user_id: user.id, activity_id: act.id, ...s })));
    }
    if (fertilizer_list && fertilizer_list.length > 0) {
      await supabase.from("fertilizer_products").insert(fertilizer_list.map(f => ({ user_id: user.id, activity_id: act.id, ...f })));
    }
    return true;
  };
  const updateActivity = async (id, upd) => {
    const { error } = await supabase.from("activities").update(upd).eq("id", id);
    if (!error) setActivities(p => p.map(x => x.id===id ? {...x,...upd} : x));
    return !error;
  };
  const deleteActivity = async (id) => {
    await supabase.from("activities").delete().eq("id", id);
    setActivities(p => p.filter(x=>x.id!==id));
  };

  // Notes CRUD
  const addNote = async (note) => {
    const { data, error } = await supabase.from("notes").insert({ user_id: user.id, ...note }).select();
    if (!error && data) { setNotes(p => [...data, ...p]); return true; }
    return false;
  };
  const updateNote = async (id, upd) => {
    const { error } = await supabase.from("notes").update(upd).eq("id", id);
    if (!error) setNotes(p => p.map(x => x.id===id ? {...x,...upd} : x));
    return !error;
  };
  const deleteNote = async (id) => {
    await supabase.from("notes").delete().eq("id", id);
    setNotes(p => p.filter(x=>x.id!==id));
  };

  return (
    <AppContext.Provider value={{
      user, plan, planExpiresAt, isAdmin, userName, setUserName, dbError,
      fields, logs, machines, inventory, workers, activities, fieldRows, canAdd,
      signIn, signUp, signOut,
      addField, updateField, deleteField,
      addLog, updateLog, deleteLog,
      addMachine, updateMachine, deleteMachine,
      addInventory, updateInventory, deleteInventory,
      addWorker, updateWorker, deleteWorker,
      addFieldRow, updateFieldRow, deleteFieldRow,
      deliveries, addDelivery, updateDelivery, deleteDelivery,
      income, addIncome, deleteIncome,
      expenditure, addExpenditure, deleteExpenditure,
      addActivity, updateActivity, deleteActivity,
      notes, addNote, updateNote, deleteNote,
      settings, updateSettings, settingsLoaded,
      userPhone, setUserPhone,
      allSprayProducts, setAllSprayProducts,
      allActivityWorkers, setAllActivityWorkers,
    }}>
      {children}
    </AppContext.Provider>
  );
}

// ── CSS ──────────────────────────────────────────────────────
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap');
  *{box-sizing:border-box;margin:0;padding:0;-webkit-tap-highlight-color:transparent;}
  body{font-family:'Nunito',sans-serif;background:#1a3a1a;color:#1a2e1a;min-height:100vh;}

  /* ── SHELL ── */
  .shell{max-width:480px;margin:0 auto;min-height:100vh;background:#f5f7f5;display:flex;flex-direction:column;}

  /* ── HEADER ── */
  .hdr{background:linear-gradient(135deg,#1e5c1e,#2d8a2d);color:#fff;padding:18px 20px 14px;display:flex;align-items:center;justify-content:space-between;box-shadow:0 2px 12px rgba(0,0,0,.2);}
  .hdr h1{font-size:24px;font-weight:900;letter-spacing:-0.5px;}
  .badge{background:#f4c542;color:#1a2e1a;font-size:12px;font-weight:900;padding:4px 12px;border-radius:20px;letter-spacing:1px;}
  .badge.pro{background:#fff;color:#1e5c1e;}

  /* ── NAV ── */
  .nav{display:flex;background:#163616;overflow-x:auto;scrollbar-width:none;padding:4px 4px 0;}
  .nav::-webkit-scrollbar{display:none;}
  .nb{flex:1;min-width:64px;padding:10px 4px 10px;border:none;background:transparent;color:rgba(255,255,255,.45);font-family:'Nunito',sans-serif;font-size:10px;font-weight:800;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:4px;border-radius:12px 12px 0 0;transition:all .2s;letter-spacing:0.3px;}
  .nb .ic{font-size:26px;line-height:1;}
  .nb.on{color:#fff;background:rgba(255,255,255,.12);box-shadow:inset 0 2px 0 #f4c542;}

  /* ── CONTENT ── */
  .content{flex:1;padding:14px;overflow-y:auto;padding-bottom:24px;}

  /* ── SECTION TITLE ── */
  .stitle{font-size:20px;font-weight:900;color:#1e5c1e;margin-bottom:16px;display:flex;align-items:center;gap:10px;}
  .cnt{background:#d4edda;color:#1e5c1e;font-size:13px;font-weight:800;padding:3px 10px;border-radius:20px;}

  /* ── CARDS ── */
  .card{background:#fff;border:none;border-radius:18px;padding:16px;margin-bottom:12px;box-shadow:0 2px 12px rgba(0,0,0,.08);position:relative;}
  .card-icon{width:48px;height:48px;border-radius:14px;display:flex;align-items:center;justify-content:center;font-size:24px;flex-shrink:0;margin-right:12px;}
  .ctitle{font-weight:800;font-size:17px;color:#1a2e1a;line-height:1.2;}
  .csub{font-size:14px;color:#5a7a5a;margin-top:3px;line-height:1.4;}

  /* ── BUTTONS ── */
  .btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;padding:12px 20px;border-radius:16px;border:none;font-family:'Nunito',sans-serif;font-weight:800;font-size:15px;cursor:pointer;transition:all .15s;-webkit-user-select:none;}
  .btn:active{transform:scale(.94);opacity:.9;}
  .btn-p{background:linear-gradient(135deg,#2d8a2d,#1e5c1e);color:#fff;width:100%;padding:18px;font-size:18px;border-radius:18px;margin-bottom:12px;box-shadow:0 4px 16px rgba(30,92,30,.3);}
  .btn-p:disabled{opacity:.5;cursor:not-allowed;transform:none;}
  .btn-d{background:#fff0f0;color:#c0392b;padding:10px 16px;font-size:14px;border-radius:14px;border:1.5px solid #fdd;}
  .btn-u{background:linear-gradient(135deg,#f4c542,#e6a800);color:#1a2e1a;width:100%;padding:18px;font-size:18px;border-radius:18px;margin-bottom:12px;box-shadow:0 4px 16px rgba(244,197,66,.3);}

  /* ── ICON BUTTON (edit) ── */
  .btn-icon{background:#f0f7f0;color:#2d8a2d;padding:10px 14px;font-size:18px;border-radius:14px;border:none;}

  /* ── FORMS ── */
  .fg{margin-bottom:14px;}
  .fl{display:block;font-size:15px;font-weight:800;color:#2d5a2d;margin-bottom:6px;}
  .fl.error{color:#c0392b;}
  .fi{width:100%;padding:16px;border:2px solid #d4e8d4;border-radius:16px;font-family:'Nunito',sans-serif;font-size:16px;color:#1a2e1a;background:#fff;outline:none;transition:border-color .2s;-webkit-appearance:none;}
  .fi:focus{border-color:#2d8a2d;background:#fff;}
  .fi.error{border-color:#c0392b!important;background:#fff5f5!important;}
  .fr{display:grid;grid-template-columns:1fr 1fr;gap:12px;}
  .aform{background:#fff;border:none;border-radius:20px;padding:20px;margin-bottom:16px;box-shadow:0 2px 16px rgba(0,0,0,.08);}
  .aftitle{font-size:16px;font-weight:900;color:#1e5c1e;margin-bottom:16px;display:flex;align-items:center;gap:8px;}

  /* ── UPGRADE BOX ── */
  .ubox{background:linear-gradient(135deg,#fff8e1,#fff3cd);border:2px solid #f4c542;border-radius:18px;padding:16px;margin-bottom:14px;text-align:center;}
  .ubox p{font-size:15px;color:#7d5a00;margin-bottom:10px;font-weight:700;}

  /* ── AUTH ── */
  .auth-sc{display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:100vh;padding:24px;background:linear-gradient(160deg,#163616,#2d8a2d);}
  .auth-logo{font-size:80px;margin-bottom:10px;filter:drop-shadow(0 4px 12px rgba(0,0,0,.3));}
  .auth-title{font-size:36px;font-weight:900;color:#fff;margin-bottom:4px;letter-spacing:-1px;}
  .auth-sub{font-size:16px;color:rgba(255,255,255,.7);margin-bottom:32px;}
  .auth-card{background:#fff;border-radius:24px;padding:28px;width:100%;max-width:380px;box-shadow:0 8px 40px rgba(0,0,0,.3);}
  .atabs{display:flex;background:#f0f7f0;border-radius:14px;padding:4px;margin-bottom:24px;}
  .atab{flex:1;padding:12px;border:none;background:transparent;border-radius:11px;font-family:'Nunito',sans-serif;font-size:16px;font-weight:800;cursor:pointer;color:#5a7a5a;transition:all .2s;}
  .atab.on{background:#fff;color:#1e5c1e;box-shadow:0 2px 8px rgba(0,0,0,.1);}

  /* ── MESSAGES ── */
  .msg{font-size:14px;padding:14px 16px;border-radius:14px;margin-bottom:12px;font-weight:700;}
  .msg-e{background:#fee;color:#c0392b;border:1.5px solid #fcc;}
  .msg-s{background:#e8f5e9;color:#1e5c1e;border:1.5px solid #c8e6c9;}
  .msg-w{background:#fff8e1;color:#7d5a00;border:1.5px solid #ffe082;}

  /* ── EMPTY STATE ── */
  .empty{text-align:center;padding:50px 20px;color:#a0c0a0;}
  .empty .ic{font-size:64px;margin-bottom:14px;}
  .empty p{font-size:17px;font-weight:700;color:#8aaa8a;}

  /* ── MISC ── */
  .so{background:rgba(255,255,255,.15);border:none;color:#fff;font-size:20px;cursor:pointer;padding:8px;border-radius:10px;}
  .tag{display:inline-block;background:#e8f5e9;color:#1e5c1e;font-size:12px;font-weight:800;padding:4px 10px;border-radius:20px;margin-top:4px;}
  .tag-r{background:#fee;color:#c0392b;}
  .amount{transition:filter .3s;}
  .amount.blurred{filter:blur(6px);user-select:none;}
  .sql-box{background:#1e1e1e;color:#d4d4d4;border-radius:14px;padding:16px;font-size:11px;font-family:monospace;overflow-x:auto;margin-top:8px;line-height:1.7;}
  .confirm-box{background:#fff5f5;border:2px solid #fcc;border-radius:18px;padding:16px;margin-bottom:12px;}
  .confirm-box p{font-size:15px;font-weight:800;color:#c0392b;}

  /* ── STEP WIZARD ── */
  .step-bar{display:flex;gap:6px;margin-bottom:20px;}
  .step-dot{height:6px;border-radius:3px;background:#d4e8d4;flex:1;transition:all .3s;}
  .step-dot.done{background:#2d8a2d;}
  .step-dot.active{background:#f4c542;}

  /* ── CATEGORY GRID ── */
  .cat-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:16px;}
  .cat-btn{background:#fff;border:2px solid #d4e8d4;border-radius:18px;padding:16px 10px;display:flex;flex-direction:column;align-items:center;gap:6px;cursor:pointer;transition:all .2s;font-family:'Nunito',sans-serif;}
  .cat-btn:active{transform:scale(.95);}
  .cat-btn.sel{border-color:#2d8a2d;background:#f0f9f0;box-shadow:0 0 0 3px rgba(45,138,45,.15);}
  .cat-btn .cat-ic{font-size:32px;line-height:1;}
  .cat-btn .cat-lb{font-size:13px;font-weight:900;color:#2d5a2d;text-align:center;line-height:1.3;}
  .cat-btn.sel .cat-lb{color:#1e5c1e;}

  /* ── ROW SELECTOR ── */
  .row-grid{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:16px;}
  .row-btn{background:#fff;border:2px solid #d4e8d4;border-radius:14px;padding:12px 16px;font-family:'Nunito',sans-serif;font-weight:800;font-size:15px;color:#2d5a2d;cursor:pointer;transition:all .2s;}
  .row-btn:active{transform:scale(.93);}
  .row-btn.sel{background:#2d8a2d;border-color:#2d8a2d;color:#fff;}

  /* ── WHO WORKED BUTTONS ── */
  .who-grid{display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;margin-bottom:16px;}
  .who-btn{background:#fff;border:2px solid #d4e8d4;border-radius:16px;padding:16px 8px;display:flex;flex-direction:column;align-items:center;gap:6px;cursor:pointer;font-family:'Nunito',sans-serif;transition:all .2s;}
  .who-btn:active{transform:scale(.94);}
  .who-btn.sel{border-color:#2d8a2d;background:#f0f9f0;}
  .who-btn .who-ic{font-size:28px;}
  .who-btn .who-lb{font-size:11px;font-weight:800;color:#2d5a2d;text-align:center;}
`;

// ── Shared ───────────────────────────────────────────────────
function UpgradeBox() {
  return (
    <div className="ubox">
      <p>🔒 Φτάσατε το όριο του LITE πλάνου</p>
      <button className="btn btn-u">⭐ Αναβάθμιση σε PRO</button>
    </div>
  );
}
function Empty({ icon, text }) {
  return <div className="empty"><div className="ic">{icon}</div><p>{text}</p></div>;
}

// ── Confirm Dialog ───────────────────────────────────────────
function ConfirmDialog({ msg, onYes, onNo }) {
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.45)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px"}}>
      <div style={{background:"#fff",borderRadius:"18px",padding:"24px",maxWidth:"320px",width:"100%",boxShadow:"0 8px 32px rgba(0,0,0,0.2)"}}>
        <div style={{fontSize:"36px",textAlign:"center",marginBottom:"12px"}}>🗑️</div>
        <div style={{fontFamily:"Nunito,sans-serif",fontWeight:700,fontSize:"16px",textAlign:"center",marginBottom:"20px",color:"#1a2e1a"}}>{msg}</div>
        <div style={{display:"flex",gap:"10px"}}>
          <button className="btn" style={{flex:1,background:"#f0f7ee",color:"#2d6a2d",justifyContent:"center"}} onClick={onNo}>Άκυρο</button>
          <button className="btn" style={{flex:1,background:"#c0392b",color:"#fff",justifyContent:"center"}} onClick={onYes}>Διαγραφή</button>
        </div>
      </div>
    </div>
  );
}

// ── DB Error Banner ──────────────────────────────────────────
const SQL = `
-- Τρέξε αυτό στο Supabase → SQL Editor:

create table fields (
  id uuid primary key default gen_random_uuid(),
  user_id uuid references auth.users not null,
  name text, hectares numeric, crop text,
  is_rented boolean default false, rent_amount numeric,
  created_at timestamptz default now()
);
create table work_logs (
  id uuid primary key default gen_random_uuid(),
  user_id uuid references auth.users not null,
  date date, worker text, work_type text,
  hours numeric, field_id uuid, notes text,
  created_at timestamptz default now()
);
create table machines (
  id uuid primary key default gen_random_uuid(),
  user_id uuid references auth.users not null,
  name text, type text, plate text, icon text,
  created_at timestamptz default now()
);
create table inventory (
  id uuid primary key default gen_random_uuid(),
  user_id uuid references auth.users not null,
  item_name text, category text,
  quantity numeric, unit text, min_stock numeric,
  created_at timestamptz default now()
);
-- RLS policies (σημαντικό!):
alter table fields enable row level security;
alter table work_logs enable row level security;
alter table machines enable row level security;
alter table inventory enable row level security;
create policy "own" on fields for all using (auth.uid()=user_id);
create policy "own" on work_logs for all using (auth.uid()=user_id);
create policy "own" on machines for all using (auth.uid()=user_id);
create policy "own" on inventory for all using (auth.uid()=user_id);
`.trim();

function DbErrorBanner() {
  const [show, setShow] = useState(false);
  return (
    <div className="msg msg-w" style={{marginBottom:14}}>
      ⚠️ Δεν βρέθηκαν πίνακες στη Supabase.{" "}
      <span style={{textDecoration:"underline",cursor:"pointer"}} onClick={()=>setShow(!show)}>
        {show ? "Κλείσιμο SQL ▲" : "Δες το SQL ▼"}
      </span>
      {show && <pre className="sql-box">{SQL}</pre>}
    </div>
  );
}


// ── ΚΑΛΛΙΕΡΓΕΙΕΣ ─────────────────────────────────────────────
// CROPS structure:
// - For fixed crops: { ic, lb }
// - For dynamic categories: { ic, lb, dynamic: true, suggestions: [...] }
// The "Άλλο" stays as a free-form category.
const CROPS = [
  // Σταθερά Δενδρώδεις (8)
  { ic:"🍑", lb:"Ροδάκινο" },
  { ic:"🍎", lb:"Μηλιά" },
  { ic:"🍐", lb:"Αχλάδι" },
  { ic:"🍒", lb:"Κεράσι" },
  { ic:"🫒", lb:"Ελιά" },
  { ic:"🍇", lb:"Αμπέλι" },
  { ic:"🥝", lb:"Ακτινίδιο" },
  { ic:"🌰", lb:"Αμυγδαλιά" },
  // Σταθερά Αροτριαία (4)
  { ic:"🌾", lb:"Σιτάρι" },
  { ic:"🌽", lb:"Αραβόσιτος" },
  { ic:"🫘", lb:"Βαμβάκι" },
  { ic:"🍀", lb:"Τριφύλλι" },
  // Δυναμικές κατηγορίες
  { ic:"🌳", lb:"Δενδρώδες", dynamic:true,
    suggestions:["Βερίκοκο","Πορτοκάλι","Λεμόνι","Μανταρίνι","Συκιά","Καρυδιά","Φυστίκι","Ροδιά","Κυδώνι"] },
  { ic:"🌾", lb:"Αροτριαίο", dynamic:true,
    suggestions:["Κριθάρι","Σίκαλη","Βρώμη","Ρύζι","Σόργο","Ηλίανθος","Ελαιοκράμβη","Καπνός","Ζαχαρότευτλο","Μηδική","Σανός"] },
  { ic:"🍅", lb:"Κηπευτικό", dynamic:true,
    suggestions:["Πατάτα","Τομάτα","Πιπεριά","Αγγούρι","Μελιτζάνα","Κολοκύθι","Μπρόκολο","Κουνουπίδι","Λάχανο","Μαρούλι","Σπανάκι","Καρότο","Κρεμμύδι","Σκόρδο","Καρπούζι","Πεπόνι"] },
  { ic:"🫘", lb:"Όσπριο", dynamic:true,
    suggestions:["Φασόλια","Φακές","Ρεβίθια","Κουκιά","Μπιζέλια","Λαθούρι"] },
  { ic:"🌿", lb:"Άλλο" },
];

// Helper: which crops should display the "varieties" picker.
// For dynamic categories, the variety field is filled directly from the suggestions+custom flow.
// For fixed crops, we use the VARIETIES dictionary below.
const isDynamicCrop = (cropLabel) => {
  const c = CROPS.find(x => x.lb === cropLabel);
  return !!(c && c.dynamic);
};


// ── ΠΟΙΚΙΛΙΕΣ ─────────────────────────────────────────────────
const VARIETIES = {
  "Ροδάκινο": ["A37","Andros","Everts","Redhaven","Fairhaven","Caldesi","Maria Bianca","Royal Summer","Άλλο"],
  "Μηλιά":   ["Golden","Fuji","Granny Smith","Gala","Red Chief","Starking","Άλλο"],
  "Αχλάδι":  ["Κοντούλα","Williams","Conference","Abate Fetel","Άλλο"],
  "Κεράσι":  ["Ferrovia","Lapins","Kordia","Sweetheart","Van","Άλλο"],
  "Ελιά":    ["Κορωνέικη","Καλαμών","Χαλκιδική","Αμφίσσης","Μανάκι","Άλλο"],
  "Αμπέλι":  ["Σαββατιανό","Μοσχοφίλερο","Αγιωργίτικο","Ξινόμαυρο","Ασύρτικο","Μαυροδάφνη","Άλλο"],
  "Ακτινίδιο": ["Hayward","Tsechelidis","Solo","Blake","Άλλο"],
  "Αμυγδαλιά":["Texas","Ferragnès","Ferraduel","Truoito","Retsou","Άλλο"],
  "Σιτάρι":  ["Μαλακό","Σκληρό","Durum","Άλλο"],
  "Αραβόσιτος":["Pioneer","Dekalb","Syngenta","Άλλο"],
  "Βαμβάκι": ["Coker","Celia","249","DP 4749","ST 474","Άλλο"],
  "Τριφύλλι":["Κόκκινο","Λευκό","Περσικό","Άλλο"],
};


// Καλλιέργειες με δέντρα (χρειάζονται σειρές)
const TREE_CROPS = ["Ροδάκινο","Μηλιά","Αχλάδι","Κεράσι","Ελιά","Αμπέλι","Ακτινίδιο","Αμυγδαλιά","Δενδρώδες"];

// Check if rows management is active for a field: explicit flag OR existing rows (backwards compat)
const isFieldRowsEnabled = (field, allFieldRows) => {
  if (!field) return false;
  if (field.rows_enabled === true) return true;
  return (allFieldRows || []).some(r => r.field_id === field.id);
};

// ── FIELDS ───────────────────────────────────────────────────
function FieldsTab() {
  const { fields, canAdd, addField, updateField, deleteField, dbError, fieldRows, addFieldRow, updateFieldRow, deleteFieldRow } = useApp();
  const [view, setView] = useState("list");
  const [manageRowsFieldId, setManageRowsFieldId] = useState(null);
  const [show, setShow] = useState(false);
  const [name, setName] = useState(""); const [region, setRegion] = useState(""); const [parcelNum, setParcelNum] = useState(""); const [ha, setHa] = useState(""); const [crop, setCrop] = useState(""); const [variety, setVariety] = useState("");
  const [isRented, setIsRented] = useState(false); const [rentAmount, setRentAmount] = useState("");
  const [rowsEnabled, setRowsEnabled] = useState(false);
  const [gpsLat, setGpsLat] = useState(null); const [gpsLng, setGpsLng] = useState(null);
  const [gpsLoading, setGpsLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState({});
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({});
  const [confirmId, setConfirmId] = useState(null);

  const handle = async () => {
    const e = {};
    if (!name.trim()) e.name = true;
    if (!region.trim()) e.region = true;
    if (!ha || parseFloat(ha) <= 0) e.ha = true;
    if (isRented && (!rentAmount || parseFloat(rentAmount) <= 0)) e.rent = true;
    if (Object.keys(e).length) { setErr(e); setMsg("Συμπλήρωσε τα υποχρεωτικά πεδία"); return; }
    setErr({});
    const ok = await addField(name.trim(), region.trim(), parcelNum.trim(), ha, crop, variety, isRented, isRented?parseFloat(rentAmount):null, rowsEnabled, gpsLat, gpsLng);
    if (ok) { setName(""); setRegion(""); setParcelNum(""); setHa(""); setCrop(""); setVariety(""); setIsRented(false); setRentAmount(""); setRowsEnabled(false); setGpsLat(null); setGpsLng(null); setShow(false); setMsg(""); setErr({}); }
    else setMsg("Σφάλμα αποθήκευσης. Δοκίμασε ξανά.");
  };

  const handleEdit = (f) => { setEditId(f.id); setEditData({ name: f.name||"", region: f.region||"", parcel_number: f.parcel_number||"", hectares: f.hectares||"", crop: f.crop||"", variety: f.variety||"", is_rented: f.is_rented||false, rent_amount: f.rent_amount||"", rows_enabled: isFieldRowsEnabled(f, fieldRows), gps_lat: f.gps_lat||null, gps_lng: f.gps_lng||null }); };
  const handleSaveEdit = async () => {
    if (!editData.name.trim()) return;
    await updateField(editId, { name: editData.name, region: editData.region, parcel_number: editData.parcel_number, hectares: parseFloat(editData.hectares)||0, crop: editData.crop, variety: editData.variety||"", is_rented: editData.is_rented||false, rent_amount: editData.is_rented?(parseFloat(editData.rent_amount)||null):null, rows_enabled: editData.rows_enabled||false, gps_lat: editData.gps_lat||null, gps_lng: editData.gps_lng||null });
    setEditId(null);
  };

  // GPS helper: catch device location
  const catchGPS = (setLat, setLng) => {
    if (!navigator.geolocation) { alert("Η συσκευή δεν υποστηρίζει GPS"); return; }
    if (window.location.protocol !== "https:" && window.location.hostname !== "localhost") {
      alert("Το GPS απαιτεί HTTPS. Αυτή η σελίδα είναι HTTP — δεν θα δουλέψει.");
      return;
    }
    setGpsLoading(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setLat(parseFloat(pos.coords.latitude.toFixed(6)));
        setLng(parseFloat(pos.coords.longitude.toFixed(6)));
        setGpsLoading(false);
      },
      (err) => {
        setGpsLoading(false);
        let msg = "Δεν μπορέσαμε να πάρουμε τη θέση.";
        if (err.code === 1) msg = "🚫 Άρνηση πρόσβασης. Επίτρεψε την τοποθεσία στα settings του browser:\n\niPhone: Settings → Safari → Location → Allow\nChrome: 🔒 δίπλα στο URL → Location → Allow";
        else if (err.code === 2) msg = "📵 Η τοποθεσία δεν είναι διαθέσιμη. Έλεγξε αν το GPS είναι ενεργό στη συσκευή σου.";
        else if (err.code === 3) msg = "⏱ Έληξε ο χρόνος αναζήτησης. Δοκίμασε ξανά κοντά σε παράθυρο ή έξω.";
        alert(msg);
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
    );
  };

  if (view === "rows") {
    return <ManageRowsView fieldId={manageRowsFieldId} fields={fields} fieldRows={fieldRows} addFieldRow={addFieldRow} updateFieldRow={updateFieldRow} deleteFieldRow={deleteFieldRow} onBack={()=>setView("list")} />;
  }

  return (
    <div>
      {confirmId && <ConfirmDialog msg="Διαγραφή αγροτεμαχίου;" onYes={()=>{deleteField(confirmId);setConfirmId(null);}} onNo={()=>setConfirmId(null)} />}
      {window._prevTab === "settings" && (
        <button className="btn" style={{width:"100%",background:"#f0f9f0",color:"#2d8a2d",justifyContent:"center",marginBottom:12,padding:12,fontSize:14,fontWeight:800}} onClick={()=>{window._prevTab=null;window._gotoTab&&window._gotoTab("settings");}}>
          ← Πίσω στις Ρυθμίσεις
        </button>
      )}
      <div className="stitle">🌱 Αγροτεμάχια <span className="cnt">{fields.length}</span></div>
      {dbError && <DbErrorBanner />}
      {canAdd("fields", fields.length)
        ? <button className="btn btn-p" onClick={() => setShow(!show)}>{show ? "✕ Άκυρο" : "➕ Νέο Αγροτεμάχιο"}</button>
        : <UpgradeBox />}
      {show && (
        <div className="aform">
          <div className="aftitle">Νέο Αγροτεμάχιο</div>
          {msg && <div className="msg msg-e">{msg}</div>}
          <div className="fg"><label className={`fl${err.name?" error":""}`}>Παρατσούκλι *</label>
            <input className={`fi${err.name?" error":""}`} placeholder="π.χ. Κάτω αγροτεμάχιο" value={name} onChange={e=>{setName(e.target.value);setErr(p=>({...p,name:false}));}} /></div>
          <div className="fg"><label className={`fl${err.region?" error":""}`}>Περιοχή *</label>
            <input className={`fi${err.region?" error":""}`} placeholder="π.χ. Παλιούρι" value={region} onChange={e=>{setRegion(e.target.value);setErr(p=>({...p,region:false}));}} /></div>
          <div className="fg"><label className="fl">Αριθμός Τεμαχίου (προαιρετικό)</label>
            <input className="fi" placeholder="π.χ. 1234" value={parcelNum} onChange={e=>setParcelNum(e.target.value)} /></div>
          <div className="fg"><label className={`fl${err.ha?" error":""}`}>Στρέμματα *</label>
            <input className={`fi${err.ha?" error":""}`} type="number" placeholder="π.χ. 5" min="0.5" step="0.5" value={ha} onChange={e=>{setHa(e.target.value);setErr(p=>({...p,ha:false}));}} /></div>
          <div className="fg"><label className="fl">Καλλιέργεια</label>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginTop:4}}>
              {CROPS.map(c=>{
                const isDyn = !!c.dynamic;
                const isOther = c.lb === "Άλλο";
                const sel = crop===c.lb;
                // Dynamic categories: orange/amber outlined; "Άλλο" neutral; Fixed: green
                const baseColor = isDyn ? "#c47a2c" : (isOther ? "#666" : "#2d8a2d");
                const bg = sel ? baseColor : "#fff";
                const border = sel ? baseColor : (isDyn ? "#e8b87a" : (isOther ? "#d0d0d0" : "#d4e8d4"));
                const fg = sel ? "#fff" : (isDyn ? "#8a5318" : (isOther ? "#444" : "#2d5a2d"));
                return (
                  <button key={c.lb} type="button"
                    style={{background:bg,border:`2px ${isDyn?"dashed":"solid"} ${border}`,borderRadius:14,padding:"10px 4px",display:"flex",flexDirection:"column",alignItems:"center",gap:4,cursor:"pointer",transition:"all .15s",minHeight:64}}
                    onClick={()=>{setCrop(crop===c.lb?"":c.lb);setVariety("");}}>
                    <span style={{fontSize:24,lineHeight:1}}>{c.ic}</span>
                    <span style={{fontSize:11,fontWeight:800,color:fg,textAlign:"center",lineHeight:1.2}}>{c.lb}</span>
                    {isDyn && <span style={{fontSize:8,fontWeight:700,color:fg,opacity:.85,letterSpacing:.3}}>ΚΑΤΗΓΟΡΙΑ</span>}
                  </button>
                );
              })}
            </div>
            {crop && <div style={{marginTop:8,fontSize:13,fontWeight:700,color:"#2d8a2d"}}>✓ Επιλέχθηκε: {crop}</div>}
          </div>
            {crop && (() => {
              const cropDef = CROPS.find(x => x.lb === crop);
              // Dynamic category: suggestions + custom input → stored as variety
              if (cropDef && cropDef.dynamic) {
                return (
                  <div className="fg" style={{marginTop:8}}>
                    <label className="fl">Είδος {crop.toLowerCase()}</label>
                    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginTop:4}}>
                      {cropDef.suggestions.map(v=>(
                        <button key={v} type="button"
                          style={{background:variety===v?"#2d8a2d":"#fff",border:`2px solid ${variety===v?"#2d8a2d":"#d4e8d4"}`,borderRadius:12,padding:"10px 6px",fontSize:13,fontWeight:800,color:variety===v?"#fff":"#2d5a2d",cursor:"pointer",lineHeight:1.2}}
                          onClick={()=>setVariety(variety===v?"":v)}>
                          {v}
                        </button>
                      ))}
                    </div>
                    <input className="fi" style={{marginTop:8}}
                      placeholder="ή γράψε δικό σου..."
                      value={cropDef.suggestions.includes(variety) ? "" : variety}
                      onChange={e=>setVariety(e.target.value)} />
                    {variety && <div style={{marginTop:6,fontSize:13,fontWeight:700,color:"#2d8a2d"}}>✓ {variety}</div>}
                  </div>
                );
              }
              // "Άλλο": completely free input
              if (crop === "Άλλο") {
                return (
                  <div className="fg" style={{marginTop:8}}>
                    <label className="fl">Καλλιέργεια</label>
                    <input className="fi" placeholder="Γράψε την καλλιέργειά σου..."
                      value={variety} onChange={e=>setVariety(e.target.value)} />
                  </div>
                );
              }
              // Fixed crop with VARIETIES: existing variety picker
              if (VARIETIES[crop]) {
                return (
                  <div className="fg" style={{marginTop:8}}>
                    <label className="fl">Ποικιλία</label>
                    <div style={{display:"flex",flexWrap:"wrap",gap:8,marginTop:4}}>
                      {VARIETIES[crop].map(v=>(
                        <button key={v} type="button"
                          style={{background:variety===v?"#2d8a2d":"#fff",border:`2px solid ${variety===v?"#2d8a2d":"#d4e8d4"}`,borderRadius:12,padding:"8px 14px",fontSize:14,fontWeight:800,color:variety===v?"#fff":"#2d5a2d",cursor:"pointer",transition:"all .15s"}}
                          onClick={()=>setVariety(variety===v?"":v)}>
                          {v}
                        </button>
                      ))}
                    </div>
                    {variety && <div style={{marginTop:6,fontSize:13,fontWeight:700,color:"#2d8a2d"}}>✓ Ποικιλία: {variety}</div>}
                  </div>
                );
              }
              return null;
            })()}
          <div className="fg" style={{marginTop:4}}>
            <button type="button"
              style={{width:"100%",background:gpsLat&&gpsLng?"#1976d2":"#fff",border:`2px solid ${gpsLat&&gpsLng?"#1976d2":"#b3d9f5"}`,borderRadius:14,padding:"12px 14px",fontWeight:800,fontSize:14,color:gpsLat&&gpsLng?"#fff":"#0d4d92",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}
              onClick={()=>catchGPS(setGpsLat,setGpsLng)}>
              {gpsLoading ? "⏳ Φόρτωση..." : (gpsLat&&gpsLng ? `✅ 📍 ${gpsLat}, ${gpsLng}` : "📍 Πιάσε τη θέση μου (GPS)")}
            </button>
            {gpsLat && gpsLng && (
              <button type="button" style={{marginTop:6,background:"transparent",border:"none",color:"#c0392b",fontSize:12,fontWeight:700,cursor:"pointer"}} onClick={()=>{setGpsLat(null);setGpsLng(null);}}>
                ✕ Αφαίρεση στίγματος
              </button>
            )}
          </div>
          <div className="fg" style={{marginTop:4}}>
            <button type="button"
              style={{width:"100%",background:isRented?"#c47a2c":"#fff",border:`2px solid ${isRented?"#c47a2c":"#d4e8d4"}`,borderRadius:14,padding:"12px 14px",fontWeight:800,fontSize:14,color:isRented?"#fff":"#2d5a2d",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}
              onClick={()=>{setIsRented(!isRented);if(isRented)setRentAmount("");setErr(p=>({...p,rent:false}));}}>
              {isRented?"✅":"⬜"} 🏠 Ενοικιαζόμενο
            </button>
          </div>
          {isRented && (
            <div className="fg">
              <label className={`fl${err.rent?" error":""}`}>Ετήσιο Ενοίκιο (€) *</label>
              <input className={`fi${err.rent?" error":""}`} type="number" placeholder="π.χ. 800" min="0" step="10"
                value={rentAmount}
                onChange={e=>{setRentAmount(e.target.value);setErr(p=>({...p,rent:false}));}} />
            </div>
          )}
          {(() => {
            const LEGACY_TREES = ["Βερίκοκο","Πορτοκάλι","Λεμόνι","Μανταρίνι","Φυστίκι","Καρυδιά","Συκιά","Ροδιά","Κυδώνι"];
            const isTree = crop && (
              TREE_CROPS.some(t => t.trim().toLowerCase() === crop.trim().toLowerCase()) ||
              LEGACY_TREES.includes(crop)
            );
            return (
              <>
                <div className="fg" style={{marginTop:4}}>
                  <button type="button"
                    style={{width:"100%",background:rowsEnabled?"#2d8a2d":"#fff",border:`2px solid ${rowsEnabled?"#2d8a2d":"#d4e8d4"}`,borderRadius:14,padding:"12px 14px",fontWeight:800,fontSize:14,color:rowsEnabled?"#fff":"#2d5a2d",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}
                    onClick={()=>setRowsEnabled(!rowsEnabled)}>
                    {rowsEnabled?"✅":"⬜"} 🌳 Διαχείριση Σειρών/Δέντρων
                  </button>
                  <div style={{fontSize:11,color:"#8aaa8a",marginTop:6,lineHeight:1.4}}>
                    💡 {isTree ? "Συνιστάται για δενδρώδεις καλλιέργειες — " : ""}Ενεργοποίησε για να καταχωρείς σειρές και αριθμό δέντρων/φυτών ανά σειρά.
                  </div>
                </div>
                {rowsEnabled && (
                  <div style={{background:"#e8f5e9",border:"1.5px solid #2d8a2d",borderRadius:12,padding:"10px 14px",marginBottom:10,fontSize:12,color:"#1e5c1e",lineHeight:1.4}}>
                    🌳 Μετά την αποθήκευση, θα μπορείς να προσθέσεις τις σειρές του αγροτεμαχίου.
                  </div>
                )}
              </>
            );
          })()}
          <button className="btn btn-p" onClick={handle}>✅ Αποθήκευση</button>
        </div>
      )}
      {fields.length === 0 ? <Empty icon="🌾" text="Δεν έχετε αγροτεμάχια ακόμα" />
        : fields.map(f => (
          <div key={f.id} className="card">
            {editId === f.id ? (
              <div>
                <div className="fg"><label className="fl">Παρατσούκλι *</label>
                  <input className="fi" value={editData.name} onChange={e=>setEditData(p=>({...p,name:e.target.value}))} /></div>
                <div className="fg"><label className="fl">Περιοχή *</label>
                  <input className="fi" value={editData.region} onChange={e=>setEditData(p=>({...p,region:e.target.value}))} /></div>
                <div className="fg"><label className="fl">Αριθμός Τεμαχίου (προαιρετικό)</label>
                  <input className="fi" value={editData.parcel_number} onChange={e=>setEditData(p=>({...p,parcel_number:e.target.value}))} /></div>
                <div className="fg"><label className="fl">Στρέμματα *</label>
                  <input className="fi" type="number" min="0.5" step="0.5" value={editData.hectares} onChange={e=>setEditData(p=>({...p,hectares:e.target.value}))} /></div>
                <div className="fg"><label className="fl">Καλλιέργεια</label>
                  <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginTop:4}}>
                    {CROPS.map(c=>{
                      const isDyn = !!c.dynamic;
                      const isOther = c.lb === "Άλλο";
                      const sel = editData.crop===c.lb;
                      const baseColor = isDyn ? "#c47a2c" : (isOther ? "#666" : "#2d8a2d");
                      const bg = sel ? baseColor : "#fff";
                      const border = sel ? baseColor : (isDyn ? "#e8b87a" : (isOther ? "#d0d0d0" : "#d4e8d4"));
                      const fg = sel ? "#fff" : (isDyn ? "#8a5318" : (isOther ? "#444" : "#2d5a2d"));
                      return (
                        <button key={c.lb} type="button"
                          style={{background:bg,border:`2px ${isDyn?"dashed":"solid"} ${border}`,borderRadius:14,padding:"10px 4px",display:"flex",flexDirection:"column",alignItems:"center",gap:4,cursor:"pointer",minHeight:64}}
                          onClick={()=>setEditData(p=>({...p,crop:p.crop===c.lb?"":c.lb,variety:""}))}>
                          <span style={{fontSize:24,lineHeight:1}}>{c.ic}</span>
                          <span style={{fontSize:11,fontWeight:800,color:fg,textAlign:"center",lineHeight:1.2}}>{c.lb}</span>
                          {isDyn && <span style={{fontSize:8,fontWeight:700,color:fg,opacity:.85,letterSpacing:.3}}>ΚΑΤΗΓΟΡΙΑ</span>}
                        </button>
                      );
                    })}
                  </div>
                </div>
                {editData.crop && (() => {
                  const cropDef = CROPS.find(x => x.lb === editData.crop);
                  if (cropDef && cropDef.dynamic) {
                    return (
                      <div className="fg">
                        <label className="fl">Είδος {editData.crop.toLowerCase()}</label>
                        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginTop:4}}>
                          {cropDef.suggestions.map(v=>(
                            <button key={v} type="button"
                              style={{background:editData.variety===v?"#2d8a2d":"#fff",border:`2px solid ${editData.variety===v?"#2d8a2d":"#d4e8d4"}`,borderRadius:12,padding:"10px 6px",fontSize:13,fontWeight:800,color:editData.variety===v?"#fff":"#2d5a2d",cursor:"pointer",lineHeight:1.2}}
                              onClick={()=>setEditData(p=>({...p,variety:p.variety===v?"":v}))}>
                              {v}
                            </button>
                          ))}
                        </div>
                        <input className="fi" style={{marginTop:8}}
                          placeholder="ή γράψε δικό σου..."
                          value={cropDef.suggestions.includes(editData.variety) ? "" : (editData.variety||"")}
                          onChange={e=>setEditData(p=>({...p,variety:e.target.value}))} />
                        {editData.variety && <div style={{marginTop:6,fontSize:13,fontWeight:700,color:"#2d8a2d"}}>✓ {editData.variety}</div>}
                      </div>
                    );
                  }
                  if (editData.crop === "Άλλο") {
                    return (
                      <div className="fg">
                        <label className="fl">Καλλιέργεια</label>
                        <input className="fi" placeholder="Γράψε την καλλιέργειά σου..."
                          value={editData.variety||""}
                          onChange={e=>setEditData(p=>({...p,variety:e.target.value}))} />
                      </div>
                    );
                  }
                  if (VARIETIES[editData.crop]) {
                    return (
                      <div className="fg">
                        <label className="fl">Ποικιλία</label>
                        <div style={{display:"flex",flexWrap:"wrap",gap:8,marginTop:4}}>
                          {VARIETIES[editData.crop].map(v=>(
                            <button key={v} type="button"
                              style={{background:editData.variety===v?"#2d8a2d":"#fff",border:`2px solid ${editData.variety===v?"#2d8a2d":"#d4e8d4"}`,borderRadius:12,padding:"8px 14px",fontSize:14,fontWeight:800,color:editData.variety===v?"#fff":"#2d5a2d",cursor:"pointer"}}
                              onClick={()=>setEditData(p=>({...p,variety:p.variety===v?"":v}))}>
                              {v}
                            </button>
                          ))}
                        </div>
                        {editData.variety && <div style={{marginTop:6,fontSize:13,fontWeight:700,color:"#2d8a2d"}}>✓ Ποικιλία: {editData.variety}</div>}
                      </div>
                    );
                  }
                  return null;
                })()}
                <div className="fg" style={{marginTop:4}}>
                  <button type="button"
                    style={{width:"100%",background:editData.gps_lat&&editData.gps_lng?"#1976d2":"#fff",border:`2px solid ${editData.gps_lat&&editData.gps_lng?"#1976d2":"#b3d9f5"}`,borderRadius:14,padding:"12px 14px",fontWeight:800,fontSize:14,color:editData.gps_lat&&editData.gps_lng?"#fff":"#0d4d92",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}
                    onClick={()=>catchGPS(
                      (v)=>setEditData(p=>({...p,gps_lat:v})),
                      (v)=>setEditData(p=>({...p,gps_lng:v}))
                    )}>
                    {gpsLoading ? "⏳ Φόρτωση..." : (editData.gps_lat&&editData.gps_lng ? `✅ 📍 ${editData.gps_lat}, ${editData.gps_lng}` : "📍 Πιάσε τη θέση μου (GPS)")}
                  </button>
                  {editData.gps_lat && editData.gps_lng && (
                    <button type="button" style={{marginTop:6,background:"transparent",border:"none",color:"#c0392b",fontSize:12,fontWeight:700,cursor:"pointer"}} onClick={()=>setEditData(p=>({...p,gps_lat:null,gps_lng:null}))}>
                      ✕ Αφαίρεση στίγματος
                    </button>
                  )}
                </div>
                <div className="fg" style={{marginTop:4}}>
                  <button type="button"
                    style={{width:"100%",background:editData.is_rented?"#c47a2c":"#fff",border:`2px solid ${editData.is_rented?"#c47a2c":"#d4e8d4"}`,borderRadius:14,padding:"12px 14px",fontWeight:800,fontSize:14,color:editData.is_rented?"#fff":"#2d5a2d",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}
                    onClick={()=>setEditData(p=>({...p,is_rented:!p.is_rented,rent_amount:p.is_rented?"":p.rent_amount}))}>
                    {editData.is_rented?"✅":"⬜"} 🏠 Ενοικιαζόμενο
                  </button>
                </div>
                {editData.is_rented && (
                  <div className="fg">
                    <label className="fl">Ετήσιο Ενοίκιο (€)</label>
                    <input className="fi" type="number" placeholder="π.χ. 800" min="0" step="10"
                      value={editData.rent_amount}
                      onChange={e=>setEditData(p=>({...p,rent_amount:e.target.value}))} />
                  </div>
                )}
                <div className="fg" style={{marginTop:4}}>
                  <button type="button"
                    style={{width:"100%",background:editData.rows_enabled?"#2d8a2d":"#fff",border:`2px solid ${editData.rows_enabled?"#2d8a2d":"#d4e8d4"}`,borderRadius:14,padding:"12px 14px",fontWeight:800,fontSize:14,color:editData.rows_enabled?"#fff":"#2d5a2d",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}
                    onClick={()=>{
                      // Warn if turning off and rows exist
                      const existing = fieldRows.filter(r=>r.field_id===f.id).length;
                      if (editData.rows_enabled && existing > 0) {
                        if (!window.confirm(`Έχεις ήδη ${existing} σειρές. Σίγουρα να απενεργοποιήσεις τη διαχείριση; (οι σειρές παραμένουν αλλά κρύβονται)`)) return;
                      }
                      setEditData(p=>({...p,rows_enabled:!p.rows_enabled}));
                    }}>
                    {editData.rows_enabled?"✅":"⬜"} 🌳 Διαχείριση Σειρών/Δέντρων
                  </button>
                </div>
                {editData.rows_enabled && (
                  <button className="btn" style={{width:"100%",background:"#e8f5e9",color:"#1e5c1e",fontWeight:800,justifyContent:"center",marginTop:4,marginBottom:4}}
                    onClick={()=>{setManageRowsFieldId(f.id);setView("rows");}}>
                    🌳 Διαχείριση Σειρών ({fieldRows.filter(r=>r.field_id===f.id).length})
                  </button>
                )}
                <div style={{display:"flex",gap:8,marginTop:4}}>
                  <button className="btn" style={{flex:1,background:"#2d6a2d",color:"#fff",justifyContent:"center"}} onClick={handleSaveEdit}>✅ Αποθήκευση</button>
                  <button className="btn" style={{background:"#f0f7ee",color:"#2d6a2d"}} onClick={()=>setEditId(null)}>✕</button>
                </div>
              </div>
            ) : (
              <div style={{display:"flex",alignItems:"center"}}>
                <div className="card-icon" style={{background:"#e8f5e9"}}>🌱</div>
                <div style={{flex:1}}>
                  <div className="ctitle">{f.name}</div>
                  <div className="csub">📍 {f.region}{f.parcel_number ? ` · Τεμ. ${f.parcel_number}` : ""}</div>
                  <div className="csub">{f.hectares ? `📐 ${f.hectares} στρ.` : ""}{f.crop ? ` · ${CROPS.find(c=>c.lb===f.crop)?.ic||"🌾"} ${f.crop}${f.variety?` (${f.variety})`:""}`  : ""}</div>
                  {f.is_rented && (
                    <div className="csub" style={{color:"#c47a2c",fontWeight:700}}>🏠 Ενοικιαζόμενο{f.rent_amount?` · ${parseFloat(f.rent_amount).toFixed(0)}€/έτος`:""}</div>
                  )}
                  {TREE_CROPS.some(t=>t===f.crop) && fieldRows.filter(r=>r.field_id===f.id).length > 0 && (
                    <div className="csub">🌳 {fieldRows.filter(r=>r.field_id===f.id).reduce((s,r)=>s+(parseInt(r.total_trees)||0),0)} δέντρα · {fieldRows.filter(r=>r.field_id===f.id).length} σειρές</div>
                  )}
                  {(() => { const fr=fieldRows.filter(r=>r.field_id===f.id); const tt=fr.reduce((s,r)=>s+(parseInt(r.total_trees)||0),0); return tt>0 ? <div className="csub">🌳 {tt} δέντρα · {fr.length} σειρές</div> : null; })()}
                  {f.gps_lat && f.gps_lng && (
                    <div style={{display:"flex",gap:4,marginTop:8,flexWrap:"wrap"}}>
                      <div className="csub" style={{width:"100%",color:"#1976d2",fontWeight:700,marginBottom:4}}>
                        📍 {f.gps_lat}, {f.gps_lng}
                      </div>
                      <button className="btn" style={{background:"#e3f2fd",color:"#0d4d92",fontSize:11,padding:"6px 8px",borderRadius:8,fontWeight:700}}
                        onClick={()=>{
                          const text = `${f.gps_lat},${f.gps_lng}`;
                          navigator.clipboard.writeText(text);
                          alert("📋 Αντιγράφηκε!");
                        }}>📋 Αντιγραφή</button>
                      <button className="btn" style={{background:"#e3f2fd",color:"#0d4d92",fontSize:11,padding:"6px 8px",borderRadius:8,fontWeight:700}}
                        onClick={()=>window.open(`https://www.google.com/maps?q=${f.gps_lat},${f.gps_lng}`,"_blank")}>
                        🗺️ Maps
                      </button>
                      <button className="btn" style={{background:"#e3f2fd",color:"#0d4d92",fontSize:11,padding:"6px 8px",borderRadius:8,fontWeight:700}}
                        onClick={async()=>{
                          const url = `https://www.google.com/maps?q=${f.gps_lat},${f.gps_lng}`;
                          const text = `📍 ${f.name}\n${f.gps_lat},${f.gps_lng}\n${url}`;
                          if (navigator.share) {
                            try { await navigator.share({ title:f.name, text }); } catch(e){}
                          } else {
                            navigator.clipboard.writeText(text);
                            alert("📋 Αντιγράφηκε για κοινοποίηση!");
                          }
                        }}>📤 Κοινοποίηση</button>
                    </div>
                  )}
                </div>
                <div style={{display:"flex",gap:6,flexDirection:"column",alignItems:"flex-end"}}>
                  <div style={{display:"flex",gap:6}}>
                    <button aria-label="Επεξεργασία" className="btn btn-icon" onClick={()=>handleEdit(f)}>✏️</button>
                    <button aria-label="Διαγραφή" className="btn btn-d" onClick={()=>setConfirmId(f.id)}>🗑</button>
                  </div>
                  {isFieldRowsEnabled(f, fieldRows) && (
                    <button className="btn" style={{background:"#e8f5e9",color:"#1e5c1e",fontSize:12,padding:"6px 10px",borderRadius:10}} onClick={()=>{setManageRowsFieldId(f.id);setView("rows");}}>
                      🌳 Σειρές
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
    </div>
  );
}


// ── LOGS TAB (παλιό - διατηρείται για συμβατότητα) ───────────

// ── MACHINES TAB ──────────────────────────────────────────────
function MachinesTab() {
  const { machines, canAdd, addMachine, updateMachine, deleteMachine } = useApp();
  const [show, setShow] = useState(false);
  const [name, setName] = useState(""); const [type, setType] = useState(""); const [plate, setPlate] = useState(""); const [icon, setIcon] = useState("🚜");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState({});
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({});
  const [confirmId, setConfirmId] = useState(null);
  const types = ["Τρακτέρ","Θεριζοαλωνιστική","Ψεκαστήρας","Αντλία","Φορτηγό","Κλαρκ","Πλατφόρμα","Άλλο"];
  const ICONS = ["🚜","🛻","🚛","🔨","🪚","🪓","⚙️","🛠️","🌾","🌿","💦","🪣","⚡","📦"];

  const handle = async () => {
    const e = {};
    if (!name.trim()) e.name = true;
    if (Object.keys(e).length) { setErr(e); setMsg("Συμπλήρωσε τα υποχρεωτικά πεδία"); return; }
    setErr({});
    const ok = await addMachine(name.trim(), type, plate.trim(), icon);
    if (ok) { setName(""); setType(""); setPlate(""); setIcon("🚜"); setShow(false); setMsg(""); setErr({}); }
    else setMsg("Σφάλμα αποθήκευσης.");
  };

  const handleEdit = (m) => { setEditId(m.id); setEditData({ name:m.name||"", type:m.type||"", plate:m.plate||"", icon:m.icon||"🚜" }); };
  const handleSaveEdit = async () => {
    if (!editData.name.trim()) return;
    await updateMachine(editId, editData);
    setEditId(null);
  };
  const upE = (k,v) => setEditData(p=>({...p,[k]:v}));

  return (
    <div>
      {confirmId && <ConfirmDialog msg="Διαγραφή μηχανήματος;" onYes={()=>{deleteMachine(confirmId);setConfirmId(null);}} onNo={()=>setConfirmId(null)} />}
      {window._prevTab === "settings" && (
        <button className="btn" style={{width:"100%",background:"#f0f9f0",color:"#2d8a2d",justifyContent:"center",marginBottom:12,padding:12,fontSize:14,fontWeight:800}} onClick={()=>{window._prevTab=null;window._gotoTab&&window._gotoTab("settings");}}>
          ← Πίσω στις Ρυθμίσεις
        </button>
      )}
      <div className="stitle">🚜 Μηχανήματα <span className="cnt">{machines.length}</span></div>
      {canAdd("machines", machines.length)
        ? <button className="btn btn-p" onClick={()=>setShow(!show)}>{show?"✕ Άκυρο":"➕ Νέο Μηχάνημα"}</button>
        : <UpgradeBox />}
      {show && (
        <div className="aform">
          <div className="aftitle">Νέο Μηχάνημα</div>
          {msg && <div className="msg msg-e">{msg}</div>}
          <div className="fg"><label className="fl">Εικονίδιο</label>
            <div style={{display:"flex",flexWrap:"wrap",gap:8,marginTop:4}}>
              {ICONS.map(ic=>(
                <button key={ic} type="button"
                  style={{background:icon===ic?"#2d8a2d":"#fff",border:`2px solid ${icon===ic?"#2d8a2d":"#d4e8d4"}`,borderRadius:14,padding:"10px 14px",fontSize:24,cursor:"pointer",minWidth:50,minHeight:50}}
                  onClick={()=>setIcon(ic)}>{ic}</button>
              ))}
              <div style={{display:"flex",alignItems:"center",gap:6,background:!ICONS.includes(icon)?"#2d8a2d":"#f0f9f0",border:`2px solid ${!ICONS.includes(icon)?"#2d8a2d":"#d4e8d4"}`,borderRadius:14,padding:"6px 10px"}}>
                <span style={{fontSize:20,color:!ICONS.includes(icon)?"#fff":"#8aaa8a"}}>✏️</span>
                <input type="text" maxLength="2" placeholder="emoji"
                  value={!ICONS.includes(icon)?icon:""}
                  onChange={e=>{const v=e.target.value;if(v)setIcon(v);else setIcon("🚜");}}
                  style={{width:60,border:"none",background:"transparent",fontSize:20,fontWeight:800,color:!ICONS.includes(icon)?"#fff":"#2d5a2d",outline:"none",padding:0}} />
              </div>
            </div>
            <div style={{fontSize:11,color:"#8aaa8a",marginTop:6}}>💡 Διάλεξε από τη λίστα ή γράψε δικό σου emoji</div>
          </div>
          <div className="fg"><label className={`fl${err.name?" error":""}`}>Όνομα *</label>
            <input className={`fi${err.name?" error":""}`} placeholder="π.χ. John Deere 5090" value={name} onChange={e=>{setName(e.target.value);setErr(p=>({...p,name:false}));}} /></div>
          <div className="fg"><label className="fl">Τύπος</label>
            <select className="fi" value={type} onChange={e=>setType(e.target.value)}>
              <option value="">— Επιλογή —</option>
              {types.map(t=><option key={t} value={t}>{t}</option>)}
            </select></div>
          <div className="fg"><label className="fl">Πινακίδα</label>
            <input className="fi" placeholder="π.χ. ΑΒΓ-1234" value={plate} onChange={e=>setPlate(e.target.value)} /></div>
          <button className="btn btn-p" onClick={handle}>✅ Αποθήκευση</button>
        </div>
      )}
      {machines.length === 0 ? <Empty icon="🚜" text="Δεν υπάρχουν μηχανήματα ακόμα" />
        : machines.map(m => (
          <div key={m.id} className="card">
            {editId === m.id ? (
              <div>
                <div className="fg"><label className="fl">Εικονίδιο</label>
                  <div style={{display:"flex",flexWrap:"wrap",gap:8,marginTop:4}}>
                    {ICONS.map(ic=>(
                      <button key={ic} type="button"
                        style={{background:editData.icon===ic?"#2d8a2d":"#fff",border:`2px solid ${editData.icon===ic?"#2d8a2d":"#d4e8d4"}`,borderRadius:14,padding:"10px 14px",fontSize:24,cursor:"pointer",minWidth:50,minHeight:50}}
                        onClick={()=>upE("icon",ic)}>{ic}</button>
                    ))}
                    <div style={{display:"flex",alignItems:"center",gap:6,background:!ICONS.includes(editData.icon)?"#2d8a2d":"#f0f9f0",border:`2px solid ${!ICONS.includes(editData.icon)?"#2d8a2d":"#d4e8d4"}`,borderRadius:14,padding:"6px 10px"}}>
                      <span style={{fontSize:20,color:!ICONS.includes(editData.icon)?"#fff":"#8aaa8a"}}>✏️</span>
                      <input type="text" maxLength="2" placeholder="emoji"
                        value={!ICONS.includes(editData.icon)?editData.icon:""}
                        onChange={e=>{const v=e.target.value;upE("icon", v||"🚜");}}
                        style={{width:60,border:"none",background:"transparent",fontSize:20,fontWeight:800,color:!ICONS.includes(editData.icon)?"#fff":"#2d5a2d",outline:"none",padding:0}} />
                    </div>
                  </div>
                  <div style={{fontSize:11,color:"#8aaa8a",marginTop:6}}>💡 Διάλεξε από τη λίστα ή γράψε δικό σου emoji</div>
                </div>
                <div className="fg"><label className="fl">Όνομα *</label>
                  <input className="fi" value={editData.name} onChange={e=>upE("name",e.target.value)} /></div>
                <div className="fg"><label className="fl">Τύπος</label>
                  <select className="fi" value={editData.type} onChange={e=>upE("type",e.target.value)}>
                    <option value="">— Επιλογή —</option>
                    {types.map(t=><option key={t} value={t}>{t}</option>)}
                  </select></div>
                <div className="fg"><label className="fl">Πινακίδα</label>
                  <input className="fi" value={editData.plate} onChange={e=>upE("plate",e.target.value)} /></div>
                <div style={{display:"flex",gap:8}}>
                  <button className="btn" style={{flex:1,background:"#2d6a2d",color:"#fff",justifyContent:"center"}} onClick={handleSaveEdit}>✅ Αποθήκευση</button>
                  <button className="btn" style={{background:"#f0f7ee",color:"#2d6a2d"}} onClick={()=>setEditId(null)}>✕</button>
                </div>
              </div>
            ) : (
              <div style={{display:"flex",alignItems:"center"}}>
                <div className="card-icon" style={{background:"#e8f0ff"}}>{m.icon||"🚜"}</div>
                <div style={{flex:1}}>
                  <div className="ctitle">{m.name}</div>
                  <div style={{display:"flex",gap:6,marginTop:4,flexWrap:"wrap"}}>
                    {m.type && <span className="tag">⚙️ {m.type}</span>}
                    {m.plate && <span className="tag">🔖 {m.plate}</span>}
                  </div>
                </div>
                <div style={{display:"flex",gap:8}}>
                  <button aria-label="Επεξεργασία" className="btn btn-icon" onClick={()=>handleEdit(m)}>✏️</button>
                  <button aria-label="Διαγραφή" className="btn btn-d" onClick={()=>setConfirmId(m.id)}>🗑</button>
                </div>
              </div>
            )}
          </div>
        ))}
    </div>
  );
}

// ── INVENTORY TAB ─────────────────────────────────────────────
function InventoryTab() {
  const { inventory, canAdd, addInventory, updateInventory, deleteInventory } = useApp();
  const [show, setShow] = useState(false);
  const [f, setF] = useState({ item_name:"", category:"", quantity:"", unit:"", min_stock:"" });
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState({});
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({});
  const [confirmId, setConfirmId] = useState(null);
  const up = (k,v) => { setF(p=>({...p,[k]:v})); setErr(p=>({...p,[k]:false})); };
  const upE = (k,v) => setEditData(p=>({...p,[k]:v}));
  const cats = ["Λιπάσματα","Φυτοφάρμακα","Σπόροι","Καύσιμα","Ανταλλακτικά","Άλλο"];
  const units = ["kg","lt","τεμ","σάκοι","κουτιά"];

  const handle = async () => {
    const e = {};
    if (!f.item_name.trim()) e.item_name = true;
    if (Object.keys(e).length) { setErr(e); setMsg("Συμπλήρωσε τα υποχρεωτικά πεδία"); return; }
    setErr({});
    const ok = await addInventory(f);
    if (ok) { setF({ item_name:"", category:"", quantity:"", unit:"", min_stock:"" }); setShow(false); setMsg(""); setErr({}); }
    else setMsg("Σφάλμα αποθήκευσης.");
  };

  const handleEdit = (i) => { setEditId(i.id); setEditData({ item_name:i.item_name||"", category:i.category||"", quantity:i.quantity||"", unit:i.unit||"", min_stock:i.min_stock||"" }); };
  const handleSaveEdit = async () => {
    if (!editData.item_name.trim()) return;
    await updateInventory(editId, editData);
    setEditId(null);
  };

  return (
    <div>
      {confirmId && <ConfirmDialog msg="Διαγραφή είδους αποθήκης;" onYes={()=>{deleteInventory(confirmId);setConfirmId(null);}} onNo={()=>setConfirmId(null)} />}
      {window._prevTab === "settings" && (
        <button className="btn" style={{width:"100%",background:"#f0f9f0",color:"#2d8a2d",justifyContent:"center",marginBottom:12,padding:12,fontSize:14,fontWeight:800}} onClick={()=>{window._prevTab=null;window._gotoTab&&window._gotoTab("settings");}}>
          ← Πίσω στις Ρυθμίσεις
        </button>
      )}
      <div className="stitle">📦 Αποθήκη <span className="cnt">{inventory.length}</span></div>
      {canAdd("inventory", inventory.length)
        ? <button className="btn btn-p" onClick={()=>setShow(!show)}>{show?"✕ Άκυρο":"➕ Νέο Είδος"}</button>
        : <UpgradeBox />}
      {show && (
        <div className="aform">
          <div className="aftitle">Νέο Είδος Αποθήκης</div>
          {msg && <div className="msg msg-e">{msg}</div>}
          <div className="fg"><label className={`fl${err.item_name?" error":""}`}>Προϊόν *</label>
            <input className={`fi${err.item_name?" error":""}`} placeholder="π.χ. Ουρία 46%" value={f.item_name} onChange={e=>up("item_name",e.target.value)} /></div>
          <div className="fr">
            <div className="fg"><label className="fl">Κατηγορία</label>
              <select className="fi" value={f.category} onChange={e=>up("category",e.target.value)}>
                <option value="">—</option>{cats.map(c=><option key={c} value={c}>{c}</option>)}
              </select></div>
            <div className="fg"><label className="fl">Μονάδα</label>
              <select className="fi" value={f.unit} onChange={e=>up("unit",e.target.value)}>
                <option value="">—</option>{units.map(u=><option key={u} value={u}>{u}</option>)}
              </select></div>
          </div>
          <div className="fr">
            <div className="fg"><label className="fl">Ποσότητα</label>
              <input className="fi" type="number" placeholder="0" value={f.quantity} onChange={e=>up("quantity",e.target.value)} /></div>
            <div className="fg"><label className="fl">Ελάχ. Stock</label>
              <input className="fi" type="number" placeholder="0" value={f.min_stock} onChange={e=>up("min_stock",e.target.value)} /></div>
          </div>
          <button className="btn btn-p" onClick={handle}>✅ Αποθήκευση</button>
        </div>
      )}
      {inventory.length === 0 ? <Empty icon="📦" text="Η αποθήκη είναι άδεια" />
        : inventory.map(i => {
          const low = i.min_stock && parseFloat(i.quantity) <= parseFloat(i.min_stock);
          return (
            <div key={i.id} className="card">
              {editId === i.id ? (
                <div>
                  <div className="fg"><label className="fl">Προϊόν *</label>
                    <input className="fi" value={editData.item_name} onChange={e=>upE("item_name",e.target.value)} /></div>
                  <div className="fr">
                    <div className="fg"><label className="fl">Κατηγορία</label>
                      <select className="fi" value={editData.category} onChange={e=>upE("category",e.target.value)}>
                        <option value="">—</option>{cats.map(c=><option key={c} value={c}>{c}</option>)}
                      </select></div>
                    <div className="fg"><label className="fl">Μονάδα</label>
                      <select className="fi" value={editData.unit} onChange={e=>upE("unit",e.target.value)}>
                        <option value="">—</option>{units.map(u=><option key={u} value={u}>{u}</option>)}
                      </select></div>
                  </div>
                  <div className="fr">
                    <div className="fg"><label className="fl">Ποσότητα</label>
                      <input className="fi" type="number" value={editData.quantity} onChange={e=>upE("quantity",e.target.value)} /></div>
                    <div className="fg"><label className="fl">Ελάχ. Stock</label>
                      <input className="fi" type="number" value={editData.min_stock} onChange={e=>upE("min_stock",e.target.value)} /></div>
                  </div>
                  <div style={{display:"flex",gap:8}}>
                    <button className="btn" style={{flex:1,background:"#2d6a2d",color:"#fff",justifyContent:"center"}} onClick={handleSaveEdit}>✅ Αποθήκευση</button>
                    <button className="btn" style={{background:"#f0f7ee",color:"#2d6a2d"}} onClick={()=>setEditId(null)}>✕</button>
                  </div>
                </div>
              ) : (
                <div style={{display:"flex",alignItems:"center"}}>
                  <div className="card-icon" style={{background:"#fff3e0"}}>📦</div>
                  <div style={{flex:1}}>
                    <div className="ctitle">{i.item_name}</div>
                    <div style={{display:"flex",gap:6,marginTop:4,flexWrap:"wrap"}}>
                      {i.category && <span className="tag">{i.category}</span>}
                      <span className={`tag ${low?"tag-r":""}`}>{low?"⚠️ ":""}{i.quantity||0} {i.unit}{low?" ΧΑΜΗΛΟ":""}</span>
                    </div>
                  </div>
                  <div style={{display:"flex",gap:8}}>
                    <button aria-label="Επεξεργασία" className="btn btn-icon" onClick={()=>handleEdit(i)}>✏️</button>
                    <button aria-label="Διαγραφή" className="btn btn-d" onClick={()=>setConfirmId(i.id)}>🗑</button>
                  </div>
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
}

// ── WORKERS ──────────────────────────────────────────────────
function WorkersTab() {
  const { workers, activities, allActivityWorkers, fields, addWorker, updateWorker, deleteWorker } = useApp();
  const [show, setShow] = useState(false);
  const [statsModal, setStatsModal] = useState(null); // worker for analytics modal
  const [statsPeriod, setStatsPeriod] = useState("month"); // month, year, all, custom
  const [statsFrom, setStatsFrom] = useState(""); const [statsTo, setStatsTo] = useState("");
  const empty = { name:"", phone:"", email:"", amka:"", iban:"", bank:"", daily_rate:"", full_day_rate:"", half_day_rate:"", hourly_rate:"" };
  const [f, setF] = useState(empty);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState({});
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({});
  const [confirmId, setConfirmId] = useState(null);
  const up = (k,v) => { setF(p=>({...p,[k]:v})); setErr(p=>({...p,[k]:false})); };
  const upE = (k,v) => setEditData(p=>({...p,[k]:v}));

  // Compute stats for a worker over a date range
  const computeStats = (workerId, dateFrom, dateTo) => {
    const wInfo = workers.find(w=>w.id===workerId);
    const fullRate = parseFloat(wInfo?.full_day_rate)||0;
    const halfRate = parseFloat(wInfo?.half_day_rate)||0;
    const hourRate = parseFloat(wInfo?.hourly_rate)||0;
    let fullDays=0, halfDays=0, hours=0, total=0;
    const days = [];
    allActivityWorkers.filter(aw=>aw.worker_id===workerId).forEach(aw=>{
      const act = activities.find(a=>a.id===aw.activity_id);
      if (!act || !act.date) return;
      if (dateFrom && act.date < dateFrom) return;
      if (dateTo && act.date > dateTo) return;
      const fullAmt = aw.full_day ? fullRate : 0;
      const halfAmt = aw.half_day ? halfRate : 0;
      const hrsAmt = (parseFloat(aw.hours)||0) * hourRate;
      const dayTotal = fullAmt + halfAmt + hrsAmt;
      if (aw.full_day) fullDays++;
      if (aw.half_day) halfDays++;
      hours += parseFloat(aw.hours)||0;
      total += dayTotal;
      days.push({ date: act.date, full: aw.full_day, half: aw.half_day, hours: aw.hours||0, amount: dayTotal, field_id: act.field_id, activity_type: act.activity_type || act.type || act.category || "", crop: act.crop || "" });
    });
    days.sort((a,b)=>(b.date||"").localeCompare(a.date||""));
    return { fullDays, halfDays, hours, total, days };
  };

  // Current month range
  const monthRange = (() => {
    const now = new Date();
    const first = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,"0")}-01`;
    const last = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,"0")}-31`;
    return { first, last, label: `${["Ιαν","Φεβ","Μαρ","Απρ","Μάι","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ"][now.getMonth()]} ${now.getFullYear()}` };
  })();

  const handle = async () => {
    const e = {};
    if (!f.name.trim()) e.name = true;
    if (Object.keys(e).length) { setErr(e); setMsg("Συμπλήρωσε τουλάχιστον το όνομα"); return; }
    setErr({});
    const ok = await addWorker({ ...f, daily_rate: f.daily_rate ? parseFloat(f.daily_rate) : null, full_day_rate: f.full_day_rate ? parseFloat(f.full_day_rate) : null, half_day_rate: f.half_day_rate ? parseFloat(f.half_day_rate) : null, hourly_rate: f.hourly_rate ? parseFloat(f.hourly_rate) : null });
    if (ok) { setF(empty); setShow(false); setMsg(""); }
    else setMsg("Σφάλμα αποθήκευσης. Δοκίμασε ξανά.");
  };

  const handleEdit = (w) => { setEditId(w.id); setEditData({ name:w.name||"", phone:w.phone||"", email:w.email||"", amka:w.amka||"", iban:w.iban||"", bank:w.bank||"", daily_rate:w.daily_rate||"", full_day_rate:w.full_day_rate||"", half_day_rate:w.half_day_rate||"", hourly_rate:w.hourly_rate||"" }); };
  const handleSaveEdit = async () => {
    if (!editData.name.trim()) return;
    await updateWorker(editId, { ...editData, daily_rate: editData.daily_rate ? parseFloat(editData.daily_rate) : null, full_day_rate: editData.full_day_rate ? parseFloat(editData.full_day_rate) : null, half_day_rate: editData.half_day_rate ? parseFloat(editData.half_day_rate) : null, hourly_rate: editData.hourly_rate ? parseFloat(editData.hourly_rate) : null });
    setEditId(null);
  };

  return (
    <div>
      {confirmId && <ConfirmDialog msg="Διαγραφή εργάτη;" onYes={()=>{deleteWorker(confirmId);setConfirmId(null);}} onNo={()=>setConfirmId(null)} />}
      {window._prevTab === "settings" && (
        <button className="btn" style={{width:"100%",background:"#f0f9f0",color:"#2d8a2d",justifyContent:"center",marginBottom:12,padding:12,fontSize:14,fontWeight:800}} onClick={()=>{window._prevTab=null;window._gotoTab&&window._gotoTab("settings");}}>
          ← Πίσω στις Ρυθμίσεις
        </button>
      )}
      <div className="stitle">👷 Εργάτες <span className="cnt">{workers.length}</span></div>

      <button className="btn btn-p" onClick={()=>setShow(!show)}>{show?"✕ Άκυρο":"➕ Νέος Εργάτης"}</button>

      {show && (
        <div className="aform">
          <div className="aftitle">Νέος Εργάτης</div>
          {msg && <div className="msg msg-e">{msg}</div>}
          <div className="fg"><label className={`fl${err.name?" error":""}`}>Όνομα *</label>
            <input className={`fi${err.name?" error":""}`} placeholder="π.χ. Γιώργης Παπάς" value={f.name} onChange={e=>up("name",e.target.value)} /></div>
          <div className="fr">
            <div className="fg"><label className="fl">Τηλέφωνο</label>
              <input className="fi" placeholder="69xxxxxxxx" value={f.phone} onChange={e=>up("phone",e.target.value)} /></div>
            <div style={{background:"#f0f9f0",borderRadius:14,padding:12,marginBottom:4}}>
            <div style={{fontSize:13,fontWeight:800,color:"#2d8a2d",marginBottom:8}}>💰 Αμοιβές</div>
            <div className="fr">
              <div className="fg"><label className="fl">Ολόκληρο μεροκ. / πρωί (€)</label>
                <input className="fi" type="number" placeholder="π.χ. 60" value={f.full_day_rate||""} onChange={e=>up("full_day_rate",e.target.value)} /></div>
              <div className="fg"><label className="fl">Μισό μεροκ. / απόγευμα (€)</label>
                <input className="fi" type="number" placeholder="π.χ. 35" value={f.half_day_rate||""} onChange={e=>up("half_day_rate",e.target.value)} /></div>
            </div>
            <div className="fg"><label className="fl">Τιμή ώρας (€)</label>
              <input className="fi" type="number" placeholder="π.χ. 8" value={f.hourly_rate||""} onChange={e=>up("hourly_rate",e.target.value)} /></div>
          </div>
          </div>
          <div className="fg"><label className="fl">🆔 ΑΜΚΑ</label>
            <input className="fi" placeholder="11ψήφιος ΑΜΚΑ (για εργόσημα)" maxLength="11" value={f.amka} onChange={e=>up("amka",e.target.value.replace(/\D/g,""))} /></div>
          <div className="fg"><label className="fl">Email</label>
            <input className="fi" type="email" placeholder="email@example.com" value={f.email} onChange={e=>up("email",e.target.value)} /></div>
          <div className="fg"><label className="fl">Τράπεζα</label>
            <input className="fi" placeholder="π.χ. Πειραιώς, Alpha" value={f.bank} onChange={e=>up("bank",e.target.value)} /></div>
          <div className="fg"><label className="fl">IBAN</label>
            <input className="fi" placeholder="GR00 0000 0000 0000 0000 0000 000" value={f.iban} onChange={e=>up("iban",e.target.value)} /></div>
          <button className="btn btn-p" onClick={handle}>✅ Αποθήκευση</button>
        </div>
      )}

      {workers.length === 0 ? <Empty icon="👷" text="Δεν έχετε εργάτες ακόμα" />
        : workers.map(w => (
          <div key={w.id} className="card">
            {editId === w.id ? (
              <div>
                <div className="fg"><label className="fl">Όνομα *</label>
                  <input className="fi" value={editData.name} onChange={e=>upE("name",e.target.value)} /></div>
                <div className="fr">
                  <div className="fg"><label className="fl">Τηλέφωνο</label>
                    <input className="fi" value={editData.phone} onChange={e=>upE("phone",e.target.value)} /></div>
                  <div className="fg"><label className="fl">Email</label>
                    <input className="fi" value={editData.email} onChange={e=>upE("email",e.target.value)} /></div>
                </div>
                <div style={{background:"#f0f7ee",borderRadius:10,padding:12,marginBottom:10}}>
                  <div style={{fontSize:13,fontWeight:800,color:"#2d8a2d",marginBottom:8}}>💰 Αμοιβές</div>
                  <div className="fr">
                    <div className="fg"><label className="fl">Ολόκληρο μεροκ. / πρωί (€)</label>
                      <input className="fi" type="number" placeholder="π.χ. 60" value={editData.full_day_rate} onChange={e=>upE("full_day_rate",e.target.value)} /></div>
                    <div className="fg"><label className="fl">Μισό μεροκ. / απόγευμα (€)</label>
                      <input className="fi" type="number" placeholder="π.χ. 35" value={editData.half_day_rate} onChange={e=>upE("half_day_rate",e.target.value)} /></div>
                  </div>
                  <div className="fg"><label className="fl">Τιμή ώρας (€)</label>
                    <input className="fi" type="number" placeholder="π.χ. 8" value={editData.hourly_rate} onChange={e=>upE("hourly_rate",e.target.value)} /></div>
                </div>
                <div className="fg"><label className="fl">🆔 ΑΜΚΑ</label>
                  <input className="fi" placeholder="11ψήφιος ΑΜΚΑ (για εργόσημα)" maxLength="11" value={editData.amka||""} onChange={e=>upE("amka",e.target.value.replace(/\D/g,""))} /></div>
                <div className="fg"><label className="fl">Τράπεζα</label>
                  <input className="fi" value={editData.bank} onChange={e=>upE("bank",e.target.value)} /></div>
                <div className="fg"><label className="fl">IBAN</label>
                  <input className="fi" value={editData.iban} onChange={e=>upE("iban",e.target.value)} /></div>
                <div style={{display:"flex",gap:8}}>
                  <button className="btn" style={{flex:1,background:"#2d6a2d",color:"#fff",justifyContent:"center"}} onClick={handleSaveEdit}>✅ Αποθήκευση</button>
                  <button className="btn" style={{background:"#f0f7ee",color:"#2d6a2d"}} onClick={()=>setEditId(null)}>✕</button>
                </div>
              </div>
            ) : (
              <div style={{display:"flex",alignItems:"flex-start"}}>
                <div className="card-icon" style={{background:"#fff3e0"}}>👷</div>
                <div style={{flex:1}}>
                  <div className="ctitle">{w.name}</div>
                  <div style={{marginTop:4}}>
                    {w.phone && <div className="csub">📞 {w.phone}</div>}
                    {w.email && <div className="csub">✉️ {w.email}</div>}
                    {w.amka && <div className="csub" style={{fontFamily:"monospace"}}>🆔 ΑΜΚΑ: {w.amka}</div>}
                    {w.full_day_rate && <div className="csub">☀️ Ολόκληρο / πρωί: {w.full_day_rate}€</div>}
                    {w.half_day_rate && <div className="csub">🌤 Μισό / απόγευμα: {w.half_day_rate}€</div>}
                    {w.hourly_rate && <div className="csub">⏱ Ώρα: {w.hourly_rate}€</div>}
                    {w.bank && <div className="csub">🏦 {w.bank}</div>}
                    {w.iban && <div className="csub" style={{fontSize:"12px",letterSpacing:"0.5px",fontFamily:"monospace"}}>IBAN: {w.iban}</div>}
                  </div>
                  {(() => {
                    const st = computeStats(w.id, monthRange.first, monthRange.last);
                    if (st.fullDays===0 && st.halfDays===0 && st.hours===0) return null;
                    return (
                      <div style={{marginTop:10,background:"#f0f9f0",borderLeft:"3px solid #2d8a2d",borderRadius:8,padding:"10px 12px"}}>
                        <div style={{fontSize:11,fontWeight:700,color:"#1e5c1e",marginBottom:6}}>📅 {monthRange.label}</div>
                        <div style={{display:"flex",flexWrap:"wrap",gap:10,fontSize:12,color:"#2d5a2d",marginBottom:6}}>
                          {st.fullDays>0 && <span>☀️ <b>{st.fullDays}</b> ολόκληρα</span>}
                          {st.halfDays>0 && <span>🌤 <b>{st.halfDays}</b> μισά</span>}
                          {st.hours>0 && <span>⏱ <b>{st.hours}</b> ώρες</span>}
                        </div>
                        <div style={{fontSize:15,fontWeight:900,color:"#1e5c1e",marginBottom:6}}>💰 Σύνολο: {st.total.toFixed(2)}€</div>
                        <button className="btn" style={{width:"100%",background:"#2d8a2d",color:"#fff",fontSize:12,fontWeight:800,padding:"6px 10px",borderRadius:8,justifyContent:"center"}}
                          onClick={()=>{setStatsModal(w);setStatsPeriod("month");}}>
                          📊 Αναλυτικά →
                        </button>
                      </div>
                    );
                  })()}
                </div>
                <div style={{display:"flex",gap:8}}>
                  <button aria-label="Επεξεργασία" className="btn btn-icon" onClick={()=>handleEdit(w)}>✏️</button>
                  <button aria-label="Διαγραφή" className="btn btn-d" onClick={()=>setConfirmId(w.id)}>🗑</button>
                </div>
              </div>
            )}
          </div>
        ))}

      {/* Stats Modal */}
      {statsModal && (() => {
        const w = statsModal;
        const today = new Date().toISOString().split("T")[0];
        let from = "", to = today;
        if (statsPeriod === "month") { from = monthRange.first; to = monthRange.last; }
        else if (statsPeriod === "year") { from = `${new Date().getFullYear()}-01-01`; to = `${new Date().getFullYear()}-12-31`; }
        else if (statsPeriod === "all") { from = ""; to = ""; }
        else if (statsPeriod === "custom") { from = statsFrom; to = statsTo; }
        const st = computeStats(w.id, from, to);
        const periodLabel = statsPeriod === "month" ? monthRange.label : statsPeriod === "year" ? new Date().getFullYear()+"" : statsPeriod === "all" ? "Όλα" : `${statsFrom||""} → ${statsTo||""}`;
        return (
          <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.55)",zIndex:1000,display:"flex",alignItems:"flex-start",justifyContent:"center",padding:16,overflowY:"auto"}}
            onClick={()=>setStatsModal(null)}>
            <div style={{background:"#fff",borderRadius:18,padding:18,maxWidth:520,width:"100%",marginTop:20,maxHeight:"90vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <div className="card-icon" style={{background:"#fff3e0"}}>👷</div>
                  <div>
                    <div style={{fontWeight:900,fontSize:18,color:"#1a2e1a"}}>{w.name}</div>
                    {w.phone && <div style={{fontSize:12,color:"#8aaa8a"}}>📞 {w.phone}</div>}
                  </div>
                </div>
                <button className="btn btn-icon" onClick={()=>setStatsModal(null)}>✕</button>
              </div>

              <div style={{display:"flex",gap:6,marginBottom:14,flexWrap:"wrap"}}>
                {[{k:"month",l:"📅 Μήνας"},{k:"year",l:"📆 Έτος"},{k:"all",l:"🗂 Όλα"},{k:"custom",l:"🔍 Custom"}].map(p=>(
                  <button key={p.k} className="btn"
                    style={{flex:"1 1 auto",background:statsPeriod===p.k?"#2d8a2d":"#f0f9f0",color:statsPeriod===p.k?"#fff":"#2d5a2d",fontSize:12,fontWeight:800,padding:"8px 10px",justifyContent:"center"}}
                    onClick={()=>setStatsPeriod(p.k)}>{p.l}</button>
                ))}
              </div>

              {statsPeriod === "custom" && (
                <div className="fr" style={{marginBottom:14}}>
                  <div className="fg"><label className="fl">Από</label>
                    <input className="fi" type="date" value={statsFrom} onChange={e=>setStatsFrom(e.target.value)} /></div>
                  <div className="fg"><label className="fl">Έως</label>
                    <input className="fi" type="date" value={statsTo} onChange={e=>setStatsTo(e.target.value)} /></div>
                </div>
              )}

              <div style={{background:"#f0f9f0",borderRadius:14,padding:14,marginBottom:14}}>
                <div style={{fontSize:12,fontWeight:700,color:"#1e5c1e",marginBottom:8}}>📊 Περίοδος: {periodLabel}</div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:10}}>
                  <div style={{background:"#fff",borderRadius:10,padding:"8px 6px",textAlign:"center"}}>
                    <div style={{fontSize:20,fontWeight:900,color:"#1a2e1a"}}>{st.fullDays}</div>
                    <div style={{fontSize:10,fontWeight:700,color:"#8aaa8a"}}>☀️ Ολόκληρα</div>
                  </div>
                  <div style={{background:"#fff",borderRadius:10,padding:"8px 6px",textAlign:"center"}}>
                    <div style={{fontSize:20,fontWeight:900,color:"#1a2e1a"}}>{st.halfDays}</div>
                    <div style={{fontSize:10,fontWeight:700,color:"#8aaa8a"}}>🌤 Μισά</div>
                  </div>
                  <div style={{background:"#fff",borderRadius:10,padding:"8px 6px",textAlign:"center"}}>
                    <div style={{fontSize:20,fontWeight:900,color:"#1a2e1a"}}>{st.hours}</div>
                    <div style={{fontSize:10,fontWeight:700,color:"#8aaa8a"}}>⏱ Ώρες</div>
                  </div>
                </div>
                <div style={{background:"#2d8a2d",color:"#fff",borderRadius:10,padding:"10px 14px",textAlign:"center"}}>
                  <div style={{fontSize:12,fontWeight:700,opacity:.9}}>💰 Σύνολο για πληρωμή</div>
                  <div style={{fontSize:24,fontWeight:900,marginTop:2}}>{st.total.toFixed(2)} €</div>
                </div>
              </div>

              {st.days.length > 0 ? (
                <>
                  <div style={{fontSize:12,fontWeight:800,color:"#2d5a2d",marginBottom:8}}>📋 Αναλυτικά ({st.days.length} ημέρες)</div>
                  <div style={{maxHeight:300,overflowY:"auto",border:"1px solid #e0eede",borderRadius:10}}>
                    {st.days.map((d,i)=>(
                      <div key={i} style={{padding:"10px 12px",borderBottom:i<st.days.length-1?"1px solid #f0f7ee":"none",display:"flex",justifyContent:"space-between",alignItems:"center",background:i%2===0?"#fff":"#fafcfa"}}>
                        <div>
                          <div style={{fontWeight:700,fontSize:13,color:"#1a2e1a"}}>{d.date}</div>
                          {(d.activity_type || d.field_id) && (
                            <div style={{fontSize:12,color:"#2d6a2d",fontWeight:700,marginTop:1}}>
                              {d.activity_type || "Εργασία"}
                              {d.field_id && (() => { const fl = (fields||[]).find(x=>x.id===d.field_id); return fl ? ` · ${fl.name}` : ""; })()}
                            </div>
                          )}
                          <div style={{fontSize:11,color:"#8aaa8a"}}>
                            {d.full && "☀️ Ολόκληρο "}
                            {d.half && "🌤 Μισό "}
                            {parseFloat(d.hours)>0 && `⏱ ${d.hours}h`}
                          </div>
                        </div>
                        <div style={{fontWeight:900,fontSize:14,color:"#1e5c1e"}}>{d.amount.toFixed(2)}€</div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div style={{textAlign:"center",padding:30,color:"#8aaa8a",fontSize:13}}>
                  Δεν υπάρχουν εργασίες σε αυτή την περίοδο
                </div>
              )}
            </div>
          </div>
        );
      })()}
    </div>
  );
}


// ── ACTIVITY DATA ─────────────────────────────────────────────
const ACTIVITY_CATEGORIES = {
  "🚜 Κατεργασία Εδάφους": {
    scope: "field",
    types: ["Όργωμα","Φρεζάρισμα","Καλλιεργητής","Καταστροφέας","Διαμόρφωση εδάφους","Άλλο"],
  },
  "🌿 Αποψίλωση / Καθαρισμός": {
    scope: "field",
    types: ["Καταστροφέας","Χορτοκοπτικό","Μισινέζα","Χειροκίνητο καθάρισμα","Άλλο"],
  },
  "🌱 Σπορά / Φύτεμα": {
    scope: "field",
    types: ["Σπορά","Φύτεμα δενδρυλλίων","Μεταφύτευση","Άλλο"],
  },
  "✂️ Κλάδεμα": {
    scope: "rows",
    types: ["Κλάδεμα μορφοποίησης","Κλάδεμα καρποφορίας","Αποκορύφωση","Κλάδεμα αναζωογόνησης"],
  },
  "💊 Ψεκασμός": {
    scope: "field",
    types: ["🛡 Προληπτικά","👁 Είδα κάτι","📝 Άλλος λόγος"],
    hasSpray: true,
    isSprayReason: true, // marker so UI can show free text when "Άλλος λόγος"
  },
  "🌿 Λίπανση": {
    scope: "field",
    types: ["Βασική λίπανση","Επιφανειακή λίπανση","Υδρολίπανση","Οργανική λίπανση"],
    hasFertilizer: true,
  },
  "💧 Άρδευση": {
    scope: "field",
    types: ["Στάγδην άρδευση","Καταιονισμός (μπεκ)","Αυλάκια / Πλημμύρα"],
    hasIrrigation: true,
  },
  "🍑 Αραίωμα": {
    scope: "rows",
    types: ["Χειροκίνητο αραίωμα","Χημικό αραίωμα"],
  },
  "🧺 Συγκομιδή": {
    scope: "both",
    types: ["Χειροκίνητη συλλογή","Μηχανική συγκομιδή","Αλογοπλέξιμο / Δέσιμο","Μεταφορά"],
  },
  "🔧 Συντήρηση": {
    scope: "field",
    types: ["Συντήρηση μηχανήματος","Αβαρία μηχανήματος","Συντήρηση δικτύου άρδευσης"],
  },
  "📝 Διάφορα": {
    scope: "field",
    types: ["Παρατήρηση καιρού","Ζημιά από καιρό","Επίσκεψη γεωπόνου","Δειγματοληψία εδάφους"],
  },
};

const TRANSPORT_VEHICLES = [
  {ic:"🚗",lb:"ΙΧ"},
  {ic:"🛻",lb:"Αγροτικό"},
  {ic:"🚜",lb:"Τρακτέρ"},
  {ic:"🚛",lb:"Φορτηγό"},
  {ic:"🏍️",lb:"Μηχανή"},
  {ic:"🚶",lb:"Πεζός"},
];
const SPRAY_TYPES = ["Εντομοκτόνο","Μυκητοκτόνο","Ζιζανιοκτόνο","Ακαρεοκτόνο","Φυλλοδιαφυλλικό","Άλλο"];
const DOSE_UNITS = ["ml/στρ","gr/στρ","lt/στρ","kg/στρ"];
const FERTILIZER_TYPES = ["Αζωτούχο","Φωσφορικό","Καλιούχο","Σύνθετο","Οργανικό","Ασβεστούχο"];
const IRRIGATION_SOURCES = [
  {ic:"⚡",lb:"Ρεύμα"},
  {ic:"🚜",lb:"Τρακτέρ"},
  {ic:"⛽",lb:"Εξωτ. Κινητήρας"},
  {ic:"💧",lb:"TOEB"},
  {ic:"🌊",lb:"Άλλο"},
];


// Mapping καλλιεργειών → σχετικές κατηγορίες εργασίας
const TREE_ACTIVITIES = ["✂️ Κλάδεμα","💊 Ψεκασμός","🌿 Λίπανση","🧺 Συγκομιδή","💧 Άρδευση","🚜 Κατεργασία Εδάφους","🌿 Αποψίλωση / Καθαρισμός","🔧 Συντήρηση","📝 Διάφορα"];
const ARABLE_ACTIVITIES = ["🌱 Σπορά / Φύτεμα","💊 Ψεκασμός","🌿 Λίπανση","🧺 Συγκομιδή","🚜 Κατεργασία Εδάφους","🌿 Αποψίλωση / Καθαρισμός","🔧 Συντήρηση","📝 Διάφορα"];
const VEG_ACTIVITIES   = ["🌱 Σπορά / Φύτεμα","🌿 Αποψίλωση / Καθαρισμός","💊 Ψεκασμός","🌿 Λίπανση","🧺 Συγκομιδή","💧 Άρδευση","🚜 Κατεργασία Εδάφους","📝 Διάφορα"];

const CROP_CATEGORIES = {
  // Δενδρώδεις (σταθερά)
  "Ροδάκινο":   ["✂️ Κλάδεμα","🌿 Αποψίλωση / Καθαρισμός","💊 Ψεκασμός","🌿 Λίπανση","🍑 Αραίωμα","🧺 Συγκομιδή","💧 Άρδευση","🚜 Κατεργασία Εδάφους","🔧 Συντήρηση","📝 Διάφορα"],
  "Μηλιά":      ["✂️ Κλάδεμα","🌿 Αποψίλωση / Καθαρισμός","💊 Ψεκασμός","🌿 Λίπανση","🍑 Αραίωμα","🧺 Συγκομιδή","💧 Άρδευση","🚜 Κατεργασία Εδάφους","🔧 Συντήρηση","📝 Διάφορα"],
  "Αχλάδι":     ["✂️ Κλάδεμα","💊 Ψεκασμός","🌿 Λίπανση","🍑 Αραίωμα","🧺 Συγκομιδή","💧 Άρδευση","🚜 Κατεργασία Εδάφους","🌿 Αποψίλωση / Καθαρισμός","🔧 Συντήρηση","📝 Διάφορα"],
  "Κεράσι":     TREE_ACTIVITIES,
  "Ελιά":       TREE_ACTIVITIES,
  "Αμπέλι":     TREE_ACTIVITIES,
  "Ακτινίδιο":  TREE_ACTIVITIES,
  "Αμυγδαλιά":  TREE_ACTIVITIES,
  // Αροτριαία (σταθερά)
  "Σιτάρι":     ARABLE_ACTIVITIES,
  "Αραβόσιτος": ["🌱 Σπορά / Φύτεμα","💊 Ψεκασμός","🌿 Λίπανση","🧺 Συγκομιδή","💧 Άρδευση","🚜 Κατεργασία Εδάφους","🌿 Αποψίλωση / Καθαρισμός","🔧 Συντήρηση","📝 Διάφορα"],
  "Βαμβάκι":    ["🌱 Σπορά / Φύτεμα","🌿 Αποψίλωση / Καθαρισμός","💊 Ψεκασμός","🌿 Λίπανση","🧺 Συγκομιδή","💧 Άρδευση","🚜 Κατεργασία Εδάφους","🔧 Συντήρηση","📝 Διάφορα"],
  "Τριφύλλι":   ["🌱 Σπορά / Φύτεμα","🌿 Λίπανση","🌿 Αποψίλωση / Καθαρισμός","🧺 Συγκομιδή","💧 Άρδευση","🚜 Κατεργασία Εδάφους","🔧 Συντήρηση","📝 Διάφορα"],
  "Πατάτα":     ["🌱 Σπορά / Φύτεμα","💊 Ψεκασμός","🌿 Λίπανση","🧺 Συγκομιδή","💧 Άρδευση","🚜 Κατεργασία Εδάφους","🌿 Αποψίλωση / Καθαρισμός","🔧 Συντήρηση","📝 Διάφορα"],
  // Δυναμικές κατηγορίες
  "Δενδρώδες":  TREE_ACTIVITIES,
  "Αροτριαίο":  ARABLE_ACTIVITIES,
  "Κηπευτικό":  VEG_ACTIVITIES,
  "Όσπριο":     ARABLE_ACTIVITIES,
};

// Βρες τις κατηγορίες που αφορούν τον χρήστη βάσει των καλλιεργειών του
const getAvailableCategories = (userFields) => {
  const crops = [...new Set(userFields.map(f=>f.crop).filter(Boolean))];
  if (crops.length === 0) return Object.keys(ACTIVITY_CATEGORIES);
  const cats = new Set();
  crops.forEach(crop => {
    const allowed = CROP_CATEGORIES[crop];
    if (allowed) allowed.forEach(c => cats.add(c));
    else Object.keys(ACTIVITY_CATEGORIES).forEach(c => cats.add(c)); // άγνωστη καλλιέργεια → όλες
  });
  // Πάντα να υπάρχουν Συντήρηση & Διάφορα
  cats.add("🔧 Συντήρηση");
  cats.add("📝 Διάφορα");
  return Object.keys(ACTIVITY_CATEGORIES).filter(c => cats.has(c));
};

// ── ACTIVITIES TAB ────────────────────────────────────────────
function ActivitiesTab() {
  const { activities, fields, machines, workers, allActivityWorkers, fieldRows, addActivity, updateActivity, deleteActivity, addFieldRow, updateFieldRow, deleteFieldRow, settings: rawSettings2, settingsLoaded, allSprayProducts, setAllSprayProducts } = useApp();
  const settingsDefaults = { showTransport:true, showMachine:true, showWorkers:true, showSpray:true, showFertilizer:true, showRows:true, showExtraCost:true, cat_katergasia:true, cat_apskilosi:true, cat_spora:true, cat_kladema:true, cat_psekasmos:true, cat_lipansh:true, cat_ardeysh:true, cat_araioma:true, cat_sygkomidh:true, cat_syntirisi:true };
  const settings = {...settingsDefaults, ...(rawSettings2||{})};
  const [view, setView] = useState("list"); // list | new | rows
  const [confirmId, setConfirmId] = useState(null);
  const [manageRowsFieldId, setManageRowsFieldId] = useState(null);
  const [editingActivity, setEditingActivity] = useState(null);
  const [actFilter, setActFilter] = useState("today");
  useEffect(() => { if (window._autoOpenActivity) { window._autoOpenActivity = false; setView("new"); } }, []);
  const [calFrom, setCalFrom] = useState("");
  const [calTo, setCalTo] = useState("");

  // Form state
  const emptyForm = {
    field_ids: [], field_id: "", date: new Date().toISOString().split("T")[0],
    category: "", activity_type: "", scope: "field",
    transport_vehicle: "", transport_fuel_liters: "", transport_fuel_cost: "", use_transport: false,
    machine_id: "", machine_custom: "", machine_fuel_liters: "", machine_fuel_cost: "",
    performed_by: "farmer", hours_total: "", start_time: "", end_time: "",
    notes: "", cost_total: "", extra_cost_notes: "",
    irrigation_source: "", meter_start: "", meter_end: "", irrigation_hours: "",
  };
  const [form, setForm] = useState(emptyForm);
  const [selectedWorkers, setSelectedWorkers] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [sprayProducts, setSprayProducts] = useState([{ product_name:"", product_type:"", reason:"", dose_per_stremma:"", dose_unit:"ml/στρ", water_per_stremma:"", quantity_used:"", cost:"" }]);
  const [fertProducts, setFertProducts] = useState([{ product_name:"", fertilizer_type:"", dose_per_stremma:"", dose_unit:"kg/στρ", quantity_used:"", cost:"" }]);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  // Pre-fill from a note (when user clicked "Καταχώρηση Εργασίας" in NotesTab)
  const { updateNote } = useApp();
  const [noteToComplete, setNoteToComplete] = useState(null);
  useEffect(() => {
    const pre = window._prefillActivity;
    if (pre) {
      const { _noteId, ...prefill } = pre;
      setForm(p => ({ ...p, ...prefill }));
      setNoteToComplete(_noteId || null);
      setView("new");
      window._prefillActivity = null;
    }
  }, []);

  const up = (k,v) => setForm(p=>({...p,[k]:v}));
  const catInfo = ACTIVITY_CATEGORIES[form.category] || {};
  const availableCategories = getAvailableCategories(fields);
  const scopeIsRows = catInfo.scope === "rows";
  // Support both legacy single field_id and new multi field_ids
  const activeFieldIds = (form.field_ids && form.field_ids.length>0) ? form.field_ids : (form.field_id ? [form.field_id] : []);
  const fieldRowsForField = fieldRows.filter(r => activeFieldIds.includes(r.field_id));

  // Frequency-sorted spray product suggestions
  const sprayHistory = (() => {
    const freq = {};
    (allSprayProducts || []).forEach(s => {
      if (!s.product_name) return;
      const key = s.product_name.trim();
      if (!freq[key]) freq[key] = { name: key, count: 0, last: null };
      freq[key].count += 1;
      // Keep the most recent record (for prefill)
      const act = activities.find(a => a.id === s.activity_id);
      const date = act?.date || "";
      if (!freq[key].last || date > freq[key].lastDate) {
        freq[key].last = s;
        freq[key].lastDate = date;
      }
    });
    return Object.values(freq).sort((a,b)=>b.count-a.count);
  })();
  const [sprayFocusIdx, setSprayFocusIdx] = useState(-1);

  const resetForm = () => {
    setForm(emptyForm); setSelectedWorkers([]); setSelectedRows([]);
    setSprayProducts([{ product_name:"", product_type:"", reason:"", dose_per_stremma:"", dose_unit:"ml/στρ", water_per_stremma:"", quantity_used:"", cost:"" }]);
    setFertProducts([{ product_name:"", fertilizer_type:"", dose_per_stremma:"", dose_unit:"kg/στρ", quantity_used:"", cost:"" }]);
    setMsg("");
  };

  const handleSave = async () => {
    if (((!form.field_ids||form.field_ids.length===0) && !form.field_id) || !form.category || !form.activity_type) { setMsg("Συμπλήρωσε αγροτεμάχιο, κατηγορία και εργασία"); return; }
    setSaving(true);
    const toNum = v => v === "" || v === null ? null : parseFloat(v) || null;
    const { use_transport: _ut, ...formData } = form;
    const actData = { ...formData,
      scope: catInfo.scope || "field",
      transport_fuel_liters: toNum(form.transport_fuel_liters),
      transport_fuel_cost: toNum(form.transport_fuel_cost),
      machine_fuel_liters: toNum(form.machine_fuel_liters),
      machine_fuel_cost: toNum(form.machine_fuel_cost),
      hours_total: toNum(form.hours_total),
      cost_total: toNum(form.cost_total),
      machine_id: form.machine_id || null,
      start_time: form.start_time || null,
      end_time: form.end_time || null,
      meter_start: toNum(form.meter_start),
      meter_end: toNum(form.meter_end),
      irrigation_hours: toNum(form.irrigation_hours),
    };
    const wList = (form.performed_by === "farmer") ? [] : selectedWorkers
      .filter(w => w.worker_id || w.worker_name)
      .map(w => ({
        worker_id: w.worker_id === "_custom" ? null : (w.worker_id || null),
        worker_name: w.worker_name || null,
        hours: w.hours ? parseFloat(w.hours) : null,
        daily_rate: w.daily_rate ? parseFloat(w.daily_rate) : null,
        full_day: w.full_day || false,
        half_day: w.half_day || false,
      }));
    const rList = scopeIsRows ? selectedRows.filter(r => r.row_label) : [];
    const sList = catInfo.hasSpray ? sprayProducts.filter(s => s.product_name) : [];
    const fList = catInfo.hasFertilizer ? fertProducts.filter(f => f.product_name) : [];
    const ok = await addActivity(actData, wList, rList, sList, fList);
    setSaving(false);
    if (ok) {
      if (noteToComplete) {
        await updateNote(noteToComplete, { status:"done", completed_at: new Date().toISOString() });
        setNoteToComplete(null);
      }
      resetForm(); setView("list"); window.scrollTo({top:0,behavior:"smooth"});
    }
    else setMsg("Σφάλμα αποθήκευσης. Δοκίμασε ξανά.");
  };

  // Step labels

  if (view === "rows") {
    return <ManageRowsView fieldId={manageRowsFieldId} fields={fields} fieldRows={fieldRows} addFieldRow={addFieldRow} updateFieldRow={updateFieldRow} deleteFieldRow={deleteFieldRow} onBack={()=>setView("list")} />;
  }

  if (view === "new") {
    return (
      <div>
        {/* Header */}
        <button className="btn" style={{width:"100%",background:"#1e5c1e",color:"#fff",padding:14,fontSize:16,fontWeight:900,borderRadius:16,justifyContent:"center",marginBottom:16}} onClick={()=>{resetForm();setView("list");}}>
          ← Πίσω στις Εργασίες
        </button>
        <div className="stitle">📋 Νέα Εργασία</div>

        {msg && <div className="msg msg-e">{msg}</div>}

        {/* Βασικά Στοιχεία */}
        <div className="aform">
            <div className="aftitle">📍 Βασικά Στοιχεία</div>
            <div className="fg"><label className="fl">🌱 Αγροτεμάχια *</label>
              {fields.length === 0 ? (
                <div className="msg msg-w">⚠️ Δεν έχεις καταχωρίσει αγροτεμάχια.</div>
              ) : (
                <div className="cat-grid" style={{marginTop:4}}>
                  {fields.map(f=>{
                    const icon = CROPS?.find(c=>c.lb===f.crop)?.ic || "🌱";
                    const isSelected = (form.field_ids||[]).includes(f.id);
                    return (
                      <button key={f.id} className={`cat-btn ${isSelected?"sel":""}`}
                        onClick={()=>{
                          const cur = form.field_ids||[];
                          const next = cur.includes(f.id) ? cur.filter(x=>x!==f.id) : [...cur,f.id];
                          up("field_ids", next);
                          up("field_id", next[0]||"");
                        }}>
                        <span className="cat-ic">{icon}</span>
                        <span style={{fontSize:12,fontWeight:600,color:isSelected?"#fff":"#1a2e1a",textAlign:"center",lineHeight:1.2}}>{f.name}</span>
                        {f.variety && <span style={{fontSize:11,fontWeight:900,color:isSelected?"#f4c542":"#1e5c1e",textAlign:"center"}}>{f.variety}</span>}
                        {f.region && <span style={{fontSize:10,fontWeight:800,color:isSelected?"rgba(255,255,255,.95)":"#2d5a2d",textAlign:"center"}}>📍{f.region}</span>}
                        {f.hectares && <span style={{fontSize:10,fontWeight:800,color:isSelected?"rgba(255,255,255,.95)":"#2d5a2d"}}>📐{f.hectares}στρ.</span>}
                      </button>
                    );
                  })}
                </div>
              )}
              {(form.field_ids||[]).length > 0 && (
                <div style={{marginTop:8,fontSize:13,fontWeight:700,color:"#2d8a2d"}}>
                  ✓ {(form.field_ids||[]).map(id=>fields.find(f=>f.id===id)?.name||"").join(", ")}
                </div>
              )}
            </div>
            <div className="fg"><label className="fl">Ημερομηνία *</label>
              <input className="fi" type="date" value={form.date} onChange={e=>up("date",e.target.value)} /></div>
            <div className="fg"><label className="fl">Κατηγορία Εργασίας *</label>
              {!settingsLoaded && <div style={{padding:10,color:"#8aaa8a",fontSize:13}}>⏳ Φόρτωση...</div>}
              <div className="cat-grid" style={{display:settingsLoaded?"grid":"none"}}>
                {Object.entries(ACTIVITY_CATEGORIES).filter(([c])=>{
                  if (!availableCategories.includes(c)) return false;
                  const catMap = {
                    "🚜 Κατεργασία Εδάφους": "cat_katergasia",
                    "🌿 Αποψίλωση / Καθαρισμός": "cat_apskilosi",
                    "🌱 Σπορά / Φύτεμα": "cat_spora",
                    "✂️ Κλάδεμα": "cat_kladema",
                    "💊 Ψεκασμός": "cat_psekasmos",
                    "🌿 Λίπανση": "cat_lipansh",
                    "💧 Άρδευση": "cat_ardeysh",
                    "🍑 Αραίωμα": "cat_araioma",
                    "🧺 Συγκομιδή": "cat_sygkomidh",
                    "🔧 Συντήρηση": "cat_syntirisi",
                  };
                  const sk = catMap[c];
                  return sk ? settings[sk] !== false : true;
                }).map(([c, info])=>{
                  const parts = c.split(" ");
                  const ic = parts[0];
                  const lb = parts.slice(1).join(" ");
                  return (
                    <button key={c} className={`cat-btn ${form.category===c?"sel":""}`}
                      onClick={()=>{up("category",c);up("activity_type","");up("machine_custom","");}}>
                      <span className="cat-ic">{ic}</span>
                      <span className="cat-lb">{lb}</span>
                    </button>
                  );
                })}
              </div></div>
            {form.category && (
              <div className="fg"><label className="fl">{catInfo.isSprayReason ? "Λόγος Ψεκασμού *" : "Εργασία *"}</label>
                <div style={{display:"flex",flexWrap:"wrap",gap:8,marginTop:4}}>
                  {catInfo.types.map(t=>(
                    <button key={t} type="button"
                      style={{background:form.activity_type===t || (catInfo.isSprayReason && t==="📝 Άλλος λόγος" && form.activity_type && !catInfo.types.includes(form.activity_type))?"#2d8a2d":"#fff",border:`2px solid ${form.activity_type===t || (catInfo.isSprayReason && t==="📝 Άλλος λόγος" && form.activity_type && !catInfo.types.includes(form.activity_type))?"#2d8a2d":"#d4e8d4"}`,borderRadius:14,padding:"12px 16px",fontSize:14,fontWeight:800,color:form.activity_type===t || (catInfo.isSprayReason && t==="📝 Άλλος λόγος" && form.activity_type && !catInfo.types.includes(form.activity_type))?"#fff":"#2d5a2d",cursor:"pointer",transition:"all .15s"}}
                      onClick={()=>up("activity_type", form.activity_type===t?"":t)}>
                      {t}
                    </button>
                  ))}
                </div>
                {catInfo.isSprayReason && (form.activity_type === "📝 Άλλος λόγος" || (form.activity_type && !catInfo.types.includes(form.activity_type))) && (
                  <input className="fi" style={{marginTop:8}}
                    placeholder="Γράψε τον λόγο..."
                    value={catInfo.types.includes(form.activity_type) ? "" : form.activity_type}
                    onChange={e=>up("activity_type", e.target.value)} />
                )}
                {form.activity_type && !catInfo.isSprayReason && (
                  <div style={{marginTop:8,fontSize:13,fontWeight:700,color:"#2d8a2d"}}>✓ {form.activity_type}</div>
                )}
                {form.activity_type && catInfo.isSprayReason && !catInfo.types.includes(form.activity_type) && (
                  <div style={{marginTop:8,fontSize:13,fontWeight:700,color:"#2d8a2d"}}>✓ {form.activity_type}</div>
                )}
              </div>
            )}
            {scopeIsRows && activeFieldIds.length>0 && fieldRowsForField.length === 0 && (
              <div className="msg msg-w">⚠️ Δεν υπάρχουν σειρές για αυτό το αγροτεμάχιο.
                <span style={{textDecoration:"underline",cursor:"pointer",marginLeft:6}} onClick={()=>{setManageRowsFieldId(activeFieldIds[0]);setView("rows");}}>Πρόσθεσε σειρές →</span>
              </div>
            )}
            <div className="fg"><label className="fl">Σημειώσεις</label>
              <input className="fi" placeholder="Προαιρετικά..." value={form.notes} onChange={e=>up("notes",e.target.value)} /></div>
        </div>

            {catInfo.hasSpray && (
              <div style={{display:settings.showSpray===false?"none":"block"}}>
                <div className="aftitle">💊 Φάρμακα Ψεκασμού</div>
                {sprayProducts.map((sp,idx)=>(
                  <div key={idx} style={{background:"#fff",border:"1.5px solid #e0eede",borderRadius:12,padding:12,marginBottom:10}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                      <span style={{fontWeight:700,fontSize:13,color:"#2d6a2d"}}>Φάρμακο {idx+1}</span>
                      {idx>0 && <button aria-label="Διαγραφή" className="btn btn-d" style={{padding:"4px 8px",fontSize:12}} onClick={()=>setSprayProducts(sprayProducts.filter((_,i)=>i!==idx))}>✕</button>}
                    </div>
                    <div className="fg" style={{position:"relative"}}><label className="fl">Όνομα φαρμάκου</label>
                      <input className="fi" placeholder="π.χ. Calypso SC" autoComplete="off"
                        value={sp.product_name}
                        onFocus={()=>setSprayFocusIdx(idx)}
                        onBlur={()=>setTimeout(()=>setSprayFocusIdx(-1),200)}
                        onChange={e=>{const n=[...sprayProducts];n[idx]={...n[idx],product_name:e.target.value};setSprayProducts(n);}} />
                      {sprayFocusIdx===idx && sprayHistory.length > 0 && (() => {
                        const q = (sp.product_name||"").trim().toLowerCase();
                        const matches = sprayHistory.filter(h => !q || h.name.toLowerCase().includes(q)).slice(0,6);
                        if (matches.length === 0) return null;
                        return (
                          <div style={{position:"absolute",top:"100%",left:0,right:0,background:"#fff",border:"1.5px solid #d4e8d4",borderRadius:10,marginTop:4,maxHeight:240,overflowY:"auto",zIndex:10,boxShadow:"0 4px 12px rgba(0,0,0,0.1)"}}>
                            {matches.map((h,hi)=>(
                              <div key={hi}
                                style={{padding:"10px 12px",cursor:"pointer",borderBottom:hi<matches.length-1?"1px solid #f0f7ee":"none",background:"#fff"}}
                                onMouseEnter={e=>e.currentTarget.style.background="#f0f9f0"}
                                onMouseLeave={e=>e.currentTarget.style.background="#fff"}
                                onMouseDown={(e)=>{
                                  e.preventDefault();
                                  const n=[...sprayProducts];
                                  n[idx]={
                                    ...n[idx],
                                    product_name: h.name,
                                    product_type: h.last?.product_type || n[idx].product_type,
                                    dose_per_stremma: h.last?.dose_per_stremma || n[idx].dose_per_stremma,
                                    dose_unit: h.last?.dose_unit || n[idx].dose_unit || "ml/στρ",
                                  };
                                  setSprayProducts(n);
                                  setSprayFocusIdx(-1);
                                }}>
                                <div style={{fontSize:14,fontWeight:800,color:"#1a2e1a"}}>💊 {h.name}</div>
                                <div style={{fontSize:11,color:"#8aaa8a",marginTop:2}}>
                                  {h.last?.product_type && <>{h.last.product_type} · </>}{h.count} {h.count===1?"φορά":"φορές"}
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      })()}
                    </div>
                    <div className="fg"><label className="fl">Τύπος φαρμάκου (πολλαπλή επιλογή)</label>
                      <div style={{display:"flex",flexWrap:"wrap",gap:6,marginTop:4}}>
                        {SPRAY_TYPES.map(t=>{
                          const types = (sp.product_type||"").split(",").map(x=>x.trim()).filter(Boolean);
                          const sel = types.includes(t);
                          return (
                            <button key={t} type="button"
                              style={{background:sel?"#2d8a2d":"#fff",border:`1.5px solid ${sel?"#2d8a2d":"#d4e8d4"}`,borderRadius:10,padding:"6px 12px",fontSize:12,fontWeight:800,color:sel?"#fff":"#2d5a2d",cursor:"pointer"}}
                              onClick={()=>{
                                const cur = (sp.product_type||"").split(",").map(x=>x.trim()).filter(Boolean);
                                const next = cur.includes(t)?cur.filter(x=>x!==t):[...cur,t];
                                const n=[...sprayProducts];n[idx]={...n[idx],product_type:next.join(", ")};setSprayProducts(n);
                              }}>
                              {t}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                    <div className="fr">
                      <div className="fg" style={{display:"none"}}></div>
                      <div className="fg"><label className="fl">Μονάδα δόσης</label>
                        <select className="fi" value={sp.dose_unit} onChange={e=>{const n=[...sprayProducts];n[idx]={...n[idx],dose_unit:e.target.value};setSprayProducts(n);}}>
                          {DOSE_UNITS.map(u=><option key={u} value={u}>{u}</option>)}
                        </select></div>
                    </div>
                    <div className="fg"><label className="fl">Αιτία ψεκασμού</label>
                      <input className="fi" placeholder="π.χ. Μονίλια, Θρίπας..." value={sp.reason} onChange={e=>{const n=[...sprayProducts];n[idx]={...n[idx],reason:e.target.value};setSprayProducts(n);}} /></div>
                    <div className="fr">
                      <div className="fg"><label className="fl">Δόση/στρ</label>
                        <input className="fi" type="number" placeholder="0" value={sp.dose_per_stremma} onChange={e=>{const n=[...sprayProducts];n[idx]={...n[idx],dose_per_stremma:e.target.value};setSprayProducts(n);}} /></div>
                      <div className="fg"><label className="fl">Νερό/στρ (lt)</label>
                        <input className="fi" type="number" placeholder="0" value={sp.water_per_stremma} onChange={e=>{const n=[...sprayProducts];n[idx]={...n[idx],water_per_stremma:e.target.value};setSprayProducts(n);}} /></div>
                    </div>
                    <div className="fr">
                      <div className="fg"><label className="fl">Ποσότητα που χρησιμοποιήθηκε</label>
                        <input className="fi" type="number" placeholder="0" value={sp.quantity_used} onChange={e=>{const n=[...sprayProducts];n[idx]={...n[idx],quantity_used:e.target.value};setSprayProducts(n);}} /></div>
                      <div className="fg"><label className="fl">Κόστος (€)</label>
                        <input className="fi" type="number" placeholder="0" value={sp.cost} onChange={e=>{const n=[...sprayProducts];n[idx]={...n[idx],cost:e.target.value};setSprayProducts(n);}} /></div>
                    </div>
                  </div>
                ))}
                <button className="btn" style={{background:"#e8f5e9",color:"#2d6a2d",fontSize:13,marginBottom:10}} onClick={()=>setSprayProducts([...sprayProducts,{product_name:"",product_type:"",reason:"",dose_per_stremma:"",dose_unit:"ml/στρ",water_per_stremma:"",quantity_used:"",cost:""}])}>➕ Άλλο φάρμακο</button>
              </div>
            )}

            {/* ΛΙΠΑΝΣΗ */}
            {catInfo.hasFertilizer && (
              <div style={{display:settings.showFertilizer===false?"none":"block"}}>
                <div className="aftitle">🌿 Λιπάσματα</div>
                {fertProducts.map((fp,idx)=>(
                  <div key={idx} style={{background:"#fff",border:"1.5px solid #e0eede",borderRadius:12,padding:12,marginBottom:10}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                      <span style={{fontWeight:700,fontSize:13,color:"#2d6a2d"}}>Λίπασμα {idx+1}</span>
                      {idx>0 && <button aria-label="Διαγραφή" className="btn btn-d" style={{padding:"4px 8px",fontSize:12}} onClick={()=>setFertProducts(fertProducts.filter((_,i)=>i!==idx))}>✕</button>}
                    </div>
                    <div className="fg"><label className="fl">Όνομα λιπάσματος</label>
                      <input className="fi" placeholder="π.χ. Ουρία 46%" value={fp.product_name} onChange={e=>{const n=[...fertProducts];n[idx]={...n[idx],product_name:e.target.value};setFertProducts(n);}} /></div>
                    <div className="fr">
                      <div className="fg"><label className="fl">Τύπος</label>
                        <select className="fi" value={fp.fertilizer_type} onChange={e=>{const n=[...fertProducts];n[idx]={...n[idx],fertilizer_type:e.target.value};setFertProducts(n);}}>
                          <option value="">—</option>{FERTILIZER_TYPES.map(t=><option key={t} value={t}>{t}</option>)}
                        </select></div>
                      <div className="fg"><label className="fl">Μονάδα</label>
                        <select className="fi" value={fp.dose_unit} onChange={e=>{const n=[...fertProducts];n[idx]={...n[idx],dose_unit:e.target.value};setFertProducts(n);}}>
                          {["kg/στρ","lt/στρ","gr/στρ"].map(u=><option key={u} value={u}>{u}</option>)}
                        </select></div>
                    </div>
                    <div className="fr">
                      <div className="fg"><label className="fl">Δόση/στρ</label>
                        <input className="fi" type="number" placeholder="0" value={fp.dose_per_stremma} onChange={e=>{const n=[...fertProducts];n[idx]={...n[idx],dose_per_stremma:e.target.value};setFertProducts(n);}} /></div>
                      <div className="fg"><label className="fl">Κόστος (€)</label>
                        <input className="fi" type="number" placeholder="0" value={fp.cost} onChange={e=>{const n=[...fertProducts];n[idx]={...n[idx],cost:e.target.value};setFertProducts(n);}} /></div>
                    </div>
                  </div>
                ))}
                <button className="btn" style={{background:"#e8f5e9",color:"#2d6a2d",fontSize:13,marginBottom:10}} onClick={()=>setFertProducts([...fertProducts,{product_name:"",fertilizer_type:"",dose_per_stremma:"",dose_unit:"kg/στρ",quantity_used:"",cost:""}])}>➕ Άλλο λίπασμα</button>
              </div>
            )}


        {/* Μεταφορά & Μηχάνημα */}
        <div className="aform">
            <div className="aftitle">🚗 Μεταφορά & Μηχάνημα</div>
            <div className="fg" style={{display:settings.showTransport===false?"none":"block"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                <label className="fl" style={{margin:0}}>🚗 Χρησιμοποιήθηκε μέσο μετακίνησης;</label>
                <button type="button"
                  style={{background:form.use_transport?"#2d8a2d":"#e0e0e0",border:"none",borderRadius:20,width:52,height:28,cursor:"pointer",position:"relative",transition:"all .2s"}}
                  onClick={()=>up("use_transport",!form.use_transport)}>
                  <span style={{position:"absolute",top:3,left:form.use_transport?26:4,width:22,height:22,background:"#fff",borderRadius:"50%",transition:"all .2s",display:"block"}}/>
                </button>
              </div>
              {form.use_transport && (
                <>
                  <div style={{display:"flex",flexWrap:"wrap",gap:8,marginTop:4}}>
                    {TRANSPORT_VEHICLES.map(v=>{
                      const selected = (form.transport_vehicle||"").split(",").map(s=>s.trim()).includes(v.lb);
                      return (
                        <button key={v.lb} type="button"
                          style={{background:selected?"#2d8a2d":"#fff",border:`2px solid ${selected?"#2d8a2d":"#d4e8d4"}`,borderRadius:14,padding:"10px 14px",display:"flex",flexDirection:"column",alignItems:"center",gap:4,cursor:"pointer",minWidth:64,transition:"all .15s"}}
                          onClick={()=>{
                            const cur = (form.transport_vehicle||"").split(",").map(s=>s.trim()).filter(Boolean);
                            const next = cur.includes(v.lb) ? cur.filter(x=>x!==v.lb) : [...cur,v.lb];
                            up("transport_vehicle", next.join(", "));
                          }}>
                          <span style={{fontSize:24}}>{v.ic}</span>
                          <span style={{fontSize:11,fontWeight:800,color:selected?"#fff":"#2d5a2d"}}>{v.lb}</span>
                        </button>
                      );
                    })}
                  </div>
                  <div className="fg" style={{marginTop:10}}>
                    <label className="fl">Κόστος καυσίμου (€)</label>
                    <input className="fi" type="number" placeholder="0" value={form.transport_fuel_cost} onChange={e=>up("transport_fuel_cost",e.target.value)} />
                  </div>
                </>
              )}
            </div>
            {machines.length > 0 && (
              <div style={{display:settings.showMachine===false?"none":"block"}}>
                <div className="fg"><label className="fl">🚜 Μηχάνημα Εργασίας</label>
                  <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginTop:4}}>
                    {machines.map(m=>{
                      const selected = (form.machine_custom||"").split(",").map(s=>s.trim()).includes(m.name);
                        return (
                          <button key={m.id} type="button"
                            style={{background:selected?"#2d8a2d":"#fff",border:`2px solid ${selected?"#2d8a2d":"#d4e8d4"}`,borderRadius:14,padding:"10px 4px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:4,cursor:"pointer",height:96,overflow:"hidden",transition:"all .15s"}}
                            onClick={()=>{
                              const cur = (form.machine_custom||"").split(",").map(s=>s.trim()).filter(Boolean);
                              const next = cur.includes(m.name) ? cur.filter(x=>x!==m.name) : [...cur,m.name];
                              up("machine_custom", next.join(", "));
                            }}>
                            <span style={{fontSize:22,lineHeight:1}}>{m.icon||"🚜"}</span>
                            <span style={{fontSize:11,fontWeight:800,color:selected?"#fff":"#2d5a2d",textAlign:"center",lineHeight:1.15,display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden",wordBreak:"break-word"}}>{m.name}</span>
                            {m.type && <span style={{fontSize:10,color:selected?"rgba(255,255,255,.7)":"#8aaa8a",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:"100%"}}>{m.type}</span>}
                          </button>
                        );
                      })}
                  </div>
                </div>
                <div className="fg"><label className="fl">Κόστος καυσίμου μηχανήματος (€)</label>
                  <input className="fi" type="number" placeholder="0" value={form.machine_fuel_cost} onChange={e=>up("machine_fuel_cost",e.target.value)} />
                </div>
              </div>
            )}
        </div>

        <div className="aform" style={{display:settings.showWorkers===false?"none":"block"}}>
            <div className="aftitle">👷 Προσωπικό & Ώρες</div>
            <div className="fg"><label className="fl">Ποιος εργάστηκε;</label>
              <div className="who-grid">
                {[
                  {v:"farmer", ic:"🧑‍🌾", lb:"Μόνο αγρότης"},
                  {v:"workers", ic:"👷", lb:"Εργάτες"},
                  {v:"both", ic:"👥", lb:"Αγρότης + Εργάτες"},
                ].map(w=>(
                  <button key={w.v} className={`who-btn ${form.performed_by===w.v?"sel":""}`} onClick={()=>up("performed_by",w.v)}>
                    <span className="who-ic">{w.ic}</span>
                    <span className="who-lb">{w.lb}</span>
                  </button>
                ))}
              </div></div>
            <div className="fr">
              <div className="fg"><label className="fl">Ώρες εργασίας</label>
                <input className="fi" type="number" placeholder="π.χ. 4" min="0" value={form.hours_total} onChange={e=>up("hours_total",e.target.value)} /></div>
              <div className="fg"><label className="fl">Ώρα έναρξης</label>
                <input className="fi" type="time" value={form.start_time} onChange={e=>up("start_time",e.target.value)} /></div>
            </div>

            {(form.performed_by==="workers"||form.performed_by==="both") && (
              <div style={{marginTop:8}}>
                <div className="aftitle" style={{fontSize:13,marginBottom:10}}>👷 Εργάτες που συμμετείχαν</div>
                {workers.length === 0 ? (
                  <div className="msg msg-w">⚠️ Δεν έχεις καταχωρίσει εργάτες. Πήγαινε στο tab Εργάτες.</div>
                ) : (
                  <>
                    {/* Κουμπιά επιλογής εργάτη */}
                    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:12}}>
                      {workers.map(w=>{
                        const sel = selectedWorkers.find(x=>x.worker_id===w.id);
                        return (
                          <button key={w.id} type="button"
                            style={{background:sel?"#2d8a2d":"#fff",border:`2px solid ${sel?"#2d8a2d":"#d4e8d4"}`,borderRadius:14,padding:"10px 4px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:4,cursor:"pointer",height:96,transition:"all .15s",overflow:"hidden"}}
                            onClick={()=>{
                              if(sel) setSelectedWorkers(selectedWorkers.filter(x=>x.worker_id!==w.id));
                              else setSelectedWorkers([...selectedWorkers,{worker_id:w.id,worker_name:w.name,full_day:false,half_day:false,hours:"",full_day_rate:w.full_day_rate||"",half_day_rate:w.half_day_rate||"",hourly_rate:w.hourly_rate||""}]);
                            }}>
                            <span style={{fontSize:22,lineHeight:1}}>👷</span>
                            <span style={{fontSize:11,fontWeight:800,color:sel?"#fff":"#2d5a2d",textAlign:"center",lineHeight:1.15,display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden",wordBreak:"break-word"}}>{w.name}</span>
                            {w.daily_rate && <span style={{fontSize:10,color:sel?"rgba(255,255,255,.8)":"#8aaa8a"}}>{w.daily_rate}€/ημ.</span>}
                            {sel && <span style={{fontSize:10,color:"#f4c542",fontWeight:800}}>✓</span>}
                          </button>
                        );
                      })}
                    </div>
                    {/* Ώρες & Μεροκάματο ανά εργάτη */}
                    {selectedWorkers.length > 0 && (
                      <div style={{background:"#f0f9f0",borderRadius:12,padding:12}}>
                        <div style={{fontSize:13,fontWeight:700,color:"#2d8a2d",marginBottom:10}}>Ώρες & Μεροκάματο ανά εργάτη:</div>
                        {selectedWorkers.filter(sw=>sw.worker_id!=="_custom").map((sw,idx)=>{
                          const fullAmt = sw.full_day ? (parseFloat(sw.full_day_rate)||0) : 0;
                          const halfAmt = sw.half_day ? (parseFloat(sw.half_day_rate)||0) : 0;
                          const hoursAmt = (parseFloat(sw.hours)||0) * (parseFloat(sw.hourly_rate)||0);
                          const total = fullAmt + halfAmt + hoursAmt;
                          return (
                          <div key={idx} style={{marginBottom:12,background:"#fff",borderRadius:12,padding:12,border:"1.5px solid #e0eede"}}>
                            <div style={{fontWeight:800,fontSize:15,color:"#1a2e1a",marginBottom:10}}>👷 {sw.worker_name}</div>
                            {/* Ολόκληρο */}
                            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8,padding:"10px 12px",background:sw.full_day?"#e8f5e9":"#f5f5f5",borderRadius:10,border:`2px solid ${sw.full_day?"#2d8a2d":"#e0e0e0"}`,cursor:"pointer"}}
                              onClick={()=>{const nw=[...selectedWorkers];nw[idx]={...nw[idx],full_day:!nw[idx].full_day};setSelectedWorkers(nw);}}>
                              <span style={{fontWeight:700,fontSize:14,color:sw.full_day?"#1e5c1e":"#666"}}>☀️ Ολόκληρο μεροκάματο / πρωί</span>
                              <div style={{display:"flex",alignItems:"center",gap:8}}>
                                {sw.full_day_rate && <span style={{fontWeight:800,color:"#1e5c1e"}}>{sw.full_day_rate}€</span>}
                                <span style={{fontSize:20}}>{sw.full_day?"✅":"○"}</span>
                              </div>
                            </div>
                            {/* Μισό */}
                            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8,padding:"10px 12px",background:sw.half_day?"#e8f5e9":"#f5f5f5",borderRadius:10,border:`2px solid ${sw.half_day?"#2d8a2d":"#e0e0e0"}`,cursor:"pointer"}}
                              onClick={()=>{const nw=[...selectedWorkers];nw[idx]={...nw[idx],half_day:!nw[idx].half_day};setSelectedWorkers(nw);}}>
                              <span style={{fontWeight:700,fontSize:14,color:sw.half_day?"#1e5c1e":"#666"}}>🌤 Μισό μεροκάματο / απόγευμα</span>
                              <div style={{display:"flex",alignItems:"center",gap:8}}>
                                {sw.half_day_rate && <span style={{fontWeight:800,color:"#1e5c1e"}}>{sw.half_day_rate}€</span>}
                                <span style={{fontSize:20}}>{sw.half_day?"✅":"○"}</span>
                              </div>
                            </div>
                            {/* Ώρες επιπλέον */}
                            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                              <span style={{fontWeight:700,fontSize:14,color:"#666",flex:1}}>⏱ Ώρες επιπλέον</span>
                              <input className="fi" style={{width:70}} type="number" min="0" placeholder="0" value={sw.hours||""} onChange={e=>{const nw=[...selectedWorkers];nw[idx]={...nw[idx],hours:e.target.value};setSelectedWorkers(nw);}} />
                              {sw.hourly_rate && <span style={{fontSize:12,color:"#6b8c6b",fontWeight:700}}>× {sw.hourly_rate}€</span>}
                            </div>
                            {/* Σύνολο */}
                            {total > 0 && (
                              <div style={{background:"#2d8a2d",borderRadius:10,padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                                <span style={{color:"#fff",fontWeight:700,fontSize:13}}>Σύνολο ημέρας:</span>
                                <span style={{color:"#f4c542",fontWeight:900,fontSize:18}}>💰 {total.toFixed(2)}€</span>
                              </div>
                            )}
                          </div>
                          );
                        })}
                      </div>
                    )}
                    {/* Άλλος εργάτης */}
                    <button className="btn" style={{background:"rgba(255,255,255,.5)",border:"1.5px dashed #b0d4b0",color:"#2d5a2d",fontSize:13,marginTop:8,width:"100%",justifyContent:"center"}} onClick={()=>setSelectedWorkers([...selectedWorkers,{worker_id:"_custom",worker_name:"",hours:"",daily_rate:""}])}>
                      ➕ Άλλος εργάτης (χωρίς καταχώριση)
                    </button>
                    {selectedWorkers.filter(sw=>sw.worker_id==="_custom").map((sw,idx)=>(
                      <div key={"c"+idx} style={{display:"flex",gap:8,marginTop:8,alignItems:"center"}}>
                        <input className="fi" style={{flex:2}} placeholder="Όνομα εργάτη" value={sw.worker_name||""} onChange={e=>{const nw=[...selectedWorkers];const ci=nw.findIndex((x,i)=>x.worker_id==="_custom"&&i===selectedWorkers.filter(x=>x.worker_id==="_custom").indexOf(sw)+selectedWorkers.filter(x=>x.worker_id!=="_custom").length);nw[ci]={...nw[ci],worker_name:e.target.value};setSelectedWorkers(nw);}} />
                        <input className="fi" style={{width:80}} type="number" placeholder="Ώρες" value={sw.hours||""} onChange={e=>{const nw=[...selectedWorkers];const ci=nw.indexOf(sw);nw[ci]={...nw[ci],hours:e.target.value};setSelectedWorkers(nw);}} />
                        <button aria-label="Διαγραφή" className="btn btn-d" style={{padding:"6px 10px"}} onClick={()=>setSelectedWorkers(selectedWorkers.filter(x=>x!==sw))}>✕</button>
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}

        </div>

        {/* Ειδικά Πεδία */}
        <div className="aform">
            {/* ΨΕΚΑΣΜΟΣ */}

            {/* ΣΕΙΡΕΣ */}
            {scopeIsRows && (
              <>
                <div className="aftitle">🌳 Σειρές που Δουλεύτηκαν</div>
                {fieldRowsForField.length === 0 ? (
                  <div className="msg msg-w">⚠️ Δεν υπάρχουν σειρές.
                    <span style={{textDecoration:"underline",cursor:"pointer",marginLeft:6}} onClick={()=>{setManageRowsFieldId(activeFieldIds[0]);setView("rows");}}>Πρόσθεσε σειρές →</span>
                  </div>
                ) : (
                  <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:12}}>
                    {fieldRowsForField.map(r=>{
                      const sel = selectedRows.find(x=>x.row_id===r.id);
                      const fieldName = activeFieldIds.length > 1 ? (fields.find(f=>f.id===r.field_id)?.name||"") : "";
                      return (
                        <button key={r.id} className="btn" style={{background:sel?"#2d6a2d":"#f0f7ee",color:sel?"#fff":"#2d6a2d",padding:"8px 14px",fontSize:13}} onClick={()=>{
                          if(sel) setSelectedRows(selectedRows.filter(x=>x.row_id!==r.id));
                          else setSelectedRows([...selectedRows,{row_id:r.id,row_label:r.row_label,trees_done:r.total_trees||0}]);
                        }}>
                          {fieldName && <span style={{opacity:.7,fontSize:11}}>{fieldName} · </span>}Σειρά {r.row_label} {r.total_trees?`(${r.total_trees} δ.)`:""} {sel?"✓":""}
                        </button>
                      );
                    })}
                  </div>
                )}
              </>
            )}

            {/* Άρδευση: Πηγή + kWh */}
            {catInfo.hasIrrigation && (
              <div style={{background:"#e3f2fd",borderRadius:14,padding:14,marginBottom:12}}>
                <div className="aftitle" style={{marginBottom:10}}>💧 Πηγή Άρδευσης</div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:10}}>
                  {IRRIGATION_SOURCES.map(s=>{
                    const sel = form.irrigation_source === s.lb;
                    return (
                      <button key={s.lb} type="button"
                        style={{background:sel?"#1976d2":"#fff",border:`2px solid ${sel?"#1976d2":"#b3d9f5"}`,borderRadius:14,padding:"10px 4px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:4,cursor:"pointer",height:78}}
                        onClick={()=>up("irrigation_source", sel?"":s.lb)}>
                        <span style={{fontSize:22,lineHeight:1}}>{s.ic}</span>
                        <span style={{fontSize:11,fontWeight:800,color:sel?"#fff":"#0d4d92",textAlign:"center",lineHeight:1.15}}>{s.lb}</span>
                      </button>
                    );
                  })}
                </div>
                {form.irrigation_source === "Ρεύμα" && (
                  <>
                    <div className="fr">
                      <div className="fg"><label className="fl">🔢 Μετρητής Αρχή (kWh)</label>
                        <input className="fi" type="number" min="0" placeholder="π.χ. 12450" value={form.meter_start||""} onChange={e=>up("meter_start",e.target.value)} /></div>
                      <div className="fg"><label className="fl">🔢 Μετρητής Τέλος (kWh)</label>
                        <input className="fi" type="number" min="0" placeholder="π.χ. 12565" value={form.meter_end||""} onChange={e=>up("meter_end",e.target.value)} /></div>
                    </div>
                    {form.meter_start && form.meter_end && (parseFloat(form.meter_end) > parseFloat(form.meter_start)) && (
                      <div style={{background:"#fff",borderRadius:10,padding:"8px 12px",fontSize:13,fontWeight:700,color:"#1976d2"}}>
                        ⚡ Κατανάλωση: {(parseFloat(form.meter_end)-parseFloat(form.meter_start)).toFixed(1)} kWh
                      </div>
                    )}
                  </>
                )}
                <div className="fg" style={{marginTop:10}}>
                  <label className="fl">⏱ Διάρκεια άρδευσης (ώρες)</label>
                  <input className="fi" type="number" step="0.5" min="0" placeholder="π.χ. 20" value={form.irrigation_hours||""} onChange={e=>up("irrigation_hours",e.target.value)} />
                  <div style={{fontSize:11,color:"#8aaa8a",marginTop:4,fontStyle:"italic"}}>Πόσες ώρες έτρεξε η βάνα/αντλία (όχι ώρες παρουσίας)</div>
                </div>
              </div>
            )}

            {/* Αν δεν έχει ειδικά πεδία */}
            {!catInfo.hasSpray && !catInfo.hasFertilizer && !scopeIsRows && (
              <>
                <div className="fg"><label className="fl">💸 Κόστος αβαρίας / Άλλα έξοδα (€)</label>
                  <input className="fi" type="number" placeholder="0" value={form.cost_total} onChange={e=>up("cost_total",e.target.value)} /></div>
                {(parseFloat(form.cost_total)||0) > 0 && (
                  <div className="fg"><label className="fl">📝 Αιτία αβαρίας</label>
                    <input className="fi" placeholder="π.χ. Σπασμένο λάστιχο, Έκτακτα καύσιμα..." value={form.extra_cost_notes||""} onChange={e=>up("extra_cost_notes",e.target.value)} /></div>
                )}
              </>
            )}

        </div>

        {/* Αποθήκευση */}
        {msg && <div className="msg msg-e">{msg}</div>}
        <button className="btn btn-p" style={{fontSize:18,padding:18}} onClick={handleSave} disabled={saving}>
          {saving?"⏳ Αποθήκευση...":"✅ Αποθήκευση Εργασίας"}
        </button>
      </div>
    );
  }

  // Filter logic
  const filterDays = (days) => {
    if (!days && days !== 0) return activities;
    const from = new Date();
    from.setDate(from.getDate() - days);
    return activities.filter(a => a.date >= from.toISOString().split("T")[0]);
  };
  const filteredActivities = actFilter === "calendar"
    ? activities.filter(a => (!calFrom || a.date >= calFrom) && (!calTo || a.date <= calTo))
    : actFilter === "all" ? activities
    : actFilter === "today" ? filterDays(0)
    : filterDays(actFilter);

  // LIST VIEW
  return (
    <div>
      {confirmId && <ConfirmDialog msg="Διαγραφή εργασίας;" onYes={()=>{deleteActivity(confirmId);setConfirmId(null);}} onNo={()=>setConfirmId(null)} />}
      <div className="stitle">📋 Εργασίες <span className="cnt">{activities.length}</span></div>

      <button className="btn btn-p" onClick={()=>{resetForm();setView("new");}}>➕ Νέα Εργασία</button>

      <div style={{marginBottom:14,marginTop:12}}>
        <div style={{fontSize:13,fontWeight:800,color:"#2d8a2d",marginBottom:8}}>📋 Οι Εργασίες μου:</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:8}}>
          {[{v:"today",lb:"📅 Σήμερα"},{v:5,lb:"5 μέρες"},{v:10,lb:"10 μέρες"},{v:30,lb:"30 μέρες"},{v:"calendar",lb:"🗓 Ημερολόγιο"},{v:"all",lb:"Όλες"}].map(f=>(
            <button key={String(f.v)} type="button"
              style={{background:actFilter===f.v?"#2d8a2d":"#fff",border:`2px solid ${actFilter===f.v?"#2d8a2d":"#d4e8d4"}`,borderRadius:12,padding:"8px 14px",fontSize:13,fontWeight:800,color:actFilter===f.v?"#fff":"#2d5a2d",cursor:"pointer"}}
              onClick={()=>setActFilter(f.v)}>{f.lb}</button>
          ))}
        </div>
        {actFilter==="calendar" && (
          <div style={{display:"flex",gap:8,background:"#f0f9f0",borderRadius:12,padding:10}}>
            <div style={{flex:1}}><label style={{fontSize:11,fontWeight:700,color:"#4a6a4a",display:"block",marginBottom:3}}>Από</label>
              <input className="fi" type="date" value={calFrom} onChange={e=>setCalFrom(e.target.value)} /></div>
            <div style={{fontWeight:700,color:"#8aaa8a",alignSelf:"flex-end",paddingBottom:8}}>→</div>
            <div style={{flex:1}}><label style={{fontSize:11,fontWeight:700,color:"#4a6a4a",display:"block",marginBottom:3}}>Έως</label>
              <input className="fi" type="date" value={calTo} onChange={e=>setCalTo(e.target.value)} /></div>
          </div>
        )}
      </div>

      {filteredActivities.length === 0 ? <Empty icon="📋" text="Δεν υπάρχουν εργασίες για την περίοδο αυτή" /> :
        filteredActivities.map(a => (
          <div key={a.id} className="card">
            {editingActivity?.id === a.id ? (
              <div>
                <div className="aftitle">✏️ Επεξεργασία Εργασίας</div>

                {/* Βασικά */}
                <div style={{background:"#e8f5e9",borderRadius:10,padding:"10px 12px",marginBottom:12,fontSize:13,fontWeight:700,color:"#1e5c1e"}}>
                  {editingActivity.category} → {editingActivity.activity_type}
                </div>
                <div className="fr">
                  <div className="fg"><label className="fl">Ημερομηνία</label>
                    <input className="fi" type="date" value={editingActivity.date||""} onChange={e=>setEditingActivity(p=>({...p,date:e.target.value}))} /></div>
                  <div className="fg"><label className="fl">Ώρες εργασίας</label>
                    <input className="fi" type="number" min="0" placeholder="0" value={editingActivity.hours_total||""} onChange={e=>setEditingActivity(p=>({...p,hours_total:e.target.value}))} /></div>
                </div>

                {/* Μεταφορά */}
                <div className="fg">
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                    <label className="fl" style={{margin:0}}>🚗 Χρησιμοποιήθηκε μέσο μετακίνησης;</label>
                    <button type="button"
                      style={{background:editingActivity.use_transport?"#2d8a2d":"#e0e0e0",border:"none",borderRadius:20,width:52,height:28,cursor:"pointer",position:"relative",transition:"all .2s"}}
                      onClick={()=>setEditingActivity(p=>({...p,use_transport:!p.use_transport}))}>
                      <span style={{position:"absolute",top:3,left:editingActivity.use_transport?26:4,width:22,height:22,background:"#fff",borderRadius:"50%",transition:"all .2s",display:"block"}}/>
                    </button>
                  </div>
                  {editingActivity.use_transport && (
                    <>
                      <div style={{display:"flex",flexWrap:"wrap",gap:8,marginTop:4}}>
                        {TRANSPORT_VEHICLES.map(v=>{
                          const selected = (editingActivity.transport_vehicle||"").split(",").map(s=>s.trim()).includes(v.lb);
                          return (
                            <button key={v.lb} type="button"
                              style={{background:selected?"#2d8a2d":"#fff",border:`2px solid ${selected?"#2d8a2d":"#d4e8d4"}`,borderRadius:14,padding:"10px 14px",display:"flex",flexDirection:"column",alignItems:"center",gap:4,cursor:"pointer",minWidth:64}}
                              onClick={()=>{
                                const cur = (editingActivity.transport_vehicle||"").split(",").map(s=>s.trim()).filter(Boolean);
                                const next = cur.includes(v.lb) ? cur.filter(x=>x!==v.lb) : [...cur,v.lb];
                                setEditingActivity(p=>({...p,transport_vehicle:next.join(", ")}));
                              }}>
                              <span style={{fontSize:24}}>{v.ic}</span>
                              <span style={{fontSize:11,fontWeight:800,color:selected?"#fff":"#2d5a2d"}}>{v.lb}</span>
                            </button>
                          );
                        })}
                      </div>
                      <div className="fg" style={{marginTop:10}}>
                        <label className="fl">Κόστος καυσίμου (€)</label>
                        <input className="fi" type="number" min="0" placeholder="0" value={editingActivity.transport_fuel_cost||""} onChange={e=>setEditingActivity(p=>({...p,transport_fuel_cost:e.target.value}))} />
                      </div>
                    </>
                  )}
                </div>

                {/* Μηχάνημα */}
                <div className="fg"><label className="fl">🚜 Μηχάνημα Εργασίας</label>
                  {machines.length === 0 ? (
                    <div className="msg msg-w">⚠️ Δεν έχεις καταχωρίσει μηχανήματα.</div>
                  ) : (
                    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginTop:4}}>
                      {machines.map(m=>{
                        const selected = (editingActivity.machine_custom||"").split(",").map(s=>s.trim()).includes(m.name);
                        return (
                          <button key={m.id} type="button"
                            style={{background:selected?"#2d8a2d":"#fff",border:`2px solid ${selected?"#2d8a2d":"#d4e8d4"}`,borderRadius:14,padding:"10px 4px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:4,cursor:"pointer",height:96,overflow:"hidden"}}
                            onClick={()=>{
                              const cur = (editingActivity.machine_custom||"").split(",").map(s=>s.trim()).filter(Boolean);
                              const next = cur.includes(m.name) ? cur.filter(x=>x!==m.name) : [...cur,m.name];
                              setEditingActivity(p=>({...p,machine_custom:next.join(", ")}));
                            }}>
                            <span style={{fontSize:22,lineHeight:1}}>{m.icon||"🚜"}</span>
                            <span style={{fontSize:11,fontWeight:800,color:selected?"#fff":"#2d5a2d",textAlign:"center",lineHeight:1.15,display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden",wordBreak:"break-word"}}>{m.name}</span>
                            {m.type && <span style={{fontSize:10,color:selected?"rgba(255,255,255,.7)":"#8aaa8a",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:"100%"}}>{m.type}</span>}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
                <div className="fr">
                  <div className="fg"><label className="fl">Καύσιμο μηχανήματος (lt)</label>
                    <input className="fi" type="number" min="0" placeholder="0" value={editingActivity.machine_fuel_liters||""} onChange={e=>setEditingActivity(p=>({...p,machine_fuel_liters:e.target.value}))} /></div>
                  <div className="fg"><label className="fl">Κόστος (€)</label>
                    <input className="fi" type="number" min="0" placeholder="0" value={editingActivity.machine_fuel_cost||""} onChange={e=>setEditingActivity(p=>({...p,machine_fuel_cost:e.target.value}))} /></div>
                </div>

                {/* Προσωπικό */}
                <div className="fg"><label className="fl">👷 Ποιος εργάστηκε</label>
                  <div className="who-grid">
                    {[{v:"farmer",ic:"🧑‍🌾",lb:"Μόνο αγρότης"},{v:"workers",ic:"👷",lb:"Εργάτες"},{v:"both",ic:"👥",lb:"Και τα δύο"}].map(w=>(
                      <button key={w.v} type="button" className={`who-btn ${editingActivity.performed_by===w.v?"sel":""}`} onClick={()=>setEditingActivity(p=>({...p,performed_by:w.v}))}>
                        <span className="who-ic">{w.ic}</span>
                        <span className="who-lb">{w.lb}</span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Ώρα έναρξης */}
                <div className="fr">
                  <div className="fg"><label className="fl">Ώρα έναρξης</label>
                    <input className="fi" type="time" value={editingActivity.start_time||""} onChange={e=>setEditingActivity(p=>({...p,start_time:e.target.value}))} /></div>
                  <div className="fg"><label className="fl">💸 Κόστος αβαρίας / Άλλα έξοδα (€)</label>
                    <input className="fi" type="number" min="0" placeholder="0" value={editingActivity.cost_total||""} onChange={e=>setEditingActivity(p=>({...p,cost_total:e.target.value}))} /></div>
                  {(parseFloat(editingActivity.cost_total)||0) > 0 && (
                    <div className="fg"><label className="fl">📝 Αιτία αβαρίας</label>
                      <input className="fi" placeholder="π.χ. Σπασμένο λάστιχο..." value={editingActivity.extra_cost_notes||""} onChange={e=>setEditingActivity(p=>({...p,extra_cost_notes:e.target.value}))} /></div>
                  )}
                </div>

                {/* Εργάτες */}
                <div style={{background:"#f0f9f0",borderRadius:14,padding:14,marginBottom:12}}>
                  <div className="aftitle" style={{marginBottom:10}}>👷 Εργάτες που Συμμετείχαν</div>
                  {workers.length === 0 ? (
                    <div className="msg msg-w">⚠️ Δεν έχεις καταχωρίσει εργάτες.</div>
                  ) : (
                    <>
                      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:12}}>
                        {workers.map(w=>{
                          const ew = (editingActivity.editWorkers||[]).find(x=>x.worker_id===w.id);
                          const sel = !!ew;
                          return (
                            <button key={w.id} type="button"
                              style={{background:sel?"#2d8a2d":"#fff",border:`2px solid ${sel?"#2d8a2d":"#d4e8d4"}`,borderRadius:14,padding:"10px 4px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:4,cursor:"pointer",height:96,overflow:"hidden"}}
                              onClick={()=>{
                                const cur = editingActivity.editWorkers||[];
                                if(sel) setEditingActivity(p=>({...p,editWorkers:cur.filter(x=>x.worker_id!==w.id)}));
                                else setEditingActivity(p=>({...p,editWorkers:[...cur,{worker_id:w.id,worker_name:w.name,full_day:false,half_day:false,hours:"",full_day_rate:w.full_day_rate||"",half_day_rate:w.half_day_rate||"",hourly_rate:w.hourly_rate||""}]}));
                              }}>
                              <span style={{fontSize:22,lineHeight:1}}>👷</span>
                              <span style={{fontSize:11,fontWeight:800,color:sel?"#fff":"#2d5a2d",textAlign:"center",lineHeight:1.15,display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden",wordBreak:"break-word"}}>{w.name}</span>
                              {sel && <span style={{fontSize:10,color:"#f4c542",fontWeight:800}}>✓</span>}
                            </button>
                          );
                        })}
                      </div>
                      {(editingActivity.editWorkers||[]).length > 0 && (
                        <div style={{background:"#fff",borderRadius:12,padding:12,border:"1.5px solid #e0eede"}}>
                          {(editingActivity.editWorkers||[]).map((sw,idx)=>(
                            <div key={idx} style={{marginBottom:10,paddingBottom:10,borderBottom:idx<editingActivity.editWorkers.length-1?"1px solid #f0f0f0":"none"}}>
                              <div style={{fontWeight:800,fontSize:14,color:"#1a2e1a",marginBottom:8}}>👷 {sw.worker_name}</div>
                              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6,padding:"8px 10px",background:sw.full_day?"#e8f5e9":"#f5f5f5",borderRadius:10,border:`2px solid ${sw.full_day?"#2d8a2d":"#e0e0e0"}`,cursor:"pointer"}}
                                onClick={()=>{const nw=[...editingActivity.editWorkers];nw[idx]={...nw[idx],full_day:!nw[idx].full_day};setEditingActivity(p=>({...p,editWorkers:nw}));}}>
                                <span style={{fontWeight:700,fontSize:13,color:sw.full_day?"#1e5c1e":"#666"}}>☀️ Ολόκληρο / πρωί</span>
                                <div style={{display:"flex",alignItems:"center",gap:6}}>
                                  {sw.full_day_rate && <span style={{fontWeight:800,color:"#1e5c1e",fontSize:13}}>{sw.full_day_rate}€</span>}
                                  <span style={{fontSize:18}}>{sw.full_day?"✅":"○"}</span>
                                </div>
                              </div>
                              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6,padding:"8px 10px",background:sw.half_day?"#e8f5e9":"#f5f5f5",borderRadius:10,border:`2px solid ${sw.half_day?"#2d8a2d":"#e0e0e0"}`,cursor:"pointer"}}
                                onClick={()=>{const nw=[...editingActivity.editWorkers];nw[idx]={...nw[idx],half_day:!nw[idx].half_day};setEditingActivity(p=>({...p,editWorkers:nw}));}}>
                                <span style={{fontWeight:700,fontSize:13,color:sw.half_day?"#1e5c1e":"#666"}}>🌤 Μισό / απόγευμα</span>
                                <div style={{display:"flex",alignItems:"center",gap:6}}>
                                  {sw.half_day_rate && <span style={{fontWeight:800,color:"#1e5c1e",fontSize:13}}>{sw.half_day_rate}€</span>}
                                  <span style={{fontSize:18}}>{sw.half_day?"✅":"○"}</span>
                                </div>
                              </div>
                              <div style={{display:"flex",alignItems:"center",gap:8}}>
                                <span style={{fontWeight:700,fontSize:13,color:"#666",flex:1}}>⏱ Ώρες επιπλέον</span>
                                <input className="fi" style={{width:70}} type="number" min="0" placeholder="0" value={sw.hours||""} onChange={e=>{const nw=[...editingActivity.editWorkers];nw[idx]={...nw[idx],hours:e.target.value};setEditingActivity(p=>({...p,editWorkers:nw}));}} />
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </div>

                {/* Ειδικά πεδία - Ψεκασμός */}
                {(ACTIVITY_CATEGORIES[editingActivity.category]?.hasSpray) && (
                  <div style={{background:"#fff8e1",borderRadius:14,padding:14,marginBottom:12}}>
                    <div className="aftitle" style={{marginBottom:10}}>💊 Φάρμακα Ψεκασμού</div>
                    {(editingActivity.editSpray||[{product_name:"",product_type:"",reason:"",dose_per_stremma:"",dose_unit:"ml/στρ",water_per_stremma:"",quantity_used:"",cost:""}]).map((sp,idx)=>(
                      <div key={idx} style={{background:"#fff",border:"1.5px solid #e0eede",borderRadius:12,padding:12,marginBottom:8}}>
                        <div className="fg"><label className="fl">Όνομα φαρμάκου</label>
                          <input className="fi" placeholder="π.χ. Calypso SC" value={sp.product_name||""} onChange={e=>{const n=[...(editingActivity.editSpray||[sp])];n[idx]={...n[idx],product_name:e.target.value};setEditingActivity(p=>({...p,editSpray:n}));}} /></div>
                        <div className="fg"><label className="fl">Αιτία ψεκασμού</label>
                          <input className="fi" placeholder="π.χ. Μονίλια, Θρίπας" value={sp.reason||""} onChange={e=>{const n=[...(editingActivity.editSpray||[sp])];n[idx]={...n[idx],reason:e.target.value};setEditingActivity(p=>({...p,editSpray:n}));}} /></div>
                        <div className="fr">
                          <div className="fg"><label className="fl">Δόση/στρ</label>
                            <input className="fi" type="number" placeholder="0" value={sp.dose_per_stremma||""} onChange={e=>{const n=[...(editingActivity.editSpray||[sp])];n[idx]={...n[idx],dose_per_stremma:e.target.value};setEditingActivity(p=>({...p,editSpray:n}));}} /></div>
                          <div className="fg"><label className="fl">Κόστος (€)</label>
                            <input className="fi" type="number" placeholder="0" value={sp.cost||""} onChange={e=>{const n=[...(editingActivity.editSpray||[sp])];n[idx]={...n[idx],cost:e.target.value};setEditingActivity(p=>({...p,editSpray:n}));}} /></div>
                        </div>
                      </div>
                    ))}
                    <button className="btn" style={{background:"#e8f5e9",color:"#2d6a2d",fontSize:13}} onClick={()=>setEditingActivity(p=>({...p,editSpray:[...(p.editSpray||[]),{product_name:"",product_type:"",reason:"",dose_per_stremma:"",dose_unit:"ml/στρ",water_per_stremma:"",quantity_used:"",cost:""}]}))}>➕ Άλλο φάρμακο</button>
                  </div>
                )}

                {/* Άρδευση: Πηγή + kWh (edit) */}
                {(ACTIVITY_CATEGORIES[editingActivity.category]?.hasIrrigation) && (
                  <div style={{background:"#e3f2fd",borderRadius:14,padding:14,marginBottom:12}}>
                    <div className="aftitle" style={{marginBottom:10}}>💧 Πηγή Άρδευσης</div>
                    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:10}}>
                      {IRRIGATION_SOURCES.map(s=>{
                        const sel = editingActivity.irrigation_source === s.lb;
                        return (
                          <button key={s.lb} type="button"
                            style={{background:sel?"#1976d2":"#fff",border:`2px solid ${sel?"#1976d2":"#b3d9f5"}`,borderRadius:14,padding:"10px 4px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:4,cursor:"pointer",height:78}}
                            onClick={()=>setEditingActivity(p=>({...p,irrigation_source:sel?"":s.lb}))}>
                            <span style={{fontSize:22,lineHeight:1}}>{s.ic}</span>
                            <span style={{fontSize:11,fontWeight:800,color:sel?"#fff":"#0d4d92",textAlign:"center",lineHeight:1.15}}>{s.lb}</span>
                          </button>
                        );
                      })}
                    </div>
                    {editingActivity.irrigation_source === "Ρεύμα" && (
                      <>
                        <div className="fr">
                          <div className="fg"><label className="fl">🔢 Μετρητής Αρχή (kWh)</label>
                            <input className="fi" type="number" min="0" placeholder="π.χ. 12450" value={editingActivity.meter_start||""} onChange={e=>setEditingActivity(p=>({...p,meter_start:e.target.value}))} /></div>
                          <div className="fg"><label className="fl">🔢 Μετρητής Τέλος (kWh)</label>
                            <input className="fi" type="number" min="0" placeholder="π.χ. 12565" value={editingActivity.meter_end||""} onChange={e=>setEditingActivity(p=>({...p,meter_end:e.target.value}))} /></div>
                        </div>
                        {editingActivity.meter_start && editingActivity.meter_end && (parseFloat(editingActivity.meter_end) > parseFloat(editingActivity.meter_start)) && (
                          <div style={{background:"#fff",borderRadius:10,padding:"8px 12px",fontSize:13,fontWeight:700,color:"#1976d2"}}>
                            ⚡ Κατανάλωση: {(parseFloat(editingActivity.meter_end)-parseFloat(editingActivity.meter_start)).toFixed(1)} kWh
                          </div>
                        )}
                      </>
                    )}
                    <div className="fg" style={{marginTop:10}}>
                      <label className="fl">⏱ Διάρκεια άρδευσης (ώρες)</label>
                      <input className="fi" type="number" step="0.5" min="0" placeholder="π.χ. 20" value={editingActivity.irrigation_hours||""} onChange={e=>setEditingActivity(p=>({...p,irrigation_hours:e.target.value}))} />
                      <div style={{fontSize:11,color:"#8aaa8a",marginTop:4,fontStyle:"italic"}}>Πόσες ώρες έτρεξε η βάνα/αντλία (όχι ώρες παρουσίας)</div>
                    </div>
                  </div>
                )}

                {/* Ειδικά πεδία - Σειρές */}
                {(ACTIVITY_CATEGORIES[editingActivity.category]?.scope==="rows") && (
                  <div style={{background:"#f0f9f0",borderRadius:14,padding:14,marginBottom:12}}>
                    <div className="aftitle" style={{marginBottom:10}}>🌳 Σειρές που Δουλεύτηκαν</div>
                    <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                      {fieldRows.filter(r=>r.field_id===editingActivity.field_id).map(r=>{
                        const editRows = editingActivity.editRows||[];
                        const sel = editRows.find(x=>x.row_id===r.id);
                        return (
                          <button key={r.id} className="btn"
                            style={{background:sel?"#2d8a2d":"#fff",border:`2px solid ${sel?"#2d8a2d":"#d4e8d4"}`,color:sel?"#fff":"#2d5a2d",padding:"10px 16px",fontWeight:800}}
                            onClick={()=>{
                              const cur = editingActivity.editRows||[];
                              const next = cur.find(x=>x.row_id===r.id) ? cur.filter(x=>x.row_id!==r.id) : [...cur,{row_id:r.id,row_label:r.row_label}];
                              setEditingActivity(p=>({...p,editRows:next}));
                            }}>
                            Σειρά {r.row_label} {sel?"✓":""}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* Σημειώσεις */}
                <div className="fg"><label className="fl">📝 Σημειώσεις</label>
                  <input className="fi" placeholder="Προαιρετικά" value={editingActivity.notes||""} onChange={e=>setEditingActivity(p=>({...p,notes:e.target.value}))} /></div>

                <div style={{display:"flex",gap:8}}>
                  <button className="btn" style={{flex:2,background:"#2d8a2d",color:"#fff",justifyContent:"center",padding:16}} onClick={async()=>{
                    const toNum = v => v===""||v===null?null:parseFloat(v)||null;
                    const {editSpray, editRows, editWorkers, use_transport, field_ids, ...actData} = editingActivity;
                    await updateActivity(a.id,{
                      ...actData,
                      hours_total:toNum(editingActivity.hours_total),
                      transport_fuel_liters:toNum(editingActivity.transport_fuel_liters),
                      transport_fuel_cost:toNum(editingActivity.transport_fuel_cost),
                      machine_fuel_liters:toNum(editingActivity.machine_fuel_liters),
                      machine_fuel_cost:toNum(editingActivity.machine_fuel_cost),
                      cost_total:toNum(editingActivity.cost_total),
                      meter_start:toNum(editingActivity.meter_start),
                      meter_end:toNum(editingActivity.meter_end),
                      irrigation_hours:toNum(editingActivity.irrigation_hours),
                    });
                    // Save spray products
                    if (editSpray && editSpray.length > 0) {
                      await supabase.from("spray_products").delete().eq("activity_id", a.id);
                      const validSpray = editSpray.filter(s=>s.product_name);
                      if (validSpray.length > 0) {
                        await supabase.from("spray_products").insert(validSpray.map(s=>({
                          user_id: a.user_id, activity_id: a.id,
                          product_name: s.product_name, product_type: s.product_type||"",
                          reason: s.reason||"", dose_per_stremma: toNum(s.dose_per_stremma),
                          dose_unit: s.dose_unit||"ml/στρ", cost: toNum(s.cost),
                        })));
                        setAllSprayProducts(prev => [
                          ...prev.filter(s=>s.activity_id!==a.id),
                          ...validSpray.map(s=>({...s, activity_id:a.id, user_id:a.user_id}))
                        ]);
                      } else {
                        setAllSprayProducts(prev => prev.filter(s=>s.activity_id!==a.id));
                      }
                    }
                    // Save rows
                    await supabase.from("activity_rows").delete().eq("activity_id", a.id);
                    if (editRows && editRows.length > 0) {
                      const validRows = editRows.filter(r=>r.row_label);
                      if (validRows.length > 0) {
                        await supabase.from("activity_rows").insert(validRows.map(r=>({
                          activity_id: a.id, row_id: r.row_id, row_label: r.row_label, trees_done: r.trees_done||0
                        })));
                      }
                    }
                    // Save workers (skip if farmer only)
                    await supabase.from("activity_workers").delete().eq("activity_id", a.id);
                    if (editingActivity.performed_by !== "farmer" && editWorkers && editWorkers.length > 0) {
                      const validW = editWorkers.filter(w=>w.worker_id || w.worker_name);
                      if (validW.length > 0) {
                        await supabase.from("activity_workers").insert(validW.map(w=>({
                          activity_id: a.id,
                          worker_id: w.worker_id || null,
                          worker_name: w.worker_name || null,
                          hours: w.hours ? parseFloat(w.hours) : null,
                          full_day: w.full_day || false,
                          half_day: w.half_day || false,
                        })));
                      }
                    }
                    setEditingActivity(null);
                    window.scrollTo({top:0,behavior:"smooth"});
                  }}>✅ Αποθήκευση</button>
                  <button className="btn" style={{flex:1,background:"#f0f7f0",color:"#2d5a2d",justifyContent:"center"}} onClick={()=>setEditingActivity(null)}>✕ Άκυρο</button>
                </div>
              </div>
            ) : (
              <div style={{display:"flex",alignItems:"flex-start"}}>
                <div className="card-icon" style={{background:"#e8f5e9",fontSize:22}}>
                  {a.category?.split(" ")[0]||"📋"}
                </div>
                <div style={{flex:1}}>
                  <div className="ctitle">{a.activity_type}</div>
                  <div className="csub" style={{fontSize:12,color:"#8aaa8a",fontWeight:700}}>{a.category}</div>
                  <div className="csub">📅 {a.date}</div>
                  <div className="csub">🌾 {
                    (() => {
                      const ids = a.field_ids?.length > 0 ? a.field_ids : (a.field_id ? [a.field_id] : []);
                      const names = ids.map(id => fields.find(f=>f.id===id)?.name).filter(Boolean);
                      return names.length > 0 ? names.join(", ") : "—";
                    })()
                  }</div>
                  {a.transport_vehicle && <div className="csub">🚗 {a.transport_vehicle}</div>}
                  {a.machine_custom && <div className="csub">🚜 {a.machine_custom}</div>}
                  {a.hours_total && <div className="csub">⏱ {a.hours_total}ω · {a.performed_by==="farmer"?"🧑‍🌾 Αγρότης":a.performed_by==="workers"?"👷 Εργάτες":"👥 Αγρότης+Εργάτες"}</div>}
                  {(() => {
                    const aws = (allActivityWorkers||[]).filter(aw=>aw.activity_id===a.id);
                    if (!aws.length) return null;
                    let full=0, half=0, pay=0;
                    aws.forEach(aw=>{
                      const w = workers.find(x=>x.id===aw.worker_id);
                      const fr = parseFloat(w?.full_day_rate)||0, hr = parseFloat(w?.half_day_rate)||0, ho = parseFloat(w?.hourly_rate)||0;
                      if (aw.full_day) { full++; pay+=fr; }
                      if (aw.half_day) { half++; pay+=hr; }
                      pay += (parseFloat(aw.hours)||0)*ho;
                    });
                    return (
                      <div style={{marginTop:6,background:"#fff3e0",border:"1px solid #ffe0b2",borderRadius:8,padding:"6px 10px",fontSize:12,fontWeight:700,color:"#8a6d1a",display:"flex",flexWrap:"wrap",gap:10,alignItems:"center"}}>
                        <span>👷 Μεροκάματα:</span>
                        {full>0 && <span>☀️ {full} πρωί</span>}
                        {half>0 && <span>🌤 {half} απόγευμα</span>}
                        {pay>0 && <span style={{color:"#1e5c1e",fontWeight:900}}>💰 {pay.toFixed(2)}€</span>}
                      </div>
                    );
                  })()}
                  {allSprayProducts.filter(s=>s.activity_id===a.id).length > 0 && (
                    <div className="csub">💊 {allSprayProducts.filter(s=>s.activity_id===a.id).map(s=>s.product_name).filter(Boolean).join(", ")}</div>
                  )}
                  {a.extra_cost_notes && <div className="csub" style={{color:"#c62828"}}>💸 {a.extra_cost_notes}</div>}
                  {a.notes && <div className="csub" style={{fontStyle:"italic"}}>📝 {a.notes}</div>}
                </div>
                <div style={{display:"flex",gap:6}}>
                  <button aria-label="Επεξεργασία" className="btn btn-icon" onClick={async()=>{
                    // Load workers, rows, spray products for this activity
                    const [wRes, rRes, sRes] = await Promise.all([
                      supabase.from("activity_workers").select("*").eq("activity_id", a.id),
                      supabase.from("activity_rows").select("*").eq("activity_id", a.id),
                      supabase.from("spray_products").select("*").eq("activity_id", a.id),
                    ]);
                    setEditingActivity({
                      ...a,
                      editWorkers: (wRes.data||[]).map(w=>{
                        // Look up worker rates if linked
                        const workerInfo = workers.find(x=>x.id===w.worker_id);
                        return {
                          ...w,
                          full_day_rate: workerInfo?.full_day_rate||"",
                          half_day_rate: workerInfo?.half_day_rate||"",
                          hourly_rate: workerInfo?.hourly_rate||"",
                        };
                      }),
                      editRows: rRes.data||[],
                      editSpray: sRes.data||[],
                    });
                  }}>✏️</button>
                  <button aria-label="Διαγραφή" className="btn btn-d" onClick={()=>setConfirmId(a.id)}>🗑</button>
                </div>
              </div>
            )}
          </div>
        ))
      }
    </div>
  );
}

// ── MANAGE ROWS VIEW ──────────────────────────────────────────
function ManageRowsView({ fieldId, fields, fieldRows, addFieldRow, updateFieldRow, deleteFieldRow, onBack }) {
  const field = fields.find(f=>f.id===fieldId);
  const rows = fieldRows.filter(r=>r.field_id===fieldId).sort((a,b)=>a.row_label?.localeCompare(b.row_label));
  const [lang, setLang] = useState("greek");
  const [form, setForm] = useState({ new_trees:"", old_trees:"", notes:"" });
  const [confirmId, setConfirmId] = useState(null);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({});
  const [msg, setMsg] = useState("");
  const up = (k,v) => setForm(p=>({...p,[k]:v}));
  const upE = (k,v) => setEditData(p=>({...p,[k]:v}));

  const handleSaveEdit = async () => {
    const t = (parseInt(editData.new_trees)||0) + (parseInt(editData.old_trees)||0);
    await updateFieldRow(editId, { new_trees: parseInt(editData.new_trees)||0, old_trees: parseInt(editData.old_trees)||0, total_trees: t, notes: editData.notes||"" });
    setEditId(null);
  };

  const GREEK = ["Α","Β","Γ","Δ","Ε","Ζ","Η","Θ","Ι","Κ","Λ","Μ","Ν","Ξ","Ο","Π","Ρ","Σ","Τ","Υ","Φ","Χ","Ψ","Ω"];
  const LATIN = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
  const LABELS = lang === "greek" ? GREEK : LATIN;

  const usedLabels = rows.map(r=>r.row_label?.toUpperCase());
  const nextLabel = LABELS.find(l => !usedLabels.includes(l)) || "";

  // Σύνολο φόρμας
  const total = (parseInt(form.new_trees)||0) + (parseInt(form.old_trees)||0);

  // Σύνολα χωραφιού
  const totalTrees = rows.reduce((s,r)=>s+(parseInt(r.total_trees)||0), 0);
  const totalNew   = rows.reduce((s,r)=>s+(parseInt(r.new_trees)||0), 0);
  const totalOld   = rows.reduce((s,r)=>s+(parseInt(r.old_trees)||0), 0);

  const handleAdd = async () => {
    if (!nextLabel) { setMsg("Δεν υπάρχει διαθέσιμη σειρά"); return; }
    if (!form.new_trees && !form.old_trees) { setMsg("Βάλε αριθμό νέων ή παλιών δέντρων"); return; }
    const ok = await addFieldRow({
      field_id: fieldId,
      row_label: nextLabel,
      new_trees: parseInt(form.new_trees)||0,
      old_trees: parseInt(form.old_trees)||0,
      total_trees: total,
      notes: form.notes
    });
    if (ok) { setForm({ new_trees:"", old_trees:"", notes:"" }); setMsg(""); }
    else setMsg("Σφάλμα αποθήκευσης. Δοκίμασε ξανά.");
  };

  return (
    <div>
      {confirmId && <ConfirmDialog msg="Διαγραφή σειράς;" onYes={()=>{deleteFieldRow(confirmId);setConfirmId(null);}} onNo={()=>setConfirmId(null)} />}

      {/* Header */}
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
        <div style={{width:"100%",marginBottom:4}}>
          <button className="btn" style={{width:"100%",background:"#1e5c1e",color:"#fff",padding:"16px",fontSize:"17px",fontWeight:900,borderRadius:16,justifyContent:"center",boxShadow:"0 4px 12px rgba(30,92,30,.3)"}} onClick={onBack}>
            ← Πίσω στα Αγροτεμάχια
          </button>
        </div>
        <div className="stitle" style={{margin:"8px 0 0"}}>🌳 {field?.name}</div>
      </div>

      {/* Σύνολο χωραφιού */}
      {rows.length > 0 && (
        <div style={{background:"linear-gradient(135deg,#1e5c1e,#2d8a2d)",borderRadius:16,padding:14,marginBottom:14,color:"#fff"}}>
          <div style={{fontSize:12,fontWeight:700,opacity:.8,marginBottom:6}}>ΣΥΝΟΛΟ ΧΩΡΑΦΙΟΥ</div>
          <div style={{display:"flex",gap:16}}>
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:24,fontWeight:900}}>{totalTrees}</div>
              <div style={{fontSize:11,opacity:.8}}>Σύνολο</div>
            </div>
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:24,fontWeight:900}}>{totalNew}</div>
              <div style={{fontSize:11,opacity:.8}}>Νέα</div>
            </div>
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:24,fontWeight:900}}>{totalOld}</div>
              <div style={{fontSize:11,opacity:.8}}>Παλιά</div>
            </div>
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:24,fontWeight:900}}>{rows.length}</div>
              <div style={{fontSize:11,opacity:.8}}>Σειρές</div>
            </div>
          </div>
        </div>
      )}

      {/* Επιλογή αλφαβήτου */}
      <div style={{display:"flex",gap:8,marginBottom:12}}>
        <button className="btn" style={{flex:1,justifyContent:"center",background:lang==="greek"?"#2d8a2d":"#fff",color:lang==="greek"?"#fff":"#2d5a2d",border:"2px solid #2d8a2d",borderRadius:12,padding:"10px"}} onClick={()=>setLang("greek")}>Ελληνικά (Α,Β,Γ...)</button>
        <button className="btn" style={{flex:1,justifyContent:"center",background:lang==="latin"?"#2d8a2d":"#fff",color:lang==="latin"?"#fff":"#2d5a2d",border:"2px solid #2d8a2d",borderRadius:12,padding:"10px"}} onClick={()=>setLang("latin")}>Λατινικά (A,B,C...)</button>
      </div>

      {/* Φόρμα νέας σειράς */}
      <div className="aform">
        <div className="aftitle">
          ➕ Επόμενη Σειρά:
          <span style={{background:"#2d8a2d",color:"#fff",padding:"4px 14px",borderRadius:20,marginLeft:8,fontSize:18,fontWeight:900}}>{nextLabel || "—"}</span>
        </div>
        {msg && <div className="msg msg-e">{msg}</div>}
        <div className="fr">
          <div className="fg"><label className="fl">🌱 Νέα δέντρα</label>
            <input className="fi" type="number" placeholder="0" min="0" value={form.new_trees} onChange={e=>up("new_trees",e.target.value)} /></div>
          <div className="fg"><label className="fl">🌳 Παλιά δέντρα</label>
            <input className="fi" type="number" placeholder="0" min="0" value={form.old_trees} onChange={e=>up("old_trees",e.target.value)} /></div>
        </div>
        <div style={{background:"#e8f5e9",borderRadius:12,padding:"12px 14px",marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontWeight:700,color:"#1e5c1e",fontSize:15}}>🌳 Σύνολο σειράς {nextLabel}:</span>
          <span style={{fontWeight:900,color:"#1e5c1e",fontSize:22}}>{total} δέντρα</span>
        </div>
        <div className="fg"><label className="fl">Σημειώσεις</label>
          <input className="fi" placeholder="Προαιρετικά" value={form.notes} onChange={e=>up("notes",e.target.value)} /></div>
        <button className="btn btn-p" onClick={handleAdd} disabled={!nextLabel}>
          ✅ Αποθήκευση Σειράς {nextLabel}
        </button>
      </div>

      {/* Λίστα σειρών */}
      {rows.length === 0 ? <Empty icon="🌳" text="Δεν υπάρχουν σειρές ακόμα" /> :
        rows.map(r => (
          <div key={r.id} className="card">
            {editId === r.id ? (
              <div>
                <div className="aftitle">✏️ Σειρά {r.row_label}</div>
                <div className="fr">
                  <div className="fg"><label className="fl">🌱 Νέα δέντρα</label>
                    <input className="fi" type="number" min="0" value={editData.new_trees} onChange={e=>upE("new_trees",e.target.value)} /></div>
                  <div className="fg"><label className="fl">🌳 Παλιά δέντρα</label>
                    <input className="fi" type="number" min="0" value={editData.old_trees} onChange={e=>upE("old_trees",e.target.value)} /></div>
                </div>
                <div style={{background:"#e8f5e9",borderRadius:10,padding:"10px",marginBottom:10,fontWeight:800,color:"#1e5c1e",textAlign:"center",fontSize:15}}>
                  🌳 Σύνολο: {(parseInt(editData.new_trees)||0)+(parseInt(editData.old_trees)||0)} δέντρα
                </div>
                <div className="fg"><label className="fl">Σημειώσεις</label>
                  <input className="fi" value={editData.notes||""} onChange={e=>upE("notes",e.target.value)} /></div>
                <div style={{display:"flex",gap:8}}>
                  <button className="btn" style={{flex:1,background:"#2d8a2d",color:"#fff",justifyContent:"center"}} onClick={handleSaveEdit}>✅ Αποθήκευση</button>
                  <button className="btn" style={{background:"#f0f7f0",color:"#2d5a2d"}} onClick={()=>setEditId(null)}>✕</button>
                </div>
              </div>
            ) : (
              <div style={{display:"flex",alignItems:"center"}}>
                <div style={{width:48,height:48,background:"#e8f5e9",borderRadius:14,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,fontWeight:900,color:"#1e5c1e",marginRight:12,flexShrink:0}}>{r.row_label}</div>
                <div style={{flex:1}}>
                  <div className="ctitle">Σειρά {r.row_label}</div>
                  <div style={{display:"flex",gap:8,marginTop:4,flexWrap:"wrap"}}>
                    <span style={{background:"#e8f5e9",color:"#1e5c1e",borderRadius:8,padding:"2px 8px",fontSize:13,fontWeight:700}}>🌳 {r.total_trees||0}</span>
                    <span style={{background:"#fff3e0",color:"#e65100",borderRadius:8,padding:"2px 8px",fontSize:13,fontWeight:700}}>🌱 {r.new_trees||0} νέα</span>
                    <span style={{background:"#f3e5f5",color:"#6a1b9a",borderRadius:8,padding:"2px 8px",fontSize:13,fontWeight:700}}>🌲 {r.old_trees||0} παλιά</span>
                  </div>
                  {r.notes && <div className="csub" style={{fontStyle:"italic",marginTop:4}}>{r.notes}</div>}
                </div>
                <div style={{display:"flex",gap:6}}>
                  <button aria-label="Επεξεργασία" className="btn btn-icon" onClick={()=>{setEditId(r.id);setEditData({new_trees:r.new_trees||0,old_trees:r.old_trees||0,notes:r.notes||""});}}>✏️</button>
                  <button aria-label="Διαγραφή" className="btn btn-d" onClick={()=>setConfirmId(r.id)}>🗑</button>
                </div>
              </div>
            )}
          </div>
        ))
      }
    </div>
  );
}



// ── DELIVERIES TAB ────────────────────────────────────────────
// ═══════════════════════════════════════════════════════════════
// Ισοζύγιο επιστρεφόμενων (bins/κλούβες) ανά συνεταιρισμό
// pickup_empty (+) = παίρνεις άδεια · return_empty (−) = επιστρέφεις
// ═══════════════════════════════════════════════════════════════
function ContainerBalance() {
  const { user, settings } = useApp();
  const dnIssuers = (() => {
    const d = (settings || {}).dn || {};
    return (Array.isArray(d.issuers) && d.issuers.length) ? d.issuers : (d.issuer ? [d.issuer] : []);
  })();
  const [rows, setRows] = useState([]);
  const [partners, setPartners] = useState([]);
  const [open, setOpen] = useState(false);
  const [pid, setPid] = useState("");
  const [issVat, setIssVat] = useState((dnIssuers[0]?.vat || "").trim());
  const [dir, setDir] = useState("pickup_empty");
  const [bins, setBins] = useState(0);
  const [crates, setCrates] = useState(0);
  const [moveDate, setMoveDate] = useState(new Date().toISOString().split("T")[0]);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [history, setHistory] = useState([]);
  const [histOpen, setHistOpen] = useState(false);
  const [pmap, setPmap] = useState({});
  const issuerName = (vat) => {
    const i = dnIssuers.find(x => (x.vat||"").trim() === (vat||"").trim());
    return i ? ([i.firstName,i.lastName].filter(Boolean).join(" ")||i.vat) : (vat || "—");
  };

  const load = async () => {
    const { data: ps } = await supabase.from("dn_partners").select("id,name").order("name");
    setPartners(ps || []);
    const nmeMap = {}; (ps||[]).forEach(p=>nmeMap[p.id]=p.name); setPmap(nmeMap);
    if (ps && ps[0]) setPid(prev => prev || ps[0].id);
    const { data: mv } = await supabase.from("dn_container_moves").select("id,partner_id,bins,crates,kind,date,issuer_vat").order("date", { ascending:false });
    const map = {};
    (mv || []).forEach(m => {
      const iv = (m.issuer_vat || "").trim();
      const key = iv + "|" + m.partner_id;
      if (!map[key]) map[key] = { iv, pid:m.partner_id, bins:0, crates:0 };
      map[key].bins += m.bins||0; map[key].crates += m.crates||0;
    });
    setRows(Object.values(map).filter(x => x.bins || x.crates));
    setHistory(mv || []);
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    const p = partners.find(x => x.id === pid);
    if (!p || (!bins && !crates)) { setMsg("Επίλεξε συνεταιρισμό και πλήθος."); return; }
    setBusy(true);
    const sign = dir === "pickup_empty" ? 1 : -1;
    const { error } = await supabase.from("dn_container_moves").insert({
      user_id: user.id, partner_id: p.id, kind: dir, issuer_vat: (issVat||"").trim() || null,
      bins: (bins||0)*sign, crates: (crates||0)*sign, date: moveDate || new Date().toISOString().split("T")[0],
    });
    setBusy(false);
    if (error) { setMsg("Σφάλμα: " + error.message); return; }
    setOpen(false); setBins(0); setCrates(0); setDir("pickup_empty"); setMoveDate(new Date().toISOString().split("T")[0]); setMsg("");
    load();
  };

  const totalBins = rows.reduce((s,r)=>s+(r.bins||0),0);
  const totalCrates = rows.reduce((s,r)=>s+(r.crates||0),0);
  // Σύνολα ανά εκδότη
  const perIssuer = {};
  rows.forEach(r => { const k=(r.iv||"").trim(); if(!perIssuer[k])perIssuer[k]={bins:0,crates:0}; perIssuer[k].bins+=r.bins||0; perIssuer[k].crates+=r.crates||0; });

  return (
    <div style={{marginBottom:14}}>
      {/* Μπάρα-κεφαλίδα (στιλ «Τα δελτία σου») */}
      <div onClick={()=>setHistOpen(o=>!o)} style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:16,color:histOpen?"#fff":"#1a2e1a",display:"flex",alignItems:"center",gap:10,cursor:"pointer",userSelect:"none",background:histOpen?"#1e5c1e":"#eef7ee",border:"2px solid #1e5c1e",borderRadius:14,padding:"13px 16px"}}>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <span>📦 Άδεια</span>
            {dnIssuers.length <= 1 && <span style={{fontFamily:"monospace",fontWeight:800,fontSize:15,color:histOpen?"#cde8cd":"#2d8a2d"}}>bins {totalBins} · κλούβες {totalCrates}</span>}
          </div>
          {dnIssuers.length > 1 && dnIssuers.map((is,i)=>{
            const k=(is.vat||"").trim(); const t=perIssuer[k]||{bins:0,crates:0};
            return <div key={i} style={{fontSize:12.5,fontWeight:700,color:histOpen?"#cde8cd":"#3a5a3a",marginTop:2}}>
              👤 {[is.firstName,is.lastName].filter(Boolean).join(" ")||is.vat}: <span style={{fontFamily:"monospace"}}>{t.bins} bins · {t.crates} κλ.</span>
            </div>;
          })}
        </div>
        <span style={{marginLeft:"auto",width:32,height:32,borderRadius:"50%",background:histOpen?"rgba(255,255,255,.2)":"#1e5c1e",color:"#fff",fontSize:23,fontWeight:900,display:"flex",alignItems:"center",justifyContent:"center",transform:histOpen?"rotate(90deg)":"none",transition:"transform .2s",flex:"none"}}>›</span>
      </div>

      {histOpen && (
        <div style={{background:"#fff",border:"2px solid #e8f5e9",borderTop:"none",borderRadius:"0 0 14px 14px",padding:14}}>
          <div style={{display:"flex",justifyContent:"flex-end",marginBottom:10}}>
            <button className="btn" style={{background:"#e8f5e9",color:"#1e5c1e",padding:"8px 14px",fontWeight:800,fontSize:13}} onClick={()=>{setOpen(true);setMsg("");}}>± Κίνηση</button>
          </div>

          {/* Ανά εκδότη + συνεταιρισμό */}
          {rows.length === 0
            ? <div style={{fontSize:13,color:"#8aaa8a"}}>Δεν κρατάς άδεια. «± Κίνηση» → Παραλαβή για την πρώτη φορά.</div>
            : rows.map((r,idx) => (
                <div key={idx} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 0",borderTop:"1px solid #f0f7f0"}}>
                  <div>
                    <span style={{fontSize:14,fontWeight:700,color:"#1a2e1a"}}>{pmap[r.pid]||"—"}</span>
                    {dnIssuers.length > 1 && <div style={{fontSize:11.5,color:"#6b8c6b",fontWeight:700}}>👤 {issuerName(r.iv)}</div>}
                  </div>
                  <span style={{fontFamily:"monospace",fontSize:14,color:"#1e5c1e",fontWeight:700}}>{r.bins} bins · {r.crates} κλ.</span>
                </div>
              ))
          }

          {/* Ιστορικό κινήσεων */}
          {history.length > 0 && (
            <div style={{marginTop:10,borderTop:"1px solid #f0f7f0",paddingTop:10}}>
              <div style={{fontSize:12.5,fontWeight:800,color:"#6b8c6b",marginBottom:8}}>🧾 Όλες οι κινήσεις ({history.length})</div>
              {history.map(m => {
                const isPick = (m.bins||0) > 0 || (m.crates||0) > 0;
                const label = m.kind === "sent_full" ? "📤 Έστειλες γεμάτα" : m.kind === "pickup_empty" ? "➕ Παραλαβή άδειων" : m.kind === "return_empty" ? "➖ Επιστροφή άδειων" : "Κίνηση";
                return (
                  <div key={m.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"9px 12px",background:"#fff",border:"1px solid #eef2ee",borderRadius:10,marginBottom:6}}>
                    <div>
                      <div style={{fontSize:13.5,fontWeight:700,color:"#1a2e1a"}}>{label}</div>
                      <div style={{fontSize:12,color:"#6b8c6b"}}>{pmap[m.partner_id]||"—"} · {m.date}</div>
                    </div>
                    <div style={{fontFamily:"monospace",fontSize:13.5,fontWeight:800,color:isPick?"#1e5c1e":"#c0392b"}}>
                      {(m.bins||0)>0?"+":""}{m.bins||0} bins · {(m.crates||0)>0?"+":""}{m.crates||0} κλ.
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {open && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:1000,display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={()=>setOpen(false)}>
          <div style={{background:"#fff",borderRadius:"20px 20px 0 0",padding:18,width:"100%",maxWidth:520,maxHeight:"88vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
            <div className="aftitle" style={{marginBottom:12}}>📦 Κίνηση άδειων</div>
            {msg && <div className="msg msg-e">{msg}</div>}
            {dnIssuers.length > 1 && (
              <div className="fg"><label className="fl">Εκδότης (ποιος κρατάει τα άδεια)</label>
                <select className="fi" style={{fontSize:16,minHeight:52}} value={issVat} onChange={e=>setIssVat(e.target.value)}>
                  {dnIssuers.map((is,i)=><option key={i} value={(is.vat||"").trim()}>{[is.firstName,is.lastName].filter(Boolean).join(" ")||is.vat}</option>)}
                </select></div>
            )}
            <div className="fg"><label className="fl">Συνεταιρισμός</label>
              <select className="fi" style={{fontSize:16,minHeight:52}} value={pid} onChange={e=>setPid(e.target.value)}>
                {partners.length===0 && <option value="">— Πρόσθεσε από Ρυθμίσεις —</option>}
                {partners.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
              </select></div>
            <div className="fg"><label className="fl">Τύπος κίνησης</label>
              <div style={{display:"flex",gap:8}}>
                <button className="btn" style={{flex:1,justifyContent:"center",padding:14,fontSize:15,fontWeight:800,background:dir==="pickup_empty"?"#1e5c1e":"#f0f7f0",color:dir==="pickup_empty"?"#fff":"#2d5a2d"}} onClick={()=>setDir("pickup_empty")}>➕ Παραλαβή</button>
                <button className="btn" style={{flex:1,justifyContent:"center",padding:14,fontSize:15,fontWeight:800,background:dir==="return_empty"?"#b5651d":"#f0f7f0",color:dir==="return_empty"?"#fff":"#2d5a2d"}} onClick={()=>setDir("return_empty")}>➖ Επιστροφή</button>
              </div>
            </div>
            <div className="fr">
              <div className="fg"><label className="fl">Bins</label><input className="fi" type="number" min="0" style={{fontSize:16,minHeight:52}} value={bins} onChange={e=>setBins(Math.max(0,parseInt(e.target.value,10)||0))} /></div>
              <div className="fg"><label className="fl">Κλούβες</label><input className="fi" type="number" min="0" style={{fontSize:16,minHeight:52}} value={crates} onChange={e=>setCrates(Math.max(0,parseInt(e.target.value,10)||0))} /></div>
            </div>
            <div className="fg"><label className="fl">Ημερομηνία</label>
              <input className="fi" type="date" style={{fontSize:16,minHeight:52}} value={moveDate} max={new Date().toISOString().split("T")[0]} onChange={e=>setMoveDate(e.target.value)} />
              {moveDate !== new Date().toISOString().split("T")[0] && (
                <div style={{fontSize:11.5,color:"#b5651d",marginTop:4,fontWeight:700}}>Καταχώρηση με παλαιότερη ημερομηνία</div>
              )}
            </div>
            <div style={{display:"flex",gap:8,marginTop:8}}>
              <button className="btn" style={{flex:1,background:"#f0f7f0",color:"#2d5a2d",justifyContent:"center",padding:16}} onClick={()=>setOpen(false)}>✕ Άκυρο</button>
              <button className="btn btn-p" style={{flex:2,margin:0,justifyContent:"center",padding:16,fontWeight:900}} disabled={busy} onClick={save}>{busy?"…":"✓ Καταχώρηση"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// Εκτυπώσιμο «χαρτί» δελτίου αποστολής (HTML → print → Save as PDF)
// ═══════════════════════════════════════════════════════════════
function dnEsc(v){ return String(v==null?"":v).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;"); }
function buildNoteHtml(d, issuer, field, partner){
  const issuerName = [issuer.firstName, issuer.lastName].filter(Boolean).join(" ") || "—";
  const pkg = [];
  if (d.bins_delivered) pkg.push(`${d.bins_delivered} bins`);
  if (d.crates_delivered) pkg.push(`${d.crates_delivered} κλούβες`);
  const qty = d.final_weight || d.net_weight || null;
  const weighed = d.gross_weight || d.net_weight || d.final_weight;
  const qrData = d.qr_url || (d.mark ? String(d.mark) : "");
  const qrImg = qrData ? `<img src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(qrData)}" alt="QR" style="width:120px;height:120px" />` : `<div style="width:120px;height:120px;border:1px dashed #bbb;display:flex;align-items:center;justify-content:center;font-size:10px;color:#999;text-align:center;padding:6px">QR μετά τη διαβίβαση</div>`;
  const row = (l,v)=>`<tr><td style="color:#555;padding:3px 10px 3px 0;white-space:nowrap;vertical-align:top">${l}</td><td style="font-weight:600;padding:3px 0">${dnEsc(v)||"—"}</td></tr>`;
  const isReturnNote = d.crop === "Άδεια Bins" || d.crop === "Άδεια Κλούβες";
  const returnQtyPrint = isReturnNote ? ((d.bins_delivered || d.crates_delivered) || 0) : 0;
  return `<!doctype html><html lang="el"><head><meta charset="utf-8"><title>Δελτίο ${dnEsc(d.dn_series)}-${dnEsc(d.dn_aa)}</title>
<style>
  *{box-sizing:border-box} body{font-family:Georgia,'Times New Roman',serif;color:#1a2418;margin:0;padding:28px;max-width:760px;margin:0 auto}
  .hd{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #1a2418;padding-bottom:12px;margin-bottom:16px}
  .tt{font-size:22px;font-weight:800;letter-spacing:.5px} .sub{font-size:12px;color:#555;margin-top:2px}
  .tp{font-family:monospace;font-size:12px;border:1.5px solid #1a2418;border-radius:6px;padding:4px 8px;font-weight:700}
  .cols{display:flex;gap:24px;flex-wrap:wrap;margin-bottom:16px}
  .col{flex:1;min-width:220px} .lbl{font-size:10px;font-weight:800;letter-spacing:1px;text-transform:uppercase;color:#777;border-bottom:1px solid #ddd;padding-bottom:3px;margin-bottom:6px}
  table{border-collapse:collapse;font-size:13px;width:100%} .items{margin:14px 0;border:1px solid #ccc}
  .items th{background:#f0efe8;text-align:left;padding:8px;font-size:11px;text-transform:uppercase;letter-spacing:.5px}
  .items td{padding:8px;border-top:1px solid #e2e0d6;font-size:14px}
  .stamp{display:inline-block;border:2px solid #b5651d;color:#b5651d;font-weight:800;padding:4px 12px;border-radius:6px;transform:rotate(-4deg);font-size:14px;letter-spacing:1px;margin:8px 0}
  .weigh{background:#f7f6f0;border:1px solid #d8d6c8;border-radius:6px;padding:10px 14px;margin:12px 0;font-size:13px;display:flex;flex-wrap:wrap;gap:16px}
  .weigh b{font-family:monospace} .fin{color:#b5651d;font-weight:800;font-size:15px;margin-left:auto}
  .ft{display:flex;justify-content:space-between;align-items:flex-end;margin-top:20px;border-top:1px solid #ccc;padding-top:14px}
  .mk{font-family:monospace;font-size:12px;line-height:1.7;text-align:right}
  .cancelbanner{background:#fdecec;border:2px solid #c62828;color:#c62828;border-radius:8px;padding:10px 16px;margin:0 0 16px;text-align:center;font-weight:800;letter-spacing:1px;font-size:16px}
  .cancelwm{position:fixed;top:38%;left:50%;transform:translate(-50%,-50%) rotate(-24deg);font-size:96px;font-weight:900;color:rgba(198,40,40,.16);letter-spacing:6px;pointer-events:none;z-index:0}
  @media print{ body{padding:6mm} button{display:none} }
</style></head><body>
  ${d.cancel_mark ? `<div class="cancelwm">ΑΚΥΡΩΜΕΝΟ</div><div class="cancelbanner">❌ ΑΚΥΡΩΜΕΝΟ ΔΕΛΤΙΟ · ΜΑΡΚ ακύρωσης ${dnEsc(d.cancel_mark)}</div>` : ""}
  <div class="hd">
    <div><div class="tt">ΔΕΛΤΙΟ ΑΠΟΣΤΟΛΗΣ</div><div class="sub">Ψηφιακό παραστατικό διακίνησης</div></div>
    <div class="tp">ΤΠ 9.3</div>
  </div>
  <div class="cols">
    <div class="col"><div class="lbl">Αποστολέας</div><table>
      ${row("Επωνυμία", issuerName)}${row("Δραστ.", issuer.activity)}${row("ΑΦΜ", issuer.vat)}${row("ΔΟΥ", issuer.doy)}
    </table></div>
    <div class="col"><div class="lbl">Παραλήπτης</div><table>
      ${row("Επωνυμία", (partner&&partner.name)||d.buyer)}${row("ΑΦΜ", partner&&partner.vat)}${row("Πόλη", partner&&[partner.postal_code,partner.city].filter(Boolean).join(" "))}
    </table></div>
  </div>
  <div class="cols">
    <div class="col"><div class="lbl">Στοιχεία</div><table>
      ${row("Σειρά-ΑΑ", `${d.dn_series||"0"}-${d.dn_aa||""}`)}${row("Ημ/νία", `${d.date||""}${d.time_of_day?" "+d.time_of_day:""}`)}${d.vehicle_no?row("Όχημα", d.vehicle_no):""}${d.other_purpose_title?row("Αιτία", d.other_purpose_title):""}
    </table></div>
    <div class="col"><div class="lbl">Τόπος φόρτωσης → παράδοσης</div><table>
      ${row("Από", field?`${field.name}${field.city?", "+field.city:""}`:"—")}${row("Προς", partner?[partner.postal_code,partner.city].filter(Boolean).join(" "):"—")}
    </table></div>
  </div>
  <table class="items"><thead><tr><th>Είδος</th><th>Συσκευασία</th><th style="text-align:right">Ποσότητα</th></tr></thead>
    <tbody><tr>
      <td>${dnEsc(d.crop)}</td><td>${dnEsc(pkg.join(" + "))||"—"}</td>
      <td style="text-align:right;font-family:monospace">${isReturnNote ? dnEsc(returnQtyPrint)+" τεμ." : (qty?dnEsc(qty)+" kg":(d.to_weigh?"προς ζύγιση":"—"))}</td>
    </tr></tbody>
  </table>
  ${d.to_weigh && !weighed ? `<div class="stamp">ΠΡΟΣ ΖΥΓΙΣΗ</div>` : ""}
  ${weighed ? `<div class="weigh">
    <span>Μικτό <b>${dnEsc(d.gross_weight)||"—"}</b></span>
    <span>Απόβ. οχήμ. <b>${dnEsc(d.tare_weight)||"—"}</b></span>
    ${d.packaging_tare?`<span>Απόβ. υλικών <b>${dnEsc(d.packaging_tare)}</b></span>`:""}
    <span>Καθαρά <b>${dnEsc(d.net_weight)||"—"}</b></span>
    ${d.reject_percent?`<span>Απομείωση <b>${dnEsc(d.reject_percent)}%</b></span>`:""}
    <span class="fin">Πληρωτέα ${dnEsc(d.final_weight)||"—"} kg</span>
  </div>
  ${(d.coop_doc_no||d.quality_check_no||d.vehicle_no)?`<div class="weigh" style="background:#fff">
    ${d.coop_doc_no?`<span>Παραστ. συνετ. <b>${dnEsc(d.coop_doc_no)}</b></span>`:""}
    ${d.quality_check_no?`<span>Ποιοτ. έλεγχος <b>${dnEsc(d.quality_check_no)}</b></span>`:""}
    ${d.vehicle_no?`<span>Όχημα <b>${dnEsc(d.vehicle_no)}</b></span>`:""}
  </div>`:""}` : ""}
  <div class="ft">
    <div>${qrImg}</div>
    <div class="mk">
      ${d.mark?`ΜΑΡΚ: <b>${dnEsc(d.mark)}</b><br>`:"Κατάσταση: προς διαβίβαση<br>"}
      Σκοπός: ${dnEsc(d.move_purpose)||"—"}${d.other_purpose_title?` · ${dnEsc(d.other_purpose_title)}`:""}<br>
      <span style="color:#888;font-size:10px">AgroPalk</span>
    </div>
  </div>
  <div style="text-align:center;margin-top:20px"><button onclick="window.print()" style="font-size:15px;padding:10px 22px;border-radius:8px;border:none;background:#1e5c1e;color:#fff;font-weight:700;cursor:pointer">🖨 Εκτύπωση / Αποθήκευση PDF</button></div>
</body></html>`;
}

// ═══════════════════════════════════════════════════════════════
// Έκδοση Ψηφιακού Δελτίου Αποστολής (ΤΠ 9.3) — field-first
// Δεσμεύει αύξοντα, δημιουργεί γραμμή deliveries με στοιχεία δελτίου.
// (Η πραγματική διαβίβαση στο myDATA προστίθεται σε επόμενο βήμα.)
// ═══════════════════════════════════════════════════════════════
function DeliveryNoteIssue({ fields, onDone, onCancel }) {
  const { settings: rawSettings, user, addDelivery, updateDelivery, deliveries } = useApp();
  const dn = (rawSettings || {}).dn || {};
  const products = (Array.isArray(dn.products) ? dn.products : []).filter(p => p.active);
  // Λίστα εκδοτών (νέο: dn.issuers[]· παλιό συμβατό: dn.issuer)
  const issuersList = (Array.isArray(dn.issuers) && dn.issuers.length)
    ? dn.issuers
    : (dn.issuer ? [dn.issuer] : []);
  // Τελευταίο όχημα που χρησιμοποιήθηκε (προσυμπλήρωση)
  const lastVehicle = (() => {
    const list = Array.isArray(deliveries) ? deliveries : [];
    const prev = [...list].sort((a,b) => (b.date||"").localeCompare(a.date||"") || (b.dn_aa||0)-(a.dn_aa||0));
    return (prev.find(x => x.vehicle_no) || {}).vehicle_no || "";
  })();
  const [vehicleNo, setVehicleNo] = useState(lastVehicle);
  const [issuerIdx, setIssuerIdx] = useState(0);
  const [partners, setPartners] = useState([]);
  const [balances, setBalances] = useState({}); // partner_id -> {bins, crates}
  const [fieldId, setFieldId] = useState(fields[0]?.id || "");
  const [partnerId, setPartnerId] = useState("");
  const [prodIdx, setProdIdx] = useState(0);
  const [variety, setVariety] = useState("");
  const [bins, setBins] = useState(0);
  const [crates, setCrates] = useState(0);
  const [toWeigh, setToWeigh] = useState(true);
  const [purpose, setPurpose] = useState(1);
  const [otherPurposeTitle, setOtherPurposeTitle] = useState("");
  const [returnKind, setReturnKind] = useState(null); // null | "bins" | "crates" (δελτίο επιστροφής άδειων)
  const [returnQty, setReturnQty] = useState(0);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [preview, setPreview] = useState(false);

  useEffect(() => {
    (async () => {
      const { data } = await supabase.from("dn_partners").select("id,name,vat,postal_code,city").order("name");
      setPartners(data || []);
      if (data && data[0]) setPartnerId(data[0].id);
      const { data: mv } = await supabase.from("dn_container_moves").select("partner_id,bins,crates,issuer_vat");
      const map = {};
      (mv || []).forEach(m => {
        const iv = (m.issuer_vat || "").trim();
        const key = iv + "|" + m.partner_id;
        if (!map[key]) map[key] = { bins:0, crates:0 };
        map[key].bins += m.bins||0; map[key].crates += m.crates||0;
      });
      setBalances(map);
    })();
  }, []);
  const curIssuerVat = ((issuersList[issuerIdx] || {}).vat || "").trim();
  const bal = balances[curIssuerVat + "|" + partnerId] || { bins:0, crates:0 };
  const shortBins = bins > (bal.bins||0);
  const shortCrates = crates > (bal.crates||0);

  const product = products[prodIdx] || null;
  useEffect(() => { setVariety(product?.varieties?.[0] || ""); }, [prodIdx]);
  const estimate = product ? (bins * (product.binKg || 0) + crates * (product.crateKg || 0)) : 0;

  // Αυτόματη προσυμπλήρωση τίτλου όταν σκοπός=19 (μπορεί να αλλάξει χειροκίνητα)
  useEffect(() => {
    if (purpose === 19 && !otherPurposeTitle.trim()) {
      setOtherPurposeTitle(toWeigh ? "Παράδοση προς ζύγιση" : "Παράδοση σε συνεταιρισμό");
    }
  }, [purpose]);

  const step = (setter, cur, d) => setter(Math.max(0, cur + d));

  const validate = () => {
    const partner = partners.find(p => p.id === partnerId);
    if (!partner) return "Επίλεξε συναλλασσόμενο (Ρυθμίσεις → Δελτίο Αποστολής).";
    if (returnKind) {
      if (!returnQty || returnQty < 1) return "Βάλε πλήθος άδειων προς επιστροφή.";
      return null;
    }
    if (!product) return "Δεν υπάρχει ενεργό προϊόν. Πρόσθεσε από τις Ρυθμίσεις.";
    const field = fields.find(f => f.id === fieldId);
    if (field && (!field.postal_code || !field.city)) return "Το αγροτεμάχιο χρειάζεται Τ.Κ./πόλη (Ρυθμίσεις → Αγροτεμάχια).";
    if (purpose === 19 && !otherPurposeTitle.trim()) return "Ο σκοπός 19 (Λοιπές) χρειάζεται τίτλο αιτίας.";
    return null;
  };
  const review = () => { const e = validate(); if (e) { setMsg(e); return; } setMsg(""); setPreview(true); };

  const doIssue = async () => {
    const partner = partners.find(p => p.id === partnerId);
    const isReturn = !!returnKind;
    const product2 = isReturn
      ? { name: returnKind === "bins" ? "Άδεια Bins" : "Άδεια Κλούβες", vatCategory: 8, itemCode: "" }
      : products[prodIdx];
    const RETURN_TITLE = "Επιστροφή στον συνεταιρισμό";
    const effPurpose = isReturn ? 19 : purpose; // 19 = Λοιπές διακινήσεις (επιστροφή άδειων)
    const effOtherTitle = isReturn ? RETURN_TITLE : (purpose === 19 ? otherPurposeTitle.trim() : "");
    const effToWeigh = isReturn ? false : toWeigh;
    const retQty = returnQty || 0;
    const field = fields.find(f => f.id === fieldId);
    const issuer = issuersList[issuerIdx] || issuersList[0] || {};
    // Αυτόματη σειρά ανά εκδότη: Α, Β, Γ… (ελληνικά κεφαλαία)
    const GRK = ["Α","Β","Γ","Δ","Ε","Ζ","Η","Θ","Ι","Κ"];
    const dnSeries = GRK[issuerIdx] || String(issuerIdx + 1);
    setBusy(true);
    try {
      // Σιγουρέψου ότι η συνεδρία είναι ενεργή (ανανέωση token αν χρειάζεται)
      try { await supabase.auth.getSession(); } catch (_) {}

      // allocate: δοκίμασε RPC με timeout 6s· αν κρεμάσει, πήγαινε στο fallback
      let aa = null, aaErr = null;
      const allocVat = (issuer.vat || "").trim();
      const withTimeout = (promise, ms) => Promise.race([
        promise,
        new Promise((_, rej) => setTimeout(() => rej(new Error("timeout")), ms)),
      ]);
      try {
        console.log("AGROPALK: allocate RPC…", { σειρά: dnSeries, εκδότης: allocVat });
        const r = await withTimeout(supabase.rpc("allocate_dn_number", { p_series: dnSeries, p_issuer_vat: allocVat }), 6000);
        aa = r.data; aaErr = r.error;
        console.log("AGROPALK: RPC απάντησε", { aa, aaErr });
      } catch (te) {
        console.warn("AGROPALK: RPC timeout/σφάλμα → fallback", te && te.message);
        aaErr = te;
      }

      // Fallback: allocate ΚΑΤΕΥΘΕΙΑΝ στον πίνακα (ανά εκδότη)
      if (aaErr || aa == null) {
        console.warn("AGROPALK: fallback σε απευθείας πίνακα");
        try {
          const { data: cur, error: readErr } = await withTimeout(
            supabase.from("dn_counters").select("last_aa").eq("user_id", user.id).eq("series", dnSeries).eq("issuer_vat", allocVat).maybeSingle(), 6000);
          if (readErr) throw readErr;
          if (cur && cur.last_aa != null) {
            const next = cur.last_aa + 1;
            const { error: updErr } = await withTimeout(
              supabase.from("dn_counters").update({ last_aa: next }).eq("user_id", user.id).eq("series", dnSeries).eq("issuer_vat", allocVat), 6000);
            if (updErr) throw updErr;
            aa = next;
          } else {
            const { error: insErr } = await withTimeout(
              supabase.from("dn_counters").insert({ user_id: user.id, series: dnSeries, issuer_vat: allocVat, last_aa: 1 }), 6000);
            if (insErr) throw insErr;
            aa = 1;
          }
          aaErr = null;
          console.log("AGROPALK: fallback allocate OK", aa);
        } catch (fe) {
          console.error("AGROPALK: fallback allocate απέτυχε", fe);
          aaErr = fe;
        }
      }

      if (aaErr || aa == null) {
        setMsg("Σφάλμα σύνδεσης στην έκδοση αριθμού" + (aaErr ? ": " + (aaErr.message || aaErr) : "") + ". Έλεγξε τη σύνδεση και ξαναδοκίμασε.");
        setBusy(false); setPreview(false);
        return;
      }
      const today = new Date().toISOString().split("T")[0];
      const now = new Date().toTimeString().slice(0, 5);

      // 1) Καταχώρηση γραμμής (draft) — εμφανίζεται αμέσως στη λίστα
      const item = {
        date: today, time_of_day: now, field_id: fieldId || null,
        buyer: partner.name, partner_id: partner.id,
        crop: product2.name, variety: isReturn ? null : (variety || null),
        crates_delivered: isReturn ? (returnKind==="crates" ? retQty : null) : (crates || null), bins_delivered: isReturn ? (returnKind==="bins" ? retQty : null) : (bins || null),
        dn_series: dnSeries, dn_aa: aa, move_purpose: effPurpose, to_weigh: effToWeigh,
        other_purpose_title: (effPurpose === 19 ? effOtherTitle : null),
        issuer_vat: (issuer.vat || "").trim() || null,
        vehicle_no: (vehicleNo || "").trim() || null,
        transmission_status: "draft",
        notes: isReturn ? `↩️ Επιστροφή ${retQty} άδεια ${returnKind==="bins"?"bins":"κλούβες"}` : (toWeigh ? `Προς ζύγιση · εκτίμηση ${estimate} kg` : null),
      };
      const ok = await addDelivery(item);
      if (!ok) throw new Error("Σφάλμα αποθήκευσης");
      console.log("AGROPALK: draft αποθηκεύτηκε, aa=", aa);
      console.log("AGROPALK: χτίζω note… partner=", !!partner, "product2=", !!product2, "issuer=", issuer);

      // 2) Διαβίβαση στο myDATA μέσω Edge Function
      const note = {
        farmerId: user.id,
        issuerVat: (issuer.vat || "").trim(),
        issuer: {
          vat: (issuer.vat || "").trim(),
          name: [issuer.firstName, issuer.lastName].filter(Boolean).join(" ").trim() || undefined,
          address: {
            street: (issuer.street || issuer.city || "Αγροτική περιοχή"),
            number: issuer.number || "0",
            postalCode: (issuer.postalCode || (field && field.postal_code) || ""),
            city: (issuer.city || "").trim(),
          },
        },
        counterpart: {
          vat: (partner.vat || "").trim(),
          name: partner.name || undefined,
          address: {
            street: partner.street || partner.city || "Αγροτική περιοχή",
            number: partner.number || "0",
            postalCode: partner.postal_code || "",
            city: partner.city || "",
          },
        },
        series: dnSeries, aa, issueDate: today, dispatchDate: today, dispatchTime: now + ":00",
        movePurpose: effPurpose,
        otherMovePurposeTitle: (effPurpose === 19 ? effOtherTitle : undefined),
        loadingAddress: { street: field ? field.name : undefined, number: "0", postalCode: (field && field.postal_code) || "", city: (field && field.city) || "" },
        deliveryAddress: { street: partner.street || undefined, number: "0", postalCode: partner.postal_code || "", city: partner.city || "" },
        toWeigh: effToWeigh,
        lines: [ isReturn ? {
          lineNumber: 1, itemDescr: product2.name,
          quantity: retQty, measurementUnit: 1, // 1 = Τεμάχια
          vatCategory: product2.vatCategory, netValue: 0, vatAmount: 0,
        } : {
          lineNumber: 1, itemDescr: product2.name, variety: variety || undefined,
          includeVariety: !!(rawSettings && rawSettings.dn && rawSettings.dn.includeVariety),
          quantity: estimate || 0, measurementUnit: 2, itemCode: product2.itemCode || undefined,
          vatCategory: product2.vatCategory, netValue: 0, vatAmount: 0,
          packaging: { bins, crates },
        }],
      };
      console.log("AGROPALK: note έτοιμο");

      // Βρες τη γραμμή που μόλις μπήκε (για ενημέρωση ΜΑΡΚ/σφάλματος)
      console.log("AGROPALK: αναζήτηση row για aa=", aa);
      let row = null;
      try {
        const rr = await withTimeout(
          supabase.from("deliveries").select("id")
            .eq("user_id", user.id).eq("dn_series", dnSeries).eq("dn_aa", aa)
            .order("created_at", { ascending: false }).limit(1),
          6000);
        row = Array.isArray(rr.data) && rr.data.length ? rr.data[0] : null;
      } catch (re) {
        console.warn("AGROPALK: αναζήτηση row timeout/σφάλμα", re && re.message);
      }
      console.log("AGROPALK: row=", row);

      // Κλήση Edge Function με δικό της try/catch + timeout — ΚΑΘΕ αποτυχία καταγράφεται
      let data = null, error = null, errBody = null, errText = "";
      try {
        console.log("AGROPALK: καλώ send-delivery-note", { aa });
        const r = await withTimeout(supabase.functions.invoke("send-delivery-note", { body: note }), 25000);
        data = r.data; error = r.error;
        console.log("AGROPALK: απάντηση", { data, error });
        if (error && error.context) {
          try {
            if (typeof error.context.clone === "function") {
              try { errBody = await error.context.clone().json(); }
              catch (_) { errText = await error.context.clone().text(); }
            } else if (typeof error.context.json === "function") {
              errBody = await error.context.json();
            }
          } catch (_) {}
        }
      } catch (ex) {
        error = ex;
        console.error("AGROPALK: εξαίρεση invoke", ex);
      }

      if (error || !data || data.ok === false) {
        const src = errBody || data;
        const emsg = (src && (src.aadeError || src.error || (src.errors && src.errors.map(x => x.message || x).join(", "))))
          || errText || (error && (error.message || String(error))) || "Αποτυχία σύνδεσης με τη διαβίβαση";
        if (row) await updateDelivery(row.id, { transmission_status: "draft", last_error: (emsg || "").slice(0, 500) || null });
        onDone && onDone(`Δελτίο 0-${aa} (draft). ${emsg}`);
        return;
      }

      // Επιτυχία → αποθήκευσε ΜΑΡΚ/QR
      if (row) await updateDelivery(row.id, { mark: data.mark, uid: data.uid, qr_url: data.qrUrl, transmission_status: "transmitted" });
      // Ενημέρωσε αυτόματα το απόθεμα άδειων bins/κλουβών
      const mvBins = isReturn ? (returnKind==="bins" ? retQty : 0) : (bins || 0);
      const mvCrates = isReturn ? (returnKind==="crates" ? retQty : 0) : (crates || 0);
      if ((mvBins || mvCrates) && partner) {
        try {
          const ivat = (issuer.vat || "").trim();
          await supabase.from("dn_container_moves").insert({
            user_id: user.id, partner_id: partner.id, kind: isReturn ? "return_empty" : "sent_full",
            bins: -(mvBins || 0), crates: -(mvCrates || 0), date: today, issuer_vat: ivat || null,
          });
          const key = ivat + "|" + partner.id;
          setBalances(prev => {
            const cur = prev[key] || { bins:0, crates:0 };
            return { ...prev, [key]: { bins: (cur.bins||0) - (mvBins||0), crates: (cur.crates||0) - (mvCrates||0) } };
          });
        } catch (_) {}
      }
      onDone && onDone(`✅ Διαβιβάστηκε! Δελτίο 0-${aa} · ΜΑΡΚ ${data.mark}`);
    } catch (e) { setMsg("Σφάλμα: " + (e.message || e)); setPreview(false); }
    finally { setBusy(false); }
  };

  const mini = { fontSize:11, fontWeight:800, color:"#6b8c6b", textTransform:"uppercase", marginBottom:4, display:"block" };
  const chip = (on) => ({ background:on?"#1e5c1e":"#fff", color:on?"#fff":"#2d5a2d", border:`1.5px solid ${on?"#1e5c1e":"#d4e8d4"}`, borderRadius:20, padding:"9px 14px", fontWeight:700, fontSize:14, cursor:"pointer" });

  return (
    <div className="aform dnbig">
      <style>{`.dnbig .fi,.dnbig select.fi,.dnbig input.fi{font-size:16px;min-height:52px;padding:13px 14px}
        .dnbig .fl{font-size:14px;margin-bottom:6px}
        .dnbig .aftitle{font-size:17px}
        .dnbig .dnb-chip{font-size:15px;padding:11px 16px}
        .dnbig .dnb-step-btn{font-size:22px;padding:8px 16px}
        .dnbig .dnb-num{width:64px;font-size:18px}`}</style>
      <div className="aftitle">📄 Έκδοση δελτίου αποστολής</div>
      {msg && <div className="msg msg-e">{msg}</div>}

      {issuersList.length > 1 && (
        <div className="fg"><label className="fl">Εκδότης (ποιος κόβει το δελτίο)</label>
          <select className="fi" value={issuerIdx} onChange={e=>setIssuerIdx(parseInt(e.target.value))}>
            {issuersList.map((is,i)=>{
              const GRK=["Α","Β","Γ","Δ","Ε","Ζ","Η","Θ","Ι","Κ"]; const s=GRK[i]||String(i+1);
              return <option key={i} value={i}>{s} · {[is.firstName,is.lastName].filter(Boolean).join(" ")||is.vat||`Εκδότης ${i+1}`}{is.vat?` · ΑΦΜ ${is.vat}`:""}</option>;
            })}
          </select></div>
      )}

      <div className="fg"><label className="fl">Αγροτεμάχιο (τόπος φόρτωσης)</label>
        <select className="fi" value={fieldId} onChange={e=>setFieldId(e.target.value)}>
          {fields.map(f=><option key={f.id} value={f.id}>{f.name}{f.city?` · ${f.city}`:""}</option>)}
        </select></div>

      <div className="fg"><label className="fl">Συναλλασσόμενος (λήπτης)</label>
        <select className="fi" value={partnerId} onChange={e=>setPartnerId(e.target.value)}>
          {partners.length===0 && <option value="">— Πρόσθεσε από Ρυθμίσεις —</option>}
          {partners.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
        </select></div>

      <div className="fg"><label className="fl">Είδος</label>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          {products.length===0 && <span style={{fontSize:13,color:"#c62828"}}>Δεν υπάρχει ενεργό προϊόν.</span>}
          {products.map((p,i)=><button key={i} className="dnb-chip" style={chip(!returnKind && i===prodIdx)} onClick={()=>{setReturnKind(null);setProdIdx(i);}}>{p.name}</button>)}
          <button className="dnb-chip" style={chip(returnKind==="bins")} onClick={()=>{setReturnKind("bins");setToWeigh(false);}}>↩️ Άδεια Bins</button>
          <button className="dnb-chip" style={chip(returnKind==="crates")} onClick={()=>{setReturnKind("crates");setToWeigh(false);}}>↩️ Άδεια Κλούβες</button>
        </div>
      </div>

      {product?.varieties?.length && !returnKind ? (
        <div className="fg"><label className="fl">Ποικιλία</label>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            {product.varieties.map(v=><button key={v} className="dnb-chip" style={chip(v===variety)} onClick={()=>setVariety(v)}>{v}</button>)}
          </div>
        </div>
      ) : null}

      {returnKind ? (
        /* ── Επιστροφή άδειων ── */
        <div style={{background:"#eef4ff",borderRadius:14,padding:14,marginBottom:12,border:"1.5px solid #b3c9e5"}}>
          <div className="aftitle" style={{marginBottom:6,color:"#2b5fa5"}}>↩️ Επιστροφή άδειων {returnKind==="bins"?"Bins":"Κλουβών"}</div>
          <div style={{fontSize:12.5,color:"#5a7a9a",marginBottom:12}}>Δελτίο επιστροφής προς τον συνεταιρισμό — μειώνει το απόθεμα άδειων.</div>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <span style={{fontWeight:800,color:"#2b5fa5"}}>Πλήθος</span>
            <div style={{display:"flex",alignItems:"center",gap:4}}>
              <button className="btn dnb-step-btn" style={{background:"#fff",border:"1.5px solid #b3c9e5",padding:"6px 12px",fontSize:18,fontWeight:800}} onClick={()=>setReturnQty(Math.max(0,returnQty-1))}>−</button>
              <input className="fi dnb-num" type="number" min="0" value={returnQty} onChange={e=>setReturnQty(Math.max(0,parseInt(e.target.value,10)||0))} style={{width:64,textAlign:"center"}} />
              <button className="btn dnb-step-btn" style={{background:"#fff",border:"1.5px solid #b3c9e5",padding:"6px 12px",fontSize:18,fontWeight:800}} onClick={()=>setReturnQty(returnQty+1)}>+</button>
              <button className="btn" style={{background:"#e3f2fd",color:"#2b5fa5",padding:"6px 10px",fontWeight:800}} onClick={()=>setReturnQty(returnQty+10)}>+10</button>
            </div>
          </div>
          <div style={{marginTop:10,fontSize:12.5,color:"#5a7a9a",textAlign:"center"}}>
            📦 Άδεια που κρατάς: <b>{returnKind==="bins"?(bal.bins||0):(bal.crates||0)}</b> {returnKind==="bins"?"bins":"κλούβες"}
          </div>
          {returnQty > (returnKind==="bins"?(bal.bins||0):(bal.crates||0)) && (
            <div style={{marginTop:8,background:"#fff3e0",border:"1.5px solid #e65100",borderRadius:10,padding:"10px 14px",fontSize:13,color:"#e65100",fontWeight:700,textAlign:"center"}}>
              ⚠️ Επιστρέφεις περισσότερα απ' όσα κρατάς ({returnQty} &gt; {returnKind==="bins"?(bal.bins||0):(bal.crates||0)}).
            </div>
          )}
        </div>
      ) : (
      /* Συσκευασία */
      <div style={{background:"#f0f7f0",borderRadius:14,padding:14,marginBottom:12}}>
        <div className="aftitle" style={{marginBottom:10}}>📦 Συσκευασία</div>
        {[["Bins",bins,setBins,product?.binKg],["Κλούβες",crates,setCrates,product?.crateKg]].map(([nm,val,setter,kg])=>(
          <div key={nm} style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8}}>
            <span style={{fontWeight:700,color:"#2d5a2d"}}>{nm} <span style={{color:"#8aaa8a",fontSize:12,fontWeight:600}}>≈{kg||0}kg</span></span>
            <div style={{display:"flex",alignItems:"center",gap:4}}>
              <button className="btn dnb-step-btn" style={{background:"#fff",border:"1.5px solid #d4e8d4",padding:"6px 12px",fontSize:18,fontWeight:800}} onClick={()=>step(setter,val,-1)}>−</button>
              <input className="fi dnb-num" type="number" min="0" value={val} onChange={e=>setter(Math.max(0,parseInt(e.target.value,10)||0))} style={{width:80,textAlign:"center",fontSize:20,fontWeight:800}} />
              <button className="btn dnb-step-btn" style={{background:"#fff",border:"1.5px solid #d4e8d4",padding:"6px 12px",fontSize:18,fontWeight:800}} onClick={()=>step(setter,val,1)}>+</button>
              <button className="btn" style={{background:"#e8f5e9",color:"#1e5c1e",padding:"6px 10px",fontWeight:800}} onClick={()=>step(setter,val,10)}>+10</button>
            </div>
          </div>
        ))}
        <div style={{background:"#e8f5e9",borderRadius:10,padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontWeight:700,color:"#1e5c1e"}}>Εκτίμηση:</span>
          <span style={{fontWeight:900,fontSize:18,color:"#1e5c1e"}}>{estimate} kg</span>
        </div>
        <div style={{marginTop:8,fontSize:12.5,color:"#6b8c6b",textAlign:"center"}}>
          📦 Άδεια που κρατάς από αυτόν: <b>{bal.bins||0}</b> bins · <b>{bal.crates||0}</b> κλούβες
        </div>
        {(shortBins || shortCrates) && (
          <div style={{marginTop:8,background:"#fff3e0",border:"1.5px solid #e65100",borderRadius:10,padding:"10px 14px",fontSize:13,color:"#e65100",fontWeight:700,textAlign:"center"}}>
            ⚠️ Στέλνεις περισσότερα απ' όσα άδεια κρατάς{shortBins?` · bins: ${bins}>${bal.bins||0}`:""}{shortCrates?` · κλούβες: ${crates}>${bal.crates||0}`:""}. Μήπως ξέχασες να καταχωρήσεις παραλαβή;
          </div>
        )}
      </div>
      )}

      {!returnKind && (
      <label style={{display:"flex",alignItems:"center",gap:10,background:"#fff8e1",border:"1.5px solid #f4c542",borderRadius:12,padding:12,marginBottom:12,fontWeight:700,color:"#e65100",cursor:"pointer"}}>
        <input type="checkbox" checked={toWeigh} onChange={e=>setToWeigh(e.target.checked)} style={{width:20,height:20,accentColor:"#e65100"}} />
        Προς Ζύγιση (η ποσότητα οριστικοποιείται στη ζυγαριά του παραλήπτη)
      </label>
      )}

      <div className="fg"><label className="fl">Σκοπός διακίνησης</label>
        <select className="fi" style={{fontSize:16,minHeight:52}} value={purpose} onChange={e=>setPurpose(parseInt(e.target.value))}>
          <option value={1}>1 · Πώληση</option>
          <option value={2}>2 · Πώληση για λογαριασμό τρίτων</option>
          <option value={19}>19 · Λοιπές Διακινήσεις</option>
        </select></div>
      {purpose===19 && (
        <div className="fg"><label className="fl">Τίτλος αιτίας διακίνησης (υποχρεωτικό για 19)</label>
          <input className="fi" style={{fontSize:16,minHeight:52}} value={otherPurposeTitle} onChange={e=>setOtherPurposeTitle(e.target.value)} placeholder="π.χ. Παράδοση προς επεξεργασία" /></div>
      )}

      <div className="fg"><label className="fl">Αριθμός οχήματος (μέσο μεταφοράς)</label>
        <input className="fi" style={{fontSize:16,minHeight:52}} value={vehicleNo} onChange={e=>setVehicleNo(e.target.value)} placeholder="π.χ. ΑΜ 76580" />
        {lastVehicle && vehicleNo === lastVehicle && (
          <div style={{fontSize:11.5,color:"#6b8c6b",marginTop:4}}>Από το προηγούμενο δελτίο — άλλαξέ το αν χρειάζεται</div>
        )}
      </div>

      {preview ? (() => {
        const issuer = issuersList[issuerIdx] || issuersList[0] || {};
        const GRKp=["Α","Β","Γ","Δ","Ε","Ζ","Η","Θ","Ι","Κ"]; const issSeries=GRKp[issuerIdx]||String(issuerIdx+1);
        const partner = partners.find(p=>p.id===partnerId);
        const field = fields.find(f=>f.id===fieldId);
        const pkg = [bins?`${bins} bins`:"", crates?`${crates} κλούβες`:""].filter(Boolean).join(" + ") || "—";
        const purposeLbl = {1:"Πώληση",2:"Πώληση για λ/σμό τρίτων",14:"Αποθήκευση σε τρίτους"}[purpose];
        const R = ({l,v,warn}) => (
          <div style={{display:"flex",gap:12,padding:"7px 0",borderBottom:"1px solid #d4e8d4",fontSize:14}}>
            <span style={{flex:"0 0 110px",color:"#6b8c6b",fontWeight:700,fontSize:12,textTransform:"uppercase"}}>{l}</span>
            <span style={{flex:1,fontWeight:700,color:warn?"#e65100":"#1a2e1a"}}>{v}</span>
          </div>
        );
        return (
          <div style={{background:"#f0f7f0",border:"2px solid #2d8a2d",borderRadius:14,padding:16,marginBottom:12}}>
            <div className="aftitle" style={{marginBottom:10}}>Έλεγχος πριν την έκδοση</div>
            <R l="Εκδότης" v={`${issuersList.length>1?`[Σειρά ${issSeries}] `:""}${[issuer.firstName,issuer.lastName].filter(Boolean).join(" ")||"—"}${issuer.vat?` · ΑΦΜ ${issuer.vat}`:""}`} />
            <R l="Παραλήπτης" v={`${partner?.name||"—"}${partner?.vat?` · ΑΦΜ ${partner.vat}`:""}`} />
            <R l="Αγροτεμάχιο" v={field?`${field.name}${field.city?` · ${field.postal_code||""} ${field.city}`:""}`:"—"} />
            <R l="Είδος" v={`${product?.name||"—"}`} />
            <R l="Συσκευασία" v={pkg} />
            <R l="Ποσότητα" v={`${estimate} kg${toWeigh?" · ΠΡΟΣ ΖΥΓΙΣΗ":""}`} warn={toWeigh} />
            <R l="Σκοπός" v={`${purpose} · ${purposeLbl}`} />
            <R l="Όχημα" v={vehicleNo.trim() || "—"} />
            <div style={{fontSize:12.5,color:"#6b8c6b",marginTop:10}}>
              {toWeigh ? "Η ποσότητα είναι εκτίμηση — οριστικοποιείται στη ζυγαριά του παραλήπτη." : "Το δελτίο θα καταχωρηθεί."}
            </div>
          </div>
        );
      })() : null}

      <div style={{display:"flex",gap:8}}>
        {preview ? (
          <>
            <button className="btn" style={{flex:1,background:"#f0f7f0",color:"#2d5a2d",justifyContent:"center",padding:16,fontSize:16}} onClick={()=>setPreview(false)}>◀ Διόρθωση</button>
            <button className="btn btn-p" style={{flex:2,margin:0,justifyContent:"center",padding:16,fontSize:16,fontWeight:900}} disabled={busy} onClick={doIssue}>{busy?"Αποστολή…":"✓ Επιβεβαίωση & Αποστολή"}</button>
          </>
        ) : (
          <>
            <button className="btn btn-p" style={{flex:2,margin:0,justifyContent:"center",padding:16,fontSize:16,fontWeight:900}} onClick={review}>📄 Συνέχεια</button>
            <button className="btn" style={{flex:1,background:"#f0f7f0",color:"#2d5a2d",justifyContent:"center",padding:16,fontSize:16}} onClick={onCancel}>✕ Άκυρο</button>
          </>
        )}
      </div>
    </div>
  );
}

function DeliveryForm({ f, onChange, onSave, onCancel, saveLabel, fields, msg="" }) {
  return (
    <div className="aform">
      <div className="aftitle">📄 {saveLabel}</div>
      {msg && <div className="msg msg-e">{msg}</div>}

      {/* Βασικά */}
      <div className="fr">
        <div className="fg"><label className="fl">Ημερομηνία *</label>
          <input className="fi" type="date" value={f.date} onChange={e=>onChange("date",e.target.value)} /></div>
        <div className="fg"><label className="fl">Ώρα</label>
          <input className="fi" type="time" value={f.time_of_day} onChange={e=>onChange("time_of_day",e.target.value)} /></div>
      </div>
      <div className="fg"><label className="fl">Αγροτεμάχιο</label>
        <select className="fi" value={f.field_id} onChange={e=>onChange("field_id",e.target.value)}>
          <option value="">— Επιλογή —</option>
          {fields.map(x=><option key={x.id} value={x.id}>{x.name}{x.region?` (${x.region})`:""}</option>)}
        </select></div>
      <div className="fg"><label className="fl">Αγοραστής *</label>
        <input className="fi" placeholder="π.χ. Συνεταιρισμός Ημαθίας" value={f.buyer} onChange={e=>onChange("buyer",e.target.value)} /></div>
      <div className="fr">
        <div className="fg"><label className="fl">Καλλιέργεια</label>
          <input className="fi" placeholder="π.χ. Ροδάκινο" value={f.crop} onChange={e=>onChange("crop",e.target.value)} /></div>
        <div className="fg"><label className="fl">Ποικιλία</label>
          <input className="fi" placeholder="π.χ. Everts" value={f.variety} onChange={e=>onChange("variety",e.target.value)} /></div>
      </div>

      {/* Ζύγιση */}
      <div style={{background:"#f0f7f0",borderRadius:14,padding:14,marginBottom:12}}>
        <div className="aftitle" style={{marginBottom:10}}>⚖️ Ζύγιση</div>
        <div className="fr">
          <div className="fg"><label className="fl">Μικτό (kg)</label>
            <input className="fi" type="number" min="0" step="0.1" placeholder="0" value={f.gross_weight} onChange={e=>onChange("gross_weight",e.target.value)} /></div>
          <div className="fg"><label className="fl">Αποβάρο (kg)</label>
            <input className="fi" type="number" min="0" step="0.1" placeholder="0" value={f.tare_weight} onChange={e=>onChange("tare_weight",e.target.value)} /></div>
        </div>
        <div style={{background:"#e8f5e9",borderRadius:10,padding:"10px 14px",marginBottom:10,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontWeight:700,color:"#1e5c1e"}}>Καθαρά kg:</span>
          <span style={{fontWeight:900,fontSize:20,color:"#1e5c1e"}}>{f.net_weight||"—"} kg</span>
        </div>
        <div className="fg"><label className="fl">% Ακατάλληλα</label>
          <input className="fi" type="number" min="0" max="100" step="0.1" placeholder="0" value={f.reject_percent} onChange={e=>onChange("reject_percent",e.target.value)} /></div>
        <div style={{background:"#2d8a2d",borderRadius:10,padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontWeight:700,color:"#fff"}}>Τελικά kg:</span>
          <span style={{fontWeight:900,fontSize:22,color:"#f4c542"}}>{f.final_weight||"—"} kg</span>
        </div>
      </div>

      {/* Κλούβες/Bins */}
      <div style={{background:"#f0f7f0",borderRadius:14,padding:14,marginBottom:12}}>
        <div className="aftitle" style={{marginBottom:10}}>📦 Κλούβες / Bins</div>
        <div className="fr">
          <div className="fg"><label className="fl">Παράδοση</label>
            <input className="fi" type="number" min="0" placeholder="0" value={f.crates_delivered} onChange={e=>onChange("crates_delivered",e.target.value)} /></div>
          <div className="fg"><label className="fl">Παραλαβή</label>
            <input className="fi" type="number" min="0" placeholder="0" value={f.crates_returned} onChange={e=>onChange("crates_returned",e.target.value)} /></div>
        </div>
      </div>

      {/* Τιμή */}
      <div style={{background:"#fff8e1",borderRadius:14,padding:14,marginBottom:12}}>
        <div className="aftitle" style={{marginBottom:10}}>💰 Τιμή (μπορεί να συμπληρωθεί αργότερα)</div>
        <div className="fg"><label className="fl">Τιμή/kg (€)</label>
          <input className="fi" type="number" min="0" step="0.001" placeholder="0.000" value={f.price_per_kg} onChange={e=>onChange("price_per_kg",e.target.value)} /></div>
        <div style={{background:"#f4c542",borderRadius:10,padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontWeight:700,color:"#1a2e1a"}}>Σύνολο:</span>
          <span style={{fontWeight:900,fontSize:22,color:"#1a2e1a"}}>{f.total_amount||"—"} €</span>
        </div>
      </div>

      <div className="fg"><label className="fl">Σημειώσεις</label>
        <input className="fi" placeholder="Προαιρετικά" value={f.notes} onChange={e=>onChange("notes",e.target.value)} /></div>

      <div style={{display:"flex",gap:8}}>
        <button className="btn btn-p" style={{flex:2,margin:0}} onClick={onSave}>{saveLabel}</button>
        <button className="btn" style={{flex:1,background:"#f0f7f0",color:"#2d5a2d",justifyContent:"center"}} onClick={onCancel}>✕ Άκυρο</button>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// Καταχώρηση Ζύγισης (Δελτίο Παράδοσης συνεταιρισμού)
// Καταγράφει τα ΠΡΑΓΜΑΤΙΚΑ κιλά πάνω στο δελτίο αποστολής.
// ΔΕΝ διαβιβάζεται τίποτα στην ΑΑΔΕ — το παραστατικό αγοράς το
// εκδίδει ο συνεταιρισμός. Εδώ μόνο καταγραφή.
// ═══════════════════════════════════════════════════════════════
const BIN_TARE_KG = 30;   // απόβαρο ανά bin
const CRATE_TARE_KG = 1.7; // απόβαρο ανά κλούβα (1,5–1,9 kg — διορθώνεται με το χέρι)

function WeighModal({ d, lastTare, lastVehicle, onClose, onSave }) {
  const binsN = parseInt(d.bins_delivered, 10) || 0;
  const cratesN = parseInt(d.crates_delivered, 10) || 0;
  const autoPack = binsN * BIN_TARE_KG + cratesN * CRATE_TARE_KG;
  // Αν δεν έχει καταχωρηθεί ακόμα, προσυμπληρώνεται από την τελευταία ζύγιση
  const tareFromLast = d.tare_weight == null && lastTare != null;
  const vehFromLast = !d.vehicle_no && !!lastVehicle;
  const [w, setW] = useState({
    gross_weight: d.gross_weight != null ? String(d.gross_weight) : "",
    tare_weight: d.tare_weight != null ? String(d.tare_weight) : (lastTare != null ? String(lastTare) : ""),
    packaging_tare: d.packaging_tare != null ? String(d.packaging_tare) : (autoPack ? String(autoPack) : ""),
    reject_percent: d.reject_percent != null ? String(d.reject_percent) : "",
    price_per_kg: d.price_per_kg != null ? String(d.price_per_kg) : "",
    coop_doc_no: d.coop_doc_no || "",
    quality_check_no: d.quality_check_no || "",
    vehicle_no: d.vehicle_no || (lastVehicle || ""),
  });
  const [busy, setBusy] = useState(false);
  const up = (k, v) => setW(p => ({ ...p, [k]: v }));
  const num = v => parseFloat(v) || 0;

  // Αλυσίδα υπολογισμού (όπως το δελτίο του συνεταιρισμού)
  const netRaw = num(w.gross_weight) - num(w.tare_weight) - num(w.packaging_tare);
  const net = netRaw > 0 ? netRaw : 0;
  const payable = net * (1 - num(w.reject_percent) / 100);
  const total = payable * num(w.price_per_kg);

  const save = async () => {
    setBusy(true);
    await onSave({
      gross_weight: w.gross_weight === "" ? null : num(w.gross_weight),
      tare_weight: w.tare_weight === "" ? null : num(w.tare_weight),
      packaging_tare: w.packaging_tare === "" ? null : num(w.packaging_tare),
      net_weight: net > 0 ? Number(net.toFixed(1)) : null,
      reject_percent: w.reject_percent === "" ? null : num(w.reject_percent),
      final_weight: payable > 0 ? Number(payable.toFixed(1)) : null,
      price_per_kg: w.price_per_kg === "" ? null : num(w.price_per_kg),
      total_amount: total > 0 ? Number(total.toFixed(2)) : null,
      coop_doc_no: w.coop_doc_no.trim() || null,
      quality_check_no: w.quality_check_no.trim() || null,
      vehicle_no: w.vehicle_no.trim() || null,
      to_weigh: false,
    });
    setBusy(false);
    onClose();
  };

  const rowBox = { background:"#e8f5e9", borderRadius:10, padding:"11px 14px", display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:10001,display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={onClose}>
      <div style={{background:"#fff",borderRadius:"20px 20px 0 0",padding:18,width:"100%",maxWidth:520,maxHeight:"92vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
        <div className="aftitle" style={{marginBottom:4}}>⚖️ Καταχώρηση Ζύγισης</div>
        <div style={{fontSize:12.5,color:"#6b8c6b",marginBottom:14}}>
          Δελτίο <b>{d.dn_series||"0"}-{d.dn_aa}</b> · {d.buyer}
          <br/>Γράψε τα νούμερα από το δελτίο παράδοσης του συνεταιρισμού.
        </div>

        <div className="fr">
          <div className="fg"><label className="fl">Μικτό βάρος (kg)</label>
            <input className="fi" type="number" min="0" step="0.1" placeholder="0" value={w.gross_weight} onChange={e=>up("gross_weight",e.target.value)} /></div>
          <div className="fg"><label className="fl">Απόβαρο οχήματος (kg)</label>
            <input className="fi" type="number" min="0" step="0.1" placeholder="0" value={w.tare_weight} onChange={e=>up("tare_weight",e.target.value)} />
            {tareFromLast && String(lastTare) === w.tare_weight && (
              <div style={{fontSize:11.5,color:"#6b8c6b",marginTop:4}}>Από την προηγούμενη ζύγιση — άλλαξέ το αν χρειάζεται</div>
            )}</div>
        </div>

        <div className="fg"><label className="fl">Απόβαρο υλικών συσκ. (kg)</label>
          <input className="fi" type="number" min="0" step="0.1" placeholder="0" value={w.packaging_tare} onChange={e=>up("packaging_tare",e.target.value)} />
          {autoPack > 0 && (
            <div style={{fontSize:11.5,color:"#6b8c6b",marginTop:4}}>
              Αυτόματο: {binsN ? `${binsN} bins × ${BIN_TARE_KG}` : ""}{binsN && cratesN ? " + " : ""}{cratesN ? `${cratesN} κλούβες × ${CRATE_TARE_KG}` : ""} = <b>{autoPack} kg</b>
              {String(autoPack) !== w.packaging_tare && (
                <button onClick={()=>up("packaging_tare",String(autoPack))} style={{marginLeft:8,padding:"2px 8px",borderRadius:8,border:"1px solid #cfe0cf",background:"#f4faf0",color:"#2d5a2d",fontWeight:800,fontSize:11,cursor:"pointer"}}>Επαναφορά</button>
              )}
            </div>
          )}
        </div>

        <div style={rowBox}>
          <span style={{fontWeight:800,color:"#1e5c1e"}}>Καθαρά κιλά</span>
          <span style={{fontWeight:900,fontSize:20,color:"#1e5c1e",fontFamily:"monospace"}}>{net > 0 ? net.toFixed(1) : "—"} kg</span>
        </div>

        <div className="fg"><label className="fl">Ποσοστό απομείωσης (%)</label>
          <input className="fi" type="number" min="0" max="100" step="0.1" placeholder="0" value={w.reject_percent} onChange={e=>up("reject_percent",e.target.value)} /></div>

        <div style={{background:"#2d8a2d",borderRadius:10,padding:"12px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
          <span style={{fontWeight:800,color:"#fff"}}>Πληρωτέα κιλά</span>
          <span style={{fontWeight:900,fontSize:23,color:"#f4c542",fontFamily:"monospace"}}>{payable > 0 ? payable.toFixed(1) : "—"} kg</span>
        </div>

        <div className="fr">
          <div className="fg"><label className="fl">Τιμή (€/kg)</label>
            <input className="fi" type="number" min="0" step="0.001" placeholder="0" value={w.price_per_kg} onChange={e=>up("price_per_kg",e.target.value)} /></div>
          <div className="fg"><label className="fl">Σύνολο</label>
            <div className="fi" style={{display:"flex",alignItems:"center",fontWeight:900,color:"#1e5c1e",background:"#f4faf0"}}>{total > 0 ? total.toFixed(2)+" €" : "—"}</div></div>
        </div>

        <div style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:13.5,color:"#6b8c6b",margin:"6px 0 8px"}}>Στοιχεία παραστατικού συνεταιρισμού (προαιρετικά)</div>
        <div className="fg"><label className="fl">Αρ. παραστατικού</label>
          <input className="fi" placeholder="π.χ. ΔΠΑ0000023" value={w.coop_doc_no} onChange={e=>up("coop_doc_no",e.target.value)} /></div>
        <div className="fr">
          <div className="fg"><label className="fl">Α/Α ποιοτικού ελέγχου</label>
            <input className="fi" placeholder="π.χ. 1959" value={w.quality_check_no} onChange={e=>up("quality_check_no",e.target.value)} /></div>
          <div className="fg"><label className="fl">Αριθμός οχήματος</label>
            <input className="fi" placeholder="π.χ. ΑΜ 76580" value={w.vehicle_no} onChange={e=>up("vehicle_no",e.target.value)} />
            {vehFromLast && lastVehicle === w.vehicle_no && (
              <div style={{fontSize:11.5,color:"#6b8c6b",marginTop:4}}>Από την προηγούμενη ζύγιση — άλλαξέ το αν χρειάζεται</div>
            )}</div>
        </div>

        <div style={{display:"flex",gap:10,marginTop:16}}>
          <button className="btn btn-p" style={{flex:2,margin:0,opacity:busy?.6:1}} disabled={busy} onClick={save}>{busy?"Αποθήκευση…":"✅ Αποθήκευση ζύγισης"}</button>
          <button className="btn" style={{flex:1,background:"#f0f7f0",color:"#2d5a2d",justifyContent:"center"}} onClick={onClose}>✕ Άκυρο</button>
        </div>
      </div>
    </div>
  );
}

function DeliveriesTab() {
  const { fields, deliveries, addDelivery, updateDelivery, deleteDelivery, settings, user } = useApp();
  const amountsVisible = window._amountsVisible || false;
  const [showForm, setShowForm] = useState(false);
  const [showIssue, setShowIssue] = useState(false);
  useEffect(() => { if (window._autoOpenIssue) { window._autoOpenIssue = false; setShowIssue(true); } }, []);
  const [noteHtml, setNoteHtml] = useState(null);
  const [cancelId, setCancelId] = useState(null);
  const [editWarnId, setEditWarnId] = useState(null);
  const [cancelling, setCancelling] = useState(false);
  const [confirmId, setConfirmId] = useState(null);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({});
  const [dnFilter, setDnFilter] = useState("week"); // today | week | all
  const [expandedId, setExpandedId] = useState(null);
  const [weighId, setWeighId] = useState(null);
  const [partnersList, setPartnersList] = useState([]);
  useEffect(() => { supabase.from("dn_partners").select("id,name").then(({data})=>setPartnersList(data||[])); }, []);
  const [listOpen, setListOpen] = useState(false);
  const [msg, setMsg] = useState("");

  const today = new Date().toISOString().split("T")[0];
  const now = new Date().toTimeString().slice(0,5);
  const empty = { date:today, time_of_day:now, field_id:"", buyer:"", crop:"", variety:"", gross_weight:"", tare_weight:"", net_weight:"", crates_delivered:"", crates_returned:"", reject_percent:"", final_weight:"", price_per_kg:"", total_amount:"", notes:"", paid:false };
  const [form, setForm] = useState(empty);
  const up = (k,v) => setForm(p => {
    const n = {...p,[k]:v};
    // Auto calculate net_weight
    if (k==="gross_weight"||k==="tare_weight") {
      const net = (parseFloat(k==="gross_weight"?v:n.gross_weight)||0) - (parseFloat(k==="tare_weight"?v:n.tare_weight)||0);
      n.net_weight = net > 0 ? net.toFixed(1) : "";
      // Auto calculate final_weight
      const rej = parseFloat(n.reject_percent)||0;
      const final = net * (1 - rej/100);
      n.final_weight = final > 0 ? final.toFixed(1) : "";
      // Auto total
      if (n.price_per_kg) n.total_amount = (final * parseFloat(n.price_per_kg)).toFixed(2);
    }
    if (k==="reject_percent") {
      const net = parseFloat(n.net_weight)||0;
      const final = net * (1 - (parseFloat(v)||0)/100);
      n.final_weight = final > 0 ? final.toFixed(1) : "";
      if (n.price_per_kg) n.total_amount = (final * parseFloat(n.price_per_kg)).toFixed(2);
    }
    if (k==="price_per_kg") {
      const final = parseFloat(n.final_weight)||0;
      n.total_amount = final > 0 ? (final * (parseFloat(v)||0)).toFixed(2) : "";
    }
    if (k==="final_weight") {
      if (n.price_per_kg) n.total_amount = ((parseFloat(v)||0) * parseFloat(n.price_per_kg)).toFixed(2);
    }
    return n;
  });

  const upE = (k,v) => setEditData(p => {
    const n = {...p,[k]:v};
    if (k==="gross_weight"||k==="tare_weight") {
      const net = (parseFloat(k==="gross_weight"?v:n.gross_weight)||0) - (parseFloat(k==="tare_weight"?v:n.tare_weight)||0);
      n.net_weight = net > 0 ? net.toFixed(1) : "";
      const rej = parseFloat(n.reject_percent)||0;
      const final = net * (1 - rej/100);
      n.final_weight = final > 0 ? final.toFixed(1) : "";
      if (n.price_per_kg) n.total_amount = (final * parseFloat(n.price_per_kg)).toFixed(2);
    }
    if (k==="reject_percent") {
      const net = parseFloat(n.net_weight)||0;
      const final = net * (1 - (parseFloat(v)||0)/100);
      n.final_weight = final > 0 ? final.toFixed(1) : "";
      if (n.price_per_kg) n.total_amount = (final * parseFloat(n.price_per_kg)).toFixed(2);
    }
    if (k==="price_per_kg") {
      const final = parseFloat(n.final_weight)||0;
      n.total_amount = final > 0 ? (final * (parseFloat(v)||0)).toFixed(2) : "";
    }
    return n;
  });

  const handleSave = async () => {
    if (!form.date || !form.buyer) { setMsg("Συμπλήρωσε ημερομηνία και αγοραστή"); return; }
    const item = {
      ...form,
      gross_weight: parseFloat(form.gross_weight)||null,
      tare_weight: parseFloat(form.tare_weight)||null,
      net_weight: parseFloat(form.net_weight)||null,
      crates_delivered: parseInt(form.crates_delivered)||null,
      crates_returned: parseInt(form.crates_returned)||null,
      reject_percent: parseFloat(form.reject_percent)||null,
      final_weight: parseFloat(form.final_weight)||null,
      price_per_kg: parseFloat(form.price_per_kg)||null,
      total_amount: parseFloat(form.total_amount)||null,
    };
    const ok = await addDelivery(item);
    if (ok) { setForm(empty); setShowForm(false); setMsg(""); }
    else setMsg("Σφάλμα αποθήκευσης.");
  };

  const handleSaveEdit = async () => {
    const upd = {
      ...editData,
      gross_weight: parseFloat(editData.gross_weight)||null,
      tare_weight: parseFloat(editData.tare_weight)||null,
      net_weight: parseFloat(editData.net_weight)||null,
      crates_delivered: parseInt(editData.crates_delivered)||null,
      crates_returned: parseInt(editData.crates_returned)||null,
      reject_percent: parseFloat(editData.reject_percent)||null,
      final_weight: parseFloat(editData.final_weight)||null,
      price_per_kg: parseFloat(editData.price_per_kg)||null,
      total_amount: parseFloat(editData.total_amount)||null,
    };
    await updateDelivery(editId, upd);
    setEditId(null);
  };

  // Εκτύπωση/PDF δελτίου: άνοιγμα ΜΕΣΑ στην εφαρμογή (modal), όχι νέα καρτέλα (PWA-safe)
  const printNote = async (d) => {
    setMsg("Δημιουργία δελτίου…"); setTimeout(()=>setMsg(""),1500);
    const dnAll = (settings && settings.dn) || {};
    const issuersAll = (Array.isArray(dnAll.issuers) && dnAll.issuers.length) ? dnAll.issuers : (dnAll.issuer ? [dnAll.issuer] : []);
    const issuer = (d.issuer_vat ? issuersAll.find(x => (x.vat||"").trim() === String(d.issuer_vat).trim()) : null) || dnAll.issuer || issuersAll[0] || {};
    const field = fields.find(f=>f.id===d.field_id) || null;
    let partner = null;
    if (d.partner_id) { const { data } = await supabase.from("dn_partners").select("*").eq("id", d.partner_id).single(); partner = data; }
    setNoteHtml(buildNoteHtml(d, issuer, field, partner));
  };

  // Ακύρωση δελτίου στην ΑΑΔΕ (CancelInvoice)
  const doCancel = async (d) => {
    setCancelling(true);
    const withTimeout = (promise, ms) => Promise.race([
      promise, new Promise((_, rej) => setTimeout(() => rej(new Error("timeout")), ms)),
    ]);
    try {
      console.log("AGROPALK: ακύρωση δελτίου, ΜΑΡΚ=", d.mark, "εκδότης=", d.issuer_vat);
      const { data, error } = await withTimeout(supabase.functions.invoke("send-delivery-note", {
        body: { action: "cancel", farmerId: user.id, mark: d.mark, issuerVat: d.issuer_vat || "" },
      }), 25000);
      console.log("AGROPALK: απάντηση ακύρωσης", { data, error });
      let errBody = null;
      if (error && error.context && typeof error.context.clone === "function") {
        try { errBody = await error.context.clone().json(); } catch (_) {}
      }
      if (error || !data || data.ok === false) {
        const src = errBody || data;
        const emsg = (src && (src.aadeError || src.error || src.raw)) || (error && error.message) || "Άγνωστο σφάλμα";
        console.warn("AGROPALK: ακύρωση απέτυχε", emsg);
        setMsg("Αποτυχία ακύρωσης: " + emsg); setTimeout(()=>setMsg(""), 8000);
        setCancelling(false); setCancelId(null);
        return;
      }
      console.log("AGROPALK: ακύρωση OK, ΜΑΡΚ ακύρωσης=", data.cancelMark);
      await updateDelivery(d.id, { cancel_mark: String(data.cancelMark), cancelled_at: new Date().toISOString() });
      // Επανάφερε τα bins/κλούβες που είχε αφαιρέσει το δελτίο (αντιστροφή κίνησης)
      const backBins = d.bins_delivered || 0;
      const backCrates = d.crates_delivered || 0;
      if ((backBins || backCrates) && d.partner_id) {
        try {
          await supabase.from("dn_container_moves").insert({
            user_id: user.id, partner_id: d.partner_id, kind: "pickup_empty",
            bins: backBins, crates: backCrates, date: new Date().toISOString().split("T")[0],
            issuer_vat: (d.issuer_vat || "").trim() || null,
          });
        } catch (_) {}
      }
      setMsg("✅ Το δελτίο ακυρώθηκε στην ΑΑΔΕ (ΜΑΡΚ ακύρωσης " + data.cancelMark + ")");
      setTimeout(()=>setMsg(""), 5000);
    } catch (e) {
      console.error("AGROPALK: εξαίρεση ακύρωσης", e);
      setMsg("Σφάλμα ακύρωσης: " + (e.message || e)); setTimeout(()=>setMsg(""), 6000);
    }
    setCancelling(false); setCancelId(null);
  };


  // Σύνολα
  const totalKg = deliveries.reduce((s,d)=>s+(parseFloat(d.final_weight)||0),0);
  const totalEur = deliveries.reduce((s,d)=>{
    if (d.cancel_mark) return s;
    const amt = (d.final_weight!=null && d.price_per_kg!=null)
      ? (parseFloat(d.final_weight)||0)*(parseFloat(d.price_per_kg)||0)
      : (parseFloat(d.total_amount)||0);
    return s + amt;
  },0);
  const unpaid = deliveries.filter(d=>!d.paid && d.total_amount).length;

  return (
    <div>
      {noteHtml && (
        <div style={{position:"fixed",inset:0,zIndex:9999,background:"rgba(0,0,0,0.55)",display:"flex",flexDirection:"column"}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8,padding:"10px 14px",background:"#111",color:"#fff"}}>
            <button onClick={()=>setNoteHtml(null)} style={{fontSize:16,fontWeight:700,background:"#333",color:"#fff",border:"none",borderRadius:10,padding:"10px 16px"}}>✕ Κλείσιμο</button>
            <span style={{fontWeight:700,fontSize:15}}>Δελτίο Αποστολής</span>
            <button onClick={()=>{try{const f=document.getElementById("noteFrame");f&&f.contentWindow&&f.contentWindow.print();}catch(e){}}} style={{fontSize:16,fontWeight:700,background:"#2e7d32",color:"#fff",border:"none",borderRadius:10,padding:"10px 16px"}}>🖨 Εκτύπωση</button>
          </div>
          <iframe id="noteFrame" title="Δελτίο" srcDoc={noteHtml} style={{flex:1,width:"100%",border:"none",background:"#fff"}} />
        </div>
      )}
      {weighId && (() => {
        const wd = deliveries.find(x=>x.id===weighId);
        if (!wd) return null;
        // Τελευταία γνωστή τιμή απόβαρου/οχήματος από προηγούμενη ζύγιση
        const prev = deliveries
          .filter(x => x.id !== wd.id)
          .sort((a,b) => (b.date||"").localeCompare(a.date||"") || (b.time_of_day||"").localeCompare(a.time_of_day||"") || (b.dn_aa||0)-(a.dn_aa||0));
        const lastTare = (prev.find(x => x.tare_weight != null) || {}).tare_weight ?? null;
        const lastVehicle = (prev.find(x => x.vehicle_no) || {}).vehicle_no || "";
        return <WeighModal d={wd} lastTare={lastTare} lastVehicle={lastVehicle} onClose={()=>setWeighId(null)} onSave={(patch)=>updateDelivery(wd.id, patch)} />;
      })()}
      {confirmId && (() => {
        const dd = deliveries.find(x=>x.id===confirmId);
        const isArchival = dd && (dd.cancel_mark || dd.mark);
        const msg = dd && dd.cancel_mark
          ? `Αυτό το δελτίο είναι ΑΚΥΡΩΜΕΝΟ στην ΑΑΔΕ και διατηρείται για το αρχείο σου. Η οριστική διαγραφή δεν συνιστάται. Θέλεις σίγουρα να το διαγράψεις;`
          : dd && dd.mark
            ? `Αυτή η παράδοση έχει διαβιβασμένο δελτίο (ΜΑΡΚ). Η οριστική διαγραφή δεν συνιστάται. Θέλεις σίγουρα να τη διαγράψεις;`
            : "Διαγραφή παράδοσης;";
        return <ConfirmDialog msg={msg} onYes={()=>{deleteDelivery(confirmId);setConfirmId(null);}} onNo={()=>setConfirmId(null)} />;
      })()}
      {editWarnId && (() => {
        const d = deliveries.find(x=>x.id===editWarnId);
        const hasMark = d && d.mark && !d.cancel_mark;
        const aaLabel = d ? `${d.dn_series||"0"}-${d.dn_aa}` : "";
        return (
          <div style={{position:"fixed",inset:0,zIndex:10002,background:"rgba(0,0,0,.6)",display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
            <div style={{background:"#fff",borderRadius:18,maxWidth:400,width:"100%",padding:"22px 20px",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
              {hasMark ? (<>
                <div style={{fontSize:40,textAlign:"center"}}>⚠️</div>
                <div style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:19,color:"#c62828",textAlign:"center",marginTop:6}}>Το δελτίο δεν διορθώνεται</div>
                <div style={{fontSize:14,color:"#2a3a2a",lineHeight:1.55,marginTop:12,textAlign:"center"}}>
                  Το δελτίο <b>{aaLabel}</b> έχει διαβιβαστεί στην ΑΑΔΕ (ΜΑΡΚ {d.mark}) και <b>δεν επιτρέπεται</b> να τροποποιηθεί.<br/><br/>
                  Αν έχει λάθος, ο μόνος νόμιμος τρόπος είναι να το <b>ακυρώσεις</b> και να εκδώσεις νέο.
                </div>
                <div style={{display:"flex",gap:10,marginTop:20}}>
                  <button onClick={()=>setEditWarnId(null)} style={{flex:1,padding:14,borderRadius:12,border:"1.5px solid #ccc",background:"#f7f7f7",fontWeight:800,fontSize:15,cursor:"pointer"}}>Άκυρο</button>
                  <button onClick={()=>{ setEditWarnId(null); setCancelId(d.id); }} style={{flex:1,padding:14,borderRadius:12,border:"none",background:"#c62828",color:"#fff",fontWeight:800,fontSize:15,cursor:"pointer"}}>Ακύρωση δελτίου</button>
                </div>
              </>) : (<>
                <div style={{fontSize:40,textAlign:"center"}}>✏️</div>
                <div style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:19,color:"#1a2e1a",textAlign:"center",marginTop:6}}>Διόρθωση Παράδοσης {aaLabel}</div>
                <div style={{fontSize:14,color:"#2a3a2a",lineHeight:1.55,marginTop:12,textAlign:"center"}}>
                  Θα διορθώσεις τη <b>συγκεκριμένη παράδοση{aaLabel?` (${aaLabel})`:""}</b>. Θέλεις να συνεχίσεις;
                </div>
                <div style={{display:"flex",gap:10,marginTop:20}}>
                  <button onClick={()=>setEditWarnId(null)} style={{flex:1,padding:14,borderRadius:12,border:"1.5px solid #ccc",background:"#f7f7f7",fontWeight:800,fontSize:15,cursor:"pointer"}}>Άκυρο</button>
                  <button onClick={()=>{ setEditId(d.id); setEditData({...d,gross_weight:d.gross_weight||"",tare_weight:d.tare_weight||"",net_weight:d.net_weight||"",crates_delivered:d.crates_delivered||"",crates_returned:d.crates_returned||"",reject_percent:d.reject_percent||"",final_weight:d.final_weight||"",price_per_kg:d.price_per_kg||"",total_amount:d.total_amount||""}); setShowForm(false); setEditWarnId(null); }} style={{flex:1,padding:14,borderRadius:12,border:"none",background:"#1e5c1e",color:"#fff",fontWeight:800,fontSize:15,cursor:"pointer"}}>Συνέχεια</button>
                </div>
              </>)}
            </div>
          </div>
        );
      })()}
      {cancelId && (() => {
        const d = deliveries.find(x=>x.id===cancelId);
        return (
          <div style={{position:"fixed",inset:0,zIndex:10002,background:"rgba(0,0,0,.6)",display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
            <div style={{background:"#fff",borderRadius:18,maxWidth:400,width:"100%",padding:"22px 20px",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
              <div style={{fontSize:40,textAlign:"center"}}>⚠️</div>
              <div style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:19,color:"#c62828",textAlign:"center",marginTop:6}}>Ακύρωση δελτίου στην ΑΑΔΕ</div>
              <div style={{fontSize:14,color:"#2a3a2a",lineHeight:1.55,marginTop:12,textAlign:"center"}}>
                Θα ακυρωθεί οριστικά το δελτίο <b>0-{d?.dn_aa}</b> (ΜΑΡΚ {d?.mark}) στην ΑΑΔΕ.<br/>
                <span style={{color:"#c62828",fontWeight:700}}>Η ενέργεια δεν αναιρείται.</span>
              </div>
              <div style={{display:"flex",gap:10,marginTop:20}}>
                <button disabled={cancelling} onClick={()=>setCancelId(null)} style={{flex:1,padding:14,borderRadius:12,border:"1.5px solid #ccc",background:"#f7f7f7",fontWeight:800,fontSize:15,cursor:"pointer"}}>Άκυρο</button>
                <button disabled={cancelling} onClick={()=>doCancel(d)} style={{flex:1,padding:14,borderRadius:12,border:"none",background:"#c62828",color:"#fff",fontWeight:800,fontSize:15,cursor:"pointer"}}>{cancelling?"Ακύρωση…":"Ναι, ακύρωσε"}</button>
              </div>
            </div>
          </div>
        );
      })()}

      <div className="stitle">📄 Παραδόσεις <span className="cnt">{deliveries.filter(d=>!d.cancel_mark).length}</span></div>
      {msg && !showForm && !showIssue && !editId && <div className="msg msg-s">{msg}</div>}

      {/* Summary */}
      {deliveries.length > 0 && (
        <div style={{background:"linear-gradient(135deg,#1e5c1e,#2d8a2d)",borderRadius:16,padding:"14px 16px",marginBottom:14,color:"#fff"}}>
          <div style={{display:"flex",justifyContent:"space-between"}}>
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:22,fontWeight:900}}>{totalKg.toFixed(0)}</div>
              <div style={{fontSize:11,opacity:.8}}>Συν. kg</div>
            </div>
            <div style={{textAlign:"center"}}>
              <div className={`amount ${amountsVisible?"":"blurred"}`} style={{fontSize:22,fontWeight:900}}>{totalEur.toFixed(2)}€</div>
              <div style={{fontSize:11,opacity:.8}}>Συν. Αξία</div>
            </div>
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:22,fontWeight:900,color:unpaid>0?"#f4c542":"#a5d6a7"}}>{unpaid}</div>
              <div style={{fontSize:11,opacity:.8}}>Εκκρεμείς</div>
            </div>
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:22,fontWeight:900}}>{deliveries.filter(d=>!d.cancel_mark).length}</div>
              <div style={{fontSize:11,opacity:.8}}>Παραδόσεις</div>
            </div>
          </div>
        </div>
      )}

      {(() => {
        const isReturnNote = (d) => d.other_purpose_title === "Επιστροφή στον συνεταιρισμό" || d.crop === "Άδεια Bins" || d.crop === "Άδεια Κλούβες" || Number(d.move_purpose) === 5;
        const pending = deliveries.filter(d => d.mark && !d.cancel_mark && !d.final_weight && !isReturnNote(d));
        if (!pending.length) return null;
        const nm = (id) => (partnersList.find(p=>p.id===id)||{}).name || "";
        return (
          <div style={{background:"#fff8e1",border:"2px solid #f4c542",borderRadius:14,padding:14,marginBottom:14}}>
            <div style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:15.5,color:"#8a6d1a",display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
              ⚖️ Εκκρεμείς παραδόσεις <span style={{background:"#f4c542",color:"#5a4600",borderRadius:20,padding:"1px 10px",fontSize:13,fontWeight:900}}>{pending.length}</span>
            </div>
            <div style={{fontSize:12.5,color:"#8a7333",marginBottom:10}}>Δελτία που στάλθηκαν και περιμένουν να καταχωρήσεις τα πραγματικά κιλά.</div>
            {pending.map(d => (
              <div key={d.id} onClick={()=>setWeighId(d.id)} style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,padding:"10px 12px",background:"#fff",border:"1px solid #f0e2b0",borderRadius:10,marginBottom:6,cursor:"pointer"}}>
                <div style={{minWidth:0}}>
                  <div style={{fontWeight:800,fontSize:14,color:"#1a2e1a"}}>Δελτίο {d.dn_series||"0"}-{d.dn_aa} · {d.bins_delivered||0} bins{d.crates_delivered?` · ${d.crates_delivered} κλ.`:""}</div>
                  <div style={{fontSize:12,color:"#6b8c6b",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{d.date} · {nm(d.partner_id)}</div>
                </div>
                <span style={{background:"#f4c542",color:"#5a4600",borderRadius:10,padding:"7px 12px",fontWeight:800,fontSize:12.5,whiteSpace:"nowrap"}}>⚖️ Κιλά</span>
              </div>
            ))}
          </div>
        );
      })()}

      <ContainerBalance />

      <div style={{display:"flex",gap:8}}>
        <button className="btn btn-p" style={{flex:1}} onClick={()=>{setShowIssue(!showIssue);setShowForm(false);}}>
          {showIssue?"✕ Άκυρο":"📄 Έκδοση δελτίου"}
        </button>
        <button className="btn" style={{flex:1,background:"#e8f5e9",color:"#1e5c1e",justifyContent:"center"}} onClick={()=>{setShowForm(!showForm);setShowIssue(false);}}>
          {showForm?"✕ Άκυρο":"➕ Νέα Παράδοση"}
        </button>
      </div>

      {showIssue && (
        <DeliveryNoteIssue fields={fields}
          onCancel={()=>setShowIssue(false)}
          onDone={(m)=>{setShowIssue(false);setMsg(m);setTimeout(()=>setMsg(""),3500);}} />
      )}

      {showForm && !editId && (
        <DeliveryForm f={form} onChange={up} onSave={handleSave} onCancel={()=>setShowForm(false)} saveLabel="✅ Αποθήκευση Παράδοσης" fields={fields} msg={msg} />
      )}

      {deliveries.length === 0 ? <Empty icon="📄" text="Δεν υπάρχουν παραδόσεις ακόμα" /> : (() => {
        const todayStr = today;
        const weekAgo = new Date(Date.now() - 7*24*3600*1000).toISOString().split("T")[0];
        const filtered = deliveries.filter(d => {
          if (dnFilter === "all") return true;
          if (dnFilter === "today") return d.date === todayStr;
          return (d.date || "") >= weekAgo; // week
        }).sort((a,b) => {
          // πιο πρόσφατο πρώτο: κατά ημερομηνία, μετά κατά αύξοντα αριθμό δελτίου
          const dc = (b.date||"").localeCompare(a.date||"");
          if (dc !== 0) return dc;
          const tc = (b.time_of_day||"").localeCompare(a.time_of_day||"");
          if (tc !== 0) return tc;
          return (b.dn_aa||0) - (a.dn_aa||0);
        });
        const fbtn = (id, lb) => (
          <button onClick={()=>setDnFilter(id)} style={{flex:1,padding:"9px 6px",borderRadius:10,border:"none",fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:13.5,cursor:"pointer",
            background: dnFilter===id ? "#1e5c1e" : "#eef4ee", color: dnFilter===id ? "#fff" : "#6b8c6b"}}>{lb}</button>
        );
        const statusChip = (d) => {
          if (d.cancel_mark) return <span style={{background:"#ffebee",color:"#c62828",borderRadius:7,padding:"2px 8px",fontWeight:800,fontSize:11}}>❌ Άκυρο</span>;
          if (d.to_weigh && !(d.final_weight||d.net_weight)) return <span style={{background:"#fff8e1",color:"#e65100",borderRadius:7,padding:"2px 8px",fontWeight:700,fontSize:11}}>Προς ζύγιση</span>;
          if (d.mark) return <span style={{background:"#e8f5e9",color:"#1e5c1e",borderRadius:7,padding:"2px 8px",fontWeight:700,fontSize:11}}>✓ ΜΑΡΚ</span>;
          if (d.dn_aa) return <span style={{background:"#eceff1",color:"#546e7a",borderRadius:7,padding:"2px 8px",fontWeight:700,fontSize:11}}>Εκκρεμεί</span>;
          return null;
        };
        return (<>
          <div onClick={()=>setListOpen(o=>!o)} style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:17,color:listOpen?"#fff":"#1a2e1a",margin:"6px 0 10px",display:"flex",alignItems:"center",gap:10,cursor:"pointer",userSelect:"none",background:listOpen?"#1e5c1e":"#eef7ee",border:"2px solid #1e5c1e",borderRadius:14,padding:"14px 16px"}}>
            📄 Τα δελτία σου <span style={{fontSize:13,fontWeight:800,color:listOpen?"#cde8cd":"#2d8a2d"}}>({filtered.filter(x=>!x.cancel_mark).length})</span>
            <span style={{marginLeft:"auto",width:34,height:34,borderRadius:"50%",background:listOpen?"rgba(255,255,255,.2)":"#1e5c1e",color:"#fff",fontSize:24,fontWeight:900,display:"flex",alignItems:"center",justifyContent:"center",transform:listOpen?"rotate(90deg)":"none",transition:"transform .2s"}}>›</span>
          </div>
          {listOpen && (<>
          <div style={{display:"flex",gap:6,margin:"4px 0 10px"}}>
            {fbtn("today","Σήμερα")}{fbtn("week","7 ημέρες")}{fbtn("all","Όλα")}
          </div>
          {filtered.length === 0 ? <Empty icon="📄" text="Καμία παράδοση σε αυτό το διάστημα" /> :
            filtered.map(d => {
              const open = expandedId === d.id || editId === d.id;
              if (!open) {
                // ── Συμπαγής γραμμή ──
                return (
                  <div key={d.id} onClick={()=>setExpandedId(d.id)} style={{background:"#fff",border:"1px solid #e5ede5",borderRadius:12,padding:"11px 14px",margin:"7px 0",cursor:"pointer",display:"flex",alignItems:"center",gap:10}}>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontWeight:800,fontSize:14.5,color:"#1a2e1a",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>
                        {d.dn_aa ? <span style={{color:d.cancel_mark?"#9e9e9e":"#1e5c1e",fontFamily:"monospace",fontSize:13}}>{d.dn_series||"0"}-{d.dn_aa} · </span> : null}{d.buyer}
                      </div>
                      <div style={{fontSize:12.5,color:"#6b8c6b",marginTop:2}}>📅 {d.date}{d.crop?` · ${d.crop}`:""}</div>
                      {d.mark ? <div style={{fontSize:11.5,color:d.cancel_mark?"#9e9e9e":"#2d8a2d",marginTop:2,fontFamily:"monospace",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{d.cancel_mark?"❌ ":"✓ "}ΜΑΡΚ {d.mark}</div> : null}
                    </div>
                    <div style={{textAlign:"right",flex:"none",display:"flex",flexDirection:"column",alignItems:"flex-end",gap:3}}>
                      {statusChip(d)}
                      {(d.final_weight||d.net_weight) ? <span style={{fontSize:12,fontWeight:800,color:"#1e5c1e"}}>{d.final_weight||d.net_weight} kg</span> : null}
                    </div>
                    <span style={{flex:"none",width:32,height:32,borderRadius:"50%",background:"#eef7ee",color:"#2d8a2d",fontSize:20,fontWeight:900,display:"flex",alignItems:"center",justifyContent:"center"}}>›</span>
                  </div>
                );
              }
              // ── Ανοιχτή κάρτα (πλήρης) ──
              return (
                <div key={d.id} className="card">
                  {editId === d.id ? (
                    <>
                      <div style={{background:"#e8f5e9",border:"1.5px solid #1e5c1e",borderRadius:12,padding:"10px 14px",marginBottom:12,fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:14.5,color:"#1e5c1e"}}>
                        ✏️ Διορθώνεις την Παράδοση{d.dn_aa?` · Δελτίο ${d.dn_series||"0"}-${d.dn_aa}`:""}
                      </div>
                      <DeliveryForm f={editData} onChange={upE} onSave={handleSaveEdit} onCancel={()=>setEditId(null)} saveLabel="✅ Αποθήκευση Αλλαγών" fields={fields} msg={msg} />
                    </>
                  ) : (
                    <div>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                        <div style={{flex:1,cursor:"pointer"}} onClick={()=>setExpandedId(null)}>
                          <div className="ctitle" style={{display:"flex",alignItems:"center",gap:8}}>{d.buyer} <span style={{color:"#7cb342",fontSize:20,fontWeight:800,transform:"rotate(90deg)",display:"inline-block"}}>›</span></div>
                          <div className="csub">📅 {d.date}{d.time_of_day?` · ${d.time_of_day}`:""}</div>
                          {d.crop && <div className="csub">🌾 {d.crop}</div>}
                          {fields.find(f=>f.id===d.field_id) && <div className="csub">📍 {fields.find(f=>f.id===d.field_id)?.name}</div>}
                          {d.dn_aa ? (
                            <div style={{display:"flex",gap:6,marginTop:6,flexWrap:"wrap",alignItems:"center"}}>
                              <span style={{background:d.cancel_mark?"#9e9e9e":"#1e5c1e",color:"#fff",borderRadius:8,padding:"3px 10px",fontWeight:800,fontSize:12,textDecoration:d.cancel_mark?"line-through":"none"}}>📄 Δελτίο {d.dn_series||"0"}-{d.dn_aa}</span>
                              {d.to_weigh && !d.cancel_mark ? <span style={{background:"#fff8e1",color:"#e65100",borderRadius:8,padding:"3px 10px",fontWeight:700,fontSize:12}}>Προς Ζύγιση</span> : null}
                              {d.cancel_mark
                                ? <span style={{background:"#ffebee",color:"#c62828",borderRadius:8,padding:"3px 10px",fontWeight:800,fontSize:12}}>❌ Ακυρωμένο</span>
                                : d.mark
                                  ? <span style={{background:"#e8f5e9",color:"#1e5c1e",borderRadius:8,padding:"3px 10px",fontWeight:700,fontSize:12}}>ΜΑΡΚ {d.mark}</span>
                                  : <span style={{background:"#eceff1",color:"#546e7a",borderRadius:8,padding:"3px 10px",fontWeight:700,fontSize:12}}>προς διαβίβαση</span>}
                            </div>
                          ) : null}
                        </div>
                        <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:6}}>
                          <div style={{display:"flex",gap:6}}>
                            {!d.cancel_mark ? <button aria-label="Καταχώρηση ζύγισης" className="btn btn-icon" style={{background:"#fff8e1",border:"1.5px solid #f4c542"}} onClick={()=>setWeighId(d.id)}>⚖️</button> : null}
                            {d.dn_aa ? <button aria-label="Εκτύπωση δελτίου" className="btn btn-icon" onClick={()=>printNote(d)}>🖨</button> : null}
                            <button aria-label="Επεξεργασία" className="btn btn-icon" onClick={()=>setEditWarnId(d.id)}>✏️</button>
                            <button aria-label={d.mark && !d.cancel_mark ? "Ακύρωση δελτίου" : "Διαγραφή"} className="btn btn-d" onClick={()=> (d.mark && !d.cancel_mark) ? setCancelId(d.id) : setConfirmId(d.id)}>🗑</button>
                          </div>
                          {(() => {
                            const dnA = (settings && settings.dn) || {};
                            const isr = (Array.isArray(dnA.issuers) && dnA.issuers.length) ? dnA.issuers : (dnA.issuer ? [dnA.issuer] : []);
                            const iss = (d.issuer_vat ? isr.find(x=>(x.vat||"").trim()===String(d.issuer_vat).trim()) : null);
                            const nm = iss ? ([iss.firstName,iss.lastName].filter(Boolean).join(" ")||iss.vat) : (d.issuer_vat||"");
                            return nm ? <div style={{fontSize:11.5,color:"#6b8c6b",fontWeight:700,textAlign:"right"}}>👤 {nm}</div> : null;
                          })()}
                        </div>
                      </div>
                      {/* Ζύγιση */}
                      <div style={{display:"flex",gap:8,marginTop:8,flexWrap:"wrap"}}>
                        {d.packaging_tare ? <span style={{background:"#eef4ff",color:"#2b5fa5",borderRadius:8,padding:"3px 10px",fontWeight:700,fontSize:13}}>📦 −{d.packaging_tare} kg υλικά</span> : null}
                        {d.net_weight && <span style={{background:"#e8f5e9",color:"#1e5c1e",borderRadius:8,padding:"3px 10px",fontWeight:700,fontSize:13}}>⚖️ {d.net_weight} kg καθαρά</span>}
                        {d.reject_percent ? <span style={{background:"#ffebee",color:"#c62828",borderRadius:8,padding:"3px 10px",fontWeight:700,fontSize:13}}>❌ {d.reject_percent}% απομείωση</span> : null}
                        {d.final_weight && <span style={{background:"#2d8a2d",color:"#fff",borderRadius:8,padding:"3px 10px",fontWeight:800,fontSize:13}}>✅ {d.final_weight} kg πληρωτέα</span>}
                        {d.coop_doc_no ? <span style={{background:"#f5f5f5",color:"#546e7a",borderRadius:8,padding:"3px 10px",fontWeight:700,fontSize:12,fontFamily:"monospace"}}>🧾 {d.coop_doc_no}</span> : null}
                      </div>
                      {/* Κλούβες */}
                      {(d.crates_delivered||d.crates_returned) ? (
                        <div style={{display:"flex",gap:8,marginTop:6}}>
                          {d.crates_delivered && <span style={{background:"#e3f2fd",color:"#1565c0",borderRadius:8,padding:"3px 10px",fontWeight:700,fontSize:13}}>📦 {d.crates_delivered} παράδοση</span>}
                          {d.crates_returned && <span style={{background:"#f3e5f5",color:"#6a1b9a",borderRadius:8,padding:"3px 10px",fontWeight:700,fontSize:13}}>📦 {d.crates_returned} παραλαβή</span>}
                        </div>
                      ) : null}
                      {/* Τιμή — κρύβεται σε ακυρωμένο δελτίο */}
                      {d.cancel_mark ? (
                        <div style={{marginTop:8,paddingTop:8,borderTop:"1px solid #e0eede",fontSize:12.5,color:"#c62828",fontWeight:700,textAlign:"center"}}>
                          ❌ Ακυρωμένο δελτίο — δεν εκκρεμεί πληρωμή
                        </div>
                      ) : (
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:8,paddingTop:8,borderTop:"1px solid #e0eede"}}>
                        <div>
                          {d.price_per_kg ? <span className={`amount ${amountsVisible?"":"blurred"}`} style={{fontSize:13,color:"#5a7a5a",fontWeight:700}}>{d.price_per_kg}€/kg</span> : <span style={{fontSize:12,color:"#f4a",fontWeight:700}}>⏳ Τιμή εκκρεμεί</span>}
                        </div>
                        <div style={{display:"flex",alignItems:"center",gap:8}}>
                          {d.total_amount ? <span className={`amount ${amountsVisible?"":"blurred"}`} style={{fontWeight:900,fontSize:18,color:"#1e5c1e"}}>{parseFloat(d.total_amount).toFixed(2)}€</span> : null}
                          <button className="btn" style={{background:d.paid?"#e8f5e9":"#fff8e1",color:d.paid?"#1e5c1e":"#e65100",padding:"6px 12px",fontSize:12,fontWeight:800,borderRadius:10}} onClick={()=>updateDelivery(d.id,{paid:!d.paid})}>
                            {d.paid?"✅ Πληρώθηκε":"⏳ Εκκρεμεί"}
                          </button>
                        </div>
                      </div>
                      )}
                      {d.notes && <div className="csub" style={{marginTop:4,fontStyle:"italic"}}>📝 {d.notes}</div>}
                      <div onClick={()=>setExpandedId(null)} style={{display:"flex",justifyContent:"center",marginTop:12,cursor:"pointer"}}>
                        <span style={{width:32,height:32,borderRadius:"50%",background:"#eef7ee",color:"#2d8a2d",fontSize:20,fontWeight:900,display:"flex",alignItems:"center",justifyContent:"center",transform:"rotate(-90deg)"}}>›</span>
                      </div>
                    </div>
                  )}
                </div>
              );
            })
          }
          </>)}
        </>);
      })()}
    </div>
  );
}

// ── FINANCE TAB ───────────────────────────────────────────────
const INCOME_CATS = [
  { ic:"🌾", lb:"Πώληση Παραγωγής" },
  { ic:"🏠", lb:"Ενοίκιο Εισπραχθέν" },
  { ic:"💶", lb:"Επιδότηση" },
  { ic:"📦", lb:"Άλλο Έσοδο" },
];

const EXPENSE_CATS = [
  { ic:"💊", lb:"Φάρμακα" },
  { ic:"🌿", lb:"Λιπάσματα" },
  { ic:"🌱", lb:"Σπόροι" },
  { ic:"⛽", lb:"Καύσιμα" },
  { ic:"👷", lb:"Εργατικά" },
  { ic:"🔧", lb:"Ανταλλακτικά" },
  { ic:"💡", lb:"Ρεύμα Άρδευσης" },
  { ic:"💧", lb:"TOEB / Άρδευση" },
  { ic:"🏠", lb:"Ενοίκιο Καταβληθέν" },
  { ic:"🚜", lb:"Μηχανήματα" },
  { ic:"📦", lb:"Άλλο Έξοδο" },
];

// ── NOTES / TO-DO TAB ─────────────────────────────────────────
const NOTE_CATEGORIES = [
  { ic:"🌱", lb:"Σπορά / Φύτεμα" },
  { ic:"💊", lb:"Ψεκασμός" },
  { ic:"🌿", lb:"Λίπανση" },
  { ic:"💧", lb:"Άρδευση" },
  { ic:"🍑", lb:"Αραίωμα" },
  { ic:"🧺", lb:"Συγκομιδή" },
  { ic:"✂️", lb:"Κλάδεμα" },
  { ic:"🚜", lb:"Κατεργασία Εδάφους" },
  { ic:"🌿", lb:"Αποψίλωση" },
  { ic:"🔧", lb:"Συντήρηση" },
  { ic:"📝", lb:"Διάφορα" },
];
const NOTE_SOURCES = [
  { ic:"👨‍🌾", lb:"Δικιά μου" },
  { ic:"🥼", lb:"Γεωπόνος" },
  { ic:"📞", lb:"Άλλος" },
];

function NotesTab() {
  const { fields, notes, addNote, updateNote, deleteNote } = useApp();
  const [show, setShow] = useState(false);
  const [confirmId, setConfirmId] = useState(null);
  const [editId, setEditId] = useState(null);
  const empty = { field_id:"", due_date: new Date().toISOString().split("T")[0], title:"", category:"", source:"Δικιά μου" };
  const [form, setForm] = useState(empty);
  const [editData, setEditData] = useState({});
  const [msg, setMsg] = useState("");
  const up = (k,v) => setForm(p=>({...p,[k]:v}));
  const upE = (k,v) => setEditData(p=>({...p,[k]:v}));

  const today = new Date().toISOString().split("T")[0];
  const isToday = (d) => d === today;
  const isPast = (d) => d && d < today;

  const handle = async () => {
    if (!form.title.trim()) { setMsg("Συμπλήρωσε περιγραφή"); return; }
    const ok = await addNote({ ...form, title: form.title.trim(), status: "pending" });
    if (ok) { setForm(empty); setShow(false); setMsg(""); }
    else setMsg("Σφάλμα αποθήκευσης.");
  };
  const handleEdit = (n) => { setEditId(n.id); setEditData({ ...n }); };
  const handleSaveEdit = async () => {
    if (!editData.title.trim()) return;
    await updateNote(editId, { field_id:editData.field_id||null, due_date:editData.due_date||null, title:editData.title.trim(), category:editData.category||"", source:editData.source||"Δικιά μου" });
    setEditId(null);
  };
  const toggleDone = async (n) => {
    if (n.status === "done") await updateNote(n.id, { status:"pending", completed_at:null });
    else await updateNote(n.id, { status:"done", completed_at: new Date().toISOString() });
  };

  const goToActivity = (n) => {
    window._prefillActivity = {
      field_ids: n.field_id ? [n.field_id] : [],
      field_id: n.field_id || "",
      date: n.due_date || today,
      notes: n.title,
      _noteId: n.id,
    };
    window._gotoTab && window._gotoTab("activities");
  };

  const pending = notes.filter(n => n.status !== "done");
  const done = notes.filter(n => n.status === "done");
  const todayCount = pending.filter(n => isToday(n.due_date)).length;
  const overdueCount = pending.filter(n => isPast(n.due_date)).length;

  const renderNote = (n) => {
    const f = fields.find(x => x.id === n.field_id);
    const cat = NOTE_CATEGORIES.find(c => c.lb === n.category);
    const src = NOTE_SOURCES.find(s => s.lb === n.source);
    const todayBadge = isToday(n.due_date);
    const overdue = isPast(n.due_date) && n.status !== "done";
    const isEditing = editId === n.id;

    if (isEditing) {
      return (
        <div key={n.id} className="card" style={{marginBottom:8}}>
          <div className="fg"><label className="fl">Περιγραφή *</label>
            <input className="fi" value={editData.title||""} onChange={e=>upE("title",e.target.value)} /></div>
          <div className="fr">
            <div className="fg"><label className="fl">Ημερομηνία</label>
              <input className="fi" type="date" value={editData.due_date||""} onChange={e=>upE("due_date",e.target.value)} /></div>
            <div className="fg"><label className="fl">Αγροτεμάχιο</label>
              <select className="fi" value={editData.field_id||""} onChange={e=>upE("field_id",e.target.value)}>
                <option value="">— Γενικό —</option>
                {fields.map(f=><option key={f.id} value={f.id}>{f.name}</option>)}
              </select>
            </div>
          </div>
          <div className="fg"><label className="fl">Κατηγορία</label>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:6,marginTop:4}}>
              {NOTE_CATEGORIES.map(c=>{
                const sel = editData.category===c.lb;
                return (
                  <button key={c.lb} type="button"
                    style={{background:sel?"#2d8a2d":"#fff",border:`2px solid ${sel?"#2d8a2d":"#d4e8d4"}`,borderRadius:10,padding:"8px 4px",display:"flex",flexDirection:"column",alignItems:"center",gap:2,cursor:"pointer",height:60}}
                    onClick={()=>upE("category",sel?"":c.lb)}>
                    <span style={{fontSize:18}}>{c.ic}</span>
                    <span style={{fontSize:10,fontWeight:700,color:sel?"#fff":"#2d5a2d"}}>{c.lb}</span>
                  </button>
                );
              })}
            </div>
          </div>
          <div className="fg"><label className="fl">Πηγή</label>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:6,marginTop:4}}>
              {NOTE_SOURCES.map(s=>{
                const sel = editData.source===s.lb;
                return (
                  <button key={s.lb} type="button"
                    style={{background:sel?"#2d8a2d":"#fff",border:`2px solid ${sel?"#2d8a2d":"#d4e8d4"}`,borderRadius:10,padding:"8px 4px",display:"flex",flexDirection:"column",alignItems:"center",gap:2,cursor:"pointer",height:60}}
                    onClick={()=>upE("source",s.lb)}>
                    <span style={{fontSize:18}}>{s.ic}</span>
                    <span style={{fontSize:10,fontWeight:700,color:sel?"#fff":"#2d5a2d"}}>{s.lb}</span>
                  </button>
                );
              })}
            </div>
          </div>
          <div style={{display:"flex",gap:8,marginTop:8}}>
            <button className="btn" style={{flex:1,background:"#2d6a2d",color:"#fff",justifyContent:"center"}} onClick={handleSaveEdit}>✅ Αποθήκευση</button>
            <button className="btn" style={{background:"#f0f7ee",color:"#2d6a2d"}} onClick={()=>setEditId(null)}>✕</button>
          </div>
        </div>
      );
    }

    return (
      <div key={n.id} className="card" style={{marginBottom:8,borderLeft:`4px solid ${overdue?"#c0392b":todayBadge?"#f4c542":"#d4e8d4"}`,opacity:n.status==="done"?.65:1}}>
        <div style={{display:"flex",alignItems:"flex-start",gap:10}}>
          <button type="button"
            style={{width:32,height:32,minWidth:32,borderRadius:"50%",border:`2px solid ${n.status==="done"?"#2d8a2d":"#d4e8d4"}`,background:n.status==="done"?"#2d8a2d":"#fff",color:"#fff",fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}
            onClick={()=>toggleDone(n)}>
            {n.status==="done"?"✓":""}
          </button>
          <div style={{flex:1,minWidth:0}}>
            <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap",marginBottom:4}}>
              {cat && <span style={{fontSize:16}}>{cat.ic}</span>}
              {todayBadge && n.status!=="done" && <span style={{background:"#f4c542",color:"#1a2e1a",padding:"2px 8px",borderRadius:8,fontSize:10,fontWeight:900}}>ΣΗΜΕΡΑ</span>}
              {overdue && <span style={{background:"#c0392b",color:"#fff",padding:"2px 8px",borderRadius:8,fontSize:10,fontWeight:900}}>ΕΚΠΡΟΘΕΣΜΟ</span>}
            </div>
            <div style={{fontWeight:800,fontSize:15,color:"#1a2e1a",textDecoration:n.status==="done"?"line-through":"none",lineHeight:1.3}}>{n.title}</div>
            <div style={{fontSize:12,color:"#8aaa8a",marginTop:4}}>
              {n.due_date && <>📅 {n.due_date}</>}
              {f && <> · 📍 {f.name}</>}
              {src && <> · {src.ic} {src.lb}</>}
            </div>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:4}}>
            <button aria-label="Επεξεργασία" className="btn btn-icon" onClick={()=>handleEdit(n)}>✏️</button>
            <button aria-label="Διαγραφή" className="btn btn-d" onClick={()=>setConfirmId(n.id)}>🗑</button>
          </div>
        </div>
        {n.status !== "done" && (
          <button className="btn" style={{width:"100%",background:"#e8f5e9",color:"#1e5c1e",fontWeight:800,justifyContent:"center",marginTop:8,fontSize:13}}
            onClick={()=>goToActivity(n)}>
            ✅ Καταχώρηση Εργασίας →
          </button>
        )}
      </div>
    );
  };

  return (
    <div>
      {confirmId && <ConfirmDialog msg="Διαγραφή σημείωσης;" onYes={()=>{deleteNote(confirmId);setConfirmId(null);}} onNo={()=>setConfirmId(null)} />}

      <div className="stitle">📋 Σημειώσεις / To-Do</div>

      {(todayCount > 0 || overdueCount > 0) && (
        <div style={{display:"flex",gap:8,marginBottom:12}}>
          {overdueCount > 0 && (
            <div style={{flex:1,background:"#ffebee",border:"1.5px solid #c0392b",borderRadius:12,padding:"10px 12px",textAlign:"center"}}>
              <div style={{fontSize:22,fontWeight:900,color:"#9c1b15"}}>{overdueCount}</div>
              <div style={{fontSize:11,fontWeight:700,color:"#9c1b15"}}>Εκπρόθεσμα</div>
            </div>
          )}
          {todayCount > 0 && (
            <div style={{flex:1,background:"#fff8e1",border:"1.5px solid #f4c542",borderRadius:12,padding:"10px 12px",textAlign:"center"}}>
              <div style={{fontSize:22,fontWeight:900,color:"#7a5a18"}}>{todayCount}</div>
              <div style={{fontSize:11,fontWeight:700,color:"#7a5a18"}}>Σήμερα</div>
            </div>
          )}
        </div>
      )}

      <button className="btn btn-p" onClick={()=>setShow(!show)}>
        {show?"✕ Άκυρο":"➕ Νέα Σημείωση"}
      </button>

      {show && (
        <div className="aform">
          <div className="aftitle">Νέα Σημείωση</div>
          {msg && <div className="msg msg-e">{msg}</div>}
          <div className="fg"><label className="fl">Περιγραφή *</label>
            <input className="fi" placeholder="π.χ. Ψεκασμός με Calypso για θρίπα" value={form.title} onChange={e=>up("title",e.target.value)} /></div>
          <div className="fr">
            <div className="fg"><label className="fl">Ημερομηνία</label>
              <input className="fi" type="date" value={form.due_date} onChange={e=>up("due_date",e.target.value)} /></div>
            <div className="fg"><label className="fl">Αγροτεμάχιο</label>
              <select className="fi" value={form.field_id} onChange={e=>up("field_id",e.target.value)}>
                <option value="">— Γενικό —</option>
                {fields.map(f=><option key={f.id} value={f.id}>{f.name}</option>)}
              </select>
            </div>
          </div>
          <div className="fg"><label className="fl">Κατηγορία</label>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:6,marginTop:4}}>
              {NOTE_CATEGORIES.map(c=>{
                const sel = form.category===c.lb;
                return (
                  <button key={c.lb} type="button"
                    style={{background:sel?"#2d8a2d":"#fff",border:`2px solid ${sel?"#2d8a2d":"#d4e8d4"}`,borderRadius:10,padding:"8px 4px",display:"flex",flexDirection:"column",alignItems:"center",gap:2,cursor:"pointer",height:60}}
                    onClick={()=>up("category",sel?"":c.lb)}>
                    <span style={{fontSize:18}}>{c.ic}</span>
                    <span style={{fontSize:10,fontWeight:700,color:sel?"#fff":"#2d5a2d"}}>{c.lb}</span>
                  </button>
                );
              })}
            </div>
          </div>
          <div className="fg"><label className="fl">Πηγή</label>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:6,marginTop:4}}>
              {NOTE_SOURCES.map(s=>{
                const sel = form.source===s.lb;
                return (
                  <button key={s.lb} type="button"
                    style={{background:sel?"#2d8a2d":"#fff",border:`2px solid ${sel?"#2d8a2d":"#d4e8d4"}`,borderRadius:10,padding:"8px 4px",display:"flex",flexDirection:"column",alignItems:"center",gap:2,cursor:"pointer",height:60}}
                    onClick={()=>up("source",s.lb)}>
                    <span style={{fontSize:18}}>{s.ic}</span>
                    <span style={{fontSize:10,fontWeight:700,color:sel?"#fff":"#2d5a2d"}}>{s.lb}</span>
                  </button>
                );
              })}
            </div>
          </div>
          <button className="btn btn-p" onClick={handle}>✅ Αποθήκευση</button>
        </div>
      )}

      {pending.length > 0 && (
        <>
          <div style={{fontSize:13,fontWeight:800,color:"#2d5a2d",marginTop:16,marginBottom:8}}>🔴 Εκκρεμή ({pending.length})</div>
          {pending.map(renderNote)}
        </>
      )}

      {done.length > 0 && (
        <>
          <div style={{fontSize:13,fontWeight:800,color:"#8aaa8a",marginTop:16,marginBottom:8}}>✅ Έγιναν ({done.length})</div>
          {done.slice(0,10).map(renderNote)}
        </>
      )}

      {notes.length === 0 && <Empty icon="📋" text="Δεν υπάρχουν σημειώσεις ακόμα" />}
    </div>
  );
}

function FinanceTab() {
  const { fields, income, addIncome, deleteIncome, expenditure, addExpenditure, deleteExpenditure, activities, deliveries } = useApp();
  const amountsVisible = window._amountsVisible || false;
  const [view, setView] = useState("summary"); // summary | income | expense
  const [showForm, setShowForm] = useState(false);
  const [confirmId, setConfirmId] = useState(null);
  const empty = { date: new Date().toISOString().split("T")[0], field_id:"", category:"", description:"", quantity:"", unit:"", unit_price:"", total_amount:"", buyer:"", supplier:"", notes:"" };
  const [form, setForm] = useState(empty);
  const [msg, setMsg] = useState("");
  const up = (k,v) => setForm(p=>({...p,[k]:v}));

  // Income: manual + deliveries
  const incomeManual = income.reduce((s,i)=>s+(parseFloat(i.total_amount)||0), 0);
  const incomeDeliveries = deliveries.reduce((s,d)=>s+(parseFloat(d.total_amount)||0), 0);
  const totalIncome = incomeManual + incomeDeliveries;

  // Expenses: manual + activities (full cost_total) + yearly rent
  const expenseManual = expenditure.reduce((s,e)=>s+(parseFloat(e.total_amount)||0), 0);
  const expenseActivities = activities.reduce((s,a)=>s+(parseFloat(a.cost_total)||0), 0);
  const expenseRent = fields.filter(f=>f.is_rented).reduce((s,f)=>s+(parseFloat(f.rent_amount)||0), 0);
  const totalExpense = expenseManual + expenseActivities + expenseRent;

  const balance = totalIncome - totalExpense;

  const handleSave = async () => {
    if (!form.category || !form.date) { setMsg("Συμπλήρωσε κατηγορία και ημερομηνία"); return; }
    if (!form.total_amount && !form.quantity) { setMsg("Βάλε ποσό ή ποσότητα"); return; }
    const item = {
      ...form,
      quantity: form.quantity ? parseFloat(form.quantity) : null,
      unit_price: form.unit_price ? parseFloat(form.unit_price) : null,
      total_amount: form.total_amount ? parseFloat(form.total_amount) : (parseFloat(form.quantity)||0)*(parseFloat(form.unit_price)||0) || null,
    };
    let ok;
    if (view === "income") ok = await addIncome(item);
    else ok = await addExpenditure(item);
    if (ok) { setForm(empty); setShowForm(false); setMsg(""); }
    else setMsg("Σφάλμα αποθήκευσης.");
  };

  const CATS = view === "income" ? INCOME_CATS : EXPENSE_CATS;
  const isIncome = view === "income";

  const SummaryView = () => (
    <div>
      {/* Σύνοψη */}
      <div style={{background:"linear-gradient(135deg,#1e5c1e,#2d8a2d)",borderRadius:18,padding:20,marginBottom:16,color:"#fff"}}>
        <div style={{fontSize:14,fontWeight:700,opacity:.8,marginBottom:12}}>Οικονομική Σύνοψη</div>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:12}}>
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:11,opacity:.7}}>ΕΣΟΔΑ</div>
            <div className={`amount ${amountsVisible?"":"blurred"}`} style={{fontSize:22,fontWeight:900,color:"#a5d6a7"}}>+{totalIncome.toFixed(2)}€</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:11,opacity:.7}}>ΕΞΟΔΑ</div>
            <div className={`amount ${amountsVisible?"":"blurred"}`} style={{fontSize:22,fontWeight:900,color:"#ef9a9a"}}>-{totalExpense.toFixed(2)}€</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:11,opacity:.7}}>ΥΠΟΛΟΙΠΟ</div>
            <div className={`amount ${amountsVisible?"":"blurred"}`} style={{fontSize:22,fontWeight:900,color:balance>=0?"#f4c542":"#ef9a9a"}}>{balance>=0?"+":""}{balance.toFixed(2)}€</div>
          </div>
        </div>
        <div style={{fontSize:11,opacity:.85,borderTop:"1px solid rgba(255,255,255,.2)",paddingTop:10,lineHeight:1.5}}>
          📥 Έσοδα: {incomeDeliveries.toFixed(0)}€ παραδόσεις + {incomeManual.toFixed(0)}€ άλλα<br/>
          📤 Έξοδα: {expenseActivities.toFixed(0)}€ εργασίες{expenseRent>0?` + ${expenseRent.toFixed(0)}€ ενοίκια`:""} + {expenseManual.toFixed(0)}€ άλλα
        </div>
      </div>

      {/* Κουμπιά */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
        <button className="btn" style={{background:"#e8f5e9",color:"#1e5c1e",padding:18,borderRadius:16,flexDirection:"column",gap:6,fontSize:15,fontWeight:800}} onClick={()=>{setView("income");setShowForm(false);}}>
          <span style={{fontSize:28}}>💰</span>
          Έσοδα
          <span style={{fontSize:12,opacity:.7}}>{income.length + deliveries.filter(d=>d.total_amount).length} εγγραφές</span>
        </button>
        <button className="btn" style={{background:"#ffebee",color:"#c62828",padding:18,borderRadius:16,flexDirection:"column",gap:6,fontSize:15,fontWeight:800}} onClick={()=>{setView("expense");setShowForm(false);}}>
          <span style={{fontSize:28}}>💸</span>
          Έξοδα
          <span style={{fontSize:12,opacity:.7}}>{expenditure.length + activities.filter(a=>parseFloat(a.cost_total)>0).length} εγγραφές</span>
        </button>
      </div>

      {/* Πρόσφατες κινήσεις */}
      <div className="stitle">📋 Πρόσφατες Κινήσεις</div>
      {(() => {
        const allItems = [
          ...income.map(i=>({...i, type:"income", source:"manual"})),
          ...deliveries.filter(d=>d.total_amount).map(d=>({
            id:"del-"+d.id, type:"income", source:"delivery",
            date:d.date, category:"Πώληση Παραγωγής",
            description:[d.crop, d.variety, d.buyer].filter(Boolean).join(" · "),
            total_amount:d.total_amount
          })),
          ...expenditure.map(e=>({...e, type:"expense", source:"manual"})),
          ...activities.filter(a=>parseFloat(a.cost_total)>0).map(a=>({
            id:"act-"+a.id, type:"expense", source:"activity",
            date:a.date,
            category:a.category||"Εργασία",
            description:a.activity_type||"",
            total_amount:a.cost_total
          })),
        ];
        const recent = allItems.sort((a,b)=>new Date(b.date)-new Date(a.date)).slice(0,8);
        if (recent.length === 0) return <Empty icon="💰" text="Δεν υπάρχουν οικονομικές εγγραφές" />;
        return recent.map(item=>(
          <div key={item.id} className="card" style={{marginBottom:8}}>
            <div style={{display:"flex",alignItems:"center",gap:10}}>
              <div style={{width:44,height:44,borderRadius:12,background:item.type==="income"?"#e8f5e9":"#ffebee",display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>
                {[...INCOME_CATS,...EXPENSE_CATS].find(c=>c.lb===item.category)?.ic||(item.type==="income"?"💰":"💸")}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div className="ctitle" style={{fontSize:15}}>
                  {item.category}
                  {item.source==="delivery" && <span style={{fontSize:10,fontWeight:700,color:"#1e5c1e",background:"#e8f5e9",padding:"2px 6px",borderRadius:6,marginLeft:6}}>Παράδοση</span>}
                  {item.source==="activity" && <span style={{fontSize:10,fontWeight:700,color:"#7a4a18",background:"#fff3e0",padding:"2px 6px",borderRadius:6,marginLeft:6}}>Εργασία</span>}
                </div>
                <div className="csub" style={{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{item.date}{item.description?` · ${item.description}`:""}</div>
              </div>
              <div className={`amount ${amountsVisible?"":"blurred"}`} style={{fontWeight:900,fontSize:16,color:item.type==="income"?"#1e5c1e":"#c62828"}}>
                {item.type==="income"?"+":"-"}{parseFloat(item.total_amount||0).toFixed(2)}€
              </div>
            </div>
          </div>
        ));
      })()}
    </div>
  );

  const ListAndForm = () => {
    const items = isIncome ? income : expenditure;
    const deleteItem = isIncome ? deleteIncome : deleteExpenditure;
    return (
      <div>
        {confirmId && <ConfirmDialog msg={`Διαγραφή ${isIncome?"εσόδου":"εξόδου"};`} onYes={()=>{deleteItem(confirmId);setConfirmId(null);}} onNo={()=>setConfirmId(null)} />}

        {/* Back */}
        <button className="btn" style={{width:"100%",background:"#1e5c1e",color:"#fff",padding:14,fontSize:16,fontWeight:900,borderRadius:16,justifyContent:"center",marginBottom:12}} onClick={()=>setView("summary")}>
          ← Πίσω στα Οικονομικά
        </button>

        <div className="stitle">
          {isIncome?"💰 Έσοδα":"💸 Έξοδα"}
          <span className="cnt">{items.length}</span>
        </div>

        {/* Σύνολο */}
        <div style={{background:isIncome?"#e8f5e9":"#ffebee",borderRadius:14,padding:"12px 16px",marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontWeight:700,color:isIncome?"#1e5c1e":"#c62828"}}>Σύνολο {isIncome?"Εσόδων":"Εξόδων"}</span>
          <span className={`amount ${amountsVisible?"":"blurred"}`} style={{fontWeight:900,fontSize:20,color:isIncome?"#1e5c1e":"#c62828"}}>
            {isIncome?"+":"-"}{(isIncome?totalIncome:totalExpense).toFixed(2)}€
          </span>
        </div>

        <button className="btn btn-p" onClick={()=>setShowForm(!showForm)}>
          {showForm?"✕ Άκυρο":`➕ Νέο ${isIncome?"Έσοδο":"Έξοδο"}`}
        </button>

        {showForm && (
          <div className="aform">
            <div className="aftitle">{isIncome?"💰 Νέο Έσοδο":"💸 Νέο Έξοδο"}</div>
            {msg && <div className="msg msg-e">{msg}</div>}

            {/* Κατηγορία */}
            <div className="fg"><label className="fl">Κατηγορία *</label>
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
                {CATS.map(c=>(
                  <button key={c.lb} type="button"
                    style={{background:form.category===c.lb?"#2d8a2d":"#fff",border:`2px solid ${form.category===c.lb?"#2d8a2d":"#d4e8d4"}`,borderRadius:14,padding:"10px 6px",display:"flex",flexDirection:"column",alignItems:"center",gap:4,cursor:"pointer"}}
                    onClick={()=>up("category",c.lb)}>
                    <span style={{fontSize:24}}>{c.ic}</span>
                    <span style={{fontSize:10,fontWeight:800,color:form.category===c.lb?"#fff":"#2d5a2d",textAlign:"center",lineHeight:1.2}}>{c.lb}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="fr">
              <div className="fg"><label className="fl">Ημερομηνία *</label>
                <input className="fi" type="date" value={form.date} onChange={e=>up("date",e.target.value)} /></div>
              <div className="fg"><label className="fl">Αγροτεμάχιο</label>
                <select className="fi" value={form.field_id} onChange={e=>up("field_id",e.target.value)}>
                  <option value="">— Όλα —</option>
                  {fields.map(f=><option key={f.id} value={f.id}>{f.name}</option>)}
                </select></div>
            </div>

            <div className="fg"><label className="fl">Περιγραφή</label>
              <input className="fi" placeholder="π.χ. Ροδάκινα A37" value={form.description} onChange={e=>up("description",e.target.value)} /></div>

            {/* Ποσότητα & τιμή για πώληση */}
            {(form.category==="Πώληση Παραγωγής") && (
              <div className="fr">
                <div className="fg"><label className="fl">Ποσότητα (kg)</label>
                  <input className="fi" type="number" min="0" placeholder="0" value={form.quantity} onChange={e=>up("quantity",e.target.value)} /></div>
                <div className="fg"><label className="fl">Τιμή/kg (€)</label>
                  <input className="fi" type="number" min="0" step="0.01" placeholder="0.00" value={form.unit_price} onChange={e=>up("unit_price",e.target.value)} /></div>
              </div>
            )}

            {/* Αγοραστής/Προμηθευτής */}
            <div className="fg"><label className="fl">{isIncome?"Αγοραστής":"Προμηθευτής"}</label>
              <input className="fi" placeholder={isIncome?"π.χ. Αγοραστής Α":"π.χ. Αγροτικός Σύλλογος"} value={isIncome?form.buyer:form.supplier} onChange={e=>up(isIncome?"buyer":"supplier",e.target.value)} /></div>

            <div className="fg"><label className="fl">Συνολικό Ποσό (€) *</label>
              <input className="fi" type="number" min="0" step="0.01" placeholder="0.00" value={form.total_amount}
                onChange={e=>up("total_amount",e.target.value)} /></div>

            <div className="fg"><label className="fl">Σημειώσεις</label>
              <input className="fi" placeholder="Προαιρετικά" value={form.notes} onChange={e=>up("notes",e.target.value)} /></div>

            <button className="btn btn-p" onClick={handleSave}>✅ Αποθήκευση</button>
          </div>
        )}

        {items.length === 0 ? <Empty icon={isIncome?"💰":"💸"} text={`Δεν υπάρχουν ${isIncome?"έσοδα":"έξοδα"} ακόμα`} /> :
          items.map(item=>(
            <div key={item.id} className="card">
              <div style={{display:"flex",alignItems:"flex-start",gap:10}}>
                <div style={{width:48,height:48,borderRadius:14,background:isIncome?"#e8f5e9":"#ffebee",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>
                  {CATS.find(c=>c.lb===item.category)?.ic||"💰"}
                </div>
                <div style={{flex:1}}>
                  <div className="ctitle">{item.category}</div>
                  {item.description && <div className="csub">{item.description}</div>}
                  <div className="csub">📅 {item.date}</div>
                  {item.quantity && item.unit_price && <div className="csub">{item.quantity}kg × {item.unit_price}€/kg</div>}
                  {(isIncome?item.buyer:item.supplier) && <div className="csub">{isIncome?"👤":"🏪"} {isIncome?item.buyer:item.supplier}</div>}
                  {item.notes && <div className="csub" style={{fontStyle:"italic"}}>{item.notes}</div>}
                </div>
                <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:6}}>
                  <span className={`amount ${amountsVisible?"":"blurred"}`} style={{fontWeight:900,fontSize:16,color:isIncome?"#1e5c1e":"#c62828"}}>
                    {isIncome?"+":"-"}{parseFloat(item.total_amount||0).toFixed(2)}€
                  </span>
                  <button aria-label="Διαγραφή" className="btn btn-d" onClick={()=>setConfirmId(item.id)}>🗑</button>
                </div>
              </div>
            </div>
          ))
        }
      </div>
    );
  };

  return (
    <div>
      {window._prevTab === "settings" && (
        <button className="btn" style={{width:"100%",background:"#f0f9f0",color:"#2d8a2d",justifyContent:"center",marginBottom:12,padding:12,fontSize:14,fontWeight:800}} onClick={()=>{window._prevTab=null;window._gotoTab&&window._gotoTab("settings");}}>
          ← Πίσω στις Ρυθμίσεις
        </button>
      )}
      <div className="stitle">💰 Οικονομικά</div>
      {view === "summary" ? <SummaryView /> : <ListAndForm />}
    </div>
  );
}



// ── SETTINGS TAB ─────────────────────────────────────────────
function NameEditor({ userName, setUserName, userId }) {
  const [editing, setEditing] = useState(false);
  const [newName, setNewName] = useState(userName||"");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!newName.trim()) return;
    setSaving(true);
    await supabase.from("profiles").update({ name: newName.trim() }).eq("id", userId);
    setUserName(newName.trim());
    setSaving(false);
    setEditing(false);
  };

  if (editing) return (
    <div style={{marginBottom:10}}>
      <label style={{fontSize:12,fontWeight:700,color:"#4a6a4a",display:"block",marginBottom:4}}>Όνομα</label>
      <div style={{display:"flex",gap:8}}>
        <input className="fi" value={newName} onChange={e=>setNewName(e.target.value)}
          placeholder="π.χ. Νίκος Παπάς" style={{flex:1}} />
        <button className="btn" style={{background:"#2d8a2d",color:"#fff",padding:"10px 14px"}} onClick={save} disabled={saving}>
          {saving?"⏳":"✅"}
        </button>
        <button className="btn" style={{background:"#f0f7f0",color:"#2d5a2d",padding:"10px 12px"}} onClick={()=>setEditing(false)}>✕</button>
      </div>
    </div>
  );

  return (
    <div style={{background:"#fff",borderRadius:12,padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
      <div>
        <div style={{fontSize:12,color:"#8aaa8a",fontWeight:600}}>Όνομα</div>
        <div style={{fontSize:14,fontWeight:800,color:"#1a2e1a"}}>{userName||"— Δεν έχει οριστεί"}</div>
      </div>
      <button className="btn" style={{background:"#f0f9f0",color:"#2d8a2d",padding:"8px 14px",fontSize:13}} onClick={()=>{setNewName(userName||"");setEditing(true);}}>
        ✏️ Αλλαγή
      </button>
    </div>
  );
}


function PhoneEditor({ userPhone, setUserPhone, userId }) {
  const [editing, setEditing] = useState(false);
  const [newPhone, setNewPhone] = useState(userPhone||"");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    await supabase.from("profiles").update({ phone: newPhone.trim() }).eq("id", userId);
    setUserPhone(newPhone.trim());
    setSaving(false);
    setEditing(false);
  };

  if (editing) return (
    <div style={{marginBottom:10}}>
      <label style={{fontSize:12,fontWeight:700,color:"#4a6a4a",display:"block",marginBottom:4}}>Τηλέφωνο</label>
      <div style={{display:"flex",gap:8}}>
        <input className="fi" value={newPhone} onChange={e=>setNewPhone(e.target.value)}
          placeholder="69xxxxxxxx" type="tel" style={{flex:1}} />
        <button className="btn" style={{background:"#2d8a2d",color:"#fff",padding:"10px 14px"}} onClick={save} disabled={saving}>
          {saving?"⏳":"✅"}
        </button>
        <button className="btn" style={{background:"#f0f7f0",color:"#2d5a2d",padding:"10px 12px"}} onClick={()=>setEditing(false)}>✕</button>
      </div>
    </div>
  );

  return (
    <div style={{background:userPhone?"#fff":"#fff9e6",borderRadius:12,padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,border:userPhone?"1px solid #f0f0f0":"1.5px dashed #f9a825"}}>
      <div>
        <div style={{fontSize:12,color:"#8aaa8a",fontWeight:600}}>📞 Τηλέφωνο</div>
        {userPhone ? (
          <div style={{fontSize:14,fontWeight:800,color:"#1a2e1a"}}>{userPhone}</div>
        ) : (
          <div style={{fontSize:13,color:"#e65100",fontWeight:600}}>Παρακαλώ βάλτε το τηλέφωνό σας για πιο άρτια υποστήριξη!</div>
        )}
      </div>
      <button className="btn" style={{background:userPhone?"#f0f9f0":"#fff3e0",color:userPhone?"#2d8a2d":"#e65100",padding:"8px 14px",fontSize:13,border:userPhone?"none":"1px solid #ffb74d"}} onClick={()=>{setNewPhone(userPhone||"");setEditing(true);}}>
        {userPhone?"✏️ Αλλαγή":"➕ Προσθήκη"}
      </button>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// Ρυθμίσεις Ψηφιακού Δελτίου Αποστολής (myDATA)
// Εκδότης + προϊόντα/ποικιλίες/βάρη → profiles.settings.dn
// Συναλλασσόμενοι → πίνακας dn_partners
// ═══════════════════════════════════════════════════════════════
function DeltioSettingsSection() {
  const { settings: rawSettings, updateSettings, user } = useApp();
  const settings = rawSettings || {};
  const dn = settings.dn || {};
  const [issuers, setIssuers] = useState(
    (Array.isArray(dn.issuers) && dn.issuers.length) ? dn.issuers
      : (dn.issuer ? [dn.issuer] : [{ firstName:"", lastName:"", activity:"", vat:"", doy:"", city:"" }])
  );
  const [issIdx, setIssIdx] = useState(0);
  const issuer = issuers[issIdx] || {};
  const setIssuer = (obj) => setIssuers(list => list.map((it,i)=> i===issIdx ? obj : it));
  const [products, setProducts] = useState(Array.isArray(dn.products) ? dn.products : []);
  // Συγχρονισμός όταν φορτώσουν τα settings από τη βάση (αποτρέπει σβήσιμο από κενά states)
  useEffect(() => {
    const d = (rawSettings || {}).dn || {};
    if (Array.isArray(d.issuers) && d.issuers.length) setIssuers(d.issuers);
    else if (d.issuer) setIssuers([d.issuer]);
    if (Array.isArray(d.products)) setProducts(d.products);
  }, [rawSettings]);
  const [includeVariety, setIncludeVariety] = useState(!!dn.includeVariety);
  const [partners, setPartners] = useState([]);
  const [varInput, setVarInput] = useState({});
  const [msg, setMsg] = useState("");
  const [saving, setSaving] = useState(false);
  // myDATA credentials
  const [cEnv, setCEnv] = useState("dev");
  const [cUser, setCUser] = useState("");
  const [cKey, setCKey] = useState("");
  const [cStatus, setCStatus] = useState([]);
  const [cSaving, setCSaving] = useState(false);
  const [cMsg, setCMsg] = useState("");

  useEffect(() => {
    (async () => {
      const { data } = await supabase.from("dn_partners")
        .select("id,name,vat,doy,street,postal_code,city,email").order("name");
      setPartners(data || []);
      try {
        const { data: cs } = await supabase.from("mydata_credentials").select("environment,aade_user_id,issuer_vat");
        setCStatus(cs || []);
      } catch (e) { /* ο πίνακας μπορεί να μην υπάρχει ακόμα */ }
    })();
  }, []);

  const saveCreds = async () => {
    if (!cUser.trim() || !cKey.trim()) { setCMsg("Συμπλήρωσε aade-user-id και subscription key."); return; }
    setCSaving(true); setCMsg("");
    const vat = (issuer.vat || "").trim();
    const { error } = await supabase.rpc("set_mydata_credentials", {
      p_environment: cEnv, p_aade_user_id: cUser.trim(), p_subscription_key: cKey.trim(), p_issuer_vat: vat,
    });
    setCSaving(false);
    if (error) {
      setCMsg(/function|does not exist|schema/i.test(error.message)
        ? "Λείπει το setup credentials (τρέξε το SQL + ενεργοποίησε Vault)."
        : "Σφάλμα: " + error.message);
      return;
    }
    setCKey(""); setCMsg("✅ Αποθηκεύτηκε κρυπτογραφημένα (" + cEnv + (vat?` · ΑΦΜ ${vat}`:"") + ")");
    try { const { data: cs } = await supabase.from("mydata_credentials").select("environment,aade_user_id,issuer_vat"); setCStatus(cs || []); } catch(e){}
  };

  const flash = (m) => { setMsg(m); setTimeout(()=>setMsg(""), 2500); };

  // Προϊόντα
  const upProd = (i, patch) => setProducts(ps => ps.map((p,idx)=> idx===i ? {...p,...patch} : p));
  const addProd = () => setProducts(ps => [...ps, { name:"", active:true, binKg:200, crateKg:22, vatCategory:8, itemCode:"", varieties:[] }]);
  const rmProd = (i) => setProducts(ps => ps.filter((_,idx)=>idx!==i));
  const addVar = (i) => {
    const v = (varInput[i]||"").trim(); if(!v) return;
    upProd(i, { varieties: [...(products[i].varieties||[]), v].filter((x,k,a)=>a.indexOf(x)===k) });
    setVarInput(s => ({...s,[i]:""}));
  };
  const rmVar = (i, vi) => upProd(i, { varieties: products[i].varieties.filter((_,k)=>k!==vi) });

  // Συναλλασσόμενοι
  const upPart = (i, patch) => setPartners(ps => ps.map((p,idx)=> idx===i ? {...p,...patch} : p));
  const addPart = () => setPartners(ps => [...ps, { id:null, name:"", vat:"", doy:"", street:"", postal_code:"", city:"", email:"" }]);
  const rmPart = async (i) => {
    const p = partners[i];
    if (p.id) { const { error } = await supabase.from("dn_partners").delete().eq("id", p.id); if (error) { flash("Σφάλμα διαγραφής"); return; } }
    setPartners(ps => ps.filter((_,idx)=>idx!==i));
    flash("Διαγράφηκε");
  };

  const saveAll = async () => {
    setSaving(true);
    try {
      // Δικλείδα ασφαλείας: μη σβήσεις μη-κενά δεδομένα με κενά (π.χ. αν δεν φόρτωσαν ακόμα)
      const dbDn = (rawSettings || {}).dn || {};
      const issuersHasData = issuers.some(i => (i.vat||"").trim() || (i.firstName||"").trim() || (i.lastName||"").trim());
      const dbIssuers = (Array.isArray(dbDn.issuers) && dbDn.issuers.length) ? dbDn.issuers : (dbDn.issuer ? [dbDn.issuer] : []);
      const dbIssuersHasData = dbIssuers.some(i => (i.vat||"").trim() || (i.firstName||"").trim() || (i.lastName||"").trim());
      const safeIssuers = (!issuersHasData && dbIssuersHasData) ? dbIssuers : issuers;
      const safeProducts = (products.length === 0 && Array.isArray(dbDn.products) && dbDn.products.length) ? dbDn.products : products;
      if (safeIssuers !== issuers) setIssuers(safeIssuers);
      if (safeProducts !== products) setProducts(safeProducts);

      // 1) εκδότης + προϊόντα → settings.dn (merge, δεν πειράζει τα υπόλοιπα settings)
      await updateSettings({ ...settings, dn: { ...dbDn, issuer: safeIssuers[0], issuers: safeIssuers, products: safeProducts, includeVariety } });
      // 2) συναλλασσόμενοι → dn_partners (απαιτείται μόνο επωνυμία· ΑΦΜ προαιρετικό προς το παρόν)
      for (const p of partners) {
        if (!(p.name||"").trim()) continue;
        const row = { user_id: user.id, name: p.name.trim(), vat: (p.vat||"").trim() || null, doy: p.doy||null,
          street: p.street||null, postal_code: p.postal_code||null, city: p.city||null, email: p.email||null };
        if (p.id) await supabase.from("dn_partners").update(row).eq("id", p.id);
        else await supabase.from("dn_partners").insert(row);
      }
      const { data } = await supabase.from("dn_partners")
        .select("id,name,vat,doy,street,postal_code,city,email").order("name");
      setPartners(data || []);
      flash("✅ Αποθηκεύτηκε!");
    } catch (e) { flash("Σφάλμα: " + (e.message||e)); }
    finally { setSaving(false); }
  };

  const box = { background:"#fff", border:"1.5px solid #d4e8d4", borderRadius:14, padding:12, marginBottom:10, position:"relative" };
  const mini = { fontSize:11, fontWeight:800, color:"#6b8c6b", textTransform:"uppercase", marginBottom:4, display:"block" };
  const grid2 = { display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 };

  return (
    <div style={{background:"#f8fdf8",borderRadius:"0 0 16px 16px",border:"2px solid #2d8a2d",borderTop:"none",padding:16}}>
      {msg && <div className="msg msg-s" style={{marginBottom:10}}>{msg}</div>}

      {/* Εκδότης */}
      <div style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:14,color:"#1a2e1a",marginBottom:8}}>Αποστολέας (Εκδότης)</div>

      {/* Επιλογή/προσθήκη εκδότη */}
      <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:10,alignItems:"center"}}>
        {issuers.map((is,i)=>(
          <button key={i} onClick={()=>setIssIdx(i)} style={{padding:"7px 12px",borderRadius:10,border:"1.5px solid",borderColor: i===issIdx?"#1e5c1e":"#cfe0cf",background: i===issIdx?"#1e5c1e":"#fff",color: i===issIdx?"#fff":"#3a5a3a",fontWeight:800,fontSize:13,cursor:"pointer"}}>
            {[is.firstName,is.lastName].filter(Boolean).join(" ") || is.vat || `Εκδότης ${i+1}`}
          </button>
        ))}
        <button onClick={()=>{ setIssuers(list=>[...list,{firstName:"",lastName:"",activity:"",vat:"",doy:"",city:""}]); setIssIdx(issuers.length); }} style={{padding:"7px 12px",borderRadius:10,border:"1.5px dashed #7cb342",background:"#f4faf0",color:"#5a8a2a",fontWeight:800,fontSize:13,cursor:"pointer"}}>+ Εκδότης</button>
        {issuers.length > 1 && (
          <button onClick={()=>{ if(confirm("Διαγραφή αυτού του εκδότη;")){ setIssuers(list=>list.filter((_,i)=>i!==issIdx)); setIssIdx(0); } }} style={{padding:"7px 12px",borderRadius:10,border:"1.5px solid #e5b3b3",background:"#fff",color:"#c62828",fontWeight:800,fontSize:13,cursor:"pointer"}}>🗑 Διαγραφή</button>
        )}
      </div>

      <div style={{...grid2, marginBottom:14}}>
        <div><span style={mini}>Όνομα</span><input className="fi" value={issuer.firstName||""} onChange={e=>setIssuer({...issuer,firstName:e.target.value})} /></div>
        <div><span style={mini}>Επίθετο</span><input className="fi" value={issuer.lastName||""} onChange={e=>setIssuer({...issuer,lastName:e.target.value})} /></div>
        <div style={{gridColumn:"1/-1"}}><span style={mini}>Δραστηριότητα</span><input className="fi" value={issuer.activity||""} onChange={e=>setIssuer({...issuer,activity:e.target.value})} /></div>
        <div><span style={mini}>ΑΦΜ</span><input className="fi" inputMode="numeric" maxLength={9} value={issuer.vat||""} onChange={e=>setIssuer({...issuer,vat:e.target.value})} /></div>
        <div><span style={mini}>ΔΟΥ</span><input className="fi" value={issuer.doy||""} onChange={e=>setIssuer({...issuer,doy:e.target.value})} /></div>
        <div style={{gridColumn:"1/-1"}}><span style={mini}>Πόλη</span><input className="fi" value={issuer.city||""} onChange={e=>setIssuer({...issuer,city:e.target.value})} /></div>
      </div>

      {/* Συναλλασσόμενοι */}
      <div style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:14,color:"#1a2e1a",marginBottom:8}}>Συναλλασσόμενοι (λήπτες)</div>
      {partners.map((p,i)=>(
        <div key={p.id||("new"+i)} style={box}>
          <button className="btn btn-d" style={{position:"absolute",top:8,right:8,padding:"4px 9px"}} onClick={()=>rmPart(i)}>✕</button>
          <div style={grid2}>
            <div style={{gridColumn:"1/-1"}}><span style={mini}>Επωνυμία</span><input className="fi" value={p.name||""} onChange={e=>upPart(i,{name:e.target.value})} /></div>
            <div><span style={mini}>ΑΦΜ (9 ψηφία)</span><input className="fi" inputMode="numeric" maxLength={9} value={p.vat||""} onChange={e=>upPart(i,{vat:e.target.value})} />
              {!/^[0-9]{9}$/.test(p.vat||"") && <span style={{fontSize:11,color:"#e65100",fontWeight:700,display:"block",marginTop:3}}>⚠ Χρειάζεται πριν τη διαβίβαση στο myDATA</span>}
            </div>
            <div><span style={mini}>ΔΟΥ</span><input className="fi" value={p.doy||""} onChange={e=>upPart(i,{doy:e.target.value})} /></div>
            <div><span style={mini}>Διεύθυνση</span><input className="fi" value={p.street||""} onChange={e=>upPart(i,{street:e.target.value})} /></div>
            <div><span style={mini}>Τ.Κ.</span><input className="fi" inputMode="numeric" maxLength={5} value={p.postal_code||""} onChange={e=>upPart(i,{postal_code:e.target.value})} /></div>
            <div><span style={mini}>Πόλη</span><input className="fi" value={p.city||""} onChange={e=>upPart(i,{city:e.target.value})} /></div>
            <div style={{gridColumn:"1/-1"}}><span style={mini}>Email</span><input className="fi" value={p.email||""} onChange={e=>upPart(i,{email:e.target.value})} /></div>
          </div>
        </div>
      ))}
      <button className="btn" style={{width:"100%",background:"#e8f5e9",color:"#1e5c1e",justifyContent:"center",padding:12,marginBottom:14}} onClick={addPart}>+ Προσθήκη συναλλασσόμενου</button>

      {/* Προϊόντα */}
      <div style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:14,color:"#1a2e1a",marginBottom:4}}>Προϊόντα, ποικιλίες & βάρη</div>
      <div style={{fontSize:12,color:"#6b8c6b",marginBottom:8}}>Ενεργοποίησε όσα παραδίδεις — μόνο αυτά εμφανίζονται στην έκδοση δελτίου.</div>
      {products.map((p,i)=>(
        <div key={i} style={{...box, opacity: p.active?1:0.6}}>
          <button className="btn btn-d" style={{position:"absolute",top:8,right:8,padding:"4px 9px"}} onClick={()=>rmProd(i)}>✕</button>
          <label style={{display:"flex",alignItems:"center",gap:8,fontWeight:800,fontSize:13,color:"#2d5a2d",marginBottom:8,cursor:"pointer"}}>
            <input type="checkbox" checked={!!p.active} onChange={e=>upProd(i,{active:e.target.checked})} style={{width:20,height:20,accentColor:"#2d8a2d"}} />
            {p.active ? "Ενεργό" : "Ανενεργό"}
          </label>
          <div style={grid2}>
            <div style={{gridColumn:"1/-1"}}><span style={mini}>Προϊόν</span><input className="fi" value={p.name||""} onChange={e=>upProd(i,{name:e.target.value})} /></div>
            <div><span style={mini}>Bin κιλά</span><input className="fi" type="number" value={p.binKg||0} onChange={e=>upProd(i,{binKg:parseFloat(e.target.value)||0})} /></div>
            <div><span style={mini}>Κλούβα κιλά</span><input className="fi" type="number" value={p.crateKg||0} onChange={e=>upProd(i,{crateKg:parseFloat(e.target.value)||0})} /></div>
            <div><span style={mini}>ΦΠΑ</span>
              <select className="fi" value={p.vatCategory||8} onChange={e=>upProd(i,{vatCategory:parseInt(e.target.value)})}>
                <option value={2}>13%</option><option value={1}>24%</option><option value={3}>6%</option><option value={8}>χωρίς ΦΠΑ</option>
              </select>
            </div>
            <div><span style={mini}>Κωδικός</span><input className="fi" value={p.itemCode||""} onChange={e=>upProd(i,{itemCode:e.target.value})} /></div>
          </div>
          <span style={{...mini, marginTop:8}}>Ποικιλίες</span>
          <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:8}}>
            {(p.varieties||[]).map((v,vi)=>(
              <span key={vi} style={{display:"inline-flex",alignItems:"center",gap:6,background:"#fff",border:"1.5px solid #d4e8d4",borderRadius:20,padding:"5px 6px 5px 12px",fontSize:13,fontWeight:600}}>
                {v}<button onClick={()=>rmVar(i,vi)} style={{width:22,height:22,borderRadius:"50%",border:"none",background:"#eef5ee",color:"#8c3b22",fontWeight:800,cursor:"pointer"}}>✕</button>
              </span>
            ))}
          </div>
          <div style={{display:"flex",gap:6}}>
            <input className="fi" style={{flex:1}} placeholder="Νέα ποικιλία (π.χ. Everts)" value={varInput[i]||""}
              onChange={e=>setVarInput(s=>({...s,[i]:e.target.value}))}
              onKeyDown={e=>{ if(e.key==="Enter"){ e.preventDefault(); addVar(i); } }} />
            <button className="btn" style={{background:"#e8f5e9",color:"#1e5c1e",padding:"0 16px"}} onClick={()=>addVar(i)}>＋</button>
          </div>
        </div>
      ))}
      <button className="btn" style={{width:"100%",background:"#e8f5e9",color:"#1e5c1e",justifyContent:"center",padding:12,marginBottom:14}} onClick={addProd}>+ Προσθήκη προϊόντος</button>

      {/* Σύνδεση με myDATA — οδηγός για αγρότη */}
      <div style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:15,color:"#1a2e1a",marginTop:6,marginBottom:6}}>🔐 Σύνδεση με το myDATA (ΑΑΔΕ)</div>
      {issuers.length > 1 && (
        <div style={{background:"#eef4ff",border:"1.5px solid #b3c9e5",borderRadius:10,padding:"9px 12px",marginBottom:8,fontSize:13,color:"#2b5fa5",fontWeight:700}}>
          Τα διαπιστευτήρια αφορούν τον εκδότη: <b>{[issuer.firstName,issuer.lastName].filter(Boolean).join(" ")||issuer.vat||`Εκδότης ${issIdx+1}`}</b>{issuer.vat?` (ΑΦΜ ${issuer.vat})`:""}. Άλλαξε εκδότη πιο πάνω για να συνδέσεις άλλον.
        </div>
      )}

      {cStatus.some(c=>c.environment===cEnv && (c.issuer_vat||"")===((issuer.vat||"").trim())) ? (
        // ── Ήδη συνδεδεμένο ──
        <div style={{...box, background:"#e8f5e9", border:"2px solid #2d8a2d", textAlign:"center"}}>
          <div style={{fontSize:34}}>✅</div>
          <div style={{fontWeight:800, color:"#1e5c1e", fontSize:16, margin:"4px 0"}}>Συνδεδεμένος{issuers.length>1?` · ${[issuer.firstName,issuer.lastName].filter(Boolean).join(" ")||issuer.vat}`:""}!</div>
          <div style={{fontSize:13, color:"#2d5a2d"}}>Μπορείς να στέλνεις δελτία στην ΑΑΔΕ με ένα κουμπί.</div>
          <div style={{fontSize:11, color:"#6b8c6b", marginTop:6}}>Χρήστης: {cStatus.find(c=>c.environment===cEnv && (c.issuer_vat||"")===((issuer.vat||"").trim()))?.aade_user_id} · {cEnv==="dev"?"δοκιμαστικό":"κανονικό"}</div>
          <button className="btn" style={{background:"#fff", color:"#2d5a2d", marginTop:10, padding:"8px 16px"}} onClick={()=>setCStatus(cStatus.filter(c=>!(c.environment===cEnv && (c.issuer_vat||"")===((issuer.vat||"").trim()))))}>Αλλαγή κλειδιού</button>
        </div>
      ) : (
        // ── Οδηγός σύνδεσης ──
        <div style={{...box, background:"#fff"}}>
          <div style={{fontSize:13, color:"#3a5a44", lineHeight:1.5, marginBottom:14, background:"#f0f7f0", borderRadius:10, padding:"10px 12px"}}>
            Για να στέλνεις νόμιμα δελτία, χρειάζεσαι ένα <b>προσωπικό κλειδί</b> από την ΑΑΔΕ.
            Το βγάζεις <b>μία φορά, σε 5 λεπτά</b>. Μετά όλα γίνονται αυτόματα. 🍑
          </div>

          {cMsg && <div className="msg" style={{background:cMsg.startsWith("✅")?"#e8f5e9":"#fdecea",color:cMsg.startsWith("✅")?"#1e5c1e":"#8a2318",marginBottom:10}}>{cMsg}</div>}

          {/* Βήμα 1 */}
          <div style={{display:"flex",gap:10,marginBottom:12}}>
            <div style={{flex:"none",width:28,height:28,borderRadius:"50%",background:"#1e5c1e",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800}}>1</div>
            <div style={{flex:1}}>
              <div style={{fontWeight:800,color:"#1a2e1a",marginBottom:6}}>Άνοιξε τη σελίδα της ΑΑΔΕ</div>
              <a href={cEnv==="dev" ? "https://mydata-dev-register.azurewebsites.net/" : "https://www.aade.gr/mydata"} target="_blank" rel="noopener"
                 style={{display:"block",textAlign:"center",textDecoration:"none",background:"#1e5c1e",color:"#fff",borderRadius:12,padding:"14px",fontWeight:800,fontSize:15}}>
                🌐 Άνοιγμα σελίδας ΑΑΔΕ
              </a>
              <div style={{fontSize:12,color:"#6b8c6b",marginTop:6}}>
                {cEnv==="dev"
                  ? "Δοκιμαστικό: βάλε Όνομα Χρήστη + το ΑΦΜ σου → ΕΓΓΡΑΦΗ."
                  : "Θα σου ζητήσει τους κωδικούς σου TAXISnet — μπες κανονικά, όπως στο Taxisnet."}
              </div>
            </div>
          </div>

          {/* Βήμα 2 */}
          <div style={{display:"flex",gap:10,marginBottom:12}}>
            <div style={{flex:"none",width:28,height:28,borderRadius:"50%",background:"#1e5c1e",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800}}>2</div>
            <div style={{flex:1}}>
              <div style={{fontWeight:800,color:"#1a2e1a",marginBottom:4}}>Κάνε εγγραφή</div>
              <div style={{fontSize:13,color:"#3a5a44",lineHeight:1.6}}>
                {cEnv==="dev"
                  ? <>Στη φόρμα γράψε ένα <b>Όνομα Χρήστη</b> (με λατινικά, π.χ. paliotzikas) και το <b>ΑΦΜ</b> σου → πάτα <b>ΕΓΓΡΑΦΗ</b>. Θα εμφανιστεί το <b>Κλειδί</b>.</>
                  : <>Πάτα «<b>Εγγραφή στο myDATA REST API</b>» → «<b>Νέα εγγραφή</b>».<br/>Γράψε ένα <b>Όνομα Χρήστη</b> (λατινικά, π.χ. paliotzikas) και το email σου → <b>Εγγραφή</b>.<br/>Θα εμφανιστεί ένα <b>Κλειδί (Subscription Key)</b>.</>}
              </div>
              <div style={{fontSize:12,color:"#b5651d",fontWeight:700,marginTop:6,background:"#fff8e1",borderRadius:8,padding:"8px 10px"}}>
                ⚠️ Σημαντικό: αντίγραψε αμέσως το <b>Όνομα Χρήστη</b> και το <b>Κλειδί</b> — δεν εμφανίζονται ξανά!
              </div>
            </div>
          </div>

          {/* Βήμα 3 */}
          <div style={{display:"flex",gap:10}}>
            <div style={{flex:"none",width:28,height:28,borderRadius:"50%",background:"#1e5c1e",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800}}>3</div>
            <div style={{flex:1}}>
              <div style={{fontWeight:800,color:"#1a2e1a",marginBottom:8}}>Βάλ' τα εδώ (μία φορά)</div>
              <div><span style={mini}>Όνομα Χρήστη</span><input className="fi" style={{fontSize:16,minHeight:52}} value={cUser} onChange={e=>setCUser(e.target.value)} autoComplete="off" placeholder="π.χ. paliotzikas" /></div>
              <div style={{marginTop:8}}><span style={mini}>Κλειδί (Subscription Key)</span><input className="fi" style={{fontSize:16,minHeight:52}} type="password" value={cKey} onChange={e=>setCKey(e.target.value)} autoComplete="off" placeholder="επικόλλησε το κλειδί" /></div>
              <button className="btn btn-p" style={{width:"100%",justifyContent:"center",padding:15,marginTop:12,fontWeight:900,fontSize:16}} disabled={cSaving} onClick={saveCreds}>{cSaving?"Αποθήκευση…":"✓ Σύνδεση με myDATA"}</button>
              <div style={{fontSize:11,color:"#8aaa8a",marginTop:8,textAlign:"center"}}>🔒 Το κλειδί σου αποθηκεύεται κρυπτογραφημένο. Δεν το βλέπει κανείς.</div>
            </div>
          </div>

          {/* Διακόπτης δοκιμαστικό/κανονικό — διακριτικός */}
          <div style={{display:"flex",gap:6,marginTop:14,borderTop:"1px solid #eee",paddingTop:10}}>
            <button className="btn" style={{flex:1,justifyContent:"center",padding:8,fontSize:12,fontWeight:700,background:cEnv==="prod"?"#b5651d":"#f0f7f0",color:cEnv==="prod"?"#fff":"#8aaa8a"}} onClick={()=>setCEnv("prod")}>Κανονικό (πραγματικά δελτία)</button>
            <button className="btn" style={{flex:1,justifyContent:"center",padding:8,fontSize:12,fontWeight:700,background:cEnv==="dev"?"#1e5c1e":"#f0f7f0",color:cEnv==="dev"?"#fff":"#8aaa8a"}} onClick={()=>setCEnv("dev")}>Δοκιμαστικό</button>
          </div>
        </div>
      )}

      <label style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px",background:"#f7faf7",border:"1px solid #e0ebe0",borderRadius:14,margin:"6px 0 14px",cursor:"pointer"}}>
        <input type="checkbox" checked={includeVariety} onChange={e=>setIncludeVariety(e.target.checked)} style={{width:22,height:22,accentColor:"#1e5c1e",flex:"none"}} />
        <span style={{fontSize:13.5,color:"#2a3a2a",lineHeight:1.4}}>
          <b>Εμφάνιση ποικιλίας στην περιγραφή είδους</b><br/>
          <span style={{fontSize:12,color:"#6b8c6b"}}>Αν είναι κλειστό, στέλνεται μόνο το είδος (π.χ. «Ροδάκινα συμπύρηνα»). Τα bins/συσκευασία εμφανίζονται πάντα.</span>
        </span>
      </label>

      <button className="btn btn-p" style={{width:"100%",justifyContent:"center",padding:14,fontSize:16,fontWeight:900}} disabled={saving} onClick={saveAll}>
        {saving ? "Αποθήκευση…" : "✓ Αποθήκευση ρυθμίσεων δελτίου"}
      </button>
    </div>
  );
}

function SettingsTab() {
  const { settings: rawSettings, updateSettings, user, plan, userName, setUserName, userPhone, setUserPhone } = useApp();
  const settings = rawSettings || { showTransport:true, showMachine:true, showWorkers:true, showSpray:true, showFertilizer:true, showRows:true, showExtraCost:true, cat_metafora:true, cat_mixanima:true, cat_ergates:true, cat_psekasmos:true, cat_lipansh:true, cat_katergasia:true, cat_apskilosi:true, cat_spora:true, cat_kladema:true, cat_ardeysh:true, cat_araioma:true, cat_sygkomidh:true, cat_syntirisi:true };
  const [saved, setSaved] = useState(false);
  const [activeSection, setActiveSection] = useState(null);

  const toggle = async (key) => {
    const newSettings = { ...settings, [key]: !settings[key] };
    await updateSettings(newSettings);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  const Toggle = ({k}) => (
    <button type="button"
      style={{background:settings[k]?"#2d8a2d":"#e0e0e0",border:"none",borderRadius:20,width:52,height:28,cursor:"pointer",position:"relative",transition:"all .3s",flexShrink:0}}
      onClick={()=>toggle(k)}>
      <span style={{position:"absolute",top:3,left:settings[k]?26:4,width:22,height:22,background:"#fff",borderRadius:"50%",transition:"all .3s",display:"block",boxShadow:"0 1px 4px rgba(0,0,0,.2)"}}/>
    </button>
  );

  const ACTIVITY_ITEMS = [
    { key: "showTransport",   label: "🚗 Μεταφορά & Καύσιμα",   desc: "Μέσο μετακίνησης, καύσιμα" },
    { key: "showMachine",     label: "🚜 Μηχάνημα Εργασίας",    desc: "Επιλογή μηχανήματος" },
    { key: "showWorkers",     label: "👷 Εργάτες",               desc: "Καταχώριση εργατών & αμοιβών" },
    { key: "showSpray",       label: "💊 Φάρμακα Ψεκασμού",     desc: "Φάρμακα, δόσεις, αιτία" },
    { key: "showFertilizer",  label: "🌿 Λιπάσματα",            desc: "Είδος & ποσότητα λιπάσματος" },
    { key: "showRows",        label: "🌳 Σειρές Δέντρων",       desc: "Επιλογή σειρών κλαδέματος" },
    { key: "showExtraCost",   label: "💸 Κόστος Αβαρίας",       desc: "Επιπλέον έξοδα εργασίας" },
  ];

  const CATEGORY_ITEMS = [
    { key: "cat_katergasia", label: "🚜 Κατεργασία Εδάφους",        desc: "Όργωμα, φρεζάρισμα κλπ" },
    { key: "cat_apskilosi",  label: "🌿 Αποψίλωση / Καθαρισμός",   desc: "Καταστροφέας, χορτοκοπτικό" },
    { key: "cat_spora",      label: "🌱 Σπορά / Φύτεμα",           desc: "Σπορά, φύτεμα δενδρυλλίων" },
    { key: "cat_kladema",    label: "✂️ Κλάδεμα",                  desc: "Μορφοποίησης, καρποφορίας" },
    { key: "cat_psekasmos",  label: "💊 Ψεκασμός",                  desc: "Εντομοκτόνα, μυκητοκτόνα" },
    { key: "cat_lipansh",    label: "🌿 Λίπανση",                   desc: "Λιπάσματα εδάφους/φυλλώματος" },
    { key: "cat_ardeysh",    label: "💧 Άρδευση",                   desc: "Πότισμα, στάγδην, καταιονισμός" },
    { key: "cat_araioma",    label: "🍑 Αραίωμα",                   desc: "Αραίωμα καρπών" },
    { key: "cat_sygkomidh",  label: "🧺 Συγκομιδή",                 desc: "Μάζεμα καρπών" },
    { key: "cat_syntirisi",  label: "🔧 Συντήρηση",                 desc: "Συντήρηση εξοπλισμού" },
  ];

  const sections = [
    { id: "mydata",       ic: "🌾",  lb: "Η Εκμετάλλευσή μου" },
    { id: "deltio",       ic: "📄",  lb: "Δελτίο Αποστολής (myDATA)" },
    { id: "weather_set",  ic: "🌤",  lb: "Καιρός" },
    { id: "display",      ic: "👁",  lb: "Εμφάνιση" },
    { id: "profile",      ic: "👤",  lb: "Στοιχεία Χρήστη" },
    { id: "finance_link", ic: "💰",  lb: "Οικονομικά", isLink: true, target: "finance" },
    { id: "stats_link",   ic: "📊",  lb: "Στατιστικά", isLink: true, target: "stats" },
    { id: "contact",      ic: "📞",  lb: "Επικοινωνία" },
    { id: "subscription", ic: "⭐",  lb: "Συνδρομή" },
  ];

  return (
    <div>
      <div className="stitle">⚙️ Ρυθμίσεις</div>
      {saved && <div className="msg msg-s">✅ Αποθηκεύτηκε!</div>}

      {/* Sections menu */}
      <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:16}}>
        {sections.map(s=>(
          <div key={s.id}>
            <button type="button"
              style={{width:"100%",background:"#fff",border:`2px solid ${activeSection===s.id?"#2d8a2d":"#e8f5e9"}`,borderRadius:16,padding:"16px 18px",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer",boxShadow:"0 2px 8px rgba(0,0,0,.06)"}}
              onClick={()=>{
                if (s.isLink && s.target) {
                  window._prevTab = "settings";
                  window._gotoTab && window._gotoTab(s.target);
                } else {
                  setActiveSection(activeSection===s.id?null:s.id);
                }
              }}>
              <div style={{display:"flex",alignItems:"center",gap:12}}>
                <span style={{fontSize:22}}>{s.ic}</span>
                <span style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:16,color:"#1a2e1a"}}>{s.lb}</span>
              </div>
              <span style={{fontSize:18,color:"#8aaa8a"}}>{s.isLink ? "→" : (activeSection===s.id?"▲":"▼")}</span>
            </button>

            {/* Η Εκμετάλλευσή μου */}
            {activeSection==="mydata" && s.id==="mydata" && (
              <div style={{background:"#f8fdf8",borderRadius:"0 0 16px 16px",border:"2px solid #2d8a2d",borderTop:"none",padding:12}}>
                {[
                  {ic:"🌱", lb:"Αγροτεμάχια", id:"fields"},
                  {ic:"🚜", lb:"Μηχανήματα", id:"machines"},
                  {ic:"👷", lb:"Εργάτες", id:"workers"},
                  {ic:"📦", lb:"Αποθήκη", id:"inventory"},
                ].map(item=>(
                  <button key={item.id} type="button"
                    style={{width:"100%",background:"#fff",border:"1.5px solid #d4e8d4",borderRadius:14,padding:"14px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer",marginBottom:8}}
                    onClick={()=>{ setActiveSection(null); window._gotoTab && window._gotoTab(item.id); window._prevTab = "settings"; }}>
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <span style={{fontSize:22}}>{item.ic}</span>
                      <span style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:15,color:"#1a2e1a"}}>{item.lb}</span>
                    </div>
                    <span style={{fontSize:16,color:"#8aaa8a"}}>›</span>
                  </button>
                ))}
              </div>
            )}

            {/* Δελτίο Αποστολής (myDATA) */}
            {activeSection==="deltio" && s.id==="deltio" && <DeltioSettingsSection />}

            {/* Καιρός */}
            {activeSection==="weather_set" && s.id==="weather_set" && (
              <div style={{background:"#f8fdf8",borderRadius:"0 0 16px 16px",border:"2px solid #2d8a2d",borderTop:"none",padding:16}}>
                <div style={{fontSize:13,color:"#6b8c6b",marginBottom:12}}>Πρόσθεσε τις περιοχές σου για γρήγορη πρόσβαση στον καιρό:</div>
                {(settings.weatherCities||[]).map((city,idx)=>(
                  <div key={idx} style={{display:"flex",gap:8,marginBottom:8,alignItems:"center"}}>
                    <div style={{flex:1,background:"#fff",borderRadius:10,padding:"10px 14px",fontWeight:700,fontSize:14,color:"#1a2e1a",border:"1.5px solid #d4e8d4"}}>{city}</div>
                    <button aria-label="Διαγραφή" className="btn btn-d" style={{padding:"8px 12px"}} onClick={async()=>{
                      const newCities = (settings.weatherCities||[]).filter((_,i)=>i!==idx);
                      await updateSettings({...settings, weatherCities: newCities});
                    }}>✕</button>
                  </div>
                ))}
                <input className="fi" id="newWeatherCity" placeholder="π.χ. Τρίκαλα" style={{width:"100%",marginBottom:8,marginTop:8}} />
                <button className="btn btn-p" style={{width:"100%",justifyContent:"center",marginBottom:4}} onClick={async()=>{
                    const inp = document.getElementById("newWeatherCity");
                    const city = inp?.value?.trim();
                    if (!city) return;
                    const newCities = [...(settings.weatherCities||[]), city];
                    await updateSettings({...settings, weatherCities: newCities});
                    if(inp) inp.value = "";
                  }}>➕ Προσθήκη</button>
              </div>
            )}

            {/* Εμφάνιση */}
            {activeSection==="display" && s.id==="display" && (
              <div style={{background:"#f8fdf8",borderRadius:"0 0 16px 16px",border:"2px solid #2d8a2d",borderTop:"none",padding:16}}>
                {/* Καταχώρηση Εργασίας sub-button */}
                <button type="button"
                  style={{width:"100%",background:"#fff",border:"1.5px solid #d4e8d4",borderRadius:14,padding:"14px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer",marginBottom:8}}
                  onClick={()=>setActiveSection("activity_form")}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <span style={{fontSize:18}}>📋</span>
                    <span style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:15,color:"#1a2e1a"}}>Πεδία Εργασίας</span>
                  </div>
                  <span style={{fontSize:14,color:"#8aaa8a"}}>›</span>
                </button>
                <button type="button"
                  style={{width:"100%",background:"#fff",border:"1.5px solid #d4e8d4",borderRadius:14,padding:"14px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer"}}
                  onClick={()=>setActiveSection("activity_cats")}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <span style={{fontSize:18}}>🗂</span>
                    <span style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:15,color:"#1a2e1a"}}>Κατηγορίες Εργασίας</span>
                  </div>
                  <span style={{fontSize:14,color:"#8aaa8a"}}>›</span>
                </button>
              </div>
            )}

            {/* Κατηγορίες Εργασίας toggles */}
            {activeSection==="activity_cats" && s.id==="display" && (
              <div style={{background:"#f8fdf8",borderRadius:"0 0 16px 16px",border:"2px solid #2d8a2d",borderTop:"none"}}>
                <button type="button"
                  style={{width:"100%",background:"transparent",border:"none",borderBottom:"1px solid #e8f5e9",padding:"12px 16px",display:"flex",alignItems:"center",gap:8,cursor:"pointer",color:"#2d8a2d",fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:13}}
                  onClick={()=>setActiveSection("display")}>
                  ← Πίσω
                </button>
                <div style={{padding:"4px 0"}}>
                  {CATEGORY_ITEMS.map((item,idx)=>(
                    <div key={item.key} style={{display:"flex",alignItems:"center",padding:"14px 16px",borderBottom:idx<CATEGORY_ITEMS.length-1?"1px solid #f0f0f0":"none",gap:12}}>
                      <div style={{flex:1}}>
                        <div style={{fontWeight:800,fontSize:15,color:"#1a2e1a"}}>{item.label}</div>
                        <div style={{fontSize:12,color:"#8aaa8a",marginTop:2}}>{item.desc}</div>
                      </div>
                      <Toggle k={item.key} />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Πεδία Εργασίας toggles */}
            {activeSection==="activity_form" && s.id==="display" && (
              <div style={{background:"#f8fdf8",borderRadius:"0 0 16px 16px",border:"2px solid #2d8a2d",borderTop:"none"}}>
                <button type="button"
                  style={{width:"100%",background:"transparent",border:"none",borderBottom:"1px solid #e8f5e9",padding:"12px 16px",display:"flex",alignItems:"center",gap:8,cursor:"pointer",color:"#2d8a2d",fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:13}}
                  onClick={()=>setActiveSection("display")}>
                  ← Πίσω
                </button>
                <div style={{padding:"4px 0"}}>
                  {ACTIVITY_ITEMS.map((item,idx)=>(
                    <div key={item.key} style={{display:"flex",alignItems:"center",padding:"14px 16px",borderBottom:idx<ACTIVITY_ITEMS.length-1?"1px solid #f0f0f0":"none",gap:12}}>
                      <div style={{flex:1}}>
                        <div style={{fontWeight:800,fontSize:15,color:"#1a2e1a"}}>{item.label}</div>
                        <div style={{fontSize:12,color:"#8aaa8a",marginTop:2}}>{item.desc}</div>
                      </div>
                      <Toggle k={item.key} />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Στοιχεία Χρήστη */}
            {activeSection==="profile" && s.id==="profile" && (
              <div style={{background:"#f8fdf8",borderRadius:"0 0 16px 16px",border:"2px solid #2d8a2d",borderTop:"none",padding:16}}>
                <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
                  <div style={{width:52,height:52,borderRadius:16,background:"#e8f5e9",display:"flex",alignItems:"center",justifyContent:"center",fontSize:26}}>👤</div>
                  <div>
                    <div style={{fontWeight:900,fontSize:16,color:"#1a2e1a"}}>{userName||"—"}</div>
                    <div style={{fontSize:13,color:"#6b8c6b"}}>{user?.email}</div>
                  </div>
                </div>
                {/* Αλλαγή ονόματος */}
                <NameEditor userName={userName} setUserName={setUserName} userId={user?.id} />
                <PhoneEditor userPhone={userPhone} setUserPhone={setUserPhone} userId={user?.id} />
                <div style={{background:"#fff",borderRadius:12,padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:10}}>
                  <span style={{fontFamily:"Nunito,sans-serif",fontWeight:700,fontSize:14,color:"#2d5a2d"}}>Πλάνο</span>
                  <span className={`badge ${plan==="pro"?"pro":""}`} style={{fontSize:13,padding:"4px 14px",borderRadius:20,background:plan==="pro"?"#2d8a2d":"#f4c542",color:plan==="pro"?"#fff":"#1a2e1a",fontWeight:800}}>{plan==="free_expired"?"FREE":plan.toUpperCase()}</span>
                </div>
              </div>
            )}

            {/* Επικοινωνία */}
            {activeSection==="contact" && s.id==="contact" && (
              <div style={{background:"#f8fdf8",borderRadius:"0 0 16px 16px",border:"2px solid #2d8a2d",borderTop:"none",padding:16}}>
                {[
                  {ic:"📧", lb:"Email Υποστήριξης", val:"support@jitech.gr"},
                  {ic:"🔒", lb:"GDPR / Απορρήτου", val:"gdpr@jitech.gr"},
                  {ic:"🌐", lb:"Website", val:"jitech.gr"},
                ].map(c=>(
                  <div key={c.lb} style={{background:"#fff",borderRadius:12,padding:"12px 16px",marginBottom:8,display:"flex",alignItems:"center",gap:12}}>
                    <span style={{fontSize:20}}>{c.ic}</span>
                    <div>
                      <div style={{fontSize:12,color:"#8aaa8a",fontWeight:600}}>{c.lb}</div>
                      <div style={{fontSize:14,fontWeight:800,color:"#1a2e1a"}}>{c.val}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Συνδρομή */}
            {activeSection==="subscription" && s.id==="subscription" && (
              <div style={{background:"#f8fdf8",borderRadius:"0 0 16px 16px",border:"2px solid #2d8a2d",borderTop:"none",padding:16}}>
                <div style={{background:"#fff",borderRadius:12,padding:16,marginBottom:12}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                    <span style={{fontWeight:700,color:"#2d5a2d"}}>Τρέχον Πλάνο</span>
                    <span style={{background:plan==="pro"?"#2d8a2d":"#f4c542",color:plan==="pro"?"#fff":"#1a2e1a",padding:"4px 14px",borderRadius:20,fontWeight:800,fontSize:13}}>{plan==="free_expired"?"FREE":plan.toUpperCase()}</span>
                  </div>
                  {plan==="pro" ? (
                    <div style={{fontSize:13,color:"#6b8c6b"}}>✅ Πλήρης πρόσβαση σε όλες τις λειτουργίες</div>
                  ) : (
                    <div>
                      <div style={{fontSize:13,color:"#6b8c6b",marginBottom:12}}>Αναβάθμισε για πλήρη πρόσβαση</div>
                      <button style={{width:"100%",background:"linear-gradient(135deg,#f4c542,#e6a800)",border:"none",borderRadius:14,padding:14,fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:16,cursor:"pointer",color:"#1a2e1a"}}>
                        ⭐ Αναβάθμιση σε PRO
                      </button>
                    </div>
                  )}
                </div>
                <div style={{textAlign:"center",fontSize:12,color:"#8aaa8a"}}>
                  Για θέματα συνδρομής: support@jitech.gr
                </div>
              </div>
            )}

          </div>
        ))}
      </div>

      <div style={{textAlign:"center",fontSize:11,color:"#8aaa8a",marginTop:8,fontStyle:"italic"}}>
        Οι ρυθμίσεις αποθηκεύονται αυτόματα
      </div>
    </div>
  );
}



// ── STATS TAB ─────────────────────────────────────────────────
function ExtraCostStatsSection({ activities, fields }) {
  const [open, setOpen] = useState(false);

  const extraActs = activities.filter(a => parseFloat(a.cost_total) > 0);
  const totalExtra = extraActs.reduce((s,a)=>s+(parseFloat(a.cost_total)||0),0);

  // Group by notes
  const byReason = {};
  extraActs.forEach(a => {
    const reason = a.extra_cost_notes||"Χωρίς αιτία";
    if (!byReason[reason]) byReason[reason] = { count:0, total:0 };
    byReason[reason].count++;
    byReason[reason].total += parseFloat(a.cost_total)||0;
  });

  return (
    <div style={{marginBottom:20}}>
      <button type="button"
        style={{width:"100%",background:open?"#b71c1c":"#fff",border:"2px solid #b71c1c",borderRadius:16,padding:"14px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer",boxShadow:"0 2px 8px rgba(0,0,0,.06)"}}
        onClick={()=>setOpen(!open)}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <span style={{fontSize:22}}>💸</span>
          <span style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:15,color:open?"#fff":"#1a2e1a"}}>
            Αβαρίες & Έκτακτα
          </span>
          <span style={{background:open?"rgba(255,255,255,.2)":"#ffebee",color:open?"#fff":"#b71c1c",borderRadius:20,padding:"2px 10px",fontSize:12,fontWeight:800}}>
            {totalExtra.toFixed(0)}€
          </span>
        </div>
        <span style={{fontSize:18,color:open?"#fff":"#8aaa8a"}}>{open?"▲":"▼"}</span>
      </button>

      {open && (
        <div style={{background:"#fff9f9",border:"2px solid #b71c1c",borderTop:"none",borderRadius:"0 0 16px 16px",overflow:"hidden"}}>
          {extraActs.length === 0 ? (
            <div style={{padding:20,textAlign:"center",color:"#8aaa8a",fontSize:13}}>Δεν υπάρχουν αβαρίες για την περίοδο</div>
          ) : (
            <>
              {/* Ανά αιτία */}
              <div style={{padding:"12px 16px 4px",fontWeight:800,fontSize:13,color:"#b71c1c"}}>📊 Ανά αιτία</div>
              <div style={{background:"#fff",margin:"0 12px 12px",borderRadius:12,overflow:"hidden",boxShadow:"0 1px 6px rgba(0,0,0,.06)"}}>
                {Object.entries(byReason).sort((a,b)=>b[1].total-a[1].total).map(([reason,data],idx,arr)=>(
                  <div key={reason} style={{padding:"10px 14px",borderBottom:idx<arr.length-1?"1px solid #f5f5f5":"none",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div>
                      <div style={{fontWeight:800,fontSize:13,color:"#1a2e1a"}}>{reason}</div>
                      <div style={{fontSize:11,color:"#8aaa8a"}}>{data.count} φορές</div>
                    </div>
                    <div style={{fontWeight:900,fontSize:15,color:"#b71c1c"}}>{data.total.toFixed(0)}€</div>
                  </div>
                ))}
              </div>

              {/* Χρονολόγιο */}
              <div style={{padding:"4px 16px 8px",fontWeight:800,fontSize:13,color:"#b71c1c"}}>📅 Χρονολόγιο αβαριών</div>
              <div style={{background:"#fff",margin:"0 12px 16px",borderRadius:12,overflow:"hidden",boxShadow:"0 1px 6px rgba(0,0,0,.06)"}}>
                {extraActs.sort((a,b)=>b.date.localeCompare(a.date)).map((a,idx)=>{
                  const ids = a.field_ids?.length>0?a.field_ids:(a.field_id?[a.field_id]:[]);
                  const fnames = ids.map(id=>fields.find(f=>f.id===id)?.name).filter(Boolean).join(", ");
                  return (
                    <div key={a.id} style={{padding:"10px 14px",borderBottom:idx<extraActs.length-1?"1px solid #f5f5f5":"none",display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                      <div style={{flex:1}}>
                        <div style={{fontWeight:800,fontSize:13,color:"#1a2e1a"}}>{a.extra_cost_notes||"Χωρίς αιτία"}</div>
                        <div style={{fontSize:11,color:"#6b8c6b",marginTop:2}}>
                          {a.category||""}{fnames?` · 🌱 ${fnames}`:""}
                        </div>
                      </div>
                      <div style={{textAlign:"right",flexShrink:0}}>
                        <div style={{fontWeight:900,fontSize:14,color:"#b71c1c"}}>{parseFloat(a.cost_total).toFixed(0)}€</div>
                        <div style={{fontSize:11,color:"#8aaa8a"}}>{a.date}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}


function SprayStatsSection({ activities, allSprayProducts, fields }) {
  const [open, setOpen] = useState(false);

  const sprayActs = activities.filter(a => a.category && a.category.includes("Ψεκασμ"));
  
  // Get all spray products for these activities
  const sprayData = [];
  sprayActs.forEach(a => {
    const prods = allSprayProducts.filter(s => s.activity_id === a.id);
    const ids = a.field_ids?.length>0 ? a.field_ids : (a.field_id?[a.field_id]:[]);
    const fnames = ids.map(id => fields.find(f=>f.id===id)?.name).filter(Boolean).join(", ");
    prods.forEach(p => {
      if (p.product_name) sprayData.push({ date: a.date, field: fnames, ...p });
    });
  });

  // Group by product name
  const byProduct = {};
  sprayData.forEach(s => {
    if (!byProduct[s.product_name]) byProduct[s.product_name] = { count:0, totalCost:0, dates:[] };
    byProduct[s.product_name].count++;
    byProduct[s.product_name].totalCost += parseFloat(s.cost)||0;
    byProduct[s.product_name].dates.push(s.date);
  });

  return (
    <div style={{marginBottom:20}}>
      <button type="button"
        style={{width:"100%",background:open?"#1e5c1e":"#fff",border:"2px solid #1e5c1e",borderRadius:16,padding:"14px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer",boxShadow:"0 2px 8px rgba(0,0,0,.06)"}}
        onClick={()=>setOpen(!open)}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <span style={{fontSize:22}}>💊</span>
          <span style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:15,color:open?"#fff":"#1a2e1a"}}>
            Στατιστικά Ψεκασμού
          </span>
          <span style={{background:open?"rgba(255,255,255,.2)":"#e8f5e9",color:open?"#fff":"#2d8a2d",borderRadius:20,padding:"2px 10px",fontSize:12,fontWeight:800}}>
            {sprayActs.length} ψεκασμοί
          </span>
        </div>
        <span style={{fontSize:18,color:open?"#fff":"#8aaa8a"}}>{open?"▲":"▼"}</span>
      </button>

      {open && (
        <div style={{background:"#f8fdf8",border:"2px solid #1e5c1e",borderTop:"none",borderRadius:"0 0 16px 16px",overflow:"hidden"}}>
          
          {sprayData.length === 0 ? (
            <div style={{padding:20,textAlign:"center",color:"#8aaa8a",fontSize:13}}>Δεν υπάρχουν καταγεγραμμένοι ψεκασμοί</div>
          ) : (
            <>
              {/* Ανά φάρμακο */}
              <div style={{padding:"12px 16px 4px",fontWeight:800,fontSize:13,color:"#1e5c1e"}}>📊 Ανά φάρμακο</div>
              <div style={{background:"#fff",margin:"0 12px 12px",borderRadius:12,overflow:"hidden",boxShadow:"0 1px 6px rgba(0,0,0,.06)"}}>
                {Object.entries(byProduct).sort((a,b)=>b[1].count-a[1].count).map(([name,data],idx,arr)=>(
                  <div key={name} style={{padding:"10px 14px",borderBottom:idx<arr.length-1?"1px solid #f5f5f5":"none"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div>
                        <div style={{fontWeight:800,fontSize:14,color:"#1a2e1a"}}>💊 {name}</div>
                        <div style={{fontSize:11,color:"#8aaa8a",marginTop:2}}>
                          Τελευταίος: {data.dates.sort().reverse()[0]}
                        </div>
                      </div>
                      <div style={{textAlign:"right"}}>
                        <div style={{fontWeight:900,fontSize:15,color:"#2d8a2d"}}>{data.count}×</div>
                        {data.totalCost>0&&<div style={{fontSize:11,color:"#8aaa8a"}}>{data.totalCost.toFixed(0)}€</div>}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Χρονολόγιο ψεκασμών */}
              <div style={{padding:"4px 16px 8px",fontWeight:800,fontSize:13,color:"#1e5c1e"}}>📅 Χρονολόγιο ψεκασμών</div>
              <div style={{background:"#fff",margin:"0 12px 16px",borderRadius:12,overflow:"hidden",boxShadow:"0 1px 6px rgba(0,0,0,.06)"}}>
                {sprayData.sort((a,b)=>b.date.localeCompare(a.date)).map((s,idx)=>(
                  <div key={idx} style={{padding:"10px 14px",borderBottom:idx<sprayData.length-1?"1px solid #f5f5f5":"none"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                      <div style={{flex:1}}>
                        <div style={{fontWeight:800,fontSize:13,color:"#1a2e1a"}}>💊 {s.product_name}</div>
                        <div style={{fontSize:11,color:"#6b8c6b",marginTop:2}}>
                          🌱 {s.field||"—"}
                          {s.reason&&<span style={{marginLeft:8}}>· {s.reason}</span>}
                        </div>
                        {s.dose_per_stremma&&<div style={{fontSize:11,color:"#8aaa8a",marginTop:1}}>⚖️ {s.dose_per_stremma} {s.dose_unit||""}/στρ</div>}
                      </div>
                      <div style={{textAlign:"right",flexShrink:0}}>
                        <div style={{fontSize:12,fontWeight:700,color:"#2d5a2d"}}>{s.date}</div>
                        {s.cost&&<div style={{fontSize:11,color:"#8aaa8a"}}>{parseFloat(s.cost).toFixed(0)}€</div>}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}


function StatsTab() {
  const { activities, deliveries, fields, allSprayProducts, workers, allActivityWorkers } = useApp();
  const [statFilter, setStatFilter] = useState("year");
  const [calFrom, setCalFrom] = useState("");
  const [calTo, setCalTo] = useState("");
  const [compareMode, setCompareMode] = useState(false);
  const [fieldFilter, setFieldFilter] = useState("all"); // "all" or field.id
  const [statsView, setStatsView] = useState("general"); // "general" | "workers"

  const now = new Date();
  const thisYear = now.getFullYear();
  const monthNames = ["Ιαν","Φεβ","Μαρ","Απρ","Μαϊ","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ"];

  const getFromDate = (filter) => {
    const d = new Date();
    if (filter==="month") { d.setDate(1); return d; }
    if (filter==="3m") { d.setMonth(d.getMonth()-3); return d; }
    if (filter==="6m") { d.setMonth(d.getMonth()-6); return d; }
    if (filter==="year") return new Date(thisYear,0,1);
    if (filter==="prev") return new Date(thisYear-1,0,1);
    if (filter==="2y") { d.setFullYear(d.getFullYear()-2); return d; }
    if (filter==="cal" && calFrom) return new Date(calFrom);
    return new Date(0);
  };

  const getToDate = (filter) => {
    if (filter==="prev") return new Date(thisYear-1,11,31);
    if (filter==="cal" && calTo) return new Date(calTo);
    return new Date();
  };

  const calcStats = (filter) => {
    const from = getFromDate(filter);
    const to = getToDate(filter);
    let acts = activities.filter(a => { const d=new Date(a.date); return d>=from&&d<=to; });
    let dels = deliveries.filter(d => { const dt=new Date(d.date); return dt>=from&&dt<=to; });

    // Filter by selected field
    if (fieldFilter !== "all") {
      acts = acts.filter(a => {
        const ids = a.field_ids?.length>0 ? a.field_ids : (a.field_id ? [a.field_id] : []);
        return ids.includes(fieldFilter);
      });
      dels = dels.filter(d => d.field_id === fieldFilter);
    }

    // Rent cost: prorated based on selected period (months)
    const monthsInPeriod = Math.max(1, (to - from) / (30.4 * 24 * 3600 * 1000));
    const rentedFields = fieldFilter !== "all"
      ? fields.filter(f => f.id === fieldFilter && f.is_rented)
      : fields.filter(f => f.is_rented);
    const yearlyRent = rentedFields.reduce((s,f) => s + (parseFloat(f.rent_amount)||0), 0);
    const rentCost = (yearlyRent / 12) * monthsInPeriod;

    const totalKg = dels.reduce((s,d)=>s+(parseFloat(d.final_weight)||0),0);
    const totalIncome = dels.reduce((s,d)=>s+(parseFloat(d.total_amount)||0),0);
    const activitiesCost = acts.reduce((s,a)=>s+(parseFloat(a.cost_total)||0),0);
    const totalHours = acts.reduce((s,a)=>s+(parseFloat(a.hours_total)||0),0);
    const fuelCost = acts.reduce((s,a)=>s+(parseFloat(a.transport_fuel_cost)||0)+(parseFloat(a.machine_fuel_cost)||0),0);
    const extraCost = acts.reduce((s,a)=>s+(parseFloat(a.cost_total)||0)-(parseFloat(a.transport_fuel_cost)||0)-(parseFloat(a.machine_fuel_cost)||0),0);

    // Worker stats — τα μεροκάματα φορτώνονται χωριστά στο allActivityWorkers
    const actIdSet = new Set(acts.map(a=>a.id));
    const periodAW = (allActivityWorkers||[]).filter(aw=>actIdSet.has(aw.activity_id));
    const workerDays = periodAW.length;
    // Κόστος μεροκαμάτων (εργάτες × ταρίφες) — μπαίνει στα έξοδα
    const workerCost = periodAW.reduce((s,aw)=>{
      const w = (workers||[]).find(x=>x.id===aw.worker_id);
      const fr = parseFloat(w?.full_day_rate)||0, hr = parseFloat(w?.half_day_rate)||0, ho = parseFloat(w?.hourly_rate)||0;
      let p = 0;
      if (aw.full_day) p += fr;
      if (aw.half_day) p += hr;
      p += (parseFloat(aw.hours)||0)*ho;
      return s + p;
    }, 0);
    const totalCost = activitiesCost + rentCost + workerCost;

    // Category counts
    const sprayCount = acts.filter(a=>a.category&&a.category.includes("Ψεκασμ")).length;
    const waterCount = acts.filter(a=>a.category&&a.category.includes("Άρδευσ")).length;
    const pruneCount = acts.filter(a=>a.category&&a.category.includes("Κλάδεμ")).length;
    const maintCount = acts.filter(a=>a.category&&a.category.includes("Συντήρ")).length;

    // Total stremata
    let totalStremata;
    if (fieldFilter !== "all") {
      // Only the selected field's stremata
      const f = fields.find(f => f.id === fieldFilter);
      totalStremata = (parseFloat(f?.hectares)||0)*10;
    } else {
      const allFieldIds = [...new Set(acts.flatMap(a=> a.field_ids?.length>0?a.field_ids:(a.field_id?[a.field_id]:[])))];
      totalStremata = allFieldIds.reduce((s,id)=>{
        const f = fields.find(f=>f.id===id);
        return s+(parseFloat(f?.hectares)||0)*10;
      },0);
    }

    const net = totalIncome - totalCost;
    const kgPerStr = totalStremata>0 ? (totalKg/totalStremata).toFixed(1) : "-";
    const costPerStr = totalStremata>0 ? (totalCost/totalStremata).toFixed(0) : "-";

    return { acts, dels, totalKg, totalIncome, totalCost, activitiesCost, rentCost, workerCost, totalHours, fuelCost,
             extraCost, workerDays, sprayCount, waterCount, pruneCount, maintCount,
             net, kgPerStr, costPerStr, totalStremata };
  };

  const s = calcStats(statFilter);
  const sp = calcStats("prev");

  // Export CSV
  const exportExcel = () => {
    const header = ["Ημερομηνία","Αγροτεμάχιο","Κατηγορία","Εργασία","Ώρες","Κόστος","Αιτία Αβαρίας","Σημειώσεις"];
    const rows = s.acts.map(a => {
      const ids = a.field_ids?.length>0?a.field_ids:(a.field_id?[a.field_id]:[]);
      const fnames = ids.map(id=>fields.find(f=>f.id===id)?.name).filter(Boolean).join(", ");
      return [a.date,fnames,a.category||"",a.activity_type||"",a.hours_total||"",a.cost_total||"",a.extra_cost_notes||"",a.notes||""];
    });
    const delHeader = ["Ημερομηνία","Αγοραστής","Καλλιέργεια","Ποικιλία","Καθαρό Βάρος(kg)","Τιμή/kg","Σύνολο(€)"];
    const delRows = s.dels.map(d=>[d.date,d.buyer||"",d.crop||"",d.variety||"",d.final_weight||"",d.price_per_kg||"",d.total_amount||""]);
    const NL="\n", TAB="\t";
    let csv = "ΕΡΓΑΣΙΕΣ"+NL+[header,...rows].map(r=>r.join(TAB)).join(NL);
    csv += NL+NL+"ΠΑΡΑΔΟΣΕΙΣ"+NL+[delHeader,...delRows].map(r=>r.join(TAB)).join(NL);
    const blob = new Blob(["\uFEFF"+csv],{type:"text/csv;charset=utf-8;"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href=url; a.download="agropalk_export.csv"; a.click(); URL.revokeObjectURL(url);
  };

  // Export Εργοσήμων - για λογιστή/τράπεζα
  const exportErgoshima = async () => {
    // Fetch activity_workers for all activities in period
    const actIds = s.acts.map(a=>a.id);
    if (actIds.length === 0) { alert("Δεν υπάρχουν εργασίες στην επιλεγμένη περίοδο"); return; }
    const { data: aw, error } = await supabase
      .from("activity_workers")
      .select("*")
      .in("activity_id", actIds);
    if (error) { alert("Σφάλμα φόρτωσης εργατών"); return; }
    if (!aw || aw.length === 0) { alert("Δεν υπάρχουν εργάτες σε αυτές τις εργασίες"); return; }

    // Aggregate per worker
    const perWorker = {};
    aw.forEach(w => {
      const wInfo = workers.find(x=>x.id===w.worker_id);
      const key = w.worker_id || w.worker_name || "unknown";
      const name = wInfo?.name || w.worker_name || "—";
      const phone = wInfo?.phone || "";
      const amka = wInfo?.amka || "";
      const iban = wInfo?.iban || "";
      const fullRate = parseFloat(wInfo?.full_day_rate)||0;
      const halfRate = parseFloat(wInfo?.half_day_rate)||0;
      const hourRate = parseFloat(wInfo?.hourly_rate)||0;
      const act = s.acts.find(a=>a.id===w.activity_id);
      if (!perWorker[key]) perWorker[key] = { name, phone, amka, iban, fullDays:0, halfDays:0, hours:0, total:0, days:[] };
      const fullAmt = w.full_day?fullRate:0;
      const halfAmt = w.half_day?halfRate:0;
      const hrsAmt = (parseFloat(w.hours)||0)*hourRate;
      const totalDay = fullAmt+halfAmt+hrsAmt;
      if (w.full_day) perWorker[key].fullDays += 1;
      if (w.half_day) perWorker[key].halfDays += 1;
      perWorker[key].hours += parseFloat(w.hours)||0;
      perWorker[key].total += totalDay;
      perWorker[key].days.push({ date: act?.date, full: w.full_day, half: w.half_day, hours: w.hours, amount: totalDay });
    });

    // Build CSV
    const NL="\n", TAB="\t";
    const summaryHeader = ["Όνομα","Τηλέφωνο","ΑΜΚΑ","IBAN","Ολόκληρα","Μισά","Ώρες","Σύνολο (€)"];
    const summaryRows = Object.values(perWorker).map(w=>[
      w.name, w.phone, w.amka, w.iban, w.fullDays, w.halfDays, w.hours.toFixed(1), w.total.toFixed(2)
    ]);
    const grandTotal = Object.values(perWorker).reduce((s,w)=>s+w.total,0);
    const grandFull = Object.values(perWorker).reduce((s,w)=>s+w.fullDays,0);
    const grandHalf = Object.values(perWorker).reduce((s,w)=>s+w.halfDays,0);

    let csv = "ΕΡΓΟΣΗΜΑ - ΣΥΝΟΨΗ"+NL+
              `Περίοδος:${TAB}${statFilter==="cal"?(calFrom+" έως "+calTo):statFilter}`+NL+NL+
              [summaryHeader,...summaryRows].map(r=>r.join(TAB)).join(NL)+NL+
              ["","","","ΣΥΝΟΛΑ:",grandFull,grandHalf,"",grandTotal.toFixed(2)].join(TAB)+NL+NL+
              "ΑΝΑΛΥΣΗ ΑΝΑ ΕΡΓΑΤΗ"+NL;

    Object.values(perWorker).forEach(w => {
      csv += NL+w.name+" "+(w.amka?`ΑΜΚΑ: ${w.amka}`:"")+" "+(w.phone?`(${w.phone})`:"")+NL;
      csv += ["Ημερομηνία","Ολόκληρο","Μισό","Ώρες","Ποσό (€)"].join(TAB)+NL;
      w.days.sort((a,b)=>(a.date||"").localeCompare(b.date||""));
      w.days.forEach(d=>{
        csv += [d.date||"",d.full?"✓":"",d.half?"✓":"",d.hours||"",d.amount.toFixed(2)].join(TAB)+NL;
      });
      csv += ["","","","ΣΥΝΟΛΟ:",w.total.toFixed(2)].join(TAB)+NL;
    });

    const blob = new Blob(["\uFEFF"+csv],{type:"text/csv;charset=utf-8;"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href=url; a.download=`ergoshima_${statFilter}.csv`; a.click(); URL.revokeObjectURL(url);
  };

  const FILTERS = [
    {v:"month",lb:"Μήνας"},{v:"3m",lb:"3μ"},{v:"6m",lb:"6μ"},
    {v:"year",lb:String(thisYear)},{v:"prev",lb:String(thisYear-1)},
    {v:"2y",lb:"2ετία"},{v:"cal",lb:"🗓"},
  ];

  const Row = ({label, cur, prev, unit="", good="high"}) => {
    const diff = prev!==null&&cur!==null ? cur-prev : null;
    const pct = prev&&prev!==0 ? ((cur-prev)/Math.abs(prev)*100).toFixed(0) : null;
    const isGood = good==="high" ? diff>=0 : diff<=0;
    return (
      <div style={{display:"flex",alignItems:"center",padding:"11px 16px",borderBottom:"1px solid #f5f5f5"}}>
        <div style={{flex:1,fontSize:13,fontWeight:700,color:"#2d5a2d"}}>{label}</div>
        <div style={{fontWeight:900,fontSize:14,color:"#1a2e1a",minWidth:70,textAlign:"right"}}>
          {cur!==null?cur+unit:"—"}
        </div>
        {compareMode && prev!==null && diff!==null && (
          <div style={{minWidth:80,textAlign:"right",fontSize:12,fontWeight:700,color:isGood?"#2d8a2d":"#c62828"}}>
            {diff>=0?"+":""}{diff.toFixed(diff%1===0?0:1)}{unit}
            {pct&&<span style={{fontSize:10,marginLeft:4}}>({pct}%)</span>}
          </div>
        )}
        {compareMode && (
          <div style={{minWidth:70,textAlign:"right",fontSize:13,color:"#8aaa8a"}}>
            {prev!==null?prev+unit:"—"}
          </div>
        )}
      </div>
    );
  };

  // Bar chart last 6 months
  const last6 = [];
  for (let i=5; i>=0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth()-i, 1);
    const m = d.getMonth(), y = d.getFullYear();
    const count = activities.filter(a=>{
      const ad=new Date(a.date);
      if (ad.getMonth()!==m || ad.getFullYear()!==y) return false;
      if (fieldFilter !== "all") {
        const ids = a.field_ids?.length>0 ? a.field_ids : (a.field_id ? [a.field_id] : []);
        if (!ids.includes(fieldFilter)) return false;
      }
      return true;
    }).length;
    last6.push({ label: monthNames[m], count });
  }
  const maxCount = Math.max(...last6.map(m=>m.count), 1);

  return (
    <div>
      {window._prevTab === "settings" && (
        <button className="btn" style={{width:"100%",background:"#f0f9f0",color:"#2d8a2d",justifyContent:"center",marginBottom:12,padding:12,fontSize:14,fontWeight:800}} onClick={()=>{window._prevTab=null;window._gotoTab&&window._gotoTab("settings");}}>
          ← Πίσω στις Ρυθμίσεις
        </button>
      )}
      <div className="stitle">📊 Στατιστικά</div>

      {/* View selector: General / Workers / Me */}
      <div style={{display:"flex",gap:6,marginBottom:14,background:"#f0f9f0",padding:4,borderRadius:14}}>
        <button className="btn"
          style={{flex:1,background:statsView==="general"?"#2d8a2d":"transparent",color:statsView==="general"?"#fff":"#2d5a2d",fontWeight:800,padding:"10px",justifyContent:"center",boxShadow:"none",fontSize:13}}
          onClick={()=>setStatsView("general")}>
          📊 Γενικά
        </button>
        <button className="btn"
          style={{flex:1,background:statsView==="workers"?"#2d8a2d":"transparent",color:statsView==="workers"?"#fff":"#2d5a2d",fontWeight:800,padding:"10px",justifyContent:"center",boxShadow:"none",fontSize:13}}
          onClick={()=>setStatsView("workers")}>
          👷 Εργάτες
        </button>
        <button className="btn"
          style={{flex:1,background:statsView==="me"?"#2d8a2d":"transparent",color:statsView==="me"?"#fff":"#2d5a2d",fontWeight:800,padding:"10px",justifyContent:"center",boxShadow:"none",fontSize:13}}
          onClick={()=>setStatsView("me")}>
          👨‍🌾 Εγώ
        </button>
      </div>

      {statsView === "workers" ? <WorkerStatsView workers={workers} activities={activities} allActivityWorkers={allActivityWorkers} fields={fields} statFilter={statFilter} setStatFilter={setStatFilter} calFrom={calFrom} setCalFrom={setCalFrom} calTo={calTo} setCalTo={setCalTo} /> : statsView === "me" ? <FarmerStatsView activities={activities} fields={fields} statFilter={statFilter} setStatFilter={setStatFilter} calFrom={calFrom} setCalFrom={setCalFrom} calTo={calTo} setCalTo={setCalTo} /> : (
      <>

      {/* Field selector */}
      <div style={{marginBottom:12}}>
        <label style={{fontSize:11,fontWeight:700,color:"#4a6a4a",display:"block",marginBottom:6}}>🌳 Αγροτεμάχιο</label>
        <select className="fi" value={fieldFilter} onChange={e=>setFieldFilter(e.target.value)}
          style={{fontWeight:700,color:"#2d5a2d"}}>
          <option value="all">Όλα τα αγροτεμάχια</option>
          {fields.map(f => (
            <option key={f.id} value={f.id}>{f.name}{f.crop?` — ${f.crop}`:""}</option>
          ))}
        </select>
      </div>

      {fieldFilter !== "all" && (() => {
        const f = fields.find(f => f.id === fieldFilter);
        if (!f) return null;
        return (
          <div style={{background:"#e8f5e9",border:"1.5px solid #2d8a2d",borderRadius:12,padding:"10px 14px",marginBottom:12,fontSize:12,color:"#1e5c1e"}}>
            📍 Στατιστικά για: <strong>{f.name}</strong>
            {f.crop && <> · {f.crop}</>}
            {f.hectares && <> · {(parseFloat(f.hectares)*10).toFixed(1)} στρ</>}
            {f.is_rented && <> · 🏠 Ενοικιαζόμενο {f.rent_amount?`(${parseFloat(f.rent_amount).toFixed(0)}€/έτος)`:""}</>}
          </div>
        );
      })()}

      {/* Φίλτρα */}
      <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:10}}>
        {FILTERS.map(f=>(
          <button key={f.v} type="button"
            style={{background:statFilter===f.v?"#2d8a2d":"#fff",border:`2px solid ${statFilter===f.v?"#2d8a2d":"#d4e8d4"}`,borderRadius:12,padding:"8px 14px",fontSize:13,fontWeight:800,color:statFilter===f.v?"#fff":"#2d5a2d",cursor:"pointer"}}
            onClick={()=>setStatFilter(f.v)}>{f.lb}
          </button>
        ))}
      </div>

      {statFilter==="cal" && (
        <div style={{display:"flex",gap:8,background:"#f0f9f0",borderRadius:12,padding:10,marginBottom:10}}>
          <div style={{flex:1}}>
            <label style={{fontSize:11,fontWeight:700,color:"#4a6a4a",display:"block",marginBottom:3}}>Από</label>
            <input className="fi" type="date" value={calFrom} onChange={e=>setCalFrom(e.target.value)} />
          </div>
          <div style={{fontWeight:700,color:"#8aaa8a",alignSelf:"flex-end",paddingBottom:8}}>→</div>
          <div style={{flex:1}}>
            <label style={{fontSize:11,fontWeight:700,color:"#4a6a4a",display:"block",marginBottom:3}}>Έως</label>
            <input className="fi" type="date" value={calTo} onChange={e=>setCalTo(e.target.value)} />
          </div>
        </div>
      )}

      {/* Σύγκριση toggle */}
      <div style={{display:"flex",gap:8,marginBottom:14,alignItems:"center"}}>
        <button className="btn" style={{flex:1,justifyContent:"center",background:compareMode?"#1e5c1e":"#f0f9f0",color:compareMode?"#fff":"#2d5a2d",fontWeight:800}}
          onClick={()=>setCompareMode(!compareMode)}>
          {compareMode?"✅ Σύγκριση με "+String(thisYear-1):"⚖️ Σύγκριση με "+String(thisYear-1)}
        </button>
        <button className="btn" style={{flex:1,justifyContent:"center",background:"#e8f5e9",color:"#1e5c1e",fontWeight:800}}
          onClick={exportExcel}>
          📥 Εξαγωγή Excel
        </button>
      </div>
      <button className="btn" style={{width:"100%",justifyContent:"center",background:"#fff8e1",color:"#7a5a18",fontWeight:800,marginBottom:12,border:"1.5px solid #f4c542"}}
        onClick={exportErgoshima}>
        👷 Εξαγωγή Εργοσήμων (για λογιστή)
      </button>

      {/* Header σύγκρισης */}
      {compareMode && (
        <div style={{display:"flex",background:"#f0f9f0",borderRadius:12,padding:"8px 16px",marginBottom:8,fontSize:12,fontWeight:800,color:"#2d5a2d"}}>
          <div style={{flex:1}}>Κατηγορία</div>
          <div style={{minWidth:70,textAlign:"right"}}>{statFilter==="prev"?thisYear-1:thisYear}</div>
          <div style={{minWidth:80,textAlign:"right",color:"#1e5c1e"}}>Διαφορά</div>
          <div style={{minWidth:70,textAlign:"right",color:"#8aaa8a"}}>{thisYear-1}</div>
        </div>
      )}

      {/* Κύρια στατιστικά */}
      <div style={{background:"#fff",borderRadius:16,overflow:"hidden",boxShadow:"0 2px 12px rgba(0,0,0,.06)",marginBottom:20}}>
        <div style={{background:"#1e5c1e",padding:"10px 16px"}}>
          <div style={{fontWeight:900,fontSize:14,color:"#fff"}}>🧺 Παραγωγή & Έσοδα</div>
        </div>
        <Row label="Παραγωγή (kg)" cur={parseFloat(s.totalKg.toFixed(0))} prev={compareMode?parseFloat(sp.totalKg.toFixed(0)):null} unit="kg" />
        <Row label="Εισόδημα" cur={parseFloat(s.totalIncome.toFixed(0))} prev={compareMode?parseFloat(sp.totalIncome.toFixed(0)):null} unit="€" />
        <Row label="Αρ. Παραδόσεων" cur={s.dels.length} prev={compareMode?sp.dels.length:null} unit="" />
        <Row label="kg/στρέμμα" cur={s.kgPerStr!=="-"?parseFloat(s.kgPerStr):null} prev={compareMode&&sp.kgPerStr!=="-"?parseFloat(sp.kgPerStr):null} unit="kg/στρ" />
      </div>

      <div style={{background:"#fff",borderRadius:16,overflow:"hidden",boxShadow:"0 2px 12px rgba(0,0,0,.06)",marginBottom:20}}>
        <div style={{background:"#b71c1c",padding:"10px 16px"}}>
          <div style={{fontWeight:900,fontSize:14,color:"#fff"}}>💸 Κόστη</div>
        </div>
        <Row label="Συνολικό κόστος" cur={parseFloat(s.totalCost.toFixed(0))} prev={compareMode?parseFloat(sp.totalCost.toFixed(0)):null} unit="€" good="low" />
        <Row label="Καύσιμα" cur={parseFloat(s.fuelCost.toFixed(0))} prev={compareMode?parseFloat(sp.fuelCost.toFixed(0)):null} unit="€" good="low" />
        {(s.workerCost > 0 || (compareMode && sp.workerCost > 0)) && (
          <Row label="👷 Μεροκάματα" cur={parseFloat(s.workerCost.toFixed(0))} prev={compareMode?parseFloat(sp.workerCost.toFixed(0)):null} unit="€" good="low" />
        )}
        <Row label="Αβαρίες & Άλλα" cur={parseFloat(Math.max(0,s.extraCost).toFixed(0))} prev={compareMode?parseFloat(Math.max(0,sp.extraCost).toFixed(0)):null} unit="€" good="low" />
        {(s.rentCost > 0 || (compareMode && sp.rentCost > 0)) && (
          <Row label="🏠 Ενοίκιο" cur={parseFloat(s.rentCost.toFixed(0))} prev={compareMode?parseFloat(sp.rentCost.toFixed(0)):null} unit="€" good="low" />
        )}
        <Row label="Κόστος/στρέμμα" cur={s.costPerStr!=="-"?parseFloat(s.costPerStr):null} prev={compareMode&&sp.costPerStr!=="-"?parseFloat(sp.costPerStr):null} unit="€/στρ" good="low" />
      </div>

      <div style={{background:"#fff",borderRadius:16,overflow:"hidden",boxShadow:"0 2px 12px rgba(0,0,0,.06)",marginBottom:20}}>
        <div style={{background:"#1565c0",padding:"10px 16px"}}>
          <div style={{fontWeight:900,fontSize:14,color:"#fff"}}>👷 Εργασίες & Εργάτες</div>
        </div>
        <Row label="Συνολικές εργασίες" cur={s.acts.length} prev={compareMode?sp.acts.length:null} unit="" />
        <Row label="Ώρες εργασίας" cur={parseFloat(s.totalHours.toFixed(1))} prev={compareMode?parseFloat(sp.totalHours.toFixed(1)):null} unit="h" />
        <Row label="Μεροκάματα εργατών" cur={s.workerDays} prev={compareMode?sp.workerDays:null} unit="" good="low" />
        <Row label="Ψεκασμοί" cur={s.sprayCount} prev={compareMode?sp.sprayCount:null} unit="" good="low" />
        <Row label="Ποτίσματα" cur={s.waterCount} prev={compareMode?sp.waterCount:null} unit="" />
        <Row label="Κλαδέματα" cur={s.pruneCount} prev={compareMode?sp.pruneCount:null} unit="" />
        <Row label="Συντήρηση" cur={s.maintCount} prev={compareMode?sp.maintCount:null} unit="" />
      </div>

      {/* Στατιστικά Ψεκασμού */}
      <SprayStatsSection activities={s.acts} allSprayProducts={allSprayProducts} fields={fields} />
      {/* Αβαρίες */}
      <ExtraCostStatsSection activities={s.acts} fields={fields} />

      {/* Bar chart */}
      <div className="aftitle">📈 Εργασίες ανά μήνα</div>
      <div style={{background:"#fff",borderRadius:16,padding:"16px 12px",boxShadow:"0 2px 12px rgba(0,0,0,.06)",marginBottom:20}}>
        <div style={{display:"flex",alignItems:"flex-end",gap:6,height:100,justifyContent:"space-around"}}>
          {last6.map((m,i)=>(
            <div key={i} style={{display:"flex",flexDirection:"column",alignItems:"center",flex:1,gap:4}}>
              <div style={{fontSize:11,color:"#1e5c1e",fontWeight:800}}>{m.count||""}</div>
              <div style={{width:"100%",maxWidth:36,height:m.count===0?4:Math.max(8,(m.count/maxCount)*80),background:i===5?"#2d8a2d":"#a5d6a7",borderRadius:"6px 6px 0 0"}}/>
              <div style={{fontSize:10,color:"#8aaa8a",fontWeight:600}}>{m.label}</div>
            </div>
          ))}
        </div>
      </div>

      {s.acts.length===0 && <Empty icon="📊" text="Δεν υπάρχουν δεδομένα για την περίοδο αυτή" />}

      {/* Αποτέλεσμα — στο τέλος: Έσοδα − ΟΛΑ τα έξοδα */}
      <div style={{background:"#fff",borderRadius:16,overflow:"hidden",boxShadow:"0 4px 16px rgba(46,125,50,.18)",marginBottom:20,border:"2px solid #2e7d32"}}>
        <div style={{background:"#2e7d32",padding:"10px 16px"}}>
          <div style={{fontWeight:900,fontSize:14,color:"#fff"}}>📈 Αποτέλεσμα Σεζόν</div>
        </div>
        <Row label="Έσοδα" cur={parseFloat(s.totalIncome.toFixed(0))} unit="€" />
        <Row label="Έξοδα (σύνολο)" cur={parseFloat(s.totalCost.toFixed(0))} unit="€" good="low" />
        <div style={{padding:"12px 16px",background:"#f1f8e9",borderTop:"2px solid #c5e1a5"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontWeight:900,fontSize:15,color:"#1b5e20"}}>💰 Καθαρά</span>
            <span style={{fontWeight:900,fontSize:18,color:s.net>=0?"#1b5e20":"#b71c1c"}}>{s.net.toFixed(0)}€</span>
          </div>
        </div>
      </div>
      </>
      )}
    </div>
  );
}

// ── WORKER STATS VIEW ────────────────────────────────────────
function WorkerStatsView({ workers, activities, allActivityWorkers, fields, statFilter, setStatFilter, calFrom, setCalFrom, calTo, setCalTo }) {
  const [openDay, setOpenDay] = useState(null);
  const [tableMode, setTableMode] = useState("day"); // day | activity
  const [rowWorker, setRowWorker] = useState(""); // φίλτρο εργάτη για τον αναλυτικό πίνακα
  // Compute date range
  const now = new Date();
  const range = (() => {
    if (statFilter === "month") {
      const f = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,"0")}-01`;
      const last = new Date(now.getFullYear(), now.getMonth()+1, 0).toISOString().split("T")[0];
      return { from: f, to: last, label: `${["Ιαν","Φεβ","Μαρ","Απρ","Μάι","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ"][now.getMonth()]} ${now.getFullYear()}` };
    }
    if (statFilter === "quarter") {
      const d = new Date(now); d.setMonth(d.getMonth()-3);
      return { from: d.toISOString().split("T")[0], to: now.toISOString().split("T")[0], label: "Τελευταίο 3μηνο" };
    }
    if (statFilter === "year") {
      return { from: `${now.getFullYear()}-01-01`, to: `${now.getFullYear()}-12-31`, label: `${now.getFullYear()}` };
    }
    if (statFilter === "cal") return { from: calFrom||"", to: calTo||"", label: `${calFrom||""} → ${calTo||""}` };
    return { from: "", to: "", label: "Όλα" };
  })();

  // Filter activities in period
  const periodActs = activities.filter(a => {
    if (!a.date) return false;
    if (range.from && a.date < range.from) return false;
    if (range.to && a.date > range.to) return false;
    return true;
  });
  const periodActIds = new Set(periodActs.map(a=>a.id));
  const periodAW = allActivityWorkers.filter(aw => periodActIds.has(aw.activity_id));

  // Helper: compute pay for an activity_worker
  const calcPay = (aw) => {
    const w = workers.find(x=>x.id===aw.worker_id);
    const fullRate = parseFloat(w?.full_day_rate)||0;
    const halfRate = parseFloat(w?.half_day_rate)||0;
    const hourRate = parseFloat(w?.hourly_rate)||0;
    return (aw.full_day?fullRate:0) + (aw.half_day?halfRate:0) + (parseFloat(aw.hours)||0)*hourRate;
  };

  // Aggregate totals
  let totalFull=0, totalHalf=0, totalHours=0, totalPay=0;
  let payFull=0, payHalf=0, payHours=0;
  periodAW.forEach(aw => {
    const w = workers.find(x=>x.id===aw.worker_id);
    const fullRate = parseFloat(w?.full_day_rate)||0;
    const halfRate = parseFloat(w?.half_day_rate)||0;
    const hourRate = parseFloat(w?.hourly_rate)||0;
    if (aw.full_day) { totalFull++; payFull += fullRate; }
    if (aw.half_day) { totalHalf++; payHalf += halfRate; }
    const hrs = parseFloat(aw.hours)||0;
    totalHours += hrs;
    payHours += hrs * hourRate;
    totalPay += calcPay(aw);
  });

  // Aggregate by category
  const byCategory = {};
  periodAW.forEach(aw => {
    const act = activities.find(a=>a.id===aw.activity_id);
    if (!act) return;
    const cat = act.category || "📝 Διάφορα";
    if (!byCategory[cat]) byCategory[cat] = { full:0, half:0, hours:0, pay:0, workers:{}, days:new Set() };
    if (aw.full_day) byCategory[cat].full++;
    if (aw.half_day) byCategory[cat].half++;
    byCategory[cat].hours += parseFloat(aw.hours)||0;
    byCategory[cat].pay += calcPay(aw);
    byCategory[cat].days.add(act.date);
    const w = workers.find(x=>x.id===aw.worker_id);
    const wName = w?.name || aw.worker_name || "—";
    if (!byCategory[cat].workers[wName]) byCategory[cat].workers[wName] = { full:0, half:0 };
    if (aw.full_day) byCategory[cat].workers[wName].full++;
    if (aw.half_day) byCategory[cat].workers[wName].half++;
  });
  const categoryList = Object.entries(byCategory).sort((a,b)=>(b[1].full+b[1].half)-(a[1].full+a[1].half));

  // Aggregate by field
  const byField = {};
  periodAW.forEach(aw => {
    const act = activities.find(a=>a.id===aw.activity_id);
    if (!act) return;
    const fieldIds = act.field_ids && act.field_ids.length>0 ? act.field_ids : (act.field_id?[act.field_id]:[]);
    fieldIds.forEach(fid => {
      const fObj = fields.find(f=>f.id===fid);
      const fName = fObj?.name || "Άγνωστο";
      if (!byField[fName]) byField[fName] = { full:0, half:0, pay:0 };
      // Divide by number of fields (if activity covers multiple fields)
      const share = 1 / fieldIds.length;
      if (aw.full_day) byField[fName].full += share;
      if (aw.half_day) byField[fName].half += share;
      byField[fName].pay += calcPay(aw) * share;
    });
  });
  const fieldList = Object.entries(byField).sort((a,b)=>(b[1].full+b[1].half)-(a[1].full+a[1].half));

  // Top workers
  const byWorker = {};
  periodAW.forEach(aw => {
    const w = workers.find(x=>x.id===aw.worker_id);
    const wName = w?.name || aw.worker_name || "—";
    if (!byWorker[wName]) byWorker[wName] = { full:0, half:0, hours:0, pay:0 };
    if (aw.full_day) byWorker[wName].full++;
    if (aw.half_day) byWorker[wName].half++;
    byWorker[wName].hours += parseFloat(aw.hours)||0;
    byWorker[wName].pay += calcPay(aw);
  });
  const workerList = Object.entries(byWorker).sort((a,b)=>b[1].pay-a[1].pay);

  // Aggregate by DAY (πίνακας ημερών)
  const byDay = {};
  periodAW.forEach(aw => {
    const act = activities.find(a=>a.id===aw.activity_id);
    if (!act || !act.date) return;
    if (!byDay[act.date]) byDay[act.date] = { full:0, half:0, pay:0, people:[] };
    const w = workers.find(x=>x.id===aw.worker_id);
    const wName = w?.name || aw.worker_name || "—";
    if (aw.full_day) byDay[act.date].full++;
    if (aw.half_day) byDay[act.date].half++;
    byDay[act.date].pay += calcPay(aw);
    byDay[act.date].people.push({
      name: wName,
      full: !!aw.full_day, half: !!aw.half_day, hours: parseFloat(aw.hours)||0,
      pay: calcPay(aw),
      activity: act.activity_type || act.category || "",
    });
  });
  const dayList = Object.entries(byDay).sort((a,b)=>(b[0]).localeCompare(a[0]));

  // Αναλυτικές γραμμές: εργασία · ημ/νία · πρωί · απόγευμα · εργάτης
  const detailRows = [];
  periodAW.forEach(aw => {
    const act = activities.find(a=>a.id===aw.activity_id);
    if (!act) return;
    const w = workers.find(x=>x.id===aw.worker_id);
    const wName = w?.name || aw.worker_name || "—";
    detailRows.push({
      date: act.date || "",
      activity: act.activity_type || act.category || "—",
      worker: wName,
      full: !!aw.full_day, half: !!aw.half_day, hours: parseFloat(aw.hours)||0,
      pay: calcPay(aw),
    });
  });
  detailRows.sort((a,b)=>(b.date).localeCompare(a.date) || a.worker.localeCompare(b.worker));
  const detailFiltered = rowWorker ? detailRows.filter(r=>r.worker===rowWorker) : detailRows;
  const workerNames = [...new Set(detailRows.map(r=>r.worker))].sort();

  // Export Excel
  const exportXLSX = () => {
    const NL="\n", TAB="\t";
    let csv = `ΣΤΑΤΙΣΤΙΚΑ ΕΡΓΑΤΩΝ - ${range.label}${NL}${NL}`;
    csv += `ΣΥΝΟΛΑ${NL}`;
    csv += `☀️ Ολόκληρα (πρωί)${TAB}${totalFull}${NL}`;
    csv += `🌤 Μισά (απόγευμα)${TAB}${totalHalf}${NL}`;
    csv += `⏱ Ώρες${TAB}${totalHours}${NL}`;
    csv += `💰 Σύνολο €${TAB}${totalPay.toFixed(2)}${NL}${NL}`;

    csv += `ΑΝΑ ΚΑΤΗΓΟΡΙΑ${NL}`;
    csv += `Κατηγορία${TAB}Ολόκληρα${TAB}Μισά${TAB}Ημέρες${TAB}€${TAB}Εργάτες${NL}`;
    categoryList.forEach(([cat,d])=>{
      const wList = Object.entries(d.workers).map(([n,c])=>`${n}(${c.full}+${c.half})`).join(", ");
      csv += `${cat}${TAB}${d.full}${TAB}${d.half}${TAB}${d.days.size}${TAB}${d.pay.toFixed(2)}${TAB}${wList}${NL}`;
    });
    csv += NL;

    csv += `ΑΝΑ ΑΓΡΟΤΕΜΑΧΙΟ${NL}`;
    csv += `Αγροτεμάχιο${TAB}Ολόκληρα${TAB}Μισά${TAB}€${NL}`;
    fieldList.forEach(([fn,d])=>{
      csv += `${fn}${TAB}${d.full.toFixed(1)}${TAB}${d.half.toFixed(1)}${TAB}${d.pay.toFixed(2)}${NL}`;
    });
    csv += NL;

    csv += `TOP ΕΡΓΑΤΕΣ${NL}`;
    csv += `Όνομα${TAB}Ολόκληρα${TAB}Μισά${TAB}Ώρες${TAB}€${NL}`;
    workerList.forEach(([n,d])=>{
      csv += `${n}${TAB}${d.full}${TAB}${d.half}${TAB}${d.hours}${TAB}${d.pay.toFixed(2)}${NL}`;
    });

    const blob = new Blob(["\uFEFF"+csv],{type:"text/csv;charset=utf-8;"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href=url; a.download=`worker_stats_${statFilter}.csv`; a.click(); URL.revokeObjectURL(url);
  };

  return (
    <div>
      {/* Period selector */}
      <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:14}}>
        {[{k:"month",l:"📅 Μήνας"},{k:"quarter",l:"📆 3μηνο"},{k:"year",l:"📊 Έτος"},{k:"cal",l:"🔍 Custom"},{k:"all",l:"🗂 Όλα"}].map(p=>(
          <button key={p.k} className="btn"
            style={{flex:"1 1 auto",background:statFilter===p.k?"#2d8a2d":"#f0f9f0",color:statFilter===p.k?"#fff":"#2d5a2d",fontSize:12,fontWeight:800,padding:"8px 10px",justifyContent:"center"}}
            onClick={()=>setStatFilter(p.k)}>{p.l}</button>
        ))}
      </div>

      {statFilter === "cal" && (
        <div className="fr" style={{marginBottom:14}}>
          <div className="fg"><label className="fl">Από</label>
            <input className="fi" type="date" value={calFrom} onChange={e=>setCalFrom(e.target.value)} /></div>
          <div className="fg"><label className="fl">Έως</label>
            <input className="fi" type="date" value={calTo} onChange={e=>setCalTo(e.target.value)} /></div>
        </div>
      )}

      {periodAW.length === 0 ? (
        <>
          <div style={{background:"#fff3e0",border:"1px solid #ffcc80",borderRadius:10,padding:12,marginBottom:12,fontSize:12,color:"#8a6d1a"}}>
            🔍 Διαγνωστικό: εργασίες φορτωμένες = <b>{activities.length}</b> · μεροκάματα φορτωμένα = <b>{allActivityWorkers.length}</b> · στην περίοδο = <b>{periodAW.length}</b>
          </div>
          <Empty icon="👷" text={`Δεν υπάρχουν δεδομένα εργατών για ${range.label}`} />
        </>
      ) : (
        <>
          {/* Totals card */}
          <div style={{background:"linear-gradient(135deg,#2d8a2d,#1e5c1e)",borderRadius:16,padding:16,marginBottom:14,color:"#fff"}}>
            <div style={{fontSize:12,fontWeight:700,opacity:.9,marginBottom:8}}>📊 {range.label}</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:12}}>
              <div style={{background:"rgba(255,255,255,.15)",borderRadius:10,padding:"10px 6px",textAlign:"center"}}>
                <div style={{fontSize:22,fontWeight:900}}>{totalFull}</div>
                <div style={{fontSize:10,fontWeight:700,opacity:.9}}>☀️ Πρωί</div>
                {payFull>0 && <div style={{fontSize:11,fontWeight:800,opacity:.85,marginTop:2}}>{payFull.toFixed(0)}€</div>}
              </div>
              <div style={{background:"rgba(255,255,255,.15)",borderRadius:10,padding:"10px 6px",textAlign:"center"}}>
                <div style={{fontSize:22,fontWeight:900}}>{totalHalf}</div>
                <div style={{fontSize:10,fontWeight:700,opacity:.9}}>🌤 Απόγευμα</div>
                {payHalf>0 && <div style={{fontSize:11,fontWeight:800,opacity:.85,marginTop:2}}>{payHalf.toFixed(0)}€</div>}
              </div>
              <div style={{background:"rgba(255,255,255,.15)",borderRadius:10,padding:"10px 6px",textAlign:"center"}}>
                <div style={{fontSize:22,fontWeight:900}}>{totalHours}</div>
                <div style={{fontSize:10,fontWeight:700,opacity:.9}}>⏱ Ώρες</div>
                {payHours>0 && <div style={{fontSize:11,fontWeight:800,opacity:.85,marginTop:2}}>{payHours.toFixed(0)}€</div>}
              </div>
            </div>
            <div style={{background:"rgba(0,0,0,.15)",borderRadius:10,padding:"10px 14px",textAlign:"center"}}>
              <div style={{fontSize:11,fontWeight:700,opacity:.85}}>💰 Σύνολο για πληρωμή</div>
              <div style={{fontSize:26,fontWeight:900,marginTop:2}}>{totalPay.toFixed(2)} €</div>
            </div>
          </div>

          {/* Export button */}
          <button className="btn" style={{width:"100%",background:"#fff8e1",color:"#7a5a18",fontWeight:800,marginBottom:14,border:"1.5px solid #f4c542",justifyContent:"center"}}
            onClick={exportXLSX}>
            📥 Εξαγωγή Excel
          </button>

          {/* Πίνακας ανά ημέρα */}
          <div style={{fontSize:13,fontWeight:800,color:"#2d5a2d",marginBottom:8}}>📅 Ημέρες — Μεροκάματα</div>
          <div style={{background:"#fff",border:"1.5px solid #d4e8d4",borderRadius:12,overflow:"hidden",marginBottom:16}}>
            {/* κεφαλίδα */}
            <div style={{display:"grid",gridTemplateColumns:"1.4fr 0.8fr 0.8fr 1fr",gap:4,padding:"8px 10px",background:"#f0f9f0",fontSize:11,fontWeight:800,color:"#1e5c1e"}}>
              <span>Ημ/νία</span><span style={{textAlign:"center"}}>☀️ Πρωί</span><span style={{textAlign:"center"}}>🌤 Απόγ.</span><span style={{textAlign:"right"}}>💰 €</span>
            </div>
            {dayList.map(([date,d],idx)=>{
              const isOpen = openDay === date;
              return (
                <div key={date} style={{borderTop:"1px solid #f0f7ee"}}>
                  <div onClick={()=>setOpenDay(isOpen?null:date)}
                    style={{display:"grid",gridTemplateColumns:"1.4fr 0.8fr 0.8fr 1fr",gap:4,padding:"10px",fontSize:13,alignItems:"center",cursor:"pointer",background:isOpen?"#f4faf0":(idx%2?"#fafcfa":"#fff")}}>
                    <span style={{fontWeight:700,color:"#1a2e1a"}}>{isOpen?"▾":"▸"} {date}</span>
                    <span style={{textAlign:"center",fontWeight:800}}>{d.full||"—"}</span>
                    <span style={{textAlign:"center",fontWeight:800}}>{d.half||"—"}</span>
                    <span style={{textAlign:"right",fontWeight:900,color:"#1e5c1e"}}>{d.pay.toFixed(2)}</span>
                  </div>
                  {isOpen && (
                    <div style={{background:"#f7fbf5",padding:"4px 10px 10px 22px"}}>
                      {d.people.map((p,i)=>(
                        <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderBottom:i<d.people.length-1?"1px dashed #e0eede":"none",fontSize:12.5}}>
                          <div>
                            <span style={{fontWeight:700,color:"#1a2e1a"}}>👷 {p.name}</span>
                            <span style={{color:"#8aaa8a",marginLeft:6}}>
                              {p.full&&"☀️ "}{p.half&&"🌤 "}{p.hours>0&&`⏱${p.hours}h `}
                              {p.activity&&`· ${p.activity}`}
                            </span>
                          </div>
                          <span style={{fontWeight:800,color:"#1e5c1e"}}>{p.pay.toFixed(2)}€</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Αναλυτικός πίνακας: Εργασία · Ημ/νία · Πρωί · Απόγευμα · Εργάτης */}
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
            <div style={{fontSize:13,fontWeight:800,color:"#2d5a2d"}}>📋 Αναλυτικά</div>
            <select value={rowWorker} onChange={e=>setRowWorker(e.target.value)}
              style={{padding:"6px 10px",borderRadius:8,border:"1.5px solid #d4e8d4",fontSize:12,fontWeight:700,color:"#2d5a2d",background:"#fff"}}>
              <option value="">👷 Όλοι οι εργάτες</option>
              {workerNames.map(n=><option key={n} value={n}>{n}</option>)}
            </select>
          </div>
          <div style={{background:"#fff",border:"1.5px solid #d4e8d4",borderRadius:12,overflow:"hidden",marginBottom:16}}>
            <div style={{display:"grid",gridTemplateColumns:"1.3fr 0.9fr 0.5fr 0.5fr 1.1fr",gap:2,padding:"8px 10px",background:"#f0f9f0",fontSize:10.5,fontWeight:800,color:"#1e5c1e"}}>
              <span>Εργασία</span><span>Ημ/νία</span><span style={{textAlign:"center"}}>☀️</span><span style={{textAlign:"center"}}>🌤</span><span>Εργάτης</span>
            </div>
            <div style={{maxHeight:360,overflowY:"auto"}}>
              {detailFiltered.length === 0 ? (
                <div style={{padding:20,textAlign:"center",color:"#8aaa8a",fontSize:12}}>Καμία εγγραφή</div>
              ) : detailFiltered.map((r,i)=>(
                <div key={i} style={{display:"grid",gridTemplateColumns:"1.3fr 0.9fr 0.5fr 0.5fr 1.1fr",gap:2,padding:"9px 10px",fontSize:12,alignItems:"center",borderTop:"1px solid #f0f7ee",background:i%2?"#fafcfa":"#fff"}}>
                  <span style={{fontWeight:700,color:"#1a2e1a",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.activity}</span>
                  <span style={{color:"#2d5a2d"}}>{r.date}</span>
                  <span style={{textAlign:"center",fontWeight:800,color:"#2d8a2d"}}>{r.full?"✓":""}</span>
                  <span style={{textAlign:"center",fontWeight:800,color:"#e08a1e"}}>{r.half?"✓":""}</span>
                  <span style={{color:"#1a2e1a",fontWeight:700,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.worker}</span>
                </div>
              ))}
            </div>
          </div>

          {/* By category */}
          <div style={{fontSize:13,fontWeight:800,color:"#2d5a2d",marginBottom:8}}>📋 Ανά Κατηγορία Εργασίας</div>
          {categoryList.map(([cat,d])=>{
            const total = d.full + d.half;
            const avgPerDay = d.days.size > 0 ? (total / d.days.size).toFixed(1) : 0;
            return (
              <div key={cat} style={{background:"#fff",border:"1.5px solid #d4e8d4",borderRadius:12,padding:12,marginBottom:8}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                  <div style={{fontWeight:800,fontSize:14,color:"#1a2e1a"}}>{cat}</div>
                  <div style={{fontWeight:900,fontSize:14,color:"#1e5c1e"}}>{d.pay.toFixed(2)}€</div>
                </div>
                <div style={{display:"flex",gap:10,flexWrap:"wrap",fontSize:12,color:"#2d5a2d",marginBottom:8}}>
                  <span>☀️ <b>{d.full}</b> πρωί</span>
                  <span>🌤 <b>{d.half}</b> απόγευμα</span>
                  <span>📅 <b>{d.days.size}</b> ημέρες</span>
                  <span style={{opacity:.7}}>~{avgPerDay}/ημέρα</span>
                </div>
                <div style={{fontSize:11,color:"#8aaa8a",borderTop:"1px dashed #d4e8d4",paddingTop:6,marginTop:6}}>
                  👷 {Object.entries(d.workers).map(([n,c])=>`${n}: ☀️${c.full} 🌤${c.half}`).join(" · ")}
                </div>
              </div>
            );
          })}

          {/* By field */}
          {fieldList.length > 0 && (
            <>
              <div style={{fontSize:13,fontWeight:800,color:"#2d5a2d",marginTop:16,marginBottom:8}}>🌳 Ανά Αγροτεμάχιο</div>
              {fieldList.map(([fn,d])=>(
                <div key={fn} style={{background:"#fff",border:"1.5px solid #d4e8d4",borderRadius:12,padding:12,marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <div style={{fontWeight:800,fontSize:14,color:"#1a2e1a"}}>{fn}</div>
                    <div style={{fontSize:12,color:"#2d5a2d",marginTop:2}}>
                      ☀️ {d.full.toFixed(1)} πρωί · 🌤 {d.half.toFixed(1)} απόγευμα
                    </div>
                  </div>
                  <div style={{fontWeight:900,fontSize:15,color:"#1e5c1e"}}>{d.pay.toFixed(2)}€</div>
                </div>
              ))}
            </>
          )}

          {/* Top workers */}
          <div style={{fontSize:13,fontWeight:800,color:"#2d5a2d",marginTop:16,marginBottom:8}}>🏆 Top Εργάτες</div>
          {workerList.map(([n,d],i)=>(
            <div key={n} style={{background:"#fff",border:"1.5px solid #d4e8d4",borderRadius:12,padding:12,marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <div style={{fontSize:18,fontWeight:900,color:"#1e5c1e",minWidth:30}}>#{i+1}</div>
                <div>
                  <div style={{fontWeight:800,fontSize:14,color:"#1a2e1a"}}>{n}</div>
                  <div style={{fontSize:12,color:"#2d5a2d",marginTop:2}}>
                    ☀️ {d.full} · 🌤 {d.half} · ⏱ {d.hours}h
                  </div>
                </div>
              </div>
              <div style={{fontWeight:900,fontSize:15,color:"#1e5c1e"}}>{d.pay.toFixed(2)}€</div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}


// ── FARMER STATS VIEW (👨‍🌾 Εγώ) ────────────────────────────
function FarmerStatsView({ activities, fields, statFilter, setStatFilter, calFrom, setCalFrom, calTo, setCalTo }) {
  const now = new Date();
  const range = (() => {
    if (statFilter === "month") {
      const f = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,"0")}-01`;
      const last = new Date(now.getFullYear(), now.getMonth()+1, 0).toISOString().split("T")[0];
      return { from: f, to: last, label: `${["Ιαν","Φεβ","Μαρ","Απρ","Μάι","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ"][now.getMonth()]} ${now.getFullYear()}` };
    }
    if (statFilter === "quarter") {
      const d = new Date(now); d.setMonth(d.getMonth()-3);
      return { from: d.toISOString().split("T")[0], to: now.toISOString().split("T")[0], label: "Τελευταίο 3μηνο" };
    }
    if (statFilter === "year") {
      return { from: `${now.getFullYear()}-01-01`, to: `${now.getFullYear()}-12-31`, label: `${now.getFullYear()}` };
    }
    if (statFilter === "cal") return { from: calFrom||"", to: calTo||"", label: `${calFrom||""} → ${calTo||""}` };
    return { from: "", to: "", label: "Όλα" };
  })();

  // Activities where farmer worked (farmer or both)
  const myActs = activities.filter(a => {
    if (!a.date) return false;
    if (range.from && a.date < range.from) return false;
    if (range.to && a.date > range.to) return false;
    return a.performed_by === "farmer" || a.performed_by === "both";
  });

  // Totals: hours_total is farmer presence hours. Irrigation duration is in irrigation_hours separately.
  const totalDays = myActs.length;
  const totalHours = myActs.reduce((s,a)=>s+(parseFloat(a.hours_total)||0),0);
  // Unique days (in case multiple activities same day)
  const uniqueDays = new Set(myActs.map(a=>a.date)).size;

  // By category
  const byCategory = {};
  myActs.forEach(a => {
    const cat = a.category || "📝 Διάφορα";
    if (!byCategory[cat]) byCategory[cat] = { days:0, hours:0, dates:new Set() };
    byCategory[cat].days++;
    byCategory[cat].hours += parseFloat(a.hours_total)||0;
    byCategory[cat].dates.add(a.date);
  });
  const categoryList = Object.entries(byCategory).sort((a,b)=>b[1].days-a[1].days);

  // By field
  const byField = {};
  myActs.forEach(a => {
    const fieldIds = a.field_ids && a.field_ids.length>0 ? a.field_ids : (a.field_id?[a.field_id]:[]);
    fieldIds.forEach(fid => {
      const fObj = fields.find(f=>f.id===fid);
      const fName = fObj?.name || "Άγνωστο";
      if (!byField[fName]) byField[fName] = { days:0, hours:0 };
      const share = 1 / fieldIds.length;
      byField[fName].days += share;
      byField[fName].hours += (parseFloat(a.hours_total)||0) * share;
    });
  });
  const fieldList = Object.entries(byField).sort((a,b)=>b[1].days-a[1].days);

  // Export
  const exportXLSX = () => {
    const NL="\n", TAB="\t";
    let csv = `ΣΤΑΤΙΣΤΙΚΑ ΕΓΩ - ${range.label}${NL}${NL}`;
    csv += `ΣΥΝΟΛΑ${NL}`;
    csv += `Εργασίες${TAB}${totalDays}${NL}`;
    csv += `Μοναδικές μέρες${TAB}${uniqueDays}${NL}`;
    csv += `Ώρες${TAB}${totalHours.toFixed(1)}${NL}${NL}`;

    csv += `ΑΝΑ ΚΑΤΗΓΟΡΙΑ${NL}`;
    csv += `Κατηγορία${TAB}Εργασίες${TAB}Μέρες${TAB}Ώρες${NL}`;
    categoryList.forEach(([cat,d])=>{
      csv += `${cat}${TAB}${d.days}${TAB}${d.dates.size}${TAB}${d.hours.toFixed(1)}${NL}`;
    });
    csv += NL;

    csv += `ΑΝΑ ΑΓΡΟΤΕΜΑΧΙΟ${NL}`;
    csv += `Αγροτεμάχιο${TAB}Εργασίες${TAB}Ώρες${NL}`;
    fieldList.forEach(([fn,d])=>{
      csv += `${fn}${TAB}${d.days.toFixed(1)}${TAB}${d.hours.toFixed(1)}${NL}`;
    });

    const blob = new Blob(["\uFEFF"+csv],{type:"text/csv;charset=utf-8;"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href=url; a.download=`me_stats_${statFilter}.csv`; a.click(); URL.revokeObjectURL(url);
  };

  return (
    <div>
      {/* Period selector */}
      <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:14}}>
        {[{k:"month",l:"📅 Μήνας"},{k:"quarter",l:"📆 3μηνο"},{k:"year",l:"📊 Έτος"},{k:"cal",l:"🔍 Custom"},{k:"all",l:"🗂 Όλα"}].map(p=>(
          <button key={p.k} className="btn"
            style={{flex:"1 1 auto",background:statFilter===p.k?"#2d8a2d":"#f0f9f0",color:statFilter===p.k?"#fff":"#2d5a2d",fontSize:12,fontWeight:800,padding:"8px 10px",justifyContent:"center"}}
            onClick={()=>setStatFilter(p.k)}>{p.l}</button>
        ))}
      </div>

      {statFilter === "cal" && (
        <div className="fr" style={{marginBottom:14}}>
          <div className="fg"><label className="fl">Από</label>
            <input className="fi" type="date" value={calFrom} onChange={e=>setCalFrom(e.target.value)} /></div>
          <div className="fg"><label className="fl">Έως</label>
            <input className="fi" type="date" value={calTo} onChange={e=>setCalTo(e.target.value)} /></div>
        </div>
      )}

      {myActs.length === 0 ? (
        <Empty icon="👨‍🌾" text={`Δεν υπάρχουν εργασίες δικές σου για ${range.label}`} />
      ) : (
        <>
          {/* Hero card */}
          <div style={{background:"linear-gradient(135deg,#c47a2c,#8a4d18)",borderRadius:16,padding:16,marginBottom:14,color:"#fff"}}>
            <div style={{fontSize:12,fontWeight:700,opacity:.9,marginBottom:8}}>👨‍🌾 {range.label}</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
              <div style={{background:"rgba(255,255,255,.15)",borderRadius:10,padding:"12px 6px",textAlign:"center"}}>
                <div style={{fontSize:26,fontWeight:900}}>{totalDays}</div>
                <div style={{fontSize:11,fontWeight:700,opacity:.9}}>📋 Εργασίες</div>
              </div>
              <div style={{background:"rgba(255,255,255,.15)",borderRadius:10,padding:"12px 6px",textAlign:"center"}}>
                <div style={{fontSize:26,fontWeight:900}}>{uniqueDays}</div>
                <div style={{fontSize:11,fontWeight:700,opacity:.9}}>📅 Μέρες</div>
              </div>
              <div style={{background:"rgba(255,255,255,.15)",borderRadius:10,padding:"12px 6px",textAlign:"center"}}>
                <div style={{fontSize:26,fontWeight:900}}>{totalHours.toFixed(1)}</div>
                <div style={{fontSize:11,fontWeight:700,opacity:.9}}>⏱ Ώρες</div>
              </div>
            </div>
          </div>

          {/* Export */}
          <button className="btn" style={{width:"100%",background:"#fff8e1",color:"#7a5a18",fontWeight:800,marginBottom:14,border:"1.5px solid #f4c542",justifyContent:"center"}}
            onClick={exportXLSX}>
            📥 Εξαγωγή Excel
          </button>

          {/* By category */}
          <div style={{fontSize:13,fontWeight:800,color:"#2d5a2d",marginBottom:8}}>📋 Ανά Κατηγορία Εργασίας</div>
          {categoryList.map(([cat,d])=>(
            <div key={cat} style={{background:"#fff",border:"1.5px solid #d4e8d4",borderRadius:12,padding:12,marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div>
                <div style={{fontWeight:800,fontSize:14,color:"#1a2e1a"}}>{cat}</div>
                <div style={{fontSize:12,color:"#2d5a2d",marginTop:2}}>
                  📋 {d.days} εργασίες · 📅 {d.dates.size} μέρες
                </div>
              </div>
              {d.hours > 0 && (
                <div style={{fontWeight:900,fontSize:14,color:"#c47a2c"}}>⏱ {d.hours.toFixed(1)}h</div>
              )}
            </div>
          ))}

          {/* By field */}
          {fieldList.length > 0 && (
            <>
              <div style={{fontSize:13,fontWeight:800,color:"#2d5a2d",marginTop:16,marginBottom:8}}>🌳 Ανά Αγροτεμάχιο</div>
              {fieldList.map(([fn,d])=>(
                <div key={fn} style={{background:"#fff",border:"1.5px solid #d4e8d4",borderRadius:12,padding:12,marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <div style={{fontWeight:800,fontSize:14,color:"#1a2e1a"}}>{fn}</div>
                    <div style={{fontSize:12,color:"#2d5a2d",marginTop:2}}>
                      📋 {d.days.toFixed(1)} εργασίες
                    </div>
                  </div>
                  {d.hours > 0 && (
                    <div style={{fontWeight:900,fontSize:14,color:"#c47a2c"}}>⏱ {d.hours.toFixed(1)}h</div>
                  )}
                </div>
              ))}
            </>
          )}
        </>
      )}
    </div>
  );
}


// ── WEATHER TAB ──────────────────────────────────────────────
function WeatherTab() {
  const { fields, settings: weatherSettings } = useApp();
  const [weather, setWeather] = useState(null);
  const [forecast, setForecast] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedCity, setSelectedCity] = useState("Λάρισα");

  const API_KEY = process.env.REACT_APP_WEATHER_KEY || "a46ca5bc17f3999b6a8440ced6ee5ac7"; // fallback for dev

  const cities = [...new Set(fields.map(f=>f.region).filter(Boolean))];

  const fetchWeather = async (city) => {
    if (!city) return;
    setLoading(true);
    setError(null);
    try {
      const [cur, fore] = await Promise.all([
        fetch(`https://api.openweathermap.org/data/2.5/weather?q=${encodeURIComponent(city)},GR&appid=${API_KEY}&units=metric&lang=el`),
        fetch(`https://api.openweathermap.org/data/2.5/forecast?q=${encodeURIComponent(city)},GR&appid=${API_KEY}&units=metric&lang=el&cnt=24`)
      ]);
      const curData = await cur.json();
      const foreData = await fore.json();
      if (curData.cod !== 200) { setError("Δεν βρέθηκε η περιοχή"); setLoading(false); return; }
      setWeather(curData);
      // Group forecast by day
      const days = {};
      foreData.list?.forEach(item => {
        const date = item.dt_txt.split(' ')[0];
        if (!days[date]) days[date] = [];
        days[date].push(item);
      });
      setForecast(Object.entries(days).slice(0,5));
    } catch(e) { setError("Σφάλμα σύνδεσης"); }
    setLoading(false);
  };

  useEffect(() => {
    fetchWeather("Λάρισα");
  }, []);

  const getWeatherIcon = (id) => {
    if (id >= 200 && id < 300) return "⛈";
    if (id >= 300 && id < 400) return "🌦";
    if (id >= 500 && id < 600) return "🌧";
    if (id >= 600 && id < 700) return "❄️";
    if (id >= 700 && id < 800) return "🌫";
    if (id === 800) return "☀️";
    if (id === 801) return "🌤";
    if (id === 802) return "⛅";
    return "☁️";
  };

  const windDir = (deg) => {
    const dirs = ["Β","ΒΑ","Α","ΝΑ","Ν","ΝΔ","Δ","ΒΔ"];
    return dirs[Math.round(deg/45) % 8];
  };

  return (
    <div>
      <div className="stitle">🌤 Καιρός</div>

      {/* Αναζήτηση πόλης */}
      <div style={{marginBottom:16}}>
        <div style={{fontSize:13,color:"#6b8c6b",fontWeight:600,marginBottom:8}}>🔍 Αναζήτηση (π.χ. Λάρισα, Τύρναβος, Βόλος)</div>
        <input className="fi" placeholder="π.χ. Λάρισα, Βόλος..." value={selectedCity}
          onChange={e=>setSelectedCity(e.target.value)}
          onKeyDown={e=>e.key==="Enter"&&fetchWeather(selectedCity)}
          style={{fontSize:16,width:"100%",marginBottom:8}} />
        <button className="btn btn-p" style={{width:"100%",justifyContent:"center",marginBottom:10}} onClick={()=>fetchWeather(selectedCity)}>🔍 Αναζήτηση</button>
        {/* Quick buttons για κοντινές πόλεις */}
        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
          {(weatherSettings?.weatherCities||["Λάρισα"]).map(city=>(
            <button key={city} type="button"
              style={{background:selectedCity===city?"#2d8a2d":"#f0f9f0",border:`1.5px solid ${selectedCity===city?"#2d8a2d":"#d4e8d4"}`,borderRadius:10,padding:"6px 12px",fontSize:12,fontWeight:700,color:selectedCity===city?"#fff":"#2d5a2d",cursor:"pointer"}}
              onClick={()=>{setSelectedCity(city);fetchWeather(city);}}>
              {city}
            </button>
          ))}
        </div>
      </div>

      {loading && <div style={{textAlign:"center",padding:40,fontSize:32}}>⏳</div>}
      {error && <div className="msg msg-e">{error}</div>}

      {weather && !loading && (
        <>
          {/* Τρέχων καιρός */}
          <div style={{background:"linear-gradient(135deg,#1e5c1e,#2d8a2d)",borderRadius:20,padding:24,marginBottom:16,color:"#fff"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
              <div>
                <div style={{fontSize:14,opacity:.8,fontWeight:600}}>📍 {weather.name}</div>
                <div style={{fontSize:64,fontWeight:900,lineHeight:1}}>{Math.round(weather.main.temp)}°</div>
                <div style={{fontSize:16,opacity:.9,marginTop:4}}>{weather.weather[0].description}</div>
              </div>
              <div style={{fontSize:80}}>{getWeatherIcon(weather.weather[0].id)}</div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12,marginTop:20,background:"rgba(255,255,255,.15)",borderRadius:14,padding:14}}>
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:11,opacity:.8}}>Αίσθηση</div>
                <div style={{fontSize:18,fontWeight:800}}>{Math.round(weather.main.feels_like)}°</div>
              </div>
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:11,opacity:.8}}>Υγρασία</div>
                <div style={{fontSize:18,fontWeight:800}}>{weather.main.humidity}%</div>
              </div>
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:11,opacity:.8}}>Άνεμος</div>
                <div style={{fontSize:18,fontWeight:800}}>{Math.round(weather.wind.speed*3.6)}km/h {windDir(weather.wind.deg)}</div>
              </div>
            </div>
            {/* Ψεκασμός alert */}
            {weather.wind.speed * 3.6 > 15 && (
              <div style={{marginTop:12,background:"rgba(255,80,80,.3)",borderRadius:10,padding:"10px 14px",fontSize:13,fontWeight:700}}>
                ⚠️ Δεν συνιστάται ψεκασμός — Δυνατός άνεμος!
              </div>
            )}
            {weather.weather[0].id >= 500 && weather.weather[0].id < 600 && (
              <div style={{marginTop:8,background:"rgba(255,80,80,.3)",borderRadius:10,padding:"10px 14px",fontSize:13,fontWeight:700}}>
                🌧 Δεν συνιστάται ψεκασμός — Βροχή!
              </div>
            )}
          </div>

          {/* Πρόγνωση 5 ημερών */}
          {forecast.length > 0 && (
            <div>
              <div className="aftitle">📅 Πρόγνωση 5 ημερών</div>
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {forecast.map(([date, items])=>{
                  const maxTemp = Math.max(...items.map(i=>i.main.temp_max));
                  const minTemp = Math.min(...items.map(i=>i.main.temp_min));
                  const mainItem = items[Math.floor(items.length/2)];
                  const d = new Date(date);
                  const dayName = d.toLocaleDateString('el-GR', {weekday:'long'});
                  return (
                    <div key={date} style={{background:"#fff",borderRadius:14,padding:"14px 16px",display:"flex",alignItems:"center",gap:12,boxShadow:"0 2px 8px rgba(0,0,0,.06)"}}>
                      <div style={{width:80,fontWeight:700,fontSize:13,color:"#2d5a2d",textTransform:"capitalize"}}>{dayName}</div>
                      <div style={{fontSize:28}}>{getWeatherIcon(mainItem.weather[0].id)}</div>
                      <div style={{flex:1,fontSize:12,color:"#8aaa8a"}}>{mainItem.weather[0].description}</div>
                      <div style={{fontWeight:800,fontSize:15,color:"#1a2e1a"}}>{Math.round(maxTemp)}° <span style={{color:"#8aaa8a",fontWeight:600}}>{Math.round(minTemp)}°</span></div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Windy Wind Forecast 24h */}
          {weather.coord && <WindForecast24h lat={weather.coord.lat} lon={weather.coord.lon} />}

          {/* Windy Map Embed (Wind layer) */}
          {weather.coord && (
            <div style={{marginTop:20}}>
              <div className="aftitle">🌬 Χάρτης Ανέμων (Windy)</div>
              <div style={{borderRadius:16,overflow:"hidden",boxShadow:"0 2px 12px rgba(0,0,0,.08)",background:"#000"}}>
                <iframe
                  title="Windy Map"
                  width="100%"
                  height="380"
                  src={`https://embed.windy.com/embed2.html?lat=${weather.coord.lat}&lon=${weather.coord.lon}&detailLat=${weather.coord.lat}&detailLon=${weather.coord.lon}&width=650&height=450&zoom=9&level=surface&overlay=wind&product=ecmwf&menu=&message=&marker=true&calendar=now&pressure=&type=map&location=coordinates&detail=&metricWind=km%2Fh&metricTemp=%C2%B0C&radarRange=-1`}
                  frameBorder="0"
                  style={{display:"block",border:0}}
                />
              </div>
              <div style={{fontSize:11,color:"#8aaa8a",marginTop:8,textAlign:"center"}}>
                💡 Πίεσε στον χάρτη για άλλα layers (βροχή, θερμοκρασία, νεφώσεις)
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

// ── Windy Point Forecast (wind & rain) ──────────────────────────
function WindForecast24h({ lat, lon }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hours, setHours] = useState(24);

  const WINDY_KEY = process.env.REACT_APP_WINDY_KEY;

  useEffect(() => {
    if (!lat || !lon) return;
    if (!WINDY_KEY) { setError("missing-key"); return; }
    setLoading(true);
    fetch("https://api.windy.com/api/point-forecast/v2", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        lat, lon,
        model: "gfs",
        parameters: ["wind", "temp", "precip"],
        levels: ["surface"],
        key: WINDY_KEY
      })
    })
    .then(r => r.json())
    .then(d => { setData(d); setLoading(false); })
    .catch(() => { setError("fetch"); setLoading(false); });
  }, [lat, lon, WINDY_KEY]);

  if (error === "missing-key") return null; // silent if no key configured
  if (loading) return <div style={{textAlign:"center",padding:20,fontSize:20}}>⏳ Φόρτωση ανέμου...</div>;
  if (error || !data || !data.ts) return null;

  // Build next 24h points (3-hourly typical from gfs)
  const now = Date.now();
  const points = data.ts.map((t, i) => {
    const u = data["wind_u-surface"]?.[i];
    const v = data["wind_v-surface"]?.[i];
    if (u == null || v == null) return null;
    const speedMs = Math.sqrt(u*u + v*v);
    const speedKmh = speedMs * 3.6;
    const dirDeg = (Math.atan2(-u, -v) * 180/Math.PI + 360) % 360;
    // Precipitation in mm (Windy gives "past_3h" cumulative for gfs)
    const rain = data["past3hprecip-surface"]?.[i] ?? data["precip-surface"]?.[i] ?? 0;
    return { t, speedMs, speedKmh, dirDeg, rain };
  }).filter(Boolean).filter(p => p.t >= now && p.t <= now + hours*3600*1000);

  if (points.length === 0) return null;

  const maxSpeed = Math.max(...points.map(p => p.speedKmh));
  const maxRain = Math.max(...points.map(p => p.rain), 0.1);
  // Ideal spray window: low wind AND no rain
  const sprayWindow = points.find(p => p.speedKmh < 15 && p.rain < 0.2);
  const dangerWindow = points.find(p => p.speedKmh > 25);
  const totalRain24h = points.reduce((s, p) => s + p.rain, 0);
  const rainWindow = points.find(p => p.rain >= 0.5);

  const windDir = (deg) => {
    const dirs = ["Β","ΒΑ","Α","ΝΑ","Ν","ΝΔ","Δ","ΒΔ"];
    return dirs[Math.round(deg/45) % 8];
  };

  const fmtHour = (t) => {
    const d = new Date(t);
    const h = d.getHours();
    return `${h.toString().padStart(2,"0")}:00`;
  };

  return (
    <div style={{marginTop:20}}>
      {/* 24h / 48h toggle */}
      <div style={{display:"flex",gap:8,marginBottom:12}}>
        <button type="button"
          style={{flex:1,background:hours===24?"#2d8a2d":"#fff",color:hours===24?"#fff":"#2d5a2d",border:`2px solid ${hours===24?"#2d8a2d":"#d4e8d4"}`,borderRadius:12,padding:"10px 14px",fontWeight:800,fontSize:14,cursor:"pointer"}}
          onClick={()=>setHours(24)}>24 ώρες</button>
        <button type="button"
          style={{flex:1,background:hours===48?"#2d8a2d":"#fff",color:hours===48?"#fff":"#2d5a2d",border:`2px solid ${hours===48?"#2d8a2d":"#d4e8d4"}`,borderRadius:12,padding:"10px 14px",fontWeight:800,fontSize:14,cursor:"pointer"}}
          onClick={()=>setHours(48)}>48 ώρες</button>
      </div>

      <div className="aftitle">🌬 Άνεμος {hours} ώρες — Παράθυρο Ψεκασμού</div>

      {/* Quick verdict */}
      {sprayWindow && (
        <div style={{background:"#e8f5e9",border:"1.5px solid #2d8a2d",borderRadius:12,padding:"10px 14px",marginBottom:10,fontSize:13,fontWeight:700,color:"#1e5c1e"}}>
          ✅ Κατάλληλη ώρα ψεκασμού: <strong>{fmtHour(sprayWindow.t)}</strong> ({Math.round(sprayWindow.speedKmh)} km/h)
        </div>
      )}
      {!sprayWindow && (
        <div style={{background:"#fff3e0",border:"1.5px solid #c47a2c",borderRadius:12,padding:"10px 14px",marginBottom:10,fontSize:13,fontWeight:700,color:"#7a4a18"}}>
          ⚠️ Δεν υπάρχει κατάλληλο παράθυρο ψεκασμού τις επόμενες {hours} ώρες (άνεμος πάνω από 15 km/h)
        </div>
      )}
      {dangerWindow && (
        <div style={{background:"#ffebee",border:"1.5px solid #c0392b",borderRadius:12,padding:"10px 14px",marginBottom:10,fontSize:13,fontWeight:700,color:"#9c1b15"}}>
          🚨 Πολύ δυνατός άνεμος στις <strong>{fmtHour(dangerWindow.t)}</strong> ({Math.round(dangerWindow.speedKmh)} km/h)
        </div>
      )}

      {/* Horizontal scroll of hourly bars */}
      <div style={{overflowX:"auto",WebkitOverflowScrolling:"touch",paddingBottom:8}}>
        <div style={{display:"flex",gap:6,minWidth:"max-content"}}>
          {points.map((p, i) => {
            const heightPct = Math.min(100, (p.speedKmh / Math.max(maxSpeed, 30)) * 100);
            const isCalm = p.speedKmh < 15;
            const isDanger = p.speedKmh > 25;
            const color = isDanger ? "#c0392b" : isCalm ? "#2d8a2d" : "#c47a2c";
            return (
              <div key={i} style={{display:"flex",flexDirection:"column",alignItems:"center",minWidth:46}}>
                <div style={{fontSize:10,fontWeight:700,color:"#1a2e1a",marginBottom:2}}>{Math.round(p.speedKmh)}</div>
                <div style={{height:80,width:24,background:"#f0f7ee",borderRadius:6,position:"relative",overflow:"hidden"}}>
                  <div style={{position:"absolute",bottom:0,left:0,right:0,height:`${heightPct}%`,background:color,borderRadius:6}} />
                </div>
                <div style={{fontSize:13,marginTop:4,fontWeight:800,color:"#2d5a2d"}}>{windDir(p.dirDeg)}</div>
                <div style={{fontSize:10,color:"#8aaa8a",marginTop:2}}>{fmtHour(p.t)}</div>
              </div>
            );
          })}
        </div>
      </div>
      <div style={{fontSize:11,color:"#8aaa8a",marginTop:6,textAlign:"center"}}>
        🟢 &lt;15 km/h ψεκασμός ΟΚ &nbsp;·&nbsp; 🟠 15-25 προσοχή &nbsp;·&nbsp; 🔴 &gt;25 επικίνδυνο
      </div>

      {/* ── RAIN 24h ───────────────────────────────────────── */}
      <div style={{marginTop:20}}>
        <div className="aftitle">🌧 Βροχή {hours} ώρες</div>

        {/* Quick verdict */}
        {totalRain24h < 0.5 && (
          <div style={{background:"#e8f5e9",border:"1.5px solid #2d8a2d",borderRadius:12,padding:"10px 14px",marginBottom:10,fontSize:13,fontWeight:700,color:"#1e5c1e"}}>
            ✅ Χωρίς βροχή τις επόμενες {hours} ώρες — Ιδανικό για ψεκασμό
          </div>
        )}
        {totalRain24h >= 0.5 && totalRain24h < 5 && rainWindow && (
          <div style={{background:"#e3f2fd",border:"1.5px solid #1976d2",borderRadius:12,padding:"10px 14px",marginBottom:10,fontSize:13,fontWeight:700,color:"#0d4d92"}}>
            💧 Ελαφριά βροχή γύρω στις <strong>{fmtHour(rainWindow.t)}</strong> — Σύνολο {totalRain24h.toFixed(1)} mm
          </div>
        )}
        {totalRain24h >= 5 && rainWindow && (
          <div style={{background:"#fff3e0",border:"1.5px solid #c47a2c",borderRadius:12,padding:"10px 14px",marginBottom:10,fontSize:13,fontWeight:700,color:"#7a4a18"}}>
            ⚠️ Σημαντική βροχόπτωση από τις <strong>{fmtHour(rainWindow.t)}</strong> — Σύνολο {totalRain24h.toFixed(1)} mm. Αποφύγετε ψεκασμό.
          </div>
        )}

        {/* Horizontal scroll of hourly rain bars */}
        <div style={{overflowX:"auto",WebkitOverflowScrolling:"touch",paddingBottom:8}}>
          <div style={{display:"flex",gap:6,minWidth:"max-content"}}>
            {points.map((p, i) => {
              const heightPct = Math.min(100, (p.rain / Math.max(maxRain, 2)) * 100);
              const isWet = p.rain >= 0.5;
              const isHeavy = p.rain >= 2;
              const color = isHeavy ? "#0d4d92" : isWet ? "#1976d2" : "#90caf9";
              return (
                <div key={i} style={{display:"flex",flexDirection:"column",alignItems:"center",minWidth:46}}>
                  <div style={{fontSize:10,fontWeight:700,color:"#1a2e1a",marginBottom:2}}>{p.rain < 0.1 ? "—" : p.rain.toFixed(1)}</div>
                  <div style={{height:80,width:24,background:"#f0f7fa",borderRadius:6,position:"relative",overflow:"hidden"}}>
                    {p.rain >= 0.1 && (
                      <div style={{position:"absolute",bottom:0,left:0,right:0,height:`${heightPct}%`,background:color,borderRadius:6}} />
                    )}
                  </div>
                  <div style={{fontSize:13,marginTop:4}}>{p.rain < 0.1 ? "☀️" : p.rain >= 2 ? "🌧" : "💧"}</div>
                  <div style={{fontSize:10,color:"#8aaa8a",marginTop:2}}>{fmtHour(p.t)}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div style={{fontSize:11,color:"#8aaa8a",marginTop:6,textAlign:"center"}}>
          ☀️ Χωρίς βροχή &nbsp;·&nbsp; 💧 0.5-2 mm ελαφριά &nbsp;·&nbsp; 🌧 &gt;2 mm δυνατή (ανά 3 ώρες)
        </div>
      </div>
    </div>
  );
}

// ── GDPR TEXTS ───────────────────────────────────────────────
const PRIVACY_POLICY = `
ΠΟΛΙΤΙΚΗ ΑΠΟΡΡΗΤΟΥ - AgroPalk
Τελευταία ενημέρωση: ${new Date().toLocaleDateString('el-GR')}

Υπεύθυνος Επεξεργασίας:
JiTech - Konstantinos Paliotzikas
Email: gdpr@jitech.gr

1. ΔΕΔΟΜΕΝΑ ΠΟΥ ΣΥΛΛΕΓΟΥΜΕ
• Στοιχεία λογαριασμού: email, κωδικός (κρυπτογραφημένος), όνομα
• Αγροτικά δεδομένα: αγροτεμάχια, εργασίες, μηχανήματα, αποθήκη
• Οικονομικά δεδομένα: έσοδα, έξοδα, παραδόσεις
• Δεδομένα εργατών: ονόματα, τηλέφωνα, IBAN (μόνο για μισθοδοσία)

2. ΣΚΟΠΟΣ ΕΠΕΞΕΡΓΑΣΙΑΣ
• Παροχή υπηρεσιών διαχείρισης αγροκτήματος
• Βάση: Εκτέλεση σύμβασης (άρθρο 6§1β ΓΚΠΔ)

3. ΑΠΟΘΗΚΕΥΣΗ & ΑΣΦΑΛΕΙΑ
• Τα δεδομένα αποθηκεύονται σε servers της Supabase (EU)
• Κρυπτογράφηση σε transit και at rest
• Διατήρηση για όσο διαρκεί ο λογαριασμός + 30 ημέρες

4. ΔΙΚΑΙΩΜΑΤΑ ΣΑΣ (ΓΚΠΔ)
• Δικαίωμα πρόσβασης στα δεδομένα σας
• Δικαίωμα διόρθωσης ανακριβών δεδομένων
• Δικαίωμα διαγραφής ("δικαίωμα στη λήθη")
• Δικαίωμα φορητότητας (εξαγωγή δεδομένων)
• Δικαίωμα εναντίωσης στην επεξεργασία

5. ΕΠΙΚΟΙΝΩΝΙΑ
Για οποιοδήποτε αίτημα GDPR: gdpr@jitech.gr

6. ΚΑΤΑΓΓΕΛΙΑ
Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα
www.dpa.gr | 210 6475600
`;

const TERMS_OF_SERVICE = `
ΟΡΟΙ ΧΡΗΣΗΣ - AgroPalk
Τελευταία ενημέρωση: ${new Date().toLocaleDateString('el-GR')}

Παρέχεται από: JiTech - Konstantinos Paliotzikas

1. ΑΠΟΔΟΧΗ ΟΡΩΝ
Χρησιμοποιώντας το AgroPalk αποδέχεστε τους παρόντες όρους.

2. ΥΠΗΡΕΣΙΑ
Το AgroPalk είναι εφαρμογή διαχείρισης αγροκτήματος για:
• Καταγραφή αγροτεμαχίων και εργασιών
• Διαχείριση εργατών και μηχανημάτων
• Παρακολούθηση εσόδων/εξόδων
• Καταγραφή παραδόσεων παραγωγής

3. ΛΟΓΑΡΙΑΣΜΟΣ
• Υπεύθυνος για την ασφάλεια του κωδικού σας
• Απαγορεύεται η κοινοποίηση στοιχείων σε τρίτους

4. ΠΝΕΥΜΑΤΙΚΗ ΙΔΙΟΚΤΗΣΙΑ
Το λογισμικό ανήκει στην JiTech. Τα δεδομένα σας ανήκουν σε εσάς.

5. ΠΕΡΙΟΡΙΣΜΟΣ ΕΥΘΥΝΗΣ
Η JiTech δεν φέρει ευθύνη για:
• Απώλεια δεδομένων λόγω ανωτέρας βίας
• Αποφάσεις βασισμένες στα δεδομένα της εφαρμογής

6. ΔΙΑΚΟΠΗ ΥΠΗΡΕΣΙΑΣ
Δικαίωμα διακοπής με 30 ημέρες προειδοποίηση.

7. ΕΦΑΡΜΟΣΤΕΟ ΔΙΚΑΙΟ
Ελληνικό δίκαιο. Αρμόδια δικαστήρια Θεσσαλονίκης.

Επικοινωνία: gdpr@jitech.gr
`;

function GDPRModal({ type, onClose }) {
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:2000,display:"flex",alignItems:"flex-end",padding:0}}>
      <div style={{background:"#fff",borderRadius:"20px 20px 0 0",padding:24,width:"100%",maxHeight:"80vh",overflowY:"auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:16,color:"#1e5c1e"}}>
            {type==="privacy"?"🔒 Πολιτική Απορρήτου":"📋 Όροι Χρήσης"}
          </div>
          <button onClick={onClose} style={{background:"#f0f7f0",border:"none",borderRadius:10,padding:"6px 14px",fontFamily:"Nunito,sans-serif",fontWeight:800,cursor:"pointer"}}>✕</button>
        </div>
        <pre style={{fontFamily:"Nunito,sans-serif",fontSize:12,color:"#2d3d2d",whiteSpace:"pre-wrap",lineHeight:1.7}}>
          {type==="privacy" ? PRIVACY_POLICY : TERMS_OF_SERVICE}
        </pre>
      </div>
    </div>
  );
}

function DeleteAccountModal({ onClose, onConfirm }) {
  const [confirmed, setConfirmed] = useState(false);
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:"#fff",borderRadius:20,padding:24,maxWidth:340,width:"100%"}}>
        <div style={{fontSize:40,textAlign:"center",marginBottom:12}}>⚠️</div>
        <div style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:18,color:"#c62828",textAlign:"center",marginBottom:8}}>Διαγραφή Λογαριασμού</div>
        <div style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:"#5a7a5a",textAlign:"center",marginBottom:16}}>
          Θα διαγραφούν <strong>μόνιμα</strong> όλα τα δεδομένα σας (αγροτεμάχια, εργασίες, οικονομικά). Αυτή η ενέργεια δεν αναιρείται.
        </div>
        <label style={{display:"flex",alignItems:"center",gap:10,marginBottom:20,cursor:"pointer",fontFamily:"Nunito,sans-serif",fontSize:13,fontWeight:700}}>
          <input type="checkbox" checked={confirmed} onChange={e=>setConfirmed(e.target.checked)} style={{width:18,height:18}} />
          Κατανοώ ότι τα δεδομένα μου θα διαγραφούν μόνιμα
        </label>
        <div style={{display:"flex",gap:8}}>
          <button onClick={onClose} style={{flex:1,padding:14,background:"#f0f7f0",border:"none",borderRadius:14,fontFamily:"Nunito,sans-serif",fontWeight:800,cursor:"pointer"}}>Άκυρο</button>
          <button onClick={onConfirm} disabled={!confirmed} style={{flex:1,padding:14,background:confirmed?"#c62828":"#ccc",border:"none",borderRadius:14,color:"#fff",fontFamily:"Nunito,sans-serif",fontWeight:800,cursor:confirmed?"pointer":"not-allowed"}}>Διαγραφή</button>
        </div>
      </div>
    </div>
  );
}

// ── AUTH ─────────────────────────────────────────────────────
function WelcomeScreen({ onLogin, onRegister }) {
  const [showPlans, setShowPlans] = useState(false);
  return (
    <div style={{minHeight:"100vh",background:"linear-gradient(160deg,#0d2e0d,#1e5c1e,#2d8a2d)",display:"flex",flexDirection:"column"}}>
      {/* Top right - μόνο Εγγραφή */}
      <div style={{display:"flex",justifyContent:"flex-end",padding:"16px 20px"}}>
        <button onClick={onRegister} style={{background:"rgba(255,255,255,.15)",border:"1.5px solid rgba(255,255,255,.3)",color:"#fff",padding:"8px 18px",borderRadius:12,fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:13,cursor:"pointer"}}>
          ✍️ Εγγραφή
        </button>
      </div>

      {/* Center content */}
      <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"20px 30px"}}>
        <div style={{fontSize:100,marginBottom:16,filter:"drop-shadow(0 8px 24px rgba(0,0,0,.4))"}}>🚜</div>
        <div style={{fontSize:44,fontWeight:900,color:"#fff",letterSpacing:-2,marginBottom:10,fontFamily:"Nunito,sans-serif"}}>AgroPalk</div>
        <div style={{fontSize:18,color:"rgba(255,255,255,.85)",fontWeight:700,fontFamily:"Nunito,sans-serif",textAlign:"center",marginBottom:48,fontStyle:"italic"}}>
          "Το δεφτέρι στο κινητό σου"
        </div>

        {/* Σύνδεση - κεντρικό κουμπί */}
        <button onClick={onLogin} style={{width:"100%",maxWidth:320,background:"#fff",color:"#1e5c1e",border:"none",padding:"20px",borderRadius:18,fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:20,cursor:"pointer",boxShadow:"0 8px 32px rgba(0,0,0,.3)",marginBottom:28}}>
          🔑 Σύνδεση
        </button>

        {/* Σύγκριση πλάνων FREE / LITE / PRO */}
        <button onClick={()=>setShowPlans(!showPlans)} style={{background:"transparent",border:"1.5px solid rgba(255,255,255,.35)",color:"rgba(255,255,255,.85)",padding:"11px 28px",borderRadius:14,fontFamily:"Nunito,sans-serif",fontWeight:700,fontSize:14,cursor:"pointer"}}>
          {showPlans?"▲ Κλείσιμο":"▼ Σύγκριση πλάνων"}
        </button>

        {showPlans && (
          <div style={{width:"100%",maxWidth:400,marginTop:16,background:"rgba(255,255,255,.1)",borderRadius:18,padding:14,backdropFilter:"blur(10px)"}}>
            <div style={{display:"grid",gridTemplateColumns:"1.3fr 1fr 1fr 1fr",gap:1,fontFamily:"Nunito,sans-serif",fontSize:11.5}}>
              {/* Κεφαλίδες */}
              <div style={{padding:"8px 6px"}}></div>
              <div style={{background:"rgba(255,255,255,.12)",borderRadius:"10px 0 0 0",padding:"8px 4px",textAlign:"center",color:"#fff",fontWeight:900,fontSize:12.5}}>FREE<br/><span style={{fontSize:9.5,opacity:.75,fontWeight:600}}>365 ημ.</span></div>
              <div style={{background:"rgba(165,214,167,.25)",padding:"8px 4px",textAlign:"center",color:"#fff",fontWeight:900,fontSize:12.5}}>LITE<br/><span style={{fontSize:9.5,opacity:.9,fontWeight:600}}>49€/έτος</span></div>
              <div style={{background:"#f4c542",borderRadius:"0 10px 0 0",padding:"8px 4px",textAlign:"center",color:"#1a2e1a",fontWeight:900,fontSize:12.5}}>PRO<br/><span style={{fontSize:9.5,fontWeight:700}}>Συνδρομή</span></div>
              {/* Γραμμές */}
              {[
                ["Αγροτεμάχια","1","5","∞"],
                ["Εργασίες","10","∞","∞"],
                ["Παραδόσεις & Δελτία myDATA","2","∞","∞"],
                ["Καιρός","✅","✅","✅"],
                ["Εργάτες","❌","1","∞"],
                ["Σημειώσεις","❌","❌","✅"],
                ["Μηχανήματα","❌","❌","✅"],
                ["Αποθήκη","❌","❌","✅"],
                ["Οικονομικά","❌","❌","✅"],
                ["Στατιστικά","❌","❌","✅"],
              ].map(([feat,free,lite,pro],i)=>(
                <div key={feat} style={{display:"contents"}}>
                  <div style={{background:"rgba(255,255,255,.05)",padding:"7px 8px",color:"rgba(255,255,255,.92)",fontSize:11.5,fontWeight:600,borderTop:"1px solid rgba(255,255,255,.08)"}}>{feat}</div>
                  <div style={{background:"rgba(255,255,255,.05)",padding:"7px 4px",color:"#fff",fontSize:11.5,fontWeight:800,textAlign:"center",borderTop:"1px solid rgba(255,255,255,.08)"}}>{free}</div>
                  <div style={{background:"rgba(165,214,167,.12)",padding:"7px 4px",color:"#fff",fontSize:11.5,fontWeight:800,textAlign:"center",borderTop:"1px solid rgba(255,255,255,.08)"}}>{lite}</div>
                  <div style={{background:"rgba(244,197,66,.12)",padding:"7px 4px",color:"#fff",fontSize:11.5,fontWeight:800,textAlign:"center",borderTop:"1px solid rgba(255,255,255,.08)"}}>{pro}</div>
                </div>
              ))}
            </div>
            <div style={{textAlign:"center",marginTop:10,fontSize:11,color:"rgba(255,255,255,.7)"}}>🍑 Τα ψηφιακά δελτία myDATA διαθέσιμα από το FREE</div>
          </div>
        )}
      </div>
    </div>
  );
}

function AuthScreen({ initialTab="login", onBack }) {
  const { signIn, signUp } = useApp();
  const isLogin = initialTab === "login";
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [msg, setMsg] = useState({ t:"", s:"" });
  const [loading, setLoading] = useState(false);
  const [gdprConsent, setGdprConsent] = useState(false);
  const [dataConsent, setDataConsent] = useState(false);
  const [showGDPR, setShowGDPR] = useState(null);
  const [showPw, setShowPw] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const turnstileRef = useRef(null);

  useEffect(() => {
    if (!document.getElementById("cf-turnstile-script")) {
      const s = document.createElement("script");
      s.id = "cf-turnstile-script";
      s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
      s.async = true;
      document.head.appendChild(s);
    }
    const t = setTimeout(() => {
      if (window.turnstile && turnstileRef.current && !turnstileRef.current.dataset.rendered) {
        turnstileRef.current.dataset.rendered = "1";
        window.turnstile.render(turnstileRef.current, {
          sitekey: "0x4AAAAAADRu7iNPRsltd5Tt",
          callback: (token) => setCaptchaToken(token),
          "expired-callback": () => setCaptchaToken(null),
        });
      }
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const handle = async () => {
    if (!email||!pw) { setMsg({t:"e",s:"Συμπλήρωσε email και κωδικό"}); return; }
    if (!captchaToken) { setMsg({t:"e",s:"Παρακαλώ επιβεβαίωσε ότι δεν είσαι ρομπότ ✓"}); return; }
    if (!isLogin && !name.trim()) { setMsg({t:"e",s:"Συμπλήρωσε το όνομά σου"}); return; }
    if (!isLogin && !phone.trim()) { setMsg({t:"e",s:"Συμπλήρωσε το τηλέφωνό σου"}); return; }
    if (!isLogin && (!gdprConsent||!dataConsent)) { setMsg({t:"e",s:"Απαιτείται αποδοχή Πολιτικής Απορρήτου και Όρων Χρήσης"}); return; }
    setLoading(true); setMsg({t:"",s:""});
    if (isLogin) {
      const { error } = await signIn(email, pw, captchaToken);
      if (error) { setMsg({t:"e",s:"Λάθος email ή κωδικός"}); setCaptchaToken(null); if(window.turnstile) window.turnstile.reset(); }
    } else {
      const { error } = await signUp(email, pw, name.trim(), captchaToken, phone.trim());
      if (error) { setMsg({t:"e",s:error.message||"Σφάλμα εγγραφής"}); setCaptchaToken(null); if(window.turnstile) window.turnstile.reset(); }
      else setMsg({t:"s",s:"✅ Εγγραφή επιτυχής! Συνδεθείτε με τα στοιχεία σας."});
    }
    setLoading(false);
  };

  return (
    <div className="auth-sc">
      {/* Πίσω */}
      <div style={{width:"100%",maxWidth:380,padding:"0 0 8px"}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,.15)",border:"1.5px solid rgba(255,255,255,.3)",color:"#fff",padding:"8px 16px",borderRadius:12,fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:13,cursor:"pointer"}}>
          ← Πίσω
        </button>
      </div>
      <div className="auth-logo">🚜</div>
      <div className="auth-title">AgroPalk</div>
      <div className="auth-sub">{isLogin ? "Σύνδεση στον λογαριασμό σου" : "Δημιουργία λογαριασμού"}</div>
      <div className="auth-card">
        {msg.s && <div className={`msg ${msg.t==="e"?"msg-e":"msg-s"}`}>{msg.s}</div>}
        {!isLogin && (
          <div className="fg"><label className="fl">Όνομα *</label>
            <input className="fi" placeholder="π.χ. Νίκος Παπάς" value={name} onChange={e=>setName(e.target.value)} /></div>
        )}
        {!isLogin && (
          <div className="fg"><label className="fl">Τηλέφωνο *</label>
            <input className="fi" type="tel" placeholder="π.χ. 6971234567" value={phone} onChange={e=>setPhone(e.target.value)} /></div>
        )}
        <div className="fg"><label className="fl">Email</label>
          <input className="fi" type="email" placeholder="name@example.com" value={email} onChange={e=>setEmail(e.target.value)} /></div>
        <div className="fg"><label className="fl">Κωδικός</label>
          <div style={{position:"relative"}}>
            <input className="fi" type={showPw?"text":"password"} placeholder="••••••••" value={pw}
              onChange={e=>setPw(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handle()}
              style={{paddingRight:48}} />
            <button type="button" onClick={()=>setShowPw(!showPw)}
              style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",cursor:"pointer",fontSize:20,color:"#6b8c6b",padding:4}}>
              {showPw?"🙈":"👁"}
            </button>
          </div>
        </div>
        {!isLogin && (
          <div style={{marginBottom:12}}>
            <label style={{display:"flex",alignItems:"flex-start",gap:8,marginBottom:8,cursor:"pointer",fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:700,color:"#2d5a2d"}}>
              <input type="checkbox" checked={gdprConsent} onChange={e=>setGdprConsent(e.target.checked)} style={{width:16,height:16,marginTop:2,flexShrink:0}} />
              <span>Αποδέχομαι την <span style={{textDecoration:"underline",cursor:"pointer",color:"#1e5c1e"}} onClick={e=>{e.stopPropagation();setShowGDPR("privacy");}}>Πολιτική Απορρήτου</span> και τους <span style={{textDecoration:"underline",cursor:"pointer",color:"#1e5c1e"}} onClick={e=>{e.stopPropagation();setShowGDPR("terms");}}>Όρους Χρήσης</span> *</span>
            </label>
            <label style={{display:"flex",alignItems:"flex-start",gap:8,cursor:"pointer",fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:700,color:"#2d5a2d"}}>
              <input type="checkbox" checked={dataConsent} onChange={e=>setDataConsent(e.target.checked)} style={{width:16,height:16,marginTop:2,flexShrink:0}} />
              <span>Συναινώ στην επεξεργασία των προσωπικών μου δεδομένων *</span>
            </label>
          </div>
        )}
        {/* Turnstile */}
        <div ref={turnstileRef} style={{marginBottom:12,display:"flex",justifyContent:"center"}} />
        <button className="btn btn-p" onClick={handle} disabled={loading||!captchaToken}>
          {loading ? "⏳ Παρακαλώ..." : isLogin ? "🔑 Σύνδεση" : "✍️ Εγγραφή"}
        </button>
        {isLogin && (
          <div style={{textAlign:"center",marginTop:10,fontFamily:"Nunito,sans-serif",fontSize:11,color:"#8aaa8a",lineHeight:1.6}}>
            Συνδεόμενος αποδέχεσαι αυτόματα την{" "}
            <span style={{textDecoration:"underline",cursor:"pointer",color:"#2d8a2d"}} onClick={()=>setShowGDPR("privacy")}>Πολιτική Απορρήτου</span>
            {" "}και τους{" "}
            <span style={{textDecoration:"underline",cursor:"pointer",color:"#2d8a2d"}} onClick={()=>setShowGDPR("terms")}>Όρους Χρήσης</span>
          </div>
        )}
        {!isLogin && (
          <div style={{textAlign:"center",marginTop:10,display:"flex",justifyContent:"center",gap:12}}>
            <span style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:"#8aaa8a",textDecoration:"underline",cursor:"pointer"}} onClick={()=>setShowGDPR("privacy")}>🔒 Πολιτική Απορρήτου</span>
            <span style={{color:"#ccc"}}>·</span>
            <span style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:"#8aaa8a",textDecoration:"underline",cursor:"pointer"}} onClick={()=>setShowGDPR("terms")}>📋 Όροι Χρήσης</span>
          </div>
        )}
      </div>
      {showGDPR && <GDPRModal type={showGDPR} onClose={()=>setShowGDPR(null)} />}
    </div>
  );
}

// ── MAIN ─────────────────────────────────────────────────────
const TABS = [
  {id:"activities",  ic:"📋", lb:"Εργασίες"},
  {id:"notes",       ic:"📝", lb:"Σημειώσεις"},
  {id:"deliveries",  ic:"📄", lb:"Παραδόσεις"},
  {id:"weather",     ic:"🌤", lb:"Καιρός"},
];

// ═══════════════════════════════════════════════════════════════
// Οθόνη αποδοχής όρων & GDPR — εμφανίζεται στο άνοιγμα μέχρι να γίνει αποδοχή
// ⚖️ ΠΡΟΤΥΠΟ — καλό να το ελέγξει νομικός πριν την παραγωγή.
// ═══════════════════════════════════════════════════════════════
function ConsentGate() {
  const { settings, updateSettings } = useApp();
  const CONSENT_VERSION = "1.0";
  const REMIND_EVERY = 10; // υπενθύμιση κάθε 10 ανοίγματα
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);
  const [show, setShow] = useState(false);
  const [mode, setMode] = useState("full"); // "full" (πρώτη φορά) | "reminder"
  const ranRef = useRef(false);

  // Στο άνοιγμα: αποφάσισε αν θα εμφανιστεί (πρώτη φορά ή κάθε 10 ανοίγματα)
  useEffect(() => {
    if (ranRef.current) return;
    if (settings === null || settings === undefined) return; // περίμενε να φορτώσει
    ranRef.current = true;
    const consent = (settings && settings.consent) || null;
    const accepted = consent && consent.version === CONSENT_VERSION;
    if (!accepted) { setMode("full"); setShow(true); return; }
    const count = (consent.openCount || 0) + 1;
    if (count >= REMIND_EVERY) {
      setMode("reminder"); setShow(true);
      // ο μετρητής μηδενίζει με την αποδοχή
    } else {
      // απλή αύξηση μετρητή, χωρίς εμφάνιση
      updateSettings({ ...(settings || {}), consent: { ...consent, openCount: count } });
    }
  }, [settings]);

  if (!show) return null;

  const accept = async () => {
    setSaving(true);
    const prev = (settings && settings.consent) || {};
    await updateSettings({ ...(settings || {}), consent: { ...prev, version: CONSENT_VERSION, acceptedAt: new Date().toISOString(), openCount: 0 } });
    setSaving(false);
    setShow(false);
  };

  const H = ({children}) => <div style={{fontWeight:800,color:"#1a2e1a",marginTop:14,marginBottom:4}}>{children}</div>;

  // ── ΣΥΝΤΟΜΗ ΥΠΕΝΘΥΜΙΣΗ (κάθε 10 ανοίγματα) ──
  if (mode === "reminder") {
    return (
      <div style={{position:"fixed",inset:0,zIndex:10000,background:"rgba(13,46,13,.65)",display:"flex",alignItems:"center",justifyContent:"center",padding:12}}>
        <div style={{background:"#fff",borderRadius:20,maxWidth:460,width:"100%",overflow:"hidden",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
          <div style={{padding:"18px 20px",borderBottom:"2px solid #1e5c1e"}}>
            <div style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:19,color:"#1a2e1a"}}>Υπενθύμιση Όρων Χρήσης</div>
            <div style={{fontSize:13,color:"#6b8c6b",marginTop:2}}>Μια γρήγορη επιβεβαίωση</div>
          </div>
          <div style={{padding:"16px 20px",fontSize:14,lineHeight:1.6,color:"#2a3a2a"}}>
            Θυμίζουμε ότι είσαι ο <b>νόμιμος εκδότης</b> των παραστατικών που δημιουργείς και υπεύθυνος για την ορθότητά τους. Το AgroPalk λειτουργεί ως εργαλείο διαβίβασης κατ' εντολή σου. Για φορολογικά θέματα συμβουλέψου τον λογιστή σου.
            <div style={{marginTop:8,fontSize:12.5,color:"#6b8c6b"}}>Πλήρεις όροι: <b>info@jitech.gr</b> · Έκδοση {CONSENT_VERSION}</div>
          </div>
          <div style={{padding:"14px 20px",borderTop:"1px solid #eee",background:"#fafcf9"}}>
            <label style={{display:"flex",gap:10,alignItems:"flex-start",cursor:"pointer",marginBottom:12}}>
              <input type="checkbox" checked={checked} onChange={e=>setChecked(e.target.checked)} style={{width:24,height:24,marginTop:1,accentColor:"#1e5c1e",flex:"none"}} />
              <span style={{fontSize:14,fontWeight:700,color:"#1a2e1a"}}>Το διάβασα και συνεχίζω αποδεχόμενος τους όρους.</span>
            </label>
            <button disabled={!checked || saving} onClick={accept}
              style={{width:"100%",padding:15,borderRadius:12,border:"none",fontWeight:900,fontSize:16,
                      cursor: checked && !saving ? "pointer":"not-allowed",
                      background: checked ? "#1e5c1e" : "#c8d6c8", color:"#fff", transition:"background .2s"}}>
              {saving ? "…" : "Συνέχεια"}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ── ΠΛΗΡΕΣ ΚΕΙΜΕΝΟ (πρώτη φορά) ──
  return (
    <div style={{position:"fixed",inset:0,zIndex:10000,background:"rgba(13,46,13,.65)",display:"flex",alignItems:"center",justifyContent:"center",padding:12}}>
      <div style={{background:"#fff",borderRadius:20,maxWidth:580,width:"100%",maxHeight:"92vh",display:"flex",flexDirection:"column",overflow:"hidden",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
        <div style={{padding:"18px 20px",borderBottom:"2px solid #1e5c1e"}}>
          <div style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:20,color:"#1a2e1a"}}>Όροι Χρήσης & Προστασία Δεδομένων</div>
          <div style={{fontSize:13,color:"#6b8c6b",marginTop:2}}>Παρακαλούμε διάβασέ τους πριν συνεχίσεις</div>
        </div>

        <div style={{padding:"14px 20px",overflowY:"auto",flex:1,fontSize:13.5,lineHeight:1.6,color:"#2a3a2a"}}>
          <H>1. Σχετικά με το AgroPalk</H>
          Το AgroPalk είναι εργαλείο διαχείρισης αγροτικών εργασιών και έκδοσης ψηφιακών δελτίων αποστολής προς την ΑΑΔΕ (myDATA).

          <H>2. Ρόλοι & ευθύνη</H>
          Ως χρήστης/παραγωγός είσαι ο <b>νόμιμος εκδότης</b> των παραστατικών που δημιουργείς και ο αποκλειστικά υπεύθυνος για την ορθότητα και τη νομιμότητά τους. Το AgroPalk λειτουργεί ως εργαλείο που διαβιβάζει τα δεδομένα κατ' εντολή σου.

          <H>3. Δεδομένα που επεξεργαζόμαστε</H>
          Στοιχεία λογαριασμού (όνομα, email, τηλέφωνο), δεδομένα αγροτεμαχίων, εργασιών, παραδόσεων και συναλλασσομένων, καθώς και τα διαπιστευτήρια myDATA (Όνομα Χρήστη & Κλειδί) που καταχωρείς.

          <H>4. Διαπιστευτήρια myDATA</H>
          Τα διαπιστευτήριά σου αποθηκεύονται <b>κρυπτογραφημένα</b> και χρησιμοποιούνται αποκλειστικά για τη διαβίβαση των δικών σου παραστατικών στην ΑΑΔΕ, κατ' εντολή σου. Δεν κοινοποιούνται σε τρίτους.

          <H>5. Ασφάλεια</H>
          Λαμβάνουμε εύλογα τεχνικά μέτρα (κρυπτογράφηση, έλεγχος πρόσβασης) για την προστασία των δεδομένων σου.

          <H>6. Τα δικαιώματά σου (GDPR)</H>
          Έχεις δικαίωμα πρόσβασης, διόρθωσης, διαγραφής, περιορισμού και φορητότητας των δεδομένων σου. Μπορείς να διαγράψεις τον λογαριασμό σου ανά πάσα στιγμή από τις Ρυθμίσεις.

          <H>7. Φορολογική ευθύνη</H>
          Το AgroPalk δεν υποκαθιστά λογιστή/φοροτεχνικό. Για την ορθότητα των φορολογικών στοιχείων (σκοπός διακίνησης, ΦΠΑ, καθεστώς) συμβουλέψου τον λογιστή σου.

          <H>8. Περιορισμός ευθύνης</H>
          Η εφαρμογή παρέχεται «ως έχει». Δεν φέρουμε ευθύνη για ζημίες από λανθασμένα στοιχεία που καταχωρείς ή από τη μη διαθεσιμότητα υπηρεσιών τρίτων (π.χ. ΑΑΔΕ).

          <H>9. Επικοινωνία</H>
          Για θέματα δεδομένων επικοινώνησε στο: <b>info@jitech.gr</b>

          <div style={{marginTop:16,fontSize:12,color:"#8aaa8a"}}>Έκδοση όρων 1.0</div>
        </div>

        <div style={{padding:"14px 20px",borderTop:"1px solid #eee",background:"#fafcf9"}}>
          <label style={{display:"flex",gap:10,alignItems:"flex-start",cursor:"pointer",marginBottom:12}}>
            <input type="checkbox" checked={checked} onChange={e=>setChecked(e.target.checked)} style={{width:24,height:24,marginTop:1,accentColor:"#1e5c1e",flex:"none"}} />
            <span style={{fontSize:14,fontWeight:700,color:"#1a2e1a"}}>Διάβασα και αποδέχομαι τους όρους χρήσης και την πολιτική προστασίας δεδομένων.</span>
          </label>
          <button disabled={!checked || saving} onClick={accept}
            style={{width:"100%",padding:16,borderRadius:12,border:"none",fontWeight:900,fontSize:16.5,
                    cursor: checked && !saving ? "pointer":"not-allowed",
                    background: checked ? "#1e5c1e" : "#c8d6c8", color:"#fff", transition:"background .2s"}}>
            {saving ? "…" : "Αποδοχή & Συνέχεια"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Admin Panel (μόνο για admin) — διαχείριση πλάνων χρηστών ──
function AdminPanel({ onClose }) {

  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const [savingId, setSavingId] = useState(null);
  const [msg, setMsg] = useState("");

  const load = async () => {
    const sb = supabase;
    const { data, error } = await sb.from("profiles")
      .select("id,email,name,phone,plan,plan_expires_at,is_admin")
      .order("plan_expires_at", { ascending: true });
    if (error) { setMsg("Σφάλμα: " + error.message); setRows([]); return; }
    setRows(data || []);
  };
  useEffect(() => { load(); }, []);

  const setPlanFor = async (id, plan, years) => {
    setSavingId(id); setMsg("");
    const sb = supabase;
    const expires = years === null ? null : new Date(Date.now() + years*365*24*3600*1000).toISOString();
    const { error } = await sb.from("profiles").update({ plan, plan_expires_at: expires }).eq("id", id);
    setSavingId(null);
    if (error) { setMsg("Σφάλμα: " + error.message); return; }
    setMsg("✓ Αποθηκεύτηκε");
    setRows(prev => prev.map(r => r.id === id ? { ...r, plan, plan_expires_at: expires } : r));
    setTimeout(()=>setMsg(""), 1500);
  };

  const fmt = (d) => d ? new Date(d).toLocaleDateString("el-GR") : "—";
  const list = (rows || []).filter(r =>
    !q || (r.email||"").toLowerCase().includes(q.toLowerCase()) || (r.name||"").toLowerCase().includes(q.toLowerCase()) || (r.phone||"").includes(q)
  );

  return (
    <div style={{position:"fixed",inset:0,zIndex:10001,background:"rgba(13,46,13,.6)",display:"flex",alignItems:"center",justifyContent:"center",padding:12}}>
      <div style={{background:"#fff",borderRadius:20,maxWidth:640,width:"100%",maxHeight:"92vh",display:"flex",flexDirection:"column",overflow:"hidden",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
        <div style={{background:"#163616",color:"#fff",padding:"16px 20px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:18}}>🛠 Διαχείριση Πλάνων</div>
          <button onClick={onClose} style={{background:"rgba(255,255,255,.15)",border:"none",color:"#fff",fontSize:15,fontWeight:800,borderRadius:10,padding:"8px 12px",cursor:"pointer"}}>✕ Κλείσιμο</button>
        </div>
        <div style={{padding:"12px 16px",borderBottom:"1px solid #eee"}}>
          <input value={q} onChange={e=>setQ(e.target.value)} placeholder="🔍 Αναζήτηση (email ή όνομα)" style={{width:"100%",padding:"11px 14px",borderRadius:10,border:"1.5px solid #d9e8d9",fontSize:15,boxSizing:"border-box"}} />
          {msg && <div style={{marginTop:8,fontSize:13,fontWeight:700,color: msg.startsWith("✓")?"#2d8a2d":"#b33"}}>{msg}</div>}
        </div>
        <div style={{flex:1,overflowY:"auto",padding:"8px 12px"}}>
          {rows === null && <div style={{padding:20,textAlign:"center",color:"#6b8c6b"}}>Φόρτωση…</div>}
          {rows !== null && list.length === 0 && <div style={{padding:20,textAlign:"center",color:"#6b8c6b"}}>Κανένας χρήστης.</div>}
          {list.map(r => {
            const badge = { free:"#f4c542", lite:"#7cb342", pro:"#2d8a2d" }[r.plan] || "#999";
            const expired = r.plan_expires_at && new Date(r.plan_expires_at) < new Date();
            return (
              <div key={r.id} style={{border:"1px solid #e5ede5",borderRadius:14,padding:"12px 14px",margin:"8px 0"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
                  <div style={{minWidth:0}}>
                    <div style={{fontWeight:800,fontSize:14.5,color:"#1a2e1a",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{r.name || "—"} {r.is_admin && <span style={{fontSize:11,color:"#c25a1c"}}>★admin</span>}</div>
                    <div style={{fontSize:12.5,color:"#6b8c6b",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{r.email || r.id.slice(0,8)}</div>
                    {r.phone && <a href={`tel:${r.phone}`} onClick={e=>e.stopPropagation()} style={{fontSize:13,color:"#1e5c1e",fontWeight:800,textDecoration:"none"}}>📞 {r.phone}</a>}
                  </div>
                  <div style={{textAlign:"right",flex:"none"}}>
                    <span style={{background:badge,color:"#fff",fontWeight:800,fontSize:12,padding:"3px 10px",borderRadius:20}}>{r.plan.toUpperCase()}</span>
                    <div style={{fontSize:11,color: expired?"#c0392b":"#8aaa8a",marginTop:3}}>λήξη: {fmt(r.plan_expires_at)}{expired?" ⚠":""}</div>
                  </div>
                </div>
                <div style={{display:"flex",flexWrap:"wrap",gap:6,marginTop:10}}>
                  <button disabled={savingId===r.id} onClick={()=>setPlanFor(r.id,"free",1)} style={{flex:"1 1 30%",minWidth:90,padding:"9px 6px",borderRadius:9,border:"1.5px solid #f4c542",background:"#fff",color:"#a67c00",fontWeight:800,fontSize:12.5,cursor:"pointer"}}>FREE 1 έτος</button>
                  <button disabled={savingId===r.id} onClick={()=>setPlanFor(r.id,"lite",1)} style={{flex:"1 1 30%",minWidth:90,padding:"9px 6px",borderRadius:9,border:"1.5px solid #7cb342",background:"#fff",color:"#5a8a2a",fontWeight:800,fontSize:12.5,cursor:"pointer"}}>LITE 1 έτος</button>
                  <button disabled={savingId===r.id} onClick={()=>setPlanFor(r.id,"pro",1)} style={{flex:"1 1 30%",minWidth:90,padding:"9px 6px",borderRadius:9,border:"1.5px solid #2d8a2d",background:"#2d8a2d",color:"#fff",fontWeight:800,fontSize:12.5,cursor:"pointer"}}>PRO 1 έτος</button>
                  <button disabled={savingId===r.id} onClick={()=>setPlanFor(r.id,"pro",null)} style={{flex:"1 1 46%",minWidth:120,padding:"8px 6px",borderRadius:9,border:"1px solid #ccc",background:"#f7f9f7",color:"#555",fontWeight:700,fontSize:12,cursor:"pointer"}}>PRO χωρίς λήξη</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// ── Οθόνη λήξης δωρεάν δοκιμής (free_expired) ──
function TrialExpired() {
  const subj = encodeURIComponent("Αναβάθμιση AgroPalk");
  const body = encodeURIComponent("Γεια σας, η δωρεάν δοκιμή μου έληξε και θέλω να αναβαθμίσω (LITE ή PRO).");
  const ph = UPGRADE_CONTACT.phone;
  const btn = (href,bg,label) => (
    <a href={href} style={{textDecoration:"none",flex:"1 1 45%",minWidth:130,background:bg,color:"#fff",fontWeight:800,fontSize:15,padding:"14px 10px",borderRadius:12,textAlign:"center",boxShadow:"0 4px 12px rgba(0,0,0,.15)"}}>{label}</a>
  );
  return (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",textAlign:"center",minHeight:"75vh",padding:"20px 22px"}}>
      <div style={{background:"#fff",borderRadius:22,padding:"30px 24px",maxWidth:460,width:"100%",boxShadow:"0 18px 50px rgba(13,46,13,.28)",border:"1.5px solid #d9e8d9"}}>
        <div style={{fontSize:52}}>⏳</div>
        <div style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:23,color:"#1a2e1a",marginTop:10}}>Η δωρεάν δοκιμή έληξε</div>
        <div style={{fontSize:15,color:"#4a5c4a",marginTop:10,lineHeight:1.55}}>Ευχαριστούμε που δοκίμασες το AgroPalk! Για να συνεχίσεις να καταγράφεις εργασίες και να εκδίδεις ψηφιακά δελτία myDATA, αναβάθμισε σε <b>LITE (49€/έτος)</b> ή <b>PRO</b>.</div>
        <div style={{marginTop:12,marginBottom:16,fontSize:13.5,color:"#6b8c6b"}}>Τα δεδομένα σου είναι ασφαλή και σε περιμένουν. 🍑</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:8,justifyContent:"center"}}>
          {btn(`tel:${ph}`, "#2d8a2d", "📞 Κλήση")}
          {btn(`viber://chat?number=${encodeURIComponent(ph)}`, "#7360f2", "💬 Viber")}
          {btn(`sms:${ph}?body=${body}`, "#0a7", "📱 SMS")}
          {btn(`mailto:${UPGRADE_CONTACT.email}?subject=${subj}&body=${body}`, "#c25a1c", "📧 Email")}
        </div>
        <div style={{marginTop:14,fontSize:12.5,color:"#8aaa8a"}}>{ph} · {UPGRADE_CONTACT.email}</div>
      </div>
    </div>
  );
}

// ── Θαμπό "teaser" για κλειδωμένα tabs ──
function LockedTeaser({ tabId }) {
  const info = ({
    activities: { ic:"📋", title:"Εργασίες", desc:"Κατέγραψε ψεκασμούς, ποτίσματα, εργάτες και ώρες — τα πάντα οργανωμένα.", rows:["🌱 Ψεκασμός · Αγροτεμάχιο Α","💧 Πότισμα 4h · Ροδακινιές","👷 3 εργάτες · 24 ώρες"] },
    notes: { ic:"📝", title:"Σημειώσεις & To-Do", desc:"Σημειώσεις και υπενθυμίσεις που γίνονται αυτόματα εργασίες.", rows:["📝 Παραγγελία λιπάσματος","✅ Κλάδεμα ροδακινιών","🔔 Ραντεβού γεωπόνου"] },
    deliveries: { ic:"📄", title:"Παραδόσεις & Ψηφιακά Δελτία myDATA", desc:"Έκδοσε ψηφιακά δελτία αποστολής στην ΑΑΔΕ με ένα άγγιγμα.", rows:["📄 Δελτίο 0-24 · ΜΑΡΚ ✓","🍑 2.750 kg Ροδάκινα","📦 11 bins προς ζύγιση"] },
    finance: { ic:"💰", title:"Οικονομικά", desc:"Έσοδα, πληρωμές και υπόλοιπα με μια ματιά.", rows:["💰 Έσοδα μήνα: 4.250 €","🧾 Απλήρωτα: 2 παραδόσεις","📈 Σύνολο σεζόν"] },
    stats: { ic:"📊", title:"Στατιστικά", desc:"Αναλύσεις αποδόσεων, εργατών και αγροτεμαχίων.", rows:["📊 Απόδοση ανά στρέμμα","👷 Κόστος εργασίας ανά kg","🏆 Καλύτερο αγροτεμάχιο"] },
    machines: { ic:"🚜", title:"Μηχανήματα", desc:"Κατέγραψε τρακτέρ, παρελκόμενα και συντηρήσεις.", rows:["🚜 Τρακτέρ John Deere","🔧 Service στα 250h","⛽ Κατανάλωση καυσίμου"] },
    workers: { ic:"👷", title:"Εργάτες", desc:"Διαχειρίσου εργάτες, μεροκάματα και ένσημα.", rows:["👷 Γιώργος · 8 μεροκάματα","📋 ΑΜΚΑ & στοιχεία","📊 Ώρες ανά εργάτη"] },
    inventory: { ic:"📦", title:"Αποθήκη", desc:"Παρακολούθησε λιπάσματα, φάρμακα και υλικά.", rows:["📦 Λίπασμα 20-10-10","🧪 Φυτοφάρμακα","📉 Αποθέματα σε χαμηλά"] },
  })[tabId] || { ic:"🔒", title:"Κλειδωμένο", desc:"Διαθέσιμο σε ανώτερο πλάνο.", rows:[] };

  const minPlan = TAB_MIN_PLAN[tabId] || "LITE"; // "LITE" ή "PRO"
  const priceLine = minPlan === "LITE" ? "Διαθέσιμο στο πλάνο LITE (49€/έτος)" : "Διαθέσιμο στο πλάνο PRO";

  const subj = encodeURIComponent(`Αναβάθμιση AgroPalk σε ${minPlan}`);
  const body = encodeURIComponent(`Γεια σας, θέλω να αναβαθμίσω τον λογαριασμό μου στο πλάνο ${minPlan}.`);
  const ph = UPGRADE_CONTACT.phone;
  const btn = (href,bg,label) => (
    <a href={href} style={{textDecoration:"none",flex:"1 1 45%",minWidth:130,background:bg,color:"#fff",fontWeight:800,fontSize:15,padding:"13px 10px",borderRadius:12,textAlign:"center",boxShadow:"0 4px 12px rgba(0,0,0,.15)"}}>{label}</a>
  );

  return (
    <div style={{position:"relative",minHeight:"72vh"}}>
      {/* Θαμπό ψεύτικο preview */}
      <div style={{filter:"blur(5px)",pointerEvents:"none",userSelect:"none",opacity:.5}}>
        <div className="stitle">{info.ic} {info.title} <span className="cnt">•••</span></div>
        {info.rows.map((r,i)=>(
          <div key={i} style={{background:"#fff",border:"1px solid #e5ede5",borderRadius:14,padding:"16px 18px",margin:"10px 0",fontWeight:700,color:"#2a3a2a",display:"flex",justifyContent:"space-between"}}>
            <span>{r}</span><span style={{color:"#9bb89b"}}>›</span>
          </div>
        ))}
        <div style={{background:"#fff",border:"1px solid #e5ede5",borderRadius:14,padding:"16px 18px",margin:"10px 0",height:70}} />
        <div style={{background:"#fff",border:"1px solid #e5ede5",borderRadius:14,padding:"16px 18px",margin:"10px 0",height:70}} />
      </div>

      {/* Overlay πρόσκλησης */}
      <div style={{position:"absolute",inset:0,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",textAlign:"center",padding:"20px 22px"}}>
        <div style={{background:"rgba(255,255,255,.96)",borderRadius:22,padding:"26px 22px",maxWidth:440,width:"100%",boxShadow:"0 18px 50px rgba(13,46,13,.28)",border:"1.5px solid #d9e8d9"}}>
          <div style={{fontSize:46,lineHeight:1}}>{info.ic}</div>
          <div style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:21,color:"#1a2e1a",marginTop:10}}>Ξεκλείδωσε: {info.title}</div>
          <div style={{fontSize:14.5,color:"#4a5c4a",marginTop:8,lineHeight:1.55}}>{info.desc}</div>
          <div style={{marginTop:14,marginBottom:14,fontSize:14,fontWeight:800,color:"#1e5c1e",background:"#eef7ee",borderRadius:12,padding:"10px 14px"}}>✨ {priceLine}</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:8,justifyContent:"center"}}>
            {btn(`tel:${ph}`, "#2d8a2d", "📞 Κλήση")}
            {btn(`viber://chat?number=${encodeURIComponent(ph)}`, "#7360f2", "💬 Viber")}
            {btn(`sms:${ph}?body=${body}`, "#0a7", "📱 SMS")}
            {btn(`mailto:${UPGRADE_CONTACT.email}?subject=${subj}&body=${body}`, "#c25a1c", "📧 Email")}
          </div>
          <div style={{marginTop:12,fontSize:12.5,color:"#8aaa8a"}}>{ph} · {UPGRADE_CONTACT.email}</div>
        </div>
      </div>
    </div>
  );
}

function MainApp() {
  const { user, plan, isAdmin, userName, signOut } = useApp();
  const [tab, setTab] = useState("activities");
  const [authTab, setAuthTab] = useState("login");
  const [showWelcome, setShowWelcome] = useState(true);
  const [showSignOutConfirm, setShowSignOutConfirm] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
  const [showGDPRModal, setShowGDPRModal] = useState(null);
  const [showDeleteAccount, setShowDeleteAccount] = useState(false);
  const [showSplash, setShowSplash] = useState(true);
  const [amountsVisible, setAmountsVisible] = useState(false);
  window._amountsVisible = amountsVisible;
  window._setAmountsVisible = setAmountsVisible;

  if (!user) {
    if (showWelcome) return <WelcomeScreen onLogin={()=>{setAuthTab("login");setShowWelcome(false);}} onRegister={()=>{setAuthTab("register");setShowWelcome(false);}} />;
    return <AuthScreen initialTab={authTab} onBack={()=>setShowWelcome(true)} />;
  }

  const firstName = userName ? userName.split(" ")[0] : user.email?.split("@")[0];
  window._gotoTab = (t) => { setTab(t); };

  if (showSplash) return (
    <>
      <ConsentGate />
      <div style={{position:"fixed",inset:0,background:"linear-gradient(160deg,#0d2e0d,#1e5c1e,#2d8a2d)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",zIndex:9999,padding:"24px"}}>
      <div style={{fontSize:74,marginBottom:10}}>🚜</div>
      <div style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:38,color:"#fff",letterSpacing:-2,marginBottom:6}}>AgroPalk</div>
      <div style={{fontFamily:"Nunito,sans-serif",fontWeight:700,fontSize:20,color:"rgba(255,255,255,.92)",marginBottom:4}}>Καλώς ήρθες, {firstName}! 👋</div>
      <div style={{fontFamily:"Nunito,sans-serif",fontStyle:"italic",fontSize:14,color:"rgba(255,255,255,.65)",marginBottom:30}}>"Το δεφτέρι στο κινητό σου"</div>

      <div style={{width:"100%",maxWidth:340,display:"flex",flexDirection:"column",gap:12}}>
        <button onClick={()=>{ window._autoOpenIssue = true; setTab("deliveries"); setShowSplash(false); }}
          style={{display:"flex",alignItems:"center",gap:14,padding:"17px 20px",borderRadius:16,border:"none",background:"#fff",color:"#1a2e1a",fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:17,cursor:"pointer",boxShadow:"0 6px 20px rgba(0,0,0,.2)"}}>
          <span style={{fontSize:26}}>📄</span> Κόψε δελτίο
        </button>
        <button onClick={()=>{ window._autoOpenActivity = true; setTab("activities"); setShowSplash(false); }}
          style={{display:"flex",alignItems:"center",gap:14,padding:"17px 20px",borderRadius:16,border:"none",background:"#f4c542",color:"#1a2e1a",fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:17,cursor:"pointer",boxShadow:"0 6px 20px rgba(0,0,0,.2)"}}>
          <span style={{fontSize:26}}>➕</span> Καινούργια εργασία
        </button>
        <button onClick={()=>setShowSplash(false)}
          style={{display:"flex",alignItems:"center",justifyContent:"center",gap:10,padding:"15px 20px",borderRadius:16,border:"1.5px solid rgba(255,255,255,.4)",background:"transparent",color:"rgba(255,255,255,.92)",fontFamily:"Nunito,sans-serif",fontWeight:700,fontSize:15.5,cursor:"pointer",marginTop:4}}>
          Συνέχεια στην εφαρμογή →
        </button>
      </div>
      <div style={{position:"absolute",bottom:14,right:16,fontFamily:"Nunito,sans-serif",fontSize:12,color:"rgba(255,255,255,.55)",fontWeight:700}}>{APP_VERSION}</div>
    </div>
    </>
  );

  return (
    <div className="shell">
      <ConsentGate />
      {showGDPRModal && <GDPRModal type={showGDPRModal} onClose={()=>setShowGDPRModal(null)} />}
      {showDeleteAccount && <DeleteAccountModal onClose={()=>setShowDeleteAccount(false)} onConfirm={async()=>{
        await supabase.auth.signOut();
        signOut();
        setShowDeleteAccount(false);
        setShowWelcome(true);
      }} />}
      {showSignOutConfirm && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div style={{background:"#fff",borderRadius:20,padding:24,maxWidth:320,width:"100%",textAlign:"center",boxShadow:"0 8px 40px rgba(0,0,0,.3)"}}>
            <div style={{fontSize:48,marginBottom:12}}>👋</div>
            <div style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:18,color:"#1a2e1a",marginBottom:8}}>Αποσύνδεση;</div>
            <div style={{fontFamily:"Nunito,sans-serif",fontSize:14,color:"#5a7a5a",marginBottom:20}}>Είσαι σίγουρος ότι θέλεις να αποσυνδεθείς;</div>
            <div style={{display:"flex",gap:10,marginBottom:10}}>
              <button className="btn" style={{flex:1,background:"#f0f7f0",color:"#2d5a2d",justifyContent:"center",padding:14}} onClick={()=>setShowSignOutConfirm(false)}>Άκυρο</button>
              <button className="btn" style={{flex:1,background:"#c0392b",color:"#fff",justifyContent:"center",padding:14}} onClick={()=>{signOut();setShowSignOutConfirm(false);setShowWelcome(true);}}>Αποσύνδεση</button>
            </div>
            <div style={{borderTop:"1px solid #f0f0f0",paddingTop:10,display:"flex",gap:8,justifyContent:"center"}}>
              <button style={{background:"transparent",border:"none",color:"#8aaa8a",fontFamily:"Nunito,sans-serif",fontSize:11,fontWeight:700,cursor:"pointer",textDecoration:"underline"}} onClick={()=>{setShowSignOutConfirm(false);setShowGDPRModal("privacy");}}>Πολιτική Απορρήτου</button>
              <span style={{color:"#ccc",fontSize:11}}>·</span>
              <button style={{background:"transparent",border:"none",color:"#8aaa8a",fontFamily:"Nunito,sans-serif",fontSize:11,fontWeight:700,cursor:"pointer",textDecoration:"underline"}} onClick={()=>{setShowSignOutConfirm(false);setShowGDPRModal("terms");}}>Όροι Χρήσης</button>
              <span style={{color:"#ccc",fontSize:11}}>·</span>
              <button style={{background:"transparent",border:"none",color:"#c62828",fontFamily:"Nunito,sans-serif",fontSize:11,fontWeight:700,cursor:"pointer",textDecoration:"underline"}} onClick={()=>{setShowSignOutConfirm(false);setShowDeleteAccount(true);}}>Διαγραφή λογαριασμού</button>
            </div>
          </div>
        </div>
      )}
      <div className="hdr">
        <div>
          <h1>AgroPalk</h1>
          <div style={{fontSize:12,color:"rgba(255,255,255,.8)",fontWeight:700,marginTop:2}}>Γεια σου, {firstName}! 👋</div>
        </div>
        {/* Placeholder για logo συνεταιρισμού */}
        <div style={{position:"absolute",left:"50%",transform:"translateX(-50%)",display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
          {false && ( /* Θα ενεργοποιηθεί όταν συνδεθεί organizations table */
            <div style={{background:"rgba(255,255,255,.15)",borderRadius:10,padding:"4px 12px",backdropFilter:"blur(4px)"}}>
              <img src="" alt="Logo Συνεταιρισμού" style={{height:32,objectFit:"contain"}} />
            </div>
          )}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <span className={`badge ${plan==="pro"?"pro":""}`}>{plan==="free_expired"?"FREE":plan.toUpperCase()}</span>
          <button className="so" onClick={()=>setMenuOpen(true)} title="Μενού" style={{fontSize:22,lineHeight:1}}>☰</button>
        </div>
      </div>

      {menuOpen && (
        <div onClick={()=>setMenuOpen(false)} style={{position:"fixed",inset:0,zIndex:9998,background:"rgba(0,0,0,.45)"}}>
          <div onClick={e=>e.stopPropagation()} style={{position:"absolute",top:0,right:0,height:"100%",width:"min(320px,86vw)",background:"#fff",boxShadow:"-6px 0 30px rgba(0,0,0,.25)",display:"flex",flexDirection:"column"}}>
            <div style={{background:"#163616",color:"#fff",padding:"18px 18px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <div>
                <div style={{fontFamily:"Nunito,sans-serif",fontWeight:900,fontSize:18}}>Μενού</div>
                <div style={{fontSize:12.5,opacity:.8,marginTop:2}}>{userName || "AgroPalk"} · {plan==="free_expired"?"FREE":plan.toUpperCase()}</div>
              </div>
              <button onClick={()=>setMenuOpen(false)} style={{background:"rgba(255,255,255,.15)",border:"none",color:"#fff",fontSize:16,fontWeight:800,borderRadius:10,padding:"8px 12px",cursor:"pointer"}}>✕</button>
            </div>
            <div style={{flex:1,overflowY:"auto",padding:"10px 0"}}>
              {[
                {ic:"⚙️", lb:"Ρυθμίσεις", act:()=>{setTab("settings");setMenuOpen(false);}},
                {ic:"🌾", lb:"Αγροτεμάχια", act:()=>{setTab("fields");setMenuOpen(false);}},
                {ic:"🚜", lb:"Μηχανήματα", act:()=>{setTab("machines");setMenuOpen(false);}},
                {ic:"👷", lb:"Εργάτες", act:()=>{setTab("workers");setMenuOpen(false);}},
                {ic:"📦", lb:"Αποθήκη", act:()=>{setTab("inventory");setMenuOpen(false);}},
                {ic:"💰", lb:"Οικονομικά", act:()=>{setTab("finance");setMenuOpen(false);}},
                {ic:"📊", lb:"Στατιστικά", act:()=>{setTab("stats");setMenuOpen(false);}},
              ].map((m,i)=>(
                <button key={i} onClick={m.act} style={{width:"100%",display:"flex",alignItems:"center",gap:14,padding:"14px 20px",background:"none",border:"none",borderBottom:"1px solid #f0f4f0",fontFamily:"Nunito,sans-serif",fontWeight:700,fontSize:15.5,color:"#1a2e1a",cursor:"pointer",textAlign:"left"}}>
                  <span style={{fontSize:20}}>{m.ic}</span>{m.lb}
                </button>
              ))}
            </div>
            <div style={{borderTop:"2px solid #f0f4f0",padding:14}}>
              {isAdmin && (
                <button onClick={()=>{setMenuOpen(false);setShowAdmin(true);}} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center",gap:10,padding:"13px",marginBottom:10,background:"#eef4ff",border:"1.5px solid #b3c9e5",borderRadius:12,fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:15,color:"#2b5fa5",cursor:"pointer"}}>
                  🛠 Διαχείριση Πλάνων
                </button>
              )}
              <button onClick={()=>{setMenuOpen(false);setShowSignOutConfirm(true);}} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center",gap:10,padding:"14px",background:"#fce8e8",border:"1.5px solid #e5b3b3",borderRadius:12,fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:15.5,color:"#b33",cursor:"pointer"}}>
                🚪 Αποσύνδεση
              </button>
              <div style={{textAlign:"center",marginTop:12,fontSize:12,color:"#9bb89b",fontWeight:700}}>AgroPalk {APP_VERSION}</div>
            </div>
          </div>
        </div>
      )}
      {showAdmin && <AdminPanel onClose={()=>setShowAdmin(false)} />}
      <nav className="nav">
        {TABS.map(t=>(
          <button key={t.id} className={`nb ${tab===t.id?"on":""}`} onClick={()=>setTab(t.id)}>
            <span className="ic">{t.ic}</span>{t.lb}
          </button>
        ))}
      </nav>
      {(tab==="finance"||tab==="deliveries") && (
        <div style={{background:"#163616",display:"flex",justifyContent:"flex-end",padding:"6px 16px",borderBottom:"1px solid rgba(255,255,255,.1)"}}>
          <button onClick={()=>setAmountsVisible(!amountsVisible)}
            style={{background:"rgba(255,255,255,.12)",border:"1.5px solid rgba(255,255,255,.2)",color:"#fff",padding:"6px 14px",borderRadius:10,fontFamily:"Nunito,sans-serif",fontWeight:700,fontSize:13,cursor:"pointer",display:"flex",alignItems:"center",gap:6}}>
            {amountsVisible ? "🙈 Απόκρυψη ποσών" : "👁 Εμφάνιση ποσών"}
          </button>
        </div>
      )}
      <div className="content">
        {plan==="free_expired" && tab!=="settings" ? (
          <TrialExpired />
        ) : (PLAN_TABS[plan] && !PLAN_TABS[plan].includes(tab)) ? (
          <LockedTeaser tabId={tab} />
        ) : (<>
        {tab==="activities"  && <ActivitiesTab />}
        {tab==="notes"       && <NotesTab />}
        {tab==="deliveries"  && <DeliveriesTab />}
        {tab==="finance"     && <FinanceTab />}
        {tab==="stats"       && <StatsTab />}
        {tab==="weather"     && <WeatherTab />}
        {tab==="fields"      && <FieldsTab />}
        {tab==="machines"    && <MachinesTab />}
        {tab==="workers"     && <WorkersTab />}
        {tab==="inventory"   && <InventoryTab />}
        {tab==="settings"   && <SettingsTab />}
        </>)}
      </div>
    </div>
  );
}

export default function App() {
  return (
    <>
      <style>{css}</style>
      <AppProvider><MainApp /></AppProvider>
    </>
  );
}
